var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};

// node_modules/google-protobuf/google-protobuf.js
var require_google_protobuf = __commonJS({
  "node_modules/google-protobuf/google-protobuf.js"(exports, module) {
    var COMPILED = true;
    var goog = goog || {};
    goog.global = exports || self;
    goog.exportPath_ = function(a2, b2, c, d) {
      a2 = a2.split(".");
      d = d || goog.global;
      a2[0] in d || "undefined" == typeof d.execScript || d.execScript("var " + a2[0]);
      for (var e; a2.length && (e = a2.shift()); ) if (a2.length || void 0 === b2) d = d[e] && d[e] !== Object.prototype[e] ? d[e] : d[e] = {};
      else if (!c && goog.isObject(b2) && goog.isObject(d[e])) for (var f in b2) b2.hasOwnProperty(f) && (d[e][f] = b2[f]);
      else d[e] = b2;
    };
    goog.define = function(a2, b2) {
      if (!COMPILED) {
        var c = goog.global.CLOSURE_UNCOMPILED_DEFINES, d = goog.global.CLOSURE_DEFINES;
        c && void 0 === c.nodeType && Object.prototype.hasOwnProperty.call(c, a2) ? b2 = c[a2] : d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a2) && (b2 = d[a2]);
      }
      return b2;
    };
    goog.FEATURESET_YEAR = 2012;
    goog.DEBUG = true;
    goog.LOCALE = "en";
    goog.TRUSTED_SITE = true;
    goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
    goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = false;
    goog.provide = function(a2) {
      if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
      if (!COMPILED && goog.isProvided_(a2)) throw Error('Namespace "' + a2 + '" already declared.');
      goog.constructNamespace_(a2);
    };
    goog.constructNamespace_ = function(a2, b2, c) {
      if (!COMPILED) {
        delete goog.implicitNamespaces_[a2];
        for (var d = a2; (d = d.substring(0, d.lastIndexOf("."))) && !goog.getObjectByName(d); ) goog.implicitNamespaces_[d] = true;
      }
      goog.exportPath_(a2, b2, c);
    };
    goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
    goog.getScriptNonce_ = function(a2) {
      a2 = (a2 || goog.global).document;
      return (a2 = a2.querySelector && a2.querySelector("script[nonce]")) && (a2 = a2.nonce || a2.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a2) ? a2 : "";
    };
    goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
    goog.module = function(a2) {
      if ("string" !== typeof a2 || !a2 || -1 == a2.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
      if (!goog.isInGoogModuleLoader_()) throw Error("Module " + a2 + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
      if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
      goog.moduleLoaderState_.moduleName = a2;
      if (!COMPILED) {
        if (goog.isProvided_(a2)) throw Error('Namespace "' + a2 + '" already declared.');
        delete goog.implicitNamespaces_[a2];
      }
    };
    goog.module.get = function(a2) {
      return goog.module.getInternal_(a2);
    };
    goog.module.getInternal_ = function(a2) {
      if (!COMPILED) {
        if (a2 in goog.loadedModules_) return goog.loadedModules_[a2].exports;
        if (!goog.implicitNamespaces_[a2]) return a2 = goog.getObjectByName(a2), null != a2 ? a2 : null;
      }
      return null;
    };
    goog.ModuleType = { ES6: "es6", GOOG: "goog" };
    goog.moduleLoaderState_ = null;
    goog.isInModuleLoader_ = function() {
      return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
    };
    goog.isInGoogModuleLoader_ = function() {
      return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
    };
    goog.isInEs6ModuleLoader_ = function() {
      if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return true;
      var a2 = goog.global.$jscomp;
      return a2 ? "function" != typeof a2.getCurrentModulePath ? false : !!a2.getCurrentModulePath() : false;
    };
    goog.module.declareLegacyNamespace = function() {
      if (!COMPILED && !goog.isInGoogModuleLoader_()) throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
      if (!COMPILED && !goog.moduleLoaderState_.moduleName) throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
      goog.moduleLoaderState_.declareLegacyNamespace = true;
    };
    goog.declareModuleId = function(a2) {
      if (!COMPILED) {
        if (!goog.isInEs6ModuleLoader_()) throw Error("goog.declareModuleId may only be called from within an ES6 module");
        if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) throw Error("goog.declareModuleId may only be called once per module.");
        if (a2 in goog.loadedModules_) throw Error('Module with namespace "' + a2 + '" already exists.');
      }
      if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = a2;
      else {
        var b2 = goog.global.$jscomp;
        if (!b2 || "function" != typeof b2.getCurrentModulePath) throw Error('Module with namespace "' + a2 + '" has been loaded incorrectly.');
        b2 = b2.require(b2.getCurrentModulePath());
        goog.loadedModules_[a2] = { exports: b2, type: goog.ModuleType.ES6, moduleId: a2 };
      }
    };
    goog.setTestOnly = function(a2) {
      if (goog.DISALLOW_TEST_ONLY_CODE) throw a2 = a2 || "", Error("Importing test-only code into non-debug environment" + (a2 ? ": " + a2 : "."));
    };
    goog.forwardDeclare = function(a2) {
    };
    COMPILED || (goog.isProvided_ = function(a2) {
      return a2 in goog.loadedModules_ || !goog.implicitNamespaces_[a2] && null != goog.getObjectByName(a2);
    }, goog.implicitNamespaces_ = { "goog.module": true });
    goog.getObjectByName = function(a2, b2) {
      a2 = a2.split(".");
      b2 = b2 || goog.global;
      for (var c = 0; c < a2.length; c++) if (b2 = b2[a2[c]], null == b2) return null;
      return b2;
    };
    goog.addDependency = function(a2, b2, c, d) {
      !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a2, b2, c, d);
    };
    goog.ENABLE_DEBUG_LOADER = false;
    goog.logToConsole_ = function(a2) {
      goog.global.console && goog.global.console.error(a2);
    };
    goog.require = function(a2) {
      if (!COMPILED) {
        goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a2);
        if (goog.isProvided_(a2)) {
          if (goog.isInModuleLoader_()) return goog.module.getInternal_(a2);
        } else if (goog.ENABLE_DEBUG_LOADER) {
          var b2 = goog.moduleLoaderState_;
          goog.moduleLoaderState_ = null;
          try {
            goog.debugLoader_.load_(a2);
          } finally {
            goog.moduleLoaderState_ = b2;
          }
        }
        return null;
      }
    };
    goog.requireType = function(a2) {
      return {};
    };
    goog.basePath = "";
    goog.abstractMethod = function() {
      throw Error("unimplemented abstract method");
    };
    goog.addSingletonGetter = function(a2) {
      a2.instance_ = void 0;
      a2.getInstance = function() {
        if (a2.instance_) return a2.instance_;
        goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a2);
        return a2.instance_ = new a2();
      };
    };
    goog.instantiatedSingletons_ = [];
    goog.LOAD_MODULE_USING_EVAL = true;
    goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
    goog.loadedModules_ = {};
    goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
    goog.TRANSPILE = "detect";
    goog.ASSUME_ES_MODULES_TRANSPILED = false;
    goog.TRUSTED_TYPES_POLICY_NAME = "goog";
    goog.hasBadLetScoping = null;
    goog.loadModule = function(a2) {
      var b2 = goog.moduleLoaderState_;
      try {
        goog.moduleLoaderState_ = { moduleName: "", declareLegacyNamespace: false, type: goog.ModuleType.GOOG };
        var c = {}, d = c;
        if ("function" === typeof a2) d = a2.call(void 0, d);
        else if ("string" === typeof a2) d = goog.loadModuleFromSource_.call(void 0, d, a2);
        else throw Error("Invalid module definition");
        var e = goog.moduleLoaderState_.moduleName;
        if ("string" === typeof e && e) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(e, d, c !== d) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof d && null != d && Object.seal(d), goog.loadedModules_[e] = { exports: d, type: goog.ModuleType.GOOG, moduleId: goog.moduleLoaderState_.moduleName };
        else throw Error('Invalid module name "' + e + '"');
      } finally {
        goog.moduleLoaderState_ = b2;
      }
    };
    goog.loadModuleFromSource_ = function(a, b) {
      eval(goog.CLOSURE_EVAL_PREFILTER_.createScript(b));
      return a;
    };
    goog.normalizePath_ = function(a2) {
      a2 = a2.split("/");
      for (var b2 = 0; b2 < a2.length; ) "." == a2[b2] ? a2.splice(b2, 1) : b2 && ".." == a2[b2] && a2[b2 - 1] && ".." != a2[b2 - 1] ? a2.splice(--b2, 2) : b2++;
      return a2.join("/");
    };
    goog.loadFileSync_ = function(a2) {
      if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(a2);
      try {
        var b2 = new goog.global.XMLHttpRequest();
        b2.open("get", a2, false);
        b2.send();
        return 0 == b2.status || 200 == b2.status ? b2.responseText : null;
      } catch (c) {
        return null;
      }
    };
    goog.typeOf = function(a2) {
      var b2 = typeof a2;
      return "object" != b2 ? b2 : a2 ? Array.isArray(a2) ? "array" : b2 : "null";
    };
    goog.isArrayLike = function(a2) {
      var b2 = goog.typeOf(a2);
      return "array" == b2 || "object" == b2 && "number" == typeof a2.length;
    };
    goog.isDateLike = function(a2) {
      return goog.isObject(a2) && "function" == typeof a2.getFullYear;
    };
    goog.isObject = function(a2) {
      var b2 = typeof a2;
      return "object" == b2 && null != a2 || "function" == b2;
    };
    goog.getUid = function(a2) {
      return Object.prototype.hasOwnProperty.call(a2, goog.UID_PROPERTY_) && a2[goog.UID_PROPERTY_] || (a2[goog.UID_PROPERTY_] = ++goog.uidCounter_);
    };
    goog.hasUid = function(a2) {
      return !!a2[goog.UID_PROPERTY_];
    };
    goog.removeUid = function(a2) {
      null !== a2 && "removeAttribute" in a2 && a2.removeAttribute(goog.UID_PROPERTY_);
      try {
        delete a2[goog.UID_PROPERTY_];
      } catch (b2) {
      }
    };
    goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0);
    goog.uidCounter_ = 0;
    goog.cloneObject = function(a2) {
      var b2 = goog.typeOf(a2);
      if ("object" == b2 || "array" == b2) {
        if ("function" === typeof a2.clone) return a2.clone();
        if ("undefined" !== typeof Map && a2 instanceof Map) return new Map(a2);
        if ("undefined" !== typeof Set && a2 instanceof Set) return new Set(a2);
        b2 = "array" == b2 ? [] : {};
        for (var c in a2) b2[c] = goog.cloneObject(a2[c]);
        return b2;
      }
      return a2;
    };
    goog.bindNative_ = function(a2, b2, c) {
      return a2.call.apply(a2.bind, arguments);
    };
    goog.bindJs_ = function(a2, b2, c) {
      if (!a2) throw Error();
      if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
          var e = Array.prototype.slice.call(arguments);
          Array.prototype.unshift.apply(e, d);
          return a2.apply(b2, e);
        };
      }
      return function() {
        return a2.apply(b2, arguments);
      };
    };
    goog.bind = function(a2, b2, c) {
      Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
      return goog.bind.apply(null, arguments);
    };
    goog.partial = function(a2, b2) {
      var c = Array.prototype.slice.call(arguments, 1);
      return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a2.apply(this, d);
      };
    };
    goog.now = function() {
      return Date.now();
    };
    goog.globalEval = function(a2) {
      (0, eval)(a2);
    };
    goog.getCssName = function(a2, b2) {
      if ("." == String(a2).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a2);
      var c = function(e) {
        return goog.cssNameMapping_[e] || e;
      }, d = function(e) {
        e = e.split("-");
        for (var f = [], g = 0; g < e.length; g++) f.push(c(e[g]));
        return f.join("-");
      };
      d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(e) {
        return e;
      };
      a2 = b2 ? a2 + "-" + d(b2) : d(a2);
      return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a2) : a2;
    };
    goog.setCssNameMapping = function(a2, b2) {
      goog.cssNameMapping_ = a2;
      goog.cssNameMappingStyle_ = b2;
    };
    !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
    goog.GetMsgOptions = function() {
    };
    goog.getMsg = function(a2, b2, c) {
      c && c.html && (a2 = a2.replace(/</g, "&lt;"));
      c && c.unescapeHtmlEntities && (a2 = a2.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&"));
      b2 && (a2 = a2.replace(/\{\$([^}]+)}/g, function(d, e) {
        return null != b2 && e in b2 ? b2[e] : d;
      }));
      return a2;
    };
    goog.getMsgWithFallback = function(a2, b2) {
      return a2;
    };
    goog.exportSymbol = function(a2, b2, c) {
      goog.exportPath_(a2, b2, true, c);
    };
    goog.exportProperty = function(a2, b2, c) {
      a2[b2] = c;
    };
    goog.inherits = function(a2, b2) {
      function c() {
      }
      c.prototype = b2.prototype;
      a2.superClass_ = b2.prototype;
      a2.prototype = new c();
      a2.prototype.constructor = a2;
      a2.base = function(d, e, f) {
        for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++) g[h - 2] = arguments[h];
        return b2.prototype[e].apply(d, g);
      };
    };
    goog.scope = function(a2) {
      if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
      a2.call(goog.global);
    };
    COMPILED || (goog.global.COMPILED = COMPILED);
    goog.defineClass = function(a2, b2) {
      var c = b2.constructor, d = b2.statics;
      c && c != Object.prototype.constructor || (c = function() {
        throw Error("cannot instantiate an interface (no constructor defined).");
      });
      c = goog.defineClass.createSealingConstructor_(c, a2);
      a2 && goog.inherits(c, a2);
      delete b2.constructor;
      delete b2.statics;
      goog.defineClass.applyProperties_(c.prototype, b2);
      null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
      return c;
    };
    goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
    goog.defineClass.createSealingConstructor_ = function(a2, b2) {
      return goog.defineClass.SEAL_CLASS_INSTANCES ? function() {
        var c = a2.apply(this, arguments) || this;
        c[goog.UID_PROPERTY_] = c[goog.UID_PROPERTY_];
        return c;
      } : a2;
    };
    goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    goog.defineClass.applyProperties_ = function(a2, b2) {
      for (var c in b2) Object.prototype.hasOwnProperty.call(b2, c) && (a2[c] = b2[c]);
      for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++) c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b2, c) && (a2[c] = b2[c]);
    };
    goog.identity_ = function(a2) {
      return a2;
    };
    goog.createTrustedTypesPolicy = function(a2) {
      var b2 = null, c = goog.global.trustedTypes;
      if (!c || !c.createPolicy) return b2;
      try {
        b2 = c.createPolicy(a2, { createHTML: goog.identity_, createScript: goog.identity_, createScriptURL: goog.identity_ });
      } catch (d) {
        goog.logToConsole_(d.message);
      }
      return b2;
    };
    !COMPILED && goog.DEPENDENCIES_ENABLED && (goog.isEdge_ = function() {
      return !!(goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "").match(/Edge\/(\d+)(\.\d)*/i);
    }, goog.inHtmlDocument_ = function() {
      var a2 = goog.global.document;
      return null != a2 && "write" in a2;
    }, goog.isDocumentLoading_ = function() {
      var a2 = goog.global.document;
      return a2.attachEvent ? "complete" != a2.readyState : "loading" == a2.readyState;
    }, goog.findBasePath_ = function() {
      if (void 0 != goog.global.CLOSURE_BASE_PATH && "string" === typeof goog.global.CLOSURE_BASE_PATH) goog.basePath = goog.global.CLOSURE_BASE_PATH;
      else if (goog.inHtmlDocument_()) {
        var a2 = goog.global.document, b2 = a2.currentScript;
        a2 = b2 ? [b2] : a2.getElementsByTagName("SCRIPT");
        for (b2 = a2.length - 1; 0 <= b2; --b2) {
          var c = a2[b2].src, d = c.lastIndexOf("?");
          d = -1 == d ? c.length : d;
          if ("base.js" == c.slice(d - 7, d)) {
            goog.basePath = c.slice(0, d - 7);
            break;
          }
        }
      }
    }, goog.findBasePath_(), goog.protectScriptTag_ = function(a2) {
      return a2.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
    }, goog.DebugLoader_ = function() {
      this.dependencies_ = {};
      this.idToPath_ = {};
      this.written_ = {};
      this.loadingDeps_ = [];
      this.depsToLoad_ = [];
      this.paused_ = false;
      this.factory_ = new goog.DependencyFactory();
      this.deferredCallbacks_ = {};
      this.deferredQueue_ = [];
    }, goog.DebugLoader_.prototype.bootstrap = function(a2, b2) {
      function c() {
        d && (goog.global.setTimeout(d, 0), d = null);
      }
      var d = b2;
      if (a2.length) {
        b2 = [];
        for (var e = 0; e < a2.length; e++) {
          var f = this.getPathFromDeps_(a2[e]);
          if (!f) throw Error("Unregonized namespace: " + a2[e]);
          b2.push(this.dependencies_[f]);
        }
        f = goog.require;
        var g = 0;
        for (e = 0; e < a2.length; e++) f(a2[e]), b2[e].onLoad(function() {
          ++g == a2.length && c();
        });
      } else c();
    }, goog.DebugLoader_.prototype.loadClosureDeps = function() {
      this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + "deps.js"), "deps.js", [], [], {}));
      this.loadDeps_();
    }, goog.DebugLoader_.prototype.requested = function(a2, b2) {
      (a2 = this.getPathFromDeps_(a2)) && (b2 || this.areDepsLoaded_(this.dependencies_[a2].requires)) && (b2 = this.deferredCallbacks_[a2]) && (delete this.deferredCallbacks_[a2], b2());
    }, goog.DebugLoader_.prototype.setDependencyFactory = function(a2) {
      this.factory_ = a2;
    }, goog.DebugLoader_.prototype.load_ = function(a2) {
      if (this.getPathFromDeps_(a2)) {
        var b2 = this, c = [], d = function(e) {
          var f = b2.getPathFromDeps_(e);
          if (!f) throw Error("Bad dependency path or symbol: " + e);
          if (!b2.written_[f]) {
            b2.written_[f] = true;
            e = b2.dependencies_[f];
            for (f = 0; f < e.requires.length; f++) goog.isProvided_(e.requires[f]) || d(e.requires[f]);
            c.push(e);
          }
        };
        d(a2);
        a2 = !!this.depsToLoad_.length;
        this.depsToLoad_ = this.depsToLoad_.concat(c);
        this.paused_ || a2 || this.loadDeps_();
      } else goog.logToConsole_("goog.require could not find: " + a2);
    }, goog.DebugLoader_.prototype.loadDeps_ = function() {
      for (var a2 = this, b2 = this.paused_; this.depsToLoad_.length && !b2; ) (function() {
        var c = false, d = a2.depsToLoad_.shift(), e = false;
        a2.loading_(d);
        var f = { pause: function() {
          if (c) throw Error("Cannot call pause after the call to load.");
          b2 = true;
        }, resume: function() {
          c ? a2.resume_() : b2 = false;
        }, loaded: function() {
          if (e) throw Error("Double call to loaded.");
          e = true;
          a2.loaded_(d);
        }, pending: function() {
          for (var g = [], h = 0; h < a2.loadingDeps_.length; h++) g.push(a2.loadingDeps_[h]);
          return g;
        }, setModuleState: function(g) {
          goog.moduleLoaderState_ = {
            type: g,
            moduleName: "",
            declareLegacyNamespace: false
          };
        }, registerEs6ModuleExports: function(g, h, l) {
          l && (goog.loadedModules_[l] = { exports: h, type: goog.ModuleType.ES6, moduleId: l || "" });
        }, registerGoogModuleExports: function(g, h) {
          goog.loadedModules_[g] = { exports: h, type: goog.ModuleType.GOOG, moduleId: g };
        }, clearModuleState: function() {
          goog.moduleLoaderState_ = null;
        }, defer: function(g) {
          if (c) throw Error("Cannot register with defer after the call to load.");
          a2.defer_(d, g);
        }, areDepsLoaded: function() {
          return a2.areDepsLoaded_(d.requires);
        } };
        try {
          d.load(f);
        } finally {
          c = true;
        }
      })();
      b2 && this.pause_();
    }, goog.DebugLoader_.prototype.pause_ = function() {
      this.paused_ = true;
    }, goog.DebugLoader_.prototype.resume_ = function() {
      this.paused_ && (this.paused_ = false, this.loadDeps_());
    }, goog.DebugLoader_.prototype.loading_ = function(a2) {
      this.loadingDeps_.push(a2);
    }, goog.DebugLoader_.prototype.loaded_ = function(a2) {
      for (var b2 = 0; b2 < this.loadingDeps_.length; b2++) if (this.loadingDeps_[b2] == a2) {
        this.loadingDeps_.splice(b2, 1);
        break;
      }
      for (b2 = 0; b2 < this.deferredQueue_.length; b2++) if (this.deferredQueue_[b2] == a2.path) {
        this.deferredQueue_.splice(b2, 1);
        break;
      }
      if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length) for (; this.deferredQueue_.length; ) this.requested(this.deferredQueue_.shift(), true);
      a2.loaded();
    }, goog.DebugLoader_.prototype.areDepsLoaded_ = function(a2) {
      for (var b2 = 0; b2 < a2.length; b2++) {
        var c = this.getPathFromDeps_(a2[b2]);
        if (!c || !(c in this.deferredCallbacks_ || goog.isProvided_(a2[b2]))) return false;
      }
      return true;
    }, goog.DebugLoader_.prototype.getPathFromDeps_ = function(a2) {
      return a2 in this.idToPath_ ? this.idToPath_[a2] : a2 in this.dependencies_ ? a2 : null;
    }, goog.DebugLoader_.prototype.defer_ = function(a2, b2) {
      this.deferredCallbacks_[a2.path] = b2;
      this.deferredQueue_.push(a2.path);
    }, goog.LoadController = function() {
    }, goog.LoadController.prototype.pause = function() {
    }, goog.LoadController.prototype.resume = function() {
    }, goog.LoadController.prototype.loaded = function() {
    }, goog.LoadController.prototype.pending = function() {
    }, goog.LoadController.prototype.registerEs6ModuleExports = function(a2, b2, c) {
    }, goog.LoadController.prototype.setModuleState = function(a2) {
    }, goog.LoadController.prototype.clearModuleState = function() {
    }, goog.LoadController.prototype.defer = function(a2) {
    }, goog.LoadController.prototype.areDepsLoaded = function() {
    }, goog.Dependency = function(a2, b2, c, d, e) {
      this.path = a2;
      this.relativePath = b2;
      this.provides = c;
      this.requires = d;
      this.loadFlags = e;
      this.loaded_ = false;
      this.loadCallbacks_ = [];
    }, goog.Dependency.prototype.getPathName = function() {
      var a2 = this.path, b2 = a2.indexOf("://");
      0 <= b2 && (a2 = a2.substring(b2 + 3), b2 = a2.indexOf("/"), 0 <= b2 && (a2 = a2.substring(b2 + 1)));
      return a2;
    }, goog.Dependency.prototype.onLoad = function(a2) {
      this.loaded_ ? a2() : this.loadCallbacks_.push(a2);
    }, goog.Dependency.prototype.loaded = function() {
      this.loaded_ = true;
      var a2 = this.loadCallbacks_;
      this.loadCallbacks_ = [];
      for (var b2 = 0; b2 < a2.length; b2++) a2[b2]();
    }, goog.Dependency.defer_ = false, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function(a2) {
      var b2 = Math.random().toString(32);
      goog.Dependency.callbackMap_[b2] = a2;
      return b2;
    }, goog.Dependency.unregisterCallback_ = function(a2) {
      delete goog.Dependency.callbackMap_[a2];
    }, goog.Dependency.callback_ = function(a2, b2) {
      if (a2 in goog.Dependency.callbackMap_) {
        for (var c = goog.Dependency.callbackMap_[a2], d = [], e = 1; e < arguments.length; e++) d.push(arguments[e]);
        c.apply(void 0, d);
      } else throw Error("Callback key " + a2 + " does not exist (was base.js loaded more than once?).");
    }, goog.Dependency.prototype.load = function(a2) {
      if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a2.loaded() : a2.pause();
      else if (goog.inHtmlDocument_()) {
        var b2 = goog.global.document;
        if ("complete" == b2.readyState && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
          if (/\bdeps.js$/.test(this.path)) {
            a2.loaded();
            return;
          }
          throw Error('Cannot write "' + this.path + '" after document load');
        }
        var c = goog.getScriptNonce_();
        if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
          var d = function(h) {
            h.readyState && "complete" != h.readyState ? h.onload = d : (goog.Dependency.unregisterCallback_(e), a2.loaded());
          };
          var e = goog.Dependency.registerCallback_(d);
          c = c ? ' nonce="' + c + '"' : "";
          var f = '<script src="' + this.path + '"' + c + (goog.Dependency.defer_ ? " defer" : "") + ' id="script-' + e + '"><\/script>';
          f += "<script" + c + ">";
          f = goog.Dependency.defer_ ? f + ("document.getElementById('script-" + e + "').onload = function() {\n  goog.Dependency.callback_('" + e + "', this);\n};\n") : f + ("goog.Dependency.callback_('" + e + "', document.getElementById('script-" + e + "'));");
          f += "<\/script>";
          b2.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(f) : f);
        } else {
          var g = b2.createElement("script");
          g.defer = goog.Dependency.defer_;
          g.async = false;
          c && (g.nonce = c);
          g.onload = function() {
            g.onload = null;
            a2.loaded();
          };
          g.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path;
          b2.head.appendChild(g);
        }
      } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), "deps.js" == this.relativePath ? (goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."), a2.loaded()) : a2.pause();
    }, goog.Es6ModuleDependency = function(a2, b2, c, d, e) {
      goog.Dependency.call(
        this,
        a2,
        b2,
        c,
        d,
        e
      );
    }, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function(a2) {
      function b2(k, n) {
        var m = "", p = goog.getScriptNonce_();
        p && (m = ' nonce="' + p + '"');
        k = n ? '<script type="module" crossorigin' + m + ">" + n + "<\/script>" : '<script type="module" crossorigin src="' + k + '"' + m + "><\/script>";
        d.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(k) : k);
      }
      function c(k, n) {
        var m = d.createElement("script");
        m.defer = true;
        m.async = false;
        m.type = "module";
        m.setAttribute(
          "crossorigin",
          true
        );
        var p = goog.getScriptNonce_();
        p && (m.nonce = p);
        n ? m.text = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(n) : n : m.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(k) : k;
        d.head.appendChild(m);
      }
      if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a2.loaded() : a2.pause();
      else if (goog.inHtmlDocument_()) {
        var d = goog.global.document, e = this;
        if (goog.isDocumentLoading_()) {
          var f = b2;
          goog.Dependency.defer_ = true;
        } else f = c;
        var g = goog.Dependency.registerCallback_(function() {
          goog.Dependency.unregisterCallback_(g);
          a2.setModuleState(goog.ModuleType.ES6);
        });
        f(void 0, 'goog.Dependency.callback_("' + g + '")');
        f(this.path, void 0);
        var h = goog.Dependency.registerCallback_(function(k) {
          goog.Dependency.unregisterCallback_(h);
          a2.registerEs6ModuleExports(e.path, k, goog.moduleLoaderState_.moduleName);
        });
        f(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
        var l = goog.Dependency.registerCallback_(function() {
          goog.Dependency.unregisterCallback_(l);
          a2.clearModuleState();
          a2.loaded();
        });
        f(void 0, 'goog.Dependency.callback_("' + l + '")');
      } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), a2.pause();
    }, goog.TransformedDependency = function(a2, b2, c, d, e) {
      goog.Dependency.call(this, a2, b2, c, d, e);
      this.contents_ = null;
      this.lazyFetch_ = !goog.inHtmlDocument_() || !("noModule" in goog.global.document.createElement("script"));
    }, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function(a2) {
      function b2() {
        e.contents_ = goog.loadFileSync_(e.path);
        e.contents_ && (e.contents_ = e.transform(e.contents_), e.contents_ && (e.contents_ += "\n//# sourceURL=" + e.path));
      }
      function c() {
        e.lazyFetch_ && b2();
        if (e.contents_) {
          f && a2.setModuleState(goog.ModuleType.ES6);
          try {
            var k = e.contents_;
            e.contents_ = null;
            goog.globalEval(goog.CLOSURE_EVAL_PREFILTER_.createScript(k));
            if (f) var n = goog.moduleLoaderState_.moduleName;
          } finally {
            f && a2.clearModuleState();
          }
          f && goog.global.$jscomp.require.ensure([e.getPathName()], function() {
            a2.registerEs6ModuleExports(e.path, goog.global.$jscomp.require(e.getPathName()), n);
          });
          a2.loaded();
        }
      }
      function d() {
        var k = goog.global.document, n = goog.Dependency.registerCallback_(function() {
          goog.Dependency.unregisterCallback_(n);
          c();
        }), m = goog.getScriptNonce_();
        m = "<script" + (m ? ' nonce="' + m + '"' : "") + ">" + goog.protectScriptTag_('goog.Dependency.callback_("' + n + '");') + "<\/script>";
        k.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(m) : m);
      }
      var e = this;
      if (goog.global.CLOSURE_IMPORT_SCRIPT) b2(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT("", this.contents_) ? (this.contents_ = null, a2.loaded()) : a2.pause();
      else {
        var f = this.loadFlags.module == goog.ModuleType.ES6;
        this.lazyFetch_ || b2();
        var g = 1 < a2.pending().length;
        if (goog.Dependency.defer_ && (g || goog.isDocumentLoading_())) a2.defer(function() {
          c();
        });
        else {
          var h = goog.global.document;
          g = goog.inHtmlDocument_() && ("ActiveXObject" in goog.global || goog.isEdge_());
          if (f && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !g) {
            goog.Dependency.defer_ = true;
            a2.pause();
            var l = h.onreadystatechange;
            h.onreadystatechange = function() {
              "interactive" == h.readyState && (h.onreadystatechange = l, c(), a2.resume());
              "function" === typeof l && l.apply(void 0, arguments);
            };
          } else goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d() : c();
        }
      }
    }, goog.TransformedDependency.prototype.transform = function(a2) {
    }, goog.PreTranspiledEs6ModuleDependency = function(a2, b2, c, d, e) {
      goog.TransformedDependency.call(this, a2, b2, c, d, e);
    }, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function(a2) {
      return a2;
    }, goog.GoogModuleDependency = function(a2, b2, c, d, e) {
      goog.TransformedDependency.call(this, a2, b2, c, d, e);
    }, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function(a2) {
      return goog.LOAD_MODULE_USING_EVAL && void 0 !== goog.global.JSON ? "goog.loadModule(" + goog.global.JSON.stringify(a2 + "\n//# sourceURL=" + this.path + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + a2 + "\n;return exports});\n//# sourceURL=" + this.path + "\n";
    }, goog.DebugLoader_.prototype.addDependency = function(a2, b2, c, d) {
      b2 = b2 || [];
      a2 = a2.replace(/\\/g, "/");
      var e = goog.normalizePath_(goog.basePath + a2);
      d && "boolean" !== typeof d || (d = d ? { module: goog.ModuleType.GOOG } : {});
      c = this.factory_.createDependency(e, a2, b2, c, d);
      this.dependencies_[e] = c;
      for (c = 0; c < b2.length; c++) this.idToPath_[b2[c]] = e;
      this.idToPath_[a2] = e;
    }, goog.DependencyFactory = function() {
    }, goog.DependencyFactory.prototype.createDependency = function(a2, b2, c, d, e) {
      return e.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(a2, b2, c, d, e) : e.module == goog.ModuleType.ES6 ? goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(a2, b2, c, d, e) : new goog.Es6ModuleDependency(a2, b2, c, d, e) : new goog.Dependency(a2, b2, c, d, e);
    }, goog.debugLoader_ = new goog.DebugLoader_(), goog.loadClosureDeps = function() {
      goog.debugLoader_.loadClosureDeps();
    }, goog.setDependencyFactory = function(a2) {
      goog.debugLoader_.setDependencyFactory(a2);
    }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function(a2, b2) {
      goog.debugLoader_.bootstrap(a2, b2);
    });
    if (!COMPILED) {
      isChrome87 = false;
      try {
        isChrome87 = eval(goog.global.trustedTypes.emptyScript) !== goog.global.trustedTypes.emptyScript;
      } catch (a2) {
      }
      goog.CLOSURE_EVAL_PREFILTER_ = goog.global.trustedTypes && isChrome87 && goog.createTrustedTypesPolicy("goog#base#devonly#eval") || { createScript: goog.identity_ };
    }
    var isChrome87;
    goog.object = {};
    function module$contents$goog$object_forEach(a2, b2, c) {
      for (const d in a2) b2.call(c, a2[d], d, a2);
    }
    function module$contents$goog$object_filter(a2, b2, c) {
      const d = {};
      for (const e in a2) b2.call(c, a2[e], e, a2) && (d[e] = a2[e]);
      return d;
    }
    function module$contents$goog$object_map(a2, b2, c) {
      const d = {};
      for (const e in a2) d[e] = b2.call(c, a2[e], e, a2);
      return d;
    }
    function module$contents$goog$object_some(a2, b2, c) {
      for (const d in a2) if (b2.call(c, a2[d], d, a2)) return true;
      return false;
    }
    function module$contents$goog$object_every(a2, b2, c) {
      for (const d in a2) if (!b2.call(c, a2[d], d, a2)) return false;
      return true;
    }
    function module$contents$goog$object_getCount(a2) {
      let b2 = 0;
      for (const c in a2) b2++;
      return b2;
    }
    function module$contents$goog$object_getAnyKey(a2) {
      for (const b2 in a2) return b2;
    }
    function module$contents$goog$object_getAnyValue(a2) {
      for (const b2 in a2) return a2[b2];
    }
    function module$contents$goog$object_contains(a2, b2) {
      return module$contents$goog$object_containsValue(a2, b2);
    }
    function module$contents$goog$object_getValues(a2) {
      const b2 = [];
      let c = 0;
      for (const d in a2) b2[c++] = a2[d];
      return b2;
    }
    function module$contents$goog$object_getKeys(a2) {
      const b2 = [];
      let c = 0;
      for (const d in a2) b2[c++] = d;
      return b2;
    }
    function module$contents$goog$object_getValueByKeys(a2, b2) {
      var c = goog.isArrayLike(b2);
      const d = c ? b2 : arguments;
      for (c = c ? 0 : 1; c < d.length; c++) {
        if (null == a2) return;
        a2 = a2[d[c]];
      }
      return a2;
    }
    function module$contents$goog$object_containsKey(a2, b2) {
      return null !== a2 && b2 in a2;
    }
    function module$contents$goog$object_containsValue(a2, b2) {
      for (const c in a2) if (a2[c] == b2) return true;
      return false;
    }
    function module$contents$goog$object_findKey(a2, b2, c) {
      for (const d in a2) if (b2.call(c, a2[d], d, a2)) return d;
    }
    function module$contents$goog$object_findValue(a2, b2, c) {
      return (b2 = module$contents$goog$object_findKey(a2, b2, c)) && a2[b2];
    }
    function module$contents$goog$object_isEmpty(a2) {
      for (const b2 in a2) return false;
      return true;
    }
    function module$contents$goog$object_clear(a2) {
      for (const b2 in a2) delete a2[b2];
    }
    function module$contents$goog$object_remove(a2, b2) {
      let c;
      (c = b2 in a2) && delete a2[b2];
      return c;
    }
    function module$contents$goog$object_add(a2, b2, c) {
      if (null !== a2 && b2 in a2) throw Error(`The object already contains the key "${b2}"`);
      module$contents$goog$object_set(a2, b2, c);
    }
    function module$contents$goog$object_get(a2, b2, c) {
      return null !== a2 && b2 in a2 ? a2[b2] : c;
    }
    function module$contents$goog$object_set(a2, b2, c) {
      a2[b2] = c;
    }
    function module$contents$goog$object_setIfUndefined(a2, b2, c) {
      return b2 in a2 ? a2[b2] : a2[b2] = c;
    }
    function module$contents$goog$object_setWithReturnValueIfNotSet(a2, b2, c) {
      if (b2 in a2) return a2[b2];
      c = c();
      return a2[b2] = c;
    }
    function module$contents$goog$object_equals(a2, b2) {
      for (const c in a2) if (!(c in b2) || a2[c] !== b2[c]) return false;
      for (const c in b2) if (!(c in a2)) return false;
      return true;
    }
    function module$contents$goog$object_clone(a2) {
      const b2 = {};
      for (const c in a2) b2[c] = a2[c];
      return b2;
    }
    function module$contents$goog$object_unsafeClone(a2) {
      if (!a2 || "object" !== typeof a2) return a2;
      if ("function" === typeof a2.clone) return a2.clone();
      if ("undefined" !== typeof Map && a2 instanceof Map) return new Map(a2);
      if ("undefined" !== typeof Set && a2 instanceof Set) return new Set(a2);
      if (a2 instanceof Date) return new Date(a2.getTime());
      const b2 = Array.isArray(a2) ? [] : "function" !== typeof ArrayBuffer || "function" !== typeof ArrayBuffer.isView || !ArrayBuffer.isView(a2) || a2 instanceof DataView ? {} : new a2.constructor(a2.length);
      for (const c in a2) b2[c] = module$contents$goog$object_unsafeClone(a2[c]);
      return b2;
    }
    function module$contents$goog$object_transpose(a2) {
      const b2 = {};
      for (const c in a2) b2[a2[c]] = c;
      return b2;
    }
    var module$contents$goog$object_PROTOTYPE_FIELDS = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function module$contents$goog$object_extend(a2, b2) {
      let c, d;
      for (let e = 1; e < arguments.length; e++) {
        d = arguments[e];
        for (c in d) a2[c] = d[c];
        for (let f = 0; f < module$contents$goog$object_PROTOTYPE_FIELDS.length; f++) c = module$contents$goog$object_PROTOTYPE_FIELDS[f], Object.prototype.hasOwnProperty.call(d, c) && (a2[c] = d[c]);
      }
    }
    function module$contents$goog$object_create(a2) {
      const b2 = arguments.length;
      if (1 == b2 && Array.isArray(arguments[0])) return module$contents$goog$object_create.apply(null, arguments[0]);
      if (b2 % 2) throw Error("Uneven number of arguments");
      const c = {};
      for (let d = 0; d < b2; d += 2) c[arguments[d]] = arguments[d + 1];
      return c;
    }
    function module$contents$goog$object_createSet(a2) {
      const b2 = arguments.length;
      if (1 == b2 && Array.isArray(arguments[0])) return module$contents$goog$object_createSet.apply(null, arguments[0]);
      const c = {};
      for (let d = 0; d < b2; d++) c[arguments[d]] = true;
      return c;
    }
    function module$contents$goog$object_createImmutableView(a2) {
      let b2 = a2;
      Object.isFrozen && !Object.isFrozen(a2) && (b2 = Object.create(a2), Object.freeze(b2));
      return b2;
    }
    function module$contents$goog$object_isImmutableView(a2) {
      return !!Object.isFrozen && Object.isFrozen(a2);
    }
    function module$contents$goog$object_getAllPropertyNames(a2, b2, c) {
      if (!a2) return [];
      if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return module$contents$goog$object_getKeys(a2);
      const d = {};
      for (; a2 && (a2 !== Object.prototype || b2) && (a2 !== Function.prototype || c); ) {
        const e = Object.getOwnPropertyNames(a2);
        for (let f = 0; f < e.length; f++) d[e[f]] = true;
        a2 = Object.getPrototypeOf(a2);
      }
      return module$contents$goog$object_getKeys(d);
    }
    function module$contents$goog$object_getSuperClass(a2) {
      return (a2 = Object.getPrototypeOf(a2.prototype)) && a2.constructor;
    }
    goog.object.add = module$contents$goog$object_add;
    goog.object.clear = module$contents$goog$object_clear;
    goog.object.clone = module$contents$goog$object_clone;
    goog.object.contains = module$contents$goog$object_contains;
    goog.object.containsKey = module$contents$goog$object_containsKey;
    goog.object.containsValue = module$contents$goog$object_containsValue;
    goog.object.create = module$contents$goog$object_create;
    goog.object.createImmutableView = module$contents$goog$object_createImmutableView;
    goog.object.createSet = module$contents$goog$object_createSet;
    goog.object.equals = module$contents$goog$object_equals;
    goog.object.every = module$contents$goog$object_every;
    goog.object.extend = module$contents$goog$object_extend;
    goog.object.filter = module$contents$goog$object_filter;
    goog.object.findKey = module$contents$goog$object_findKey;
    goog.object.findValue = module$contents$goog$object_findValue;
    goog.object.forEach = module$contents$goog$object_forEach;
    goog.object.get = module$contents$goog$object_get;
    goog.object.getAllPropertyNames = module$contents$goog$object_getAllPropertyNames;
    goog.object.getAnyKey = module$contents$goog$object_getAnyKey;
    goog.object.getAnyValue = module$contents$goog$object_getAnyValue;
    goog.object.getCount = module$contents$goog$object_getCount;
    goog.object.getKeys = module$contents$goog$object_getKeys;
    goog.object.getSuperClass = module$contents$goog$object_getSuperClass;
    goog.object.getValueByKeys = module$contents$goog$object_getValueByKeys;
    goog.object.getValues = module$contents$goog$object_getValues;
    goog.object.isEmpty = module$contents$goog$object_isEmpty;
    goog.object.isImmutableView = module$contents$goog$object_isImmutableView;
    goog.object.map = module$contents$goog$object_map;
    goog.object.remove = module$contents$goog$object_remove;
    goog.object.set = module$contents$goog$object_set;
    goog.object.setIfUndefined = module$contents$goog$object_setIfUndefined;
    goog.object.setWithReturnValueIfNotSet = module$contents$goog$object_setWithReturnValueIfNotSet;
    goog.object.some = module$contents$goog$object_some;
    goog.object.transpose = module$contents$goog$object_transpose;
    goog.object.unsafeClone = module$contents$goog$object_unsafeClone;
    goog.debug = {};
    function module$contents$goog$debug$Error_DebugError(a2, b2) {
      if (Error.captureStackTrace) Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
      else {
        const c = Error().stack;
        c && (this.stack = c);
      }
      a2 && (this.message = String(a2));
      void 0 !== b2 && (this.cause = b2);
      this.reportErrorToServer = true;
    }
    goog.inherits(module$contents$goog$debug$Error_DebugError, Error);
    module$contents$goog$debug$Error_DebugError.prototype.name = "CustomError";
    goog.debug.Error = module$contents$goog$debug$Error_DebugError;
    goog.dom = {};
    goog.dom.NodeType = { ELEMENT: 1, ATTRIBUTE: 2, TEXT: 3, CDATA_SECTION: 4, ENTITY_REFERENCE: 5, ENTITY: 6, PROCESSING_INSTRUCTION: 7, COMMENT: 8, DOCUMENT: 9, DOCUMENT_TYPE: 10, DOCUMENT_FRAGMENT: 11, NOTATION: 12 };
    goog.asserts = {};
    goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
    function module$contents$goog$asserts_AssertionError(a2, b2) {
      module$contents$goog$debug$Error_DebugError.call(this, module$contents$goog$asserts_subs(a2, b2));
      this.messagePattern = a2;
    }
    goog.inherits(module$contents$goog$asserts_AssertionError, module$contents$goog$debug$Error_DebugError);
    goog.asserts.AssertionError = module$contents$goog$asserts_AssertionError;
    module$contents$goog$asserts_AssertionError.prototype.name = "AssertionError";
    goog.asserts.DEFAULT_ERROR_HANDLER = function(a2) {
      throw a2;
    };
    var module$contents$goog$asserts_errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
    function module$contents$goog$asserts_subs(a2, b2) {
      a2 = a2.split("%s");
      let c = "";
      const d = a2.length - 1;
      for (let e = 0; e < d; e++) c += a2[e] + (e < b2.length ? b2[e] : "%s");
      return c + a2[d];
    }
    function module$contents$goog$asserts_doAssertFailure(a2, b2, c, d) {
      let e = "Assertion failed", f;
      c ? (e += ": " + c, f = d) : a2 && (e += ": " + a2, f = b2);
      a2 = new module$contents$goog$asserts_AssertionError("" + e, f || []);
      module$contents$goog$asserts_errorHandler_(a2);
    }
    goog.asserts.setErrorHandler = function(a2) {
      goog.asserts.ENABLE_ASSERTS && (module$contents$goog$asserts_errorHandler_ = a2);
    };
    goog.asserts.assert = function(a2, b2, c) {
      goog.asserts.ENABLE_ASSERTS && !a2 && module$contents$goog$asserts_doAssertFailure("", null, b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.assertExists = function(a2, b2, c) {
      goog.asserts.ENABLE_ASSERTS && null == a2 && module$contents$goog$asserts_doAssertFailure("Expected to exist: %s.", [a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.fail = function(a2, b2) {
      goog.asserts.ENABLE_ASSERTS && module$contents$goog$asserts_errorHandler_(new module$contents$goog$asserts_AssertionError("Failure" + (a2 ? ": " + a2 : ""), Array.prototype.slice.call(arguments, 1)));
    };
    goog.asserts.assertNumber = function(a2, b2, c) {
      goog.asserts.ENABLE_ASSERTS && "number" !== typeof a2 && module$contents$goog$asserts_doAssertFailure("Expected number but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.assertString = function(a2, b2, c) {
      goog.asserts.ENABLE_ASSERTS && "string" !== typeof a2 && module$contents$goog$asserts_doAssertFailure("Expected string but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.assertFunction = function(a2, b2, c) {
      goog.asserts.ENABLE_ASSERTS && "function" !== typeof a2 && module$contents$goog$asserts_doAssertFailure("Expected function but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.assertObject = function(a2, b2, c) {
      goog.asserts.ENABLE_ASSERTS && !goog.isObject(a2) && module$contents$goog$asserts_doAssertFailure("Expected object but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.assertArray = function(a2, b2, c) {
      goog.asserts.ENABLE_ASSERTS && !Array.isArray(a2) && module$contents$goog$asserts_doAssertFailure("Expected array but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.assertBoolean = function(a2, b2, c) {
      goog.asserts.ENABLE_ASSERTS && "boolean" !== typeof a2 && module$contents$goog$asserts_doAssertFailure("Expected boolean but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.assertElement = function(a2, b2, c) {
      !goog.asserts.ENABLE_ASSERTS || goog.isObject(a2) && a2.nodeType == goog.dom.NodeType.ELEMENT || module$contents$goog$asserts_doAssertFailure("Expected Element but got %s: %s.", [goog.typeOf(a2), a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    goog.asserts.assertInstanceof = function(a2, b2, c, d) {
      !goog.asserts.ENABLE_ASSERTS || a2 instanceof b2 || module$contents$goog$asserts_doAssertFailure("Expected instanceof %s but got %s.", [module$contents$goog$asserts_getType(b2), module$contents$goog$asserts_getType(a2)], c, Array.prototype.slice.call(arguments, 3));
      return a2;
    };
    goog.asserts.assertFinite = function(a2, b2, c) {
      !goog.asserts.ENABLE_ASSERTS || "number" == typeof a2 && isFinite(a2) || module$contents$goog$asserts_doAssertFailure("Expected %s to be a finite number but it is not.", [a2], b2, Array.prototype.slice.call(arguments, 2));
      return a2;
    };
    function module$contents$goog$asserts_getType(a2) {
      return a2 instanceof Function ? a2.displayName || a2.name || "unknown type name" : a2 instanceof Object ? a2.constructor.displayName || a2.constructor.name || Object.prototype.toString.call(a2) : null === a2 ? "null" : typeof a2;
    }
    goog.array = {};
    goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
    var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
    goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
    function module$contents$goog$array_peek(a2) {
      return a2[a2.length - 1];
    }
    goog.array.peek = module$contents$goog$array_peek;
    goog.array.last = module$contents$goog$array_peek;
    var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a2, b2, c) {
      goog.asserts.assert(null != a2.length);
      return Array.prototype.indexOf.call(a2, b2, c);
    } : function(a2, b2, c) {
      c = null == c ? 0 : 0 > c ? Math.max(0, a2.length + c) : c;
      if ("string" === typeof a2) return "string" !== typeof b2 || 1 != b2.length ? -1 : a2.indexOf(b2, c);
      for (; c < a2.length; c++) if (c in a2 && a2[c] === b2) return c;
      return -1;
    };
    goog.array.indexOf = module$contents$goog$array_indexOf;
    var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a2, b2, c) {
      goog.asserts.assert(null != a2.length);
      return Array.prototype.lastIndexOf.call(a2, b2, null == c ? a2.length - 1 : c);
    } : function(a2, b2, c) {
      c = null == c ? a2.length - 1 : c;
      0 > c && (c = Math.max(0, a2.length + c));
      if ("string" === typeof a2) return "string" !== typeof b2 || 1 != b2.length ? -1 : a2.lastIndexOf(b2, c);
      for (; 0 <= c; c--) if (c in a2 && a2[c] === b2) return c;
      return -1;
    };
    goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
    var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a2, b2, c) {
      goog.asserts.assert(null != a2.length);
      Array.prototype.forEach.call(a2, b2, c);
    } : function(a2, b2, c) {
      const d = a2.length, e = "string" === typeof a2 ? a2.split("") : a2;
      for (let f = 0; f < d; f++) f in e && b2.call(c, e[f], f, a2);
    };
    goog.array.forEach = module$contents$goog$array_forEach;
    function module$contents$goog$array_forEachRight(a2, b2, c) {
      var d = a2.length;
      const e = "string" === typeof a2 ? a2.split("") : a2;
      for (--d; 0 <= d; --d) d in e && b2.call(c, e[d], d, a2);
    }
    goog.array.forEachRight = module$contents$goog$array_forEachRight;
    var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a2, b2, c) {
      goog.asserts.assert(null != a2.length);
      return Array.prototype.filter.call(a2, b2, c);
    } : function(a2, b2, c) {
      const d = a2.length, e = [];
      let f = 0;
      const g = "string" === typeof a2 ? a2.split("") : a2;
      for (let h = 0; h < d; h++) if (h in g) {
        const l = g[h];
        b2.call(c, l, h, a2) && (e[f++] = l);
      }
      return e;
    };
    goog.array.filter = module$contents$goog$array_filter;
    var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a2, b2, c) {
      goog.asserts.assert(null != a2.length);
      return Array.prototype.map.call(a2, b2, c);
    } : function(a2, b2, c) {
      const d = a2.length, e = Array(d), f = "string" === typeof a2 ? a2.split("") : a2;
      for (let g = 0; g < d; g++) g in f && (e[g] = b2.call(c, f[g], g, a2));
      return e;
    };
    goog.array.map = module$contents$goog$array_map;
    var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a2, b2, c, d) {
      goog.asserts.assert(null != a2.length);
      d && (b2 = goog.bind(b2, d));
      return Array.prototype.reduce.call(a2, b2, c);
    } : function(a2, b2, c, d) {
      let e = c;
      module$contents$goog$array_forEach(a2, function(f, g) {
        e = b2.call(d, e, f, g, a2);
      });
      return e;
    };
    goog.array.reduce = module$contents$goog$array_reduce;
    var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a2, b2, c, d) {
      goog.asserts.assert(null != a2.length);
      goog.asserts.assert(null != b2);
      d && (b2 = goog.bind(b2, d));
      return Array.prototype.reduceRight.call(a2, b2, c);
    } : function(a2, b2, c, d) {
      let e = c;
      module$contents$goog$array_forEachRight(a2, function(f, g) {
        e = b2.call(d, e, f, g, a2);
      });
      return e;
    };
    goog.array.reduceRight = module$contents$goog$array_reduceRight;
    var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a2, b2, c) {
      goog.asserts.assert(null != a2.length);
      return Array.prototype.some.call(a2, b2, c);
    } : function(a2, b2, c) {
      const d = a2.length, e = "string" === typeof a2 ? a2.split("") : a2;
      for (let f = 0; f < d; f++) if (f in e && b2.call(c, e[f], f, a2)) return true;
      return false;
    };
    goog.array.some = module$contents$goog$array_some;
    var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a2, b2, c) {
      goog.asserts.assert(null != a2.length);
      return Array.prototype.every.call(a2, b2, c);
    } : function(a2, b2, c) {
      const d = a2.length, e = "string" === typeof a2 ? a2.split("") : a2;
      for (let f = 0; f < d; f++) if (f in e && !b2.call(c, e[f], f, a2)) return false;
      return true;
    };
    goog.array.every = module$contents$goog$array_every;
    function module$contents$goog$array_count(a2, b2, c) {
      let d = 0;
      module$contents$goog$array_forEach(a2, function(e, f, g) {
        b2.call(c, e, f, g) && ++d;
      }, c);
      return d;
    }
    goog.array.count = module$contents$goog$array_count;
    function module$contents$goog$array_find(a2, b2, c) {
      b2 = module$contents$goog$array_findIndex(a2, b2, c);
      return 0 > b2 ? null : "string" === typeof a2 ? a2.charAt(b2) : a2[b2];
    }
    goog.array.find = module$contents$goog$array_find;
    function module$contents$goog$array_findIndex(a2, b2, c) {
      const d = a2.length, e = "string" === typeof a2 ? a2.split("") : a2;
      for (let f = 0; f < d; f++) if (f in e && b2.call(c, e[f], f, a2)) return f;
      return -1;
    }
    goog.array.findIndex = module$contents$goog$array_findIndex;
    function module$contents$goog$array_findRight(a2, b2, c) {
      b2 = module$contents$goog$array_findIndexRight(a2, b2, c);
      return 0 > b2 ? null : "string" === typeof a2 ? a2.charAt(b2) : a2[b2];
    }
    goog.array.findRight = module$contents$goog$array_findRight;
    function module$contents$goog$array_findIndexRight(a2, b2, c) {
      var d = a2.length;
      const e = "string" === typeof a2 ? a2.split("") : a2;
      for (--d; 0 <= d; d--) if (d in e && b2.call(c, e[d], d, a2)) return d;
      return -1;
    }
    goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
    function module$contents$goog$array_contains(a2, b2) {
      return 0 <= module$contents$goog$array_indexOf(a2, b2);
    }
    goog.array.contains = module$contents$goog$array_contains;
    function module$contents$goog$array_isEmpty(a2) {
      return 0 == a2.length;
    }
    goog.array.isEmpty = module$contents$goog$array_isEmpty;
    function module$contents$goog$array_clear(a2) {
      if (!Array.isArray(a2)) for (let b2 = a2.length - 1; 0 <= b2; b2--) delete a2[b2];
      a2.length = 0;
    }
    goog.array.clear = module$contents$goog$array_clear;
    function module$contents$goog$array_insert(a2, b2) {
      module$contents$goog$array_contains(a2, b2) || a2.push(b2);
    }
    goog.array.insert = module$contents$goog$array_insert;
    function module$contents$goog$array_insertAt(a2, b2, c) {
      module$contents$goog$array_splice(a2, c, 0, b2);
    }
    goog.array.insertAt = module$contents$goog$array_insertAt;
    function module$contents$goog$array_insertArrayAt(a2, b2, c) {
      goog.partial(module$contents$goog$array_splice, a2, c, 0).apply(null, b2);
    }
    goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
    function module$contents$goog$array_insertBefore(a2, b2, c) {
      let d;
      2 == arguments.length || 0 > (d = module$contents$goog$array_indexOf(a2, c)) ? a2.push(b2) : module$contents$goog$array_insertAt(a2, b2, d);
    }
    goog.array.insertBefore = module$contents$goog$array_insertBefore;
    function module$contents$goog$array_remove(a2, b2) {
      b2 = module$contents$goog$array_indexOf(a2, b2);
      let c;
      (c = 0 <= b2) && module$contents$goog$array_removeAt(a2, b2);
      return c;
    }
    goog.array.remove = module$contents$goog$array_remove;
    function module$contents$goog$array_removeLast(a2, b2) {
      b2 = module$contents$goog$array_lastIndexOf(a2, b2);
      return 0 <= b2 ? (module$contents$goog$array_removeAt(a2, b2), true) : false;
    }
    goog.array.removeLast = module$contents$goog$array_removeLast;
    function module$contents$goog$array_removeAt(a2, b2) {
      goog.asserts.assert(null != a2.length);
      return 1 == Array.prototype.splice.call(a2, b2, 1).length;
    }
    goog.array.removeAt = module$contents$goog$array_removeAt;
    function module$contents$goog$array_removeIf(a2, b2, c) {
      b2 = module$contents$goog$array_findIndex(a2, b2, c);
      return 0 <= b2 ? (module$contents$goog$array_removeAt(a2, b2), true) : false;
    }
    goog.array.removeIf = module$contents$goog$array_removeIf;
    function module$contents$goog$array_removeAllIf(a2, b2, c) {
      let d = 0;
      module$contents$goog$array_forEachRight(a2, function(e, f) {
        b2.call(c, e, f, a2) && module$contents$goog$array_removeAt(a2, f) && d++;
      });
      return d;
    }
    goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
    function module$contents$goog$array_concat(a2) {
      return Array.prototype.concat.apply([], arguments);
    }
    goog.array.concat = module$contents$goog$array_concat;
    function module$contents$goog$array_join(a2) {
      return Array.prototype.concat.apply([], arguments);
    }
    goog.array.join = module$contents$goog$array_join;
    function module$contents$goog$array_toArray(a2) {
      const b2 = a2.length;
      if (0 < b2) {
        const c = Array(b2);
        for (let d = 0; d < b2; d++) c[d] = a2[d];
        return c;
      }
      return [];
    }
    var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
    goog.array.clone = module$contents$goog$array_toArray;
    function module$contents$goog$array_extend(a2, b2) {
      for (let c = 1; c < arguments.length; c++) {
        const d = arguments[c];
        if (goog.isArrayLike(d)) {
          const e = a2.length || 0, f = d.length || 0;
          a2.length = e + f;
          for (let g = 0; g < f; g++) a2[e + g] = d[g];
        } else a2.push(d);
      }
    }
    goog.array.extend = module$contents$goog$array_extend;
    function module$contents$goog$array_splice(a2, b2, c, d) {
      goog.asserts.assert(null != a2.length);
      return Array.prototype.splice.apply(a2, module$contents$goog$array_slice(arguments, 1));
    }
    goog.array.splice = module$contents$goog$array_splice;
    function module$contents$goog$array_slice(a2, b2, c) {
      goog.asserts.assert(null != a2.length);
      return 2 >= arguments.length ? Array.prototype.slice.call(a2, b2) : Array.prototype.slice.call(a2, b2, c);
    }
    goog.array.slice = module$contents$goog$array_slice;
    function module$contents$goog$array_removeDuplicates(a2, b2, c) {
      b2 = b2 || a2;
      var d = function(g) {
        return goog.isObject(g) ? "o" + goog.getUid(g) : (typeof g).charAt(0) + g;
      };
      c = c || d;
      let e = d = 0;
      const f = {};
      for (; e < a2.length; ) {
        const g = a2[e++], h = c(g);
        Object.prototype.hasOwnProperty.call(f, h) || (f[h] = true, b2[d++] = g);
      }
      b2.length = d;
    }
    goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
    function module$contents$goog$array_binarySearch(a2, b2, c) {
      return module$contents$goog$array_binarySearch_(a2, c || module$contents$goog$array_defaultCompare, false, b2);
    }
    goog.array.binarySearch = module$contents$goog$array_binarySearch;
    function module$contents$goog$array_binarySelect(a2, b2, c) {
      return module$contents$goog$array_binarySearch_(a2, b2, true, void 0, c);
    }
    goog.array.binarySelect = module$contents$goog$array_binarySelect;
    function module$contents$goog$array_binarySearch_(a2, b2, c, d, e) {
      let f = 0, g = a2.length, h;
      for (; f < g; ) {
        const l = f + (g - f >>> 1);
        let k;
        k = c ? b2.call(e, a2[l], l, a2) : b2(d, a2[l]);
        0 < k ? f = l + 1 : (g = l, h = !k);
      }
      return h ? f : -f - 1;
    }
    function module$contents$goog$array_sort(a2, b2) {
      a2.sort(b2 || module$contents$goog$array_defaultCompare);
    }
    goog.array.sort = module$contents$goog$array_sort;
    function module$contents$goog$array_stableSort(a2, b2) {
      const c = Array(a2.length);
      for (let e = 0; e < a2.length; e++) c[e] = { index: e, value: a2[e] };
      const d = b2 || module$contents$goog$array_defaultCompare;
      module$contents$goog$array_sort(c, function(e, f) {
        return d(e.value, f.value) || e.index - f.index;
      });
      for (b2 = 0; b2 < a2.length; b2++) a2[b2] = c[b2].value;
    }
    goog.array.stableSort = module$contents$goog$array_stableSort;
    function module$contents$goog$array_sortByKey(a2, b2, c) {
      const d = c || module$contents$goog$array_defaultCompare;
      module$contents$goog$array_sort(a2, function(e, f) {
        return d(b2(e), b2(f));
      });
    }
    goog.array.sortByKey = module$contents$goog$array_sortByKey;
    function module$contents$goog$array_sortObjectsByKey(a2, b2, c) {
      module$contents$goog$array_sortByKey(a2, function(d) {
        return d[b2];
      }, c);
    }
    goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
    function module$contents$goog$array_isSorted(a2, b2, c) {
      b2 = b2 || module$contents$goog$array_defaultCompare;
      for (let d = 1; d < a2.length; d++) {
        const e = b2(a2[d - 1], a2[d]);
        if (0 < e || 0 == e && c) return false;
      }
      return true;
    }
    goog.array.isSorted = module$contents$goog$array_isSorted;
    function module$contents$goog$array_equals(a2, b2, c) {
      if (!goog.isArrayLike(a2) || !goog.isArrayLike(b2) || a2.length != b2.length) return false;
      const d = a2.length;
      c = c || module$contents$goog$array_defaultCompareEquality;
      for (let e = 0; e < d; e++) if (!c(a2[e], b2[e])) return false;
      return true;
    }
    goog.array.equals = module$contents$goog$array_equals;
    function module$contents$goog$array_compare3(a2, b2, c) {
      c = c || module$contents$goog$array_defaultCompare;
      const d = Math.min(a2.length, b2.length);
      for (let e = 0; e < d; e++) {
        const f = c(a2[e], b2[e]);
        if (0 != f) return f;
      }
      return module$contents$goog$array_defaultCompare(a2.length, b2.length);
    }
    goog.array.compare3 = module$contents$goog$array_compare3;
    function module$contents$goog$array_defaultCompare(a2, b2) {
      return a2 > b2 ? 1 : a2 < b2 ? -1 : 0;
    }
    goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
    function module$contents$goog$array_inverseDefaultCompare(a2, b2) {
      return -module$contents$goog$array_defaultCompare(a2, b2);
    }
    goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
    function module$contents$goog$array_defaultCompareEquality(a2, b2) {
      return a2 === b2;
    }
    goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
    function module$contents$goog$array_binaryInsert(a2, b2, c) {
      c = module$contents$goog$array_binarySearch(a2, b2, c);
      return 0 > c ? (module$contents$goog$array_insertAt(a2, b2, -(c + 1)), true) : false;
    }
    goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
    function module$contents$goog$array_binaryRemove(a2, b2, c) {
      b2 = module$contents$goog$array_binarySearch(a2, b2, c);
      return 0 <= b2 ? module$contents$goog$array_removeAt(a2, b2) : false;
    }
    goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
    function module$contents$goog$array_bucket(a2, b2, c) {
      const d = {};
      for (let e = 0; e < a2.length; e++) {
        const f = a2[e], g = b2.call(c, f, e, a2);
        void 0 !== g && (d[g] || (d[g] = [])).push(f);
      }
      return d;
    }
    goog.array.bucket = module$contents$goog$array_bucket;
    function module$contents$goog$array_bucketToMap(a2, b2) {
      const c = /* @__PURE__ */ new Map();
      for (let d = 0; d < a2.length; d++) {
        const e = a2[d], f = b2(e, d, a2);
        if (void 0 !== f) {
          let g = c.get(f);
          g || (g = [], c.set(f, g));
          g.push(e);
        }
      }
      return c;
    }
    goog.array.bucketToMap = module$contents$goog$array_bucketToMap;
    function module$contents$goog$array_toObject(a2, b2, c) {
      const d = {};
      module$contents$goog$array_forEach(a2, function(e, f) {
        d[b2.call(c, e, f, a2)] = e;
      });
      return d;
    }
    goog.array.toObject = module$contents$goog$array_toObject;
    function module$contents$goog$array_toMap(a2, b2) {
      const c = /* @__PURE__ */ new Map();
      for (let d = 0; d < a2.length; d++) {
        const e = a2[d];
        c.set(b2(e, d, a2), e);
      }
      return c;
    }
    goog.array.toMap = module$contents$goog$array_toMap;
    function module$contents$goog$array_range(a2, b2, c) {
      const d = [];
      let e = 0, f = a2;
      c = c || 1;
      void 0 !== b2 && (e = a2, f = b2);
      if (0 > c * (f - e)) return [];
      if (0 < c) for (a2 = e; a2 < f; a2 += c) d.push(a2);
      else for (a2 = e; a2 > f; a2 += c) d.push(a2);
      return d;
    }
    goog.array.range = module$contents$goog$array_range;
    function module$contents$goog$array_repeat(a2, b2) {
      const c = [];
      for (let d = 0; d < b2; d++) c[d] = a2;
      return c;
    }
    goog.array.repeat = module$contents$goog$array_repeat;
    function module$contents$goog$array_flatten(a2) {
      const b2 = [];
      for (let d = 0; d < arguments.length; d++) {
        const e = arguments[d];
        if (Array.isArray(e)) for (let f = 0; f < e.length; f += 8192) {
          var c = module$contents$goog$array_slice(e, f, f + 8192);
          c = module$contents$goog$array_flatten.apply(null, c);
          for (let g = 0; g < c.length; g++) b2.push(c[g]);
        }
        else b2.push(e);
      }
      return b2;
    }
    goog.array.flatten = module$contents$goog$array_flatten;
    function module$contents$goog$array_rotate(a2, b2) {
      goog.asserts.assert(null != a2.length);
      a2.length && (b2 %= a2.length, 0 < b2 ? Array.prototype.unshift.apply(a2, a2.splice(-b2, b2)) : 0 > b2 && Array.prototype.push.apply(a2, a2.splice(0, -b2)));
      return a2;
    }
    goog.array.rotate = module$contents$goog$array_rotate;
    function module$contents$goog$array_moveItem(a2, b2, c) {
      goog.asserts.assert(0 <= b2 && b2 < a2.length);
      goog.asserts.assert(0 <= c && c < a2.length);
      b2 = Array.prototype.splice.call(a2, b2, 1);
      Array.prototype.splice.call(a2, c, 0, b2[0]);
    }
    goog.array.moveItem = module$contents$goog$array_moveItem;
    function module$contents$goog$array_zip(a2) {
      if (!arguments.length) return [];
      const b2 = [];
      let c = arguments[0].length;
      for (var d = 1; d < arguments.length; d++) arguments[d].length < c && (c = arguments[d].length);
      for (d = 0; d < c; d++) {
        const e = [];
        for (let f = 0; f < arguments.length; f++) e.push(arguments[f][d]);
        b2.push(e);
      }
      return b2;
    }
    goog.array.zip = module$contents$goog$array_zip;
    function module$contents$goog$array_shuffle(a2, b2) {
      b2 = b2 || Math.random;
      for (let c = a2.length - 1; 0 < c; c--) {
        const d = Math.floor(b2() * (c + 1)), e = a2[c];
        a2[c] = a2[d];
        a2[d] = e;
      }
    }
    goog.array.shuffle = module$contents$goog$array_shuffle;
    function module$contents$goog$array_copyByIndex(a2, b2) {
      const c = [];
      module$contents$goog$array_forEach(b2, function(d) {
        c.push(a2[d]);
      });
      return c;
    }
    goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
    function module$contents$goog$array_concatMap(a2, b2, c) {
      return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(a2, b2, c));
    }
    goog.array.concatMap = module$contents$goog$array_concatMap;
    var jspb = { asserts: {} };
    function module$contents$jspb$asserts_doAssertFailure(a2, b2, c, d) {
      let e = "Assertion failed", f;
      c ? (e += ": " + c, f = d) : a2 && (e += ": " + a2, f = b2);
      throw Error("" + e, f || []);
    }
    function module$contents$jspb$asserts_assert(a2, b2, ...c) {
      a2 || module$contents$jspb$asserts_doAssertFailure("", null, b2, c);
      return a2;
    }
    function module$contents$jspb$asserts_assertString(a2, b2, ...c) {
      "string" !== typeof a2 && module$contents$jspb$asserts_doAssertFailure("Expected string but got %s: %s.", [goog.typeOf(a2), a2], b2, c);
      return a2;
    }
    function module$contents$jspb$asserts_assertArray(a2, b2, ...c) {
      Array.isArray(a2) || module$contents$jspb$asserts_doAssertFailure("Expected array but got %s: %s.", [goog.typeOf(a2), a2], b2, c);
      return a2;
    }
    function module$contents$jspb$asserts_fail(a2, ...b2) {
      throw Error("Failure" + (a2 ? ": " + a2 : ""), b2);
    }
    function module$contents$jspb$asserts_assertInstanceof(a2, b2, c, ...d) {
      a2 instanceof b2 || module$contents$jspb$asserts_doAssertFailure("Expected instanceof %s but got %s.", [module$contents$jspb$asserts_getType(b2), module$contents$jspb$asserts_getType(a2)], c, d);
      return a2;
    }
    function module$contents$jspb$asserts_getType(a2) {
      return a2 instanceof Function ? a2.displayName || a2.name || "unknown type name" : a2 instanceof Object ? a2.constructor.displayName || a2.constructor.name || Object.prototype.toString.call(a2) : null === a2 ? "null" : typeof a2;
    }
    jspb.asserts.doAssertFailure = module$contents$jspb$asserts_doAssertFailure;
    jspb.asserts.assert = module$contents$jspb$asserts_assert;
    jspb.asserts.assertString = module$contents$jspb$asserts_assertString;
    jspb.asserts.assertArray = module$contents$jspb$asserts_assertArray;
    jspb.asserts.fail = module$contents$jspb$asserts_fail;
    jspb.asserts.assertInstanceof = module$contents$jspb$asserts_assertInstanceof;
    jspb.asserts.getType = module$contents$jspb$asserts_getType;
    var module$contents$jspb$Map_Map = function(a2, b2) {
      this.arr_ = a2;
      this.valueCtor_ = b2;
      this.map_ = {};
      this.arrClean = true;
      0 < this.arr_.length && this.loadFromArray_();
    };
    var module$contents$jspb$Map_Entry_ = function(a2, b2) {
      this.key = a2;
      this.value = b2;
      this.valueWrapper = void 0;
    };
    module$contents$jspb$Map_Map.prototype.loadFromArray_ = function() {
      for (var a2 = 0; a2 < this.arr_.length; a2++) {
        var b2 = this.arr_[a2], c = b2[0];
        this.map_[c.toString()] = new module$contents$jspb$Map_Entry_(c, b2[1]);
      }
      this.arrClean = true;
    };
    module$contents$jspb$Map_Map.prototype.toArray = function() {
      if (this.arrClean) {
        if (this.valueCtor_) {
          var a2 = this.map_, b2;
          for (b2 in a2) if (Object.prototype.hasOwnProperty.call(a2, b2)) {
            var c = a2[b2].valueWrapper;
            c && c.toArray();
          }
        }
      } else {
        this.arr_.length = 0;
        a2 = this.stringKeys_();
        a2.sort();
        for (b2 = 0; b2 < a2.length; b2++) {
          var d = this.map_[a2[b2]];
          (c = d.valueWrapper) && c.toArray();
          this.arr_.push([d.key, d.value]);
        }
        this.arrClean = true;
      }
      return this.arr_;
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "toArray", module$contents$jspb$Map_Map.prototype.toArray);
    module$contents$jspb$Map_Map.prototype.toObject = function(a2, b2) {
      for (var c = this.toArray(), d = [], e = 0; e < c.length; e++) {
        var f = this.map_[c[e][0].toString()];
        this.wrapEntry_(f);
        var g = f.valueWrapper;
        g ? (module$contents$jspb$asserts_assert(b2), d.push([f.key, b2(a2, g)])) : d.push([f.key, f.value]);
      }
      return d;
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "toObject", module$contents$jspb$Map_Map.prototype.toObject);
    module$contents$jspb$Map_Map.fromObject = function(a2, b2, c) {
      b2 = new module$contents$jspb$Map_Map([], b2);
      for (var d = 0; d < a2.length; d++) {
        var e = a2[d][0], f = c(a2[d][1]);
        b2.set(e, f);
      }
      return b2;
    };
    goog.exportSymbol("module$contents$jspb$Map_Map.fromObject", module$contents$jspb$Map_Map.fromObject);
    var module$contents$jspb$Map_ArrayIteratorIterable_ = function(a2) {
      this.idx_ = 0;
      this.arr_ = a2;
    };
    module$contents$jspb$Map_ArrayIteratorIterable_.prototype.next = function() {
      return this.idx_ < this.arr_.length ? { done: false, value: this.arr_[this.idx_++] } : { done: true, value: void 0 };
    };
    "undefined" != typeof Symbol && (module$contents$jspb$Map_ArrayIteratorIterable_.prototype[Symbol.iterator] = function() {
      return this;
    });
    module$contents$jspb$Map_Map.prototype.getLength = function() {
      return this.stringKeys_().length;
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "getLength", module$contents$jspb$Map_Map.prototype.getLength);
    module$contents$jspb$Map_Map.prototype.clear = function() {
      this.map_ = {};
      this.arrClean = false;
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "clear", module$contents$jspb$Map_Map.prototype.clear);
    module$contents$jspb$Map_Map.prototype.del = function(a2) {
      a2 = a2.toString();
      var b2 = this.map_.hasOwnProperty(a2);
      delete this.map_[a2];
      this.arrClean = false;
      return b2;
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "del", module$contents$jspb$Map_Map.prototype.del);
    module$contents$jspb$Map_Map.prototype.getEntryList = function() {
      var a2 = [], b2 = this.stringKeys_();
      b2.sort();
      for (var c = 0; c < b2.length; c++) {
        var d = this.map_[b2[c]];
        a2.push([d.key, d.value]);
      }
      return a2;
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "getEntryList", module$contents$jspb$Map_Map.prototype.getEntryList);
    module$contents$jspb$Map_Map.prototype.entries = function() {
      var a2 = [], b2 = this.stringKeys_();
      b2.sort();
      for (var c = 0; c < b2.length; c++) {
        var d = this.map_[b2[c]];
        a2.push([d.key, this.wrapEntry_(d)]);
      }
      return new module$contents$jspb$Map_ArrayIteratorIterable_(a2);
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "entries", module$contents$jspb$Map_Map.prototype.entries);
    module$contents$jspb$Map_Map.prototype.keys = function() {
      var a2 = [], b2 = this.stringKeys_();
      b2.sort();
      for (var c = 0; c < b2.length; c++) a2.push(this.map_[b2[c]].key);
      return new module$contents$jspb$Map_ArrayIteratorIterable_(a2);
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "keys", module$contents$jspb$Map_Map.prototype.keys);
    module$contents$jspb$Map_Map.prototype.values = function() {
      var a2 = [], b2 = this.stringKeys_();
      b2.sort();
      for (var c = 0; c < b2.length; c++) a2.push(this.wrapEntry_(this.map_[b2[c]]));
      return new module$contents$jspb$Map_ArrayIteratorIterable_(a2);
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "values", module$contents$jspb$Map_Map.prototype.values);
    module$contents$jspb$Map_Map.prototype.forEach = function(a2, b2) {
      var c = this.stringKeys_();
      c.sort();
      for (var d = 0; d < c.length; d++) {
        var e = this.map_[c[d]];
        a2.call(b2, this.wrapEntry_(e), e.key, this);
      }
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "forEach", module$contents$jspb$Map_Map.prototype.forEach);
    module$contents$jspb$Map_Map.prototype.set = function(a2, b2) {
      var c = new module$contents$jspb$Map_Entry_(a2);
      this.valueCtor_ ? (c.valueWrapper = b2, c.value = b2.toArray()) : c.value = b2;
      this.map_[a2.toString()] = c;
      this.arrClean = false;
      return this;
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "set", module$contents$jspb$Map_Map.prototype.set);
    module$contents$jspb$Map_Map.prototype.wrapEntry_ = function(a2) {
      return this.valueCtor_ ? (a2.valueWrapper || (a2.valueWrapper = new this.valueCtor_(a2.value)), a2.valueWrapper) : a2.value;
    };
    module$contents$jspb$Map_Map.prototype.get = function(a2) {
      if (a2 = this.map_[a2.toString()]) return this.wrapEntry_(a2);
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "get", module$contents$jspb$Map_Map.prototype.get);
    module$contents$jspb$Map_Map.prototype.has = function(a2) {
      return a2.toString() in this.map_;
    };
    goog.exportProperty(module$contents$jspb$Map_Map.prototype, "has", module$contents$jspb$Map_Map.prototype.has);
    module$contents$jspb$Map_Map.deserializeBinary = function(a2, b2, c, d, e, f, g) {
      for (; b2.nextField() && !b2.isEndGroup(); ) {
        var h = b2.getFieldNumber();
        1 == h ? f = c.call(b2) : 2 == h && (a2.valueCtor_ ? (module$contents$jspb$asserts_assert(e), g ||= new a2.valueCtor_(), d.call(b2, g, e)) : g = d.call(b2));
      }
      module$contents$jspb$asserts_assert(void 0 != f);
      module$contents$jspb$asserts_assert(void 0 != g);
      a2.set(f, g);
    };
    goog.exportSymbol("module$contents$jspb$Map_Map.deserializeBinary", module$contents$jspb$Map_Map.deserializeBinary);
    module$contents$jspb$Map_Map.prototype.stringKeys_ = function() {
      var a2 = this.map_, b2 = [], c;
      for (c in a2) Object.prototype.hasOwnProperty.call(a2, c) && b2.push(c);
      return b2;
    };
    jspb.Map = module$contents$jspb$Map_Map;
    goog.async = {};
    function module$contents$goog$async$throwException_throwException(a2) {
      goog.global.setTimeout(() => {
        throw a2;
      }, 0);
    }
    goog.async.throwException = module$contents$goog$async$throwException_throwException;
    goog.crypt = {};
    goog.crypt.ASYNC_THROW_ON_UNICODE_TO_BYTE = goog.DEBUG;
    goog.crypt.TEST_ONLY = {};
    goog.crypt.TEST_ONLY.throwException = module$contents$goog$async$throwException_throwException;
    goog.crypt.TEST_ONLY.alwaysThrowSynchronously = goog.DEBUG;
    goog.crypt.binaryStringToByteArray = function(a2) {
      return goog.crypt.stringToByteArray(a2, true);
    };
    goog.crypt.stringToByteArray = function(a2, b2) {
      for (var c = [], d = 0, e = 0; e < a2.length; e++) {
        var f = a2.charCodeAt(e);
        if (255 < f) {
          var g = Error("go/unicode-to-byte-error");
          if (goog.crypt.TEST_ONLY.alwaysThrowSynchronously || b2) throw g;
          goog.crypt.ASYNC_THROW_ON_UNICODE_TO_BYTE && goog.crypt.TEST_ONLY.throwException(g);
          c[d++] = f & 255;
          f >>= 8;
        }
        c[d++] = f;
      }
      return c;
    };
    goog.crypt.byteArrayToString = function(a2) {
      return goog.crypt.byteArrayToBinaryString(a2);
    };
    goog.crypt.byteArrayToBinaryString = function(a2) {
      if (8192 >= a2.length) return String.fromCharCode.apply(null, a2);
      for (var b2 = "", c = 0; c < a2.length; c += 8192) {
        var d = Array.prototype.slice.call(a2, c, c + 8192);
        b2 += String.fromCharCode.apply(null, d);
      }
      return b2;
    };
    goog.crypt.byteArrayToHex = function(a2, b2) {
      return Array.prototype.map.call(a2, function(c) {
        c = c.toString(16);
        return 1 < c.length ? c : "0" + c;
      }).join(b2 || "");
    };
    goog.crypt.hexToByteArray = function(a2) {
      goog.asserts.assert(0 == a2.length % 2, "Key string length must be multiple of 2");
      for (var b2 = [], c = 0; c < a2.length; c += 2) b2.push(parseInt(a2.substring(c, c + 2), 16));
      return b2;
    };
    goog.crypt.stringToUtf8ByteArray = function(a2) {
      return goog.crypt.textToByteArray(a2);
    };
    goog.crypt.textToByteArray = function(a2) {
      for (var b2 = [], c = 0, d = 0; d < a2.length; d++) {
        var e = a2.charCodeAt(d);
        128 > e ? b2[c++] = e : (2048 > e ? b2[c++] = e >> 6 | 192 : (55296 == (e & 64512) && d + 1 < a2.length && 56320 == (a2.charCodeAt(d + 1) & 64512) ? (e = 65536 + ((e & 1023) << 10) + (a2.charCodeAt(++d) & 1023), b2[c++] = e >> 18 | 240, b2[c++] = e >> 12 & 63 | 128) : b2[c++] = e >> 12 | 224, b2[c++] = e >> 6 & 63 | 128), b2[c++] = e & 63 | 128);
      }
      return b2;
    };
    goog.crypt.utf8ByteArrayToString = function(a2) {
      return goog.crypt.byteArrayToText(a2);
    };
    goog.crypt.byteArrayToText = function(a2) {
      for (var b2 = [], c = 0, d = 0; c < a2.length; ) {
        var e = a2[c++];
        if (128 > e) b2[d++] = String.fromCharCode(e);
        else if (191 < e && 224 > e) {
          var f = a2[c++];
          b2[d++] = String.fromCharCode((e & 31) << 6 | f & 63);
        } else if (239 < e && 365 > e) {
          f = a2[c++];
          var g = a2[c++], h = a2[c++];
          e = ((e & 7) << 18 | (f & 63) << 12 | (g & 63) << 6 | h & 63) - 65536;
          b2[d++] = String.fromCharCode(55296 + (e >> 10));
          b2[d++] = String.fromCharCode(56320 + (e & 1023));
        } else f = a2[c++], g = a2[c++], b2[d++] = String.fromCharCode((e & 15) << 12 | (f & 63) << 6 | g & 63);
      }
      return b2.join("");
    };
    goog.crypt.xorByteArray = function(a2, b2) {
      goog.asserts.assert(a2.length == b2.length, "XOR array lengths must match");
      for (var c = [], d = 0; d < a2.length; d++) c.push(a2[d] ^ b2[d]);
      return c;
    };
    goog.string = {};
    goog.string.internal = {};
    goog.string.internal.startsWith = function(a2, b2) {
      return 0 == a2.lastIndexOf(b2, 0);
    };
    goog.string.internal.endsWith = function(a2, b2) {
      const c = a2.length - b2.length;
      return 0 <= c && a2.indexOf(b2, c) == c;
    };
    goog.string.internal.caseInsensitiveStartsWith = function(a2, b2) {
      return 0 == goog.string.internal.caseInsensitiveCompare(b2, a2.slice(0, b2.length));
    };
    goog.string.internal.caseInsensitiveEndsWith = function(a2, b2) {
      return 0 == goog.string.internal.caseInsensitiveCompare(b2, a2.slice(a2.length - b2.length));
    };
    goog.string.internal.caseInsensitiveEquals = function(a2, b2) {
      return a2.toLowerCase() == b2.toLowerCase();
    };
    goog.string.internal.isEmptyOrWhitespace = function(a2) {
      return /^[\s\xa0]*$/.test(a2);
    };
    goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a2) {
      return a2.trim();
    } : function(a2) {
      return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a2)[1];
    };
    goog.string.internal.caseInsensitiveCompare = function(a2, b2) {
      a2 = String(a2).toLowerCase();
      b2 = String(b2).toLowerCase();
      return a2 < b2 ? -1 : a2 == b2 ? 0 : 1;
    };
    goog.string.internal.newLineToBr = function(a2, b2) {
      return a2.replace(/(\r\n|\r|\n)/g, b2 ? "<br />" : "<br>");
    };
    goog.string.internal.htmlEscape = function(a2, b2) {
      if (b2) a2 = a2.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
      else {
        if (!goog.string.internal.ALL_RE_.test(a2)) return a2;
        -1 != a2.indexOf("&") && (a2 = a2.replace(goog.string.internal.AMP_RE_, "&amp;"));
        -1 != a2.indexOf("<") && (a2 = a2.replace(
          goog.string.internal.LT_RE_,
          "&lt;"
        ));
        -1 != a2.indexOf(">") && (a2 = a2.replace(goog.string.internal.GT_RE_, "&gt;"));
        -1 != a2.indexOf('"') && (a2 = a2.replace(goog.string.internal.QUOT_RE_, "&quot;"));
        -1 != a2.indexOf("'") && (a2 = a2.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
        -1 != a2.indexOf("\0") && (a2 = a2.replace(goog.string.internal.NULL_RE_, "&#0;"));
      }
      return a2;
    };
    goog.string.internal.AMP_RE_ = /&/g;
    goog.string.internal.LT_RE_ = /</g;
    goog.string.internal.GT_RE_ = />/g;
    goog.string.internal.QUOT_RE_ = /"/g;
    goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
    goog.string.internal.NULL_RE_ = /\x00/g;
    goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
    goog.string.internal.whitespaceEscape = function(a2, b2) {
      return goog.string.internal.newLineToBr(a2.replace(/  /g, " &#160;"), b2);
    };
    goog.string.internal.contains = function(a2, b2) {
      return -1 != a2.indexOf(b2);
    };
    goog.string.internal.caseInsensitiveContains = function(a2, b2) {
      return goog.string.internal.contains(a2.toLowerCase(), b2.toLowerCase());
    };
    goog.string.internal.compareVersions = function(a2, b2) {
      var c = 0;
      a2 = goog.string.internal.trim(String(a2)).split(".");
      b2 = goog.string.internal.trim(String(b2)).split(".");
      const d = Math.max(a2.length, b2.length);
      for (let g = 0; 0 == c && g < d; g++) {
        var e = a2[g] || "", f = b2[g] || "";
        do {
          e = /(\d*)(\D*)(.*)/.exec(e) || ["", "", "", ""];
          f = /(\d*)(\D*)(.*)/.exec(f) || ["", "", "", ""];
          if (0 == e[0].length && 0 == f[0].length) break;
          c = 0 == e[1].length ? 0 : parseInt(e[1], 10);
          const h = 0 == f[1].length ? 0 : parseInt(f[1], 10);
          c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(0 == e[2].length, 0 == f[2].length) || goog.string.internal.compareElements_(e[2], f[2]);
          e = e[3];
          f = f[3];
        } while (0 == c);
      }
      return c;
    };
    goog.string.internal.compareElements_ = function(a2, b2) {
      return a2 < b2 ? -1 : a2 > b2 ? 1 : 0;
    };
    goog.flags = {};
    goog.flags.USE_USER_AGENT_CLIENT_HINTS = false;
    goog.flags.ASYNC_THROW_ON_UNICODE_TO_BYTE = false;
    goog.labs = {};
    goog.labs.userAgent = {};
    var module$contents$goog$labs$userAgent_USE_CLIENT_HINTS_OVERRIDE = "";
    var module$contents$goog$labs$userAgent_USE_CLIENT_HINTS = false;
    var module$contents$goog$labs$userAgent_forceClientHintsInTests = false;
    goog.labs.userAgent.setUseClientHintsForTesting = (a2) => {
      module$contents$goog$labs$userAgent_forceClientHintsInTests = a2;
    };
    var module$contents$goog$labs$userAgent_useClientHintsRuntimeOverride = module$contents$goog$labs$userAgent_USE_CLIENT_HINTS_OVERRIDE ? !!goog.getObjectByName(module$contents$goog$labs$userAgent_USE_CLIENT_HINTS_OVERRIDE) : false;
    goog.labs.userAgent.useClientHints = () => goog.flags.USE_USER_AGENT_CLIENT_HINTS || module$contents$goog$labs$userAgent_USE_CLIENT_HINTS || module$contents$goog$labs$userAgent_useClientHintsRuntimeOverride || module$contents$goog$labs$userAgent_forceClientHintsInTests;
    goog.labs.userAgent.util = {};
    var module$contents$goog$labs$userAgent$util_ASSUME_CLIENT_HINTS_SUPPORT = false;
    function module$contents$goog$labs$userAgent$util_getNativeUserAgentString() {
      var a2 = module$contents$goog$labs$userAgent$util_getNavigator();
      return a2 && (a2 = a2.userAgent) ? a2 : "";
    }
    function module$contents$goog$labs$userAgent$util_getNativeUserAgentData() {
      const a2 = module$contents$goog$labs$userAgent$util_getNavigator();
      return a2 ? a2.userAgentData || null : null;
    }
    function module$contents$goog$labs$userAgent$util_getNavigator() {
      return goog.global.navigator;
    }
    var module$contents$goog$labs$userAgent$util_userAgentInternal = null;
    var module$contents$goog$labs$userAgent$util_userAgentDataInternal = module$contents$goog$labs$userAgent$util_getNativeUserAgentData();
    function module$contents$goog$labs$userAgent$util_setUserAgent(a2) {
      module$contents$goog$labs$userAgent$util_userAgentInternal = "string" === typeof a2 ? a2 : module$contents$goog$labs$userAgent$util_getNativeUserAgentString();
    }
    function module$contents$goog$labs$userAgent$util_getUserAgent() {
      return null == module$contents$goog$labs$userAgent$util_userAgentInternal ? module$contents$goog$labs$userAgent$util_getNativeUserAgentString() : module$contents$goog$labs$userAgent$util_userAgentInternal;
    }
    function module$contents$goog$labs$userAgent$util_setUserAgentData(a2) {
      module$contents$goog$labs$userAgent$util_userAgentDataInternal = a2;
    }
    function module$contents$goog$labs$userAgent$util_resetUserAgentData() {
      module$contents$goog$labs$userAgent$util_userAgentDataInternal = module$contents$goog$labs$userAgent$util_getNativeUserAgentData();
    }
    function module$contents$goog$labs$userAgent$util_getUserAgentData() {
      return module$contents$goog$labs$userAgent$util_userAgentDataInternal;
    }
    function module$contents$goog$labs$userAgent$util_matchUserAgentDataBrand(a2) {
      if (!(0, goog.labs.userAgent.useClientHints)()) return false;
      const b2 = module$contents$goog$labs$userAgent$util_getUserAgentData();
      return b2 ? b2.brands.some(({ brand: c }) => c && (0, goog.string.internal.contains)(c, a2)) : false;
    }
    function module$contents$goog$labs$userAgent$util_matchUserAgent(a2) {
      const b2 = module$contents$goog$labs$userAgent$util_getUserAgent();
      return (0, goog.string.internal.contains)(b2, a2);
    }
    function module$contents$goog$labs$userAgent$util_matchUserAgentIgnoreCase(a2) {
      const b2 = module$contents$goog$labs$userAgent$util_getUserAgent();
      return (0, goog.string.internal.caseInsensitiveContains)(b2, a2);
    }
    function module$contents$goog$labs$userAgent$util_extractVersionTuples(a2) {
      const b2 = RegExp("([A-Z][\\w ]+)/([^\\s]+)\\s*(?:\\((.*?)\\))?", "g"), c = [];
      let d;
      for (; d = b2.exec(a2); ) c.push([d[1], d[2], d[3] || void 0]);
      return c;
    }
    goog.labs.userAgent.util.ASSUME_CLIENT_HINTS_SUPPORT = module$contents$goog$labs$userAgent$util_ASSUME_CLIENT_HINTS_SUPPORT;
    goog.labs.userAgent.util.extractVersionTuples = module$contents$goog$labs$userAgent$util_extractVersionTuples;
    goog.labs.userAgent.util.getNativeUserAgentString = module$contents$goog$labs$userAgent$util_getNativeUserAgentString;
    goog.labs.userAgent.util.getUserAgent = module$contents$goog$labs$userAgent$util_getUserAgent;
    goog.labs.userAgent.util.getUserAgentData = module$contents$goog$labs$userAgent$util_getUserAgentData;
    goog.labs.userAgent.util.matchUserAgent = module$contents$goog$labs$userAgent$util_matchUserAgent;
    goog.labs.userAgent.util.matchUserAgentDataBrand = module$contents$goog$labs$userAgent$util_matchUserAgentDataBrand;
    goog.labs.userAgent.util.matchUserAgentIgnoreCase = module$contents$goog$labs$userAgent$util_matchUserAgentIgnoreCase;
    goog.labs.userAgent.util.resetUserAgentData = module$contents$goog$labs$userAgent$util_resetUserAgentData;
    goog.labs.userAgent.util.setUserAgent = module$contents$goog$labs$userAgent$util_setUserAgent;
    goog.labs.userAgent.util.setUserAgentData = module$contents$goog$labs$userAgent$util_setUserAgentData;
    var module$exports$goog$labs$userAgent$highEntropy$highEntropyValue = { AsyncValue: class {
      getIfLoaded() {
      }
      load() {
      }
    }, HighEntropyValue: class {
      constructor(a2) {
        this.key_ = a2;
        this.promise_ = this.value_ = void 0;
        this.pending_ = false;
      }
      getIfLoaded() {
        if (module$contents$goog$labs$userAgent$util_getUserAgentData()) return this.value_;
      }
      async load() {
        const a2 = module$contents$goog$labs$userAgent$util_getUserAgentData();
        if (a2) return this.promise_ || (this.pending_ = true, this.promise_ = (async () => {
          try {
            return this.value_ = (await a2.getHighEntropyValues([this.key_]))[this.key_];
          } finally {
            this.pending_ = false;
          }
        })()), await this.promise_;
      }
      resetForTesting() {
        if (this.pending_) throw Error("Unsafe call to resetForTesting");
        this.value_ = this.promise_ = void 0;
        this.pending_ = false;
      }
    }, Version: class {
      constructor(a2) {
        this.versionString_ = a2;
      }
      toVersionStringForLogging() {
        return this.versionString_;
      }
      isAtLeast(a2) {
        return 0 <= (0, goog.string.internal.compareVersions)(this.versionString_, a2);
      }
    } };
    var module$exports$goog$labs$userAgent$highEntropy$highEntropyData = {};
    module$exports$goog$labs$userAgent$highEntropy$highEntropyData.fullVersionList = new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.HighEntropyValue("fullVersionList");
    module$exports$goog$labs$userAgent$highEntropy$highEntropyData.platformVersion = new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.HighEntropyValue("platformVersion");
    goog.labs.userAgent.browser = {};
    var module$contents$goog$labs$userAgent$browser_Brand = { ANDROID_BROWSER: "Android Browser", CHROMIUM: "Chromium", EDGE: "Microsoft Edge", FIREFOX: "Firefox", IE: "Internet Explorer", OPERA: "Opera", SAFARI: "Safari", SILK: "Silk" };
    goog.labs.userAgent.browser.Brand = module$contents$goog$labs$userAgent$browser_Brand;
    function module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand(a2 = false) {
      if (module$contents$goog$labs$userAgent$util_ASSUME_CLIENT_HINTS_SUPPORT) return true;
      if (!a2 && !(0, goog.labs.userAgent.useClientHints)()) return false;
      a2 = module$contents$goog$labs$userAgent$util_getUserAgentData();
      return !!a2 && 0 < a2.brands.length;
    }
    function module$contents$goog$labs$userAgent$browser_hasFullVersionList() {
      return module$contents$goog$labs$userAgent$browser_isAtLeast(module$contents$goog$labs$userAgent$browser_Brand.CHROMIUM, 98);
    }
    function module$contents$goog$labs$userAgent$browser_matchOpera() {
      return module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand() ? false : module$contents$goog$labs$userAgent$util_matchUserAgent("Opera");
    }
    function module$contents$goog$labs$userAgent$browser_matchIE() {
      return module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand() ? false : module$contents$goog$labs$userAgent$util_matchUserAgent("Trident") || module$contents$goog$labs$userAgent$util_matchUserAgent("MSIE");
    }
    function module$contents$goog$labs$userAgent$browser_matchEdgeHtml() {
      return module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand() ? false : module$contents$goog$labs$userAgent$util_matchUserAgent("Edge");
    }
    function module$contents$goog$labs$userAgent$browser_matchEdgeChromium() {
      return module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand() ? module$contents$goog$labs$userAgent$util_matchUserAgentDataBrand(module$contents$goog$labs$userAgent$browser_Brand.EDGE) : module$contents$goog$labs$userAgent$util_matchUserAgent("Edg/");
    }
    function module$contents$goog$labs$userAgent$browser_matchOperaChromium() {
      return module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand() ? module$contents$goog$labs$userAgent$util_matchUserAgentDataBrand(module$contents$goog$labs$userAgent$browser_Brand.OPERA) : module$contents$goog$labs$userAgent$util_matchUserAgent("OPR");
    }
    function module$contents$goog$labs$userAgent$browser_matchFirefox() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("Firefox") || module$contents$goog$labs$userAgent$util_matchUserAgent("FxiOS");
    }
    function module$contents$goog$labs$userAgent$browser_matchSafari() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("Safari") && !(module$contents$goog$labs$userAgent$browser_matchChrome() || module$contents$goog$labs$userAgent$browser_matchCoast() || module$contents$goog$labs$userAgent$browser_matchOpera() || module$contents$goog$labs$userAgent$browser_matchEdgeHtml() || module$contents$goog$labs$userAgent$browser_matchEdgeChromium() || module$contents$goog$labs$userAgent$browser_matchOperaChromium() || module$contents$goog$labs$userAgent$browser_matchFirefox() || module$contents$goog$labs$userAgent$browser_isSilk() || module$contents$goog$labs$userAgent$util_matchUserAgent("Android"));
    }
    function module$contents$goog$labs$userAgent$browser_matchCoast() {
      return module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand() ? false : module$contents$goog$labs$userAgent$util_matchUserAgent("Coast");
    }
    function module$contents$goog$labs$userAgent$browser_matchIosWebview() {
      return (module$contents$goog$labs$userAgent$util_matchUserAgent("iPad") || module$contents$goog$labs$userAgent$util_matchUserAgent("iPhone")) && !module$contents$goog$labs$userAgent$browser_matchSafari() && !module$contents$goog$labs$userAgent$browser_matchChrome() && !module$contents$goog$labs$userAgent$browser_matchCoast() && !module$contents$goog$labs$userAgent$browser_matchFirefox() && module$contents$goog$labs$userAgent$util_matchUserAgent("AppleWebKit");
    }
    function module$contents$goog$labs$userAgent$browser_matchChrome() {
      return module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand() ? module$contents$goog$labs$userAgent$util_matchUserAgentDataBrand(module$contents$goog$labs$userAgent$browser_Brand.CHROMIUM) : (module$contents$goog$labs$userAgent$util_matchUserAgent("Chrome") || module$contents$goog$labs$userAgent$util_matchUserAgent("CriOS")) && !module$contents$goog$labs$userAgent$browser_matchEdgeHtml() || module$contents$goog$labs$userAgent$browser_isSilk();
    }
    function module$contents$goog$labs$userAgent$browser_matchAndroidBrowser() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("Android") && !(module$contents$goog$labs$userAgent$browser_matchChrome() || module$contents$goog$labs$userAgent$browser_matchFirefox() || module$contents$goog$labs$userAgent$browser_matchOpera() || module$contents$goog$labs$userAgent$browser_isSilk());
    }
    var module$contents$goog$labs$userAgent$browser_isOpera = module$contents$goog$labs$userAgent$browser_matchOpera;
    goog.labs.userAgent.browser.isOpera = module$contents$goog$labs$userAgent$browser_matchOpera;
    var module$contents$goog$labs$userAgent$browser_isIE = module$contents$goog$labs$userAgent$browser_matchIE;
    goog.labs.userAgent.browser.isIE = module$contents$goog$labs$userAgent$browser_matchIE;
    var module$contents$goog$labs$userAgent$browser_isEdge = module$contents$goog$labs$userAgent$browser_matchEdgeHtml;
    goog.labs.userAgent.browser.isEdge = module$contents$goog$labs$userAgent$browser_matchEdgeHtml;
    var module$contents$goog$labs$userAgent$browser_isEdgeChromium = module$contents$goog$labs$userAgent$browser_matchEdgeChromium;
    goog.labs.userAgent.browser.isEdgeChromium = module$contents$goog$labs$userAgent$browser_matchEdgeChromium;
    var module$contents$goog$labs$userAgent$browser_isOperaChromium = module$contents$goog$labs$userAgent$browser_matchOperaChromium;
    goog.labs.userAgent.browser.isOperaChromium = module$contents$goog$labs$userAgent$browser_matchOperaChromium;
    var module$contents$goog$labs$userAgent$browser_isFirefox = module$contents$goog$labs$userAgent$browser_matchFirefox;
    goog.labs.userAgent.browser.isFirefox = module$contents$goog$labs$userAgent$browser_matchFirefox;
    var module$contents$goog$labs$userAgent$browser_isSafari = module$contents$goog$labs$userAgent$browser_matchSafari;
    goog.labs.userAgent.browser.isSafari = module$contents$goog$labs$userAgent$browser_matchSafari;
    var module$contents$goog$labs$userAgent$browser_isCoast = module$contents$goog$labs$userAgent$browser_matchCoast;
    goog.labs.userAgent.browser.isCoast = module$contents$goog$labs$userAgent$browser_matchCoast;
    var module$contents$goog$labs$userAgent$browser_isIosWebview = module$contents$goog$labs$userAgent$browser_matchIosWebview;
    goog.labs.userAgent.browser.isIosWebview = module$contents$goog$labs$userAgent$browser_matchIosWebview;
    var module$contents$goog$labs$userAgent$browser_isChrome = module$contents$goog$labs$userAgent$browser_matchChrome;
    goog.labs.userAgent.browser.isChrome = module$contents$goog$labs$userAgent$browser_matchChrome;
    var module$contents$goog$labs$userAgent$browser_isAndroidBrowser = module$contents$goog$labs$userAgent$browser_matchAndroidBrowser;
    goog.labs.userAgent.browser.isAndroidBrowser = module$contents$goog$labs$userAgent$browser_matchAndroidBrowser;
    function module$contents$goog$labs$userAgent$browser_isSilk() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("Silk");
    }
    goog.labs.userAgent.browser.isSilk = module$contents$goog$labs$userAgent$browser_isSilk;
    function module$contents$goog$labs$userAgent$browser_createVersionMap(a2) {
      const b2 = {};
      a2.forEach((c) => {
        b2[c[0]] = c[1];
      });
      return (c) => b2[c.find((d) => d in b2)] || "";
    }
    function module$contents$goog$labs$userAgent$browser_getVersion() {
      var a2 = module$contents$goog$labs$userAgent$util_getUserAgent();
      if (module$contents$goog$labs$userAgent$browser_matchIE()) return module$contents$goog$labs$userAgent$browser_getIEVersion(a2);
      a2 = module$contents$goog$labs$userAgent$util_extractVersionTuples(a2);
      const b2 = module$contents$goog$labs$userAgent$browser_createVersionMap(a2);
      return module$contents$goog$labs$userAgent$browser_matchOpera() ? b2(["Version", "Opera"]) : module$contents$goog$labs$userAgent$browser_matchEdgeHtml() ? b2(["Edge"]) : module$contents$goog$labs$userAgent$browser_matchEdgeChromium() ? b2(["Edg"]) : module$contents$goog$labs$userAgent$browser_isSilk() ? b2(["Silk"]) : module$contents$goog$labs$userAgent$browser_matchChrome() ? b2(["Chrome", "CriOS", "HeadlessChrome"]) : (a2 = a2[2]) && a2[1] || "";
    }
    goog.labs.userAgent.browser.getVersion = module$contents$goog$labs$userAgent$browser_getVersion;
    function module$contents$goog$labs$userAgent$browser_isVersionOrHigher(a2) {
      return 0 <= (0, goog.string.internal.compareVersions)(module$contents$goog$labs$userAgent$browser_getVersion(), a2);
    }
    goog.labs.userAgent.browser.isVersionOrHigher = module$contents$goog$labs$userAgent$browser_isVersionOrHigher;
    function module$contents$goog$labs$userAgent$browser_getIEVersion(a2) {
      var b2 = /rv: *([\d\.]*)/.exec(a2);
      if (b2 && b2[1]) return b2[1];
      b2 = "";
      const c = /MSIE +([\d\.]+)/.exec(a2);
      if (c && c[1]) if (a2 = /Trident\/(\d.\d)/.exec(a2), "7.0" == c[1]) if (a2 && a2[1]) switch (a2[1]) {
        case "4.0":
          b2 = "8.0";
          break;
        case "5.0":
          b2 = "9.0";
          break;
        case "6.0":
          b2 = "10.0";
          break;
        case "7.0":
          b2 = "11.0";
      }
      else b2 = "7.0";
      else b2 = c[1];
      return b2;
    }
    function module$contents$goog$labs$userAgent$browser_getFullVersionFromUserAgentString(a2) {
      var b2 = module$contents$goog$labs$userAgent$util_getUserAgent();
      if (a2 === module$contents$goog$labs$userAgent$browser_Brand.IE) return module$contents$goog$labs$userAgent$browser_matchIE() ? module$contents$goog$labs$userAgent$browser_getIEVersion(b2) : "";
      b2 = module$contents$goog$labs$userAgent$util_extractVersionTuples(b2);
      const c = module$contents$goog$labs$userAgent$browser_createVersionMap(b2);
      switch (a2) {
        case module$contents$goog$labs$userAgent$browser_Brand.OPERA:
          if (module$contents$goog$labs$userAgent$browser_matchOpera()) return c([
            "Version",
            "Opera"
          ]);
          if (module$contents$goog$labs$userAgent$browser_matchOperaChromium()) return c(["OPR"]);
          break;
        case module$contents$goog$labs$userAgent$browser_Brand.EDGE:
          if (module$contents$goog$labs$userAgent$browser_matchEdgeHtml()) return c(["Edge"]);
          if (module$contents$goog$labs$userAgent$browser_matchEdgeChromium()) return c(["Edg"]);
          break;
        case module$contents$goog$labs$userAgent$browser_Brand.CHROMIUM:
          if (module$contents$goog$labs$userAgent$browser_matchChrome()) return c(["Chrome", "CriOS", "HeadlessChrome"]);
      }
      return a2 === module$contents$goog$labs$userAgent$browser_Brand.FIREFOX && module$contents$goog$labs$userAgent$browser_matchFirefox() || a2 === module$contents$goog$labs$userAgent$browser_Brand.SAFARI && module$contents$goog$labs$userAgent$browser_matchSafari() || a2 === module$contents$goog$labs$userAgent$browser_Brand.ANDROID_BROWSER && module$contents$goog$labs$userAgent$browser_matchAndroidBrowser() || a2 === module$contents$goog$labs$userAgent$browser_Brand.SILK && module$contents$goog$labs$userAgent$browser_isSilk() ? (a2 = b2[2]) && a2[1] || "" : "";
    }
    function module$contents$goog$labs$userAgent$browser_versionOf_(a2) {
      if (module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand() && a2 !== module$contents$goog$labs$userAgent$browser_Brand.SILK) {
        var b2 = module$contents$goog$labs$userAgent$util_getUserAgentData().brands.find(({ brand: c }) => c === a2);
        if (!b2 || !b2.version) return NaN;
        b2 = b2.version.split(".");
      } else {
        b2 = module$contents$goog$labs$userAgent$browser_getFullVersionFromUserAgentString(a2);
        if ("" === b2) return NaN;
        b2 = b2.split(".");
      }
      return 0 === b2.length ? NaN : Number(b2[0]);
    }
    function module$contents$goog$labs$userAgent$browser_isAtLeast(a2, b2) {
      (0, goog.asserts.assert)(Math.floor(b2) === b2, "Major version must be an integer");
      return module$contents$goog$labs$userAgent$browser_versionOf_(a2) >= b2;
    }
    goog.labs.userAgent.browser.isAtLeast = module$contents$goog$labs$userAgent$browser_isAtLeast;
    function module$contents$goog$labs$userAgent$browser_isAtMost(a2, b2) {
      (0, goog.asserts.assert)(Math.floor(b2) === b2, "Major version must be an integer");
      return module$contents$goog$labs$userAgent$browser_versionOf_(a2) <= b2;
    }
    goog.labs.userAgent.browser.isAtMost = module$contents$goog$labs$userAgent$browser_isAtMost;
    var module$contents$goog$labs$userAgent$browser_HighEntropyBrandVersion = class {
      constructor(a2, b2, c) {
        this.brand_ = a2;
        this.version_ = new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.Version(c);
        this.useUach_ = b2;
      }
      getIfLoaded() {
        if (this.useUach_) {
          var a2 = module$exports$goog$labs$userAgent$highEntropy$highEntropyData.fullVersionList.getIfLoaded();
          if (void 0 !== a2) return a2 = a2.find(({ brand: b2 }) => this.brand_ === b2), (0, goog.asserts.assertExists)(a2), new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.Version(a2.version);
        }
        if (module$contents$goog$labs$userAgent$browser_preUachHasLoaded) return this.version_;
      }
      async load() {
        if (this.useUach_) {
          var a2 = await module$exports$goog$labs$userAgent$highEntropy$highEntropyData.fullVersionList.load();
          if (void 0 !== a2) return a2 = a2.find(({ brand: b2 }) => this.brand_ === b2), (0, goog.asserts.assertExists)(a2), new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.Version(a2.version);
        } else await 0;
        module$contents$goog$labs$userAgent$browser_preUachHasLoaded = true;
        return this.version_;
      }
    };
    var module$contents$goog$labs$userAgent$browser_preUachHasLoaded = false;
    async function module$contents$goog$labs$userAgent$browser_loadFullVersions() {
      module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand(true) && await module$exports$goog$labs$userAgent$highEntropy$highEntropyData.fullVersionList.load();
      module$contents$goog$labs$userAgent$browser_preUachHasLoaded = true;
    }
    goog.labs.userAgent.browser.loadFullVersions = module$contents$goog$labs$userAgent$browser_loadFullVersions;
    goog.labs.userAgent.browser.resetForTesting = () => {
      module$contents$goog$labs$userAgent$browser_preUachHasLoaded = false;
      module$exports$goog$labs$userAgent$highEntropy$highEntropyData.fullVersionList.resetForTesting();
    };
    function module$contents$goog$labs$userAgent$browser_fullVersionOf(a2) {
      let b2 = "";
      module$contents$goog$labs$userAgent$browser_hasFullVersionList() || (b2 = module$contents$goog$labs$userAgent$browser_getFullVersionFromUserAgentString(a2));
      const c = a2 !== module$contents$goog$labs$userAgent$browser_Brand.SILK && module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand(true);
      if (c) {
        if (!module$contents$goog$labs$userAgent$util_getUserAgentData().brands.find(({ brand: d }) => d === a2)) return;
      } else if ("" === b2) return;
      return new module$contents$goog$labs$userAgent$browser_HighEntropyBrandVersion(
        a2,
        c,
        b2
      );
    }
    goog.labs.userAgent.browser.fullVersionOf = module$contents$goog$labs$userAgent$browser_fullVersionOf;
    function module$contents$goog$labs$userAgent$browser_getVersionStringForLogging(a2) {
      if (module$contents$goog$labs$userAgent$browser_useUserAgentDataBrand(true)) {
        var b2 = module$contents$goog$labs$userAgent$browser_fullVersionOf(a2);
        if (b2) {
          if (b2 = b2.getIfLoaded()) return b2.toVersionStringForLogging();
          b2 = module$contents$goog$labs$userAgent$util_getUserAgentData().brands.find(({ brand: c }) => c === a2);
          (0, goog.asserts.assertExists)(b2);
          return b2.version;
        }
        return "";
      }
      return module$contents$goog$labs$userAgent$browser_getFullVersionFromUserAgentString(a2);
    }
    goog.labs.userAgent.browser.getVersionStringForLogging = module$contents$goog$labs$userAgent$browser_getVersionStringForLogging;
    goog.labs.userAgent.engine = {};
    function module$contents$goog$labs$userAgent$engine_isPresto() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("Presto");
    }
    function module$contents$goog$labs$userAgent$engine_isTrident() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("Trident") || module$contents$goog$labs$userAgent$util_matchUserAgent("MSIE");
    }
    function module$contents$goog$labs$userAgent$engine_isEdge() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("Edge");
    }
    function module$contents$goog$labs$userAgent$engine_isWebKit() {
      return module$contents$goog$labs$userAgent$util_matchUserAgentIgnoreCase("WebKit") && !module$contents$goog$labs$userAgent$engine_isEdge();
    }
    function module$contents$goog$labs$userAgent$engine_isGecko() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("Gecko") && !module$contents$goog$labs$userAgent$engine_isWebKit() && !module$contents$goog$labs$userAgent$engine_isTrident() && !module$contents$goog$labs$userAgent$engine_isEdge();
    }
    function module$contents$goog$labs$userAgent$engine_getVersion() {
      var a2 = module$contents$goog$labs$userAgent$util_getUserAgent();
      if (a2) {
        a2 = module$contents$goog$labs$userAgent$util_extractVersionTuples(a2);
        const c = module$contents$goog$labs$userAgent$engine_getEngineTuple(a2);
        if (c) return "Gecko" == c[0] ? module$contents$goog$labs$userAgent$engine_getVersionForKey(a2, "Firefox") : c[1];
        a2 = a2[0];
        var b2;
        if (a2 && (b2 = a2[2]) && (b2 = /Trident\/([^\s;]+)/.exec(b2))) return b2[1];
      }
      return "";
    }
    function module$contents$goog$labs$userAgent$engine_getEngineTuple(a2) {
      if (!module$contents$goog$labs$userAgent$engine_isEdge()) return a2[1];
      for (let b2 = 0; b2 < a2.length; b2++) {
        const c = a2[b2];
        if ("Edge" == c[0]) return c;
      }
    }
    function module$contents$goog$labs$userAgent$engine_isVersionOrHigher(a2) {
      return 0 <= goog.string.internal.compareVersions(module$contents$goog$labs$userAgent$engine_getVersion(), a2);
    }
    function module$contents$goog$labs$userAgent$engine_getVersionForKey(a2, b2) {
      return (a2 = module$contents$goog$array_find(a2, function(c) {
        return b2 == c[0];
      })) && a2[1] || "";
    }
    goog.labs.userAgent.engine.getVersion = module$contents$goog$labs$userAgent$engine_getVersion;
    goog.labs.userAgent.engine.isEdge = module$contents$goog$labs$userAgent$engine_isEdge;
    goog.labs.userAgent.engine.isGecko = module$contents$goog$labs$userAgent$engine_isGecko;
    goog.labs.userAgent.engine.isPresto = module$contents$goog$labs$userAgent$engine_isPresto;
    goog.labs.userAgent.engine.isTrident = module$contents$goog$labs$userAgent$engine_isTrident;
    goog.labs.userAgent.engine.isVersionOrHigher = module$contents$goog$labs$userAgent$engine_isVersionOrHigher;
    goog.labs.userAgent.engine.isWebKit = module$contents$goog$labs$userAgent$engine_isWebKit;
    goog.labs.userAgent.platform = {};
    function module$contents$goog$labs$userAgent$platform_useUserAgentDataPlatform(a2 = false) {
      if (module$contents$goog$labs$userAgent$util_ASSUME_CLIENT_HINTS_SUPPORT) return true;
      if (!a2 && !(0, goog.labs.userAgent.useClientHints)()) return false;
      a2 = module$contents$goog$labs$userAgent$util_getUserAgentData();
      return !!a2 && !!a2.platform;
    }
    function module$contents$goog$labs$userAgent$platform_isAndroid() {
      return module$contents$goog$labs$userAgent$platform_useUserAgentDataPlatform() ? "Android" === module$contents$goog$labs$userAgent$util_getUserAgentData().platform : module$contents$goog$labs$userAgent$util_matchUserAgent("Android");
    }
    function module$contents$goog$labs$userAgent$platform_isIpod() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("iPod");
    }
    function module$contents$goog$labs$userAgent$platform_isIphone() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("iPhone") && !module$contents$goog$labs$userAgent$util_matchUserAgent("iPod") && !module$contents$goog$labs$userAgent$util_matchUserAgent("iPad");
    }
    function module$contents$goog$labs$userAgent$platform_isIpad() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("iPad");
    }
    function module$contents$goog$labs$userAgent$platform_isIos() {
      return module$contents$goog$labs$userAgent$platform_isIphone() || module$contents$goog$labs$userAgent$platform_isIpad() || module$contents$goog$labs$userAgent$platform_isIpod();
    }
    function module$contents$goog$labs$userAgent$platform_isMacintosh() {
      return module$contents$goog$labs$userAgent$platform_useUserAgentDataPlatform() ? "macOS" === module$contents$goog$labs$userAgent$util_getUserAgentData().platform : module$contents$goog$labs$userAgent$util_matchUserAgent("Macintosh");
    }
    function module$contents$goog$labs$userAgent$platform_isLinux() {
      return module$contents$goog$labs$userAgent$platform_useUserAgentDataPlatform() ? "Linux" === module$contents$goog$labs$userAgent$util_getUserAgentData().platform : module$contents$goog$labs$userAgent$util_matchUserAgent("Linux");
    }
    function module$contents$goog$labs$userAgent$platform_isWindows() {
      return module$contents$goog$labs$userAgent$platform_useUserAgentDataPlatform() ? "Windows" === module$contents$goog$labs$userAgent$util_getUserAgentData().platform : module$contents$goog$labs$userAgent$util_matchUserAgent("Windows");
    }
    function module$contents$goog$labs$userAgent$platform_isChromeOS() {
      return module$contents$goog$labs$userAgent$platform_useUserAgentDataPlatform() ? "Chrome OS" === module$contents$goog$labs$userAgent$util_getUserAgentData().platform : module$contents$goog$labs$userAgent$util_matchUserAgent("CrOS");
    }
    function module$contents$goog$labs$userAgent$platform_isChromecast() {
      return module$contents$goog$labs$userAgent$util_matchUserAgent("CrKey");
    }
    function module$contents$goog$labs$userAgent$platform_isKaiOS() {
      return module$contents$goog$labs$userAgent$util_matchUserAgentIgnoreCase("KaiOS");
    }
    function module$contents$goog$labs$userAgent$platform_getVersion() {
      var a2 = module$contents$goog$labs$userAgent$util_getUserAgent(), b2 = "";
      module$contents$goog$labs$userAgent$platform_isWindows() ? (b2 = /Windows (?:NT|Phone) ([0-9.]+)/, b2 = (a2 = b2.exec(a2)) ? a2[1] : "0.0") : module$contents$goog$labs$userAgent$platform_isIos() ? (b2 = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/, b2 = (a2 = b2.exec(a2)) && a2[1].replace(/_/g, ".")) : module$contents$goog$labs$userAgent$platform_isMacintosh() ? (b2 = /Mac OS X ([0-9_.]+)/, b2 = (a2 = b2.exec(a2)) ? a2[1].replace(
        /_/g,
        "."
      ) : "10") : module$contents$goog$labs$userAgent$platform_isKaiOS() ? (b2 = /(?:KaiOS)\/(\S+)/i, b2 = (a2 = b2.exec(a2)) && a2[1]) : module$contents$goog$labs$userAgent$platform_isAndroid() ? (b2 = /Android\s+([^\);]+)(\)|;)/, b2 = (a2 = b2.exec(a2)) && a2[1]) : module$contents$goog$labs$userAgent$platform_isChromeOS() && (b2 = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/, b2 = (a2 = b2.exec(a2)) && a2[1]);
      return b2 || "";
    }
    function module$contents$goog$labs$userAgent$platform_isVersionOrHigher(a2) {
      return 0 <= goog.string.internal.compareVersions(module$contents$goog$labs$userAgent$platform_getVersion(), a2);
    }
    var module$contents$goog$labs$userAgent$platform_PlatformVersion = class {
      constructor() {
        this.preUachHasLoaded_ = false;
      }
      getIfLoaded() {
        if (module$contents$goog$labs$userAgent$platform_useUserAgentDataPlatform(true)) {
          const a2 = module$exports$goog$labs$userAgent$highEntropy$highEntropyData.platformVersion.getIfLoaded();
          return void 0 === a2 ? void 0 : new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.Version(a2);
        }
        if (this.preUachHasLoaded_) return new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.Version(module$contents$goog$labs$userAgent$platform_getVersion());
      }
      async load() {
        if (module$contents$goog$labs$userAgent$platform_useUserAgentDataPlatform(true)) return new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.Version(await module$exports$goog$labs$userAgent$highEntropy$highEntropyData.platformVersion.load());
        this.preUachHasLoaded_ = true;
        return new module$exports$goog$labs$userAgent$highEntropy$highEntropyValue.Version(module$contents$goog$labs$userAgent$platform_getVersion());
      }
      resetForTesting() {
        module$exports$goog$labs$userAgent$highEntropy$highEntropyData.platformVersion.resetForTesting();
        this.preUachHasLoaded_ = false;
      }
    };
    var module$contents$goog$labs$userAgent$platform_version = new module$contents$goog$labs$userAgent$platform_PlatformVersion();
    goog.labs.userAgent.platform.getVersion = module$contents$goog$labs$userAgent$platform_getVersion;
    goog.labs.userAgent.platform.isAndroid = module$contents$goog$labs$userAgent$platform_isAndroid;
    goog.labs.userAgent.platform.isChromeOS = module$contents$goog$labs$userAgent$platform_isChromeOS;
    goog.labs.userAgent.platform.isChromecast = module$contents$goog$labs$userAgent$platform_isChromecast;
    goog.labs.userAgent.platform.isIos = module$contents$goog$labs$userAgent$platform_isIos;
    goog.labs.userAgent.platform.isIpad = module$contents$goog$labs$userAgent$platform_isIpad;
    goog.labs.userAgent.platform.isIphone = module$contents$goog$labs$userAgent$platform_isIphone;
    goog.labs.userAgent.platform.isIpod = module$contents$goog$labs$userAgent$platform_isIpod;
    goog.labs.userAgent.platform.isKaiOS = module$contents$goog$labs$userAgent$platform_isKaiOS;
    goog.labs.userAgent.platform.isLinux = module$contents$goog$labs$userAgent$platform_isLinux;
    goog.labs.userAgent.platform.isMacintosh = module$contents$goog$labs$userAgent$platform_isMacintosh;
    goog.labs.userAgent.platform.isVersionOrHigher = module$contents$goog$labs$userAgent$platform_isVersionOrHigher;
    goog.labs.userAgent.platform.isWindows = module$contents$goog$labs$userAgent$platform_isWindows;
    goog.labs.userAgent.platform.version = module$contents$goog$labs$userAgent$platform_version;
    goog.reflect = {};
    goog.reflect.object = function(a2, b2) {
      return b2;
    };
    goog.reflect.objectProperty = function(a2, b2) {
      return a2;
    };
    goog.reflect.sinkValue = function(a2) {
      goog.reflect.sinkValue[" "](a2);
      return a2;
    };
    goog.reflect.sinkValue[" "] = function() {
    };
    goog.reflect.canAccessProperty = function(a2, b2) {
      try {
        return goog.reflect.sinkValue(a2[b2]), true;
      } catch (c) {
      }
      return false;
    };
    goog.reflect.cache = function(a2, b2, c, d) {
      d = d ? d(b2) : b2;
      return Object.prototype.hasOwnProperty.call(a2, d) ? a2[d] : a2[d] = c(b2);
    };
    goog.userAgent = {};
    goog.userAgent.ASSUME_IE = false;
    goog.userAgent.ASSUME_EDGE = false;
    goog.userAgent.ASSUME_GECKO = false;
    goog.userAgent.ASSUME_WEBKIT = false;
    goog.userAgent.ASSUME_MOBILE_WEBKIT = false;
    goog.userAgent.ASSUME_OPERA = false;
    goog.userAgent.ASSUME_ANY_VERSION = false;
    goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA;
    goog.userAgent.getUserAgentString = function() {
      return module$contents$goog$labs$userAgent$util_getUserAgent();
    };
    goog.userAgent.getNavigatorTyped = function() {
      return goog.global.navigator || null;
    };
    goog.userAgent.getNavigator = function() {
      return goog.userAgent.getNavigatorTyped();
    };
    goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : module$contents$goog$labs$userAgent$browser_matchOpera();
    goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : module$contents$goog$labs$userAgent$browser_matchIE();
    goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : module$contents$goog$labs$userAgent$engine_isEdge();
    goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE;
    goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : module$contents$goog$labs$userAgent$engine_isGecko();
    goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : module$contents$goog$labs$userAgent$engine_isWebKit();
    goog.userAgent.isMobile_ = function() {
      return goog.userAgent.WEBKIT && module$contents$goog$labs$userAgent$util_matchUserAgent("Mobile");
    };
    goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_();
    goog.userAgent.SAFARI = goog.userAgent.WEBKIT;
    goog.userAgent.determinePlatform_ = function() {
      var a2 = goog.userAgent.getNavigatorTyped();
      return a2 && a2.platform || "";
    };
    goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_();
    goog.userAgent.ASSUME_MAC = false;
    goog.userAgent.ASSUME_WINDOWS = false;
    goog.userAgent.ASSUME_LINUX = false;
    goog.userAgent.ASSUME_X11 = false;
    goog.userAgent.ASSUME_ANDROID = false;
    goog.userAgent.ASSUME_IPHONE = false;
    goog.userAgent.ASSUME_IPAD = false;
    goog.userAgent.ASSUME_IPOD = false;
    goog.userAgent.ASSUME_KAIOS = false;
    goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD;
    goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : module$contents$goog$labs$userAgent$platform_isMacintosh();
    goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : module$contents$goog$labs$userAgent$platform_isWindows();
    goog.userAgent.isLegacyLinux_ = function() {
      return module$contents$goog$labs$userAgent$platform_isLinux() || module$contents$goog$labs$userAgent$platform_isChromeOS();
    };
    goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_();
    goog.userAgent.isX11_ = function() {
      var a2 = goog.userAgent.getNavigatorTyped();
      return !!a2 && goog.string.internal.contains(a2.appVersion || "", "X11");
    };
    goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_();
    goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : module$contents$goog$labs$userAgent$platform_isAndroid();
    goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : module$contents$goog$labs$userAgent$platform_isIphone();
    goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : module$contents$goog$labs$userAgent$platform_isIpad();
    goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : module$contents$goog$labs$userAgent$platform_isIpod();
    goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : module$contents$goog$labs$userAgent$platform_isIos();
    goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : module$contents$goog$labs$userAgent$platform_isKaiOS();
    goog.userAgent.determineVersion_ = function() {
      var a2 = "", b2 = goog.userAgent.getVersionRegexResult_();
      b2 && (a2 = b2 ? b2[1] : "");
      return goog.userAgent.IE && (b2 = goog.userAgent.getDocumentMode_(), null != b2 && b2 > parseFloat(a2)) ? String(b2) : a2;
    };
    goog.userAgent.getVersionRegexResult_ = function() {
      var a2 = goog.userAgent.getUserAgentString();
      if (goog.userAgent.GECKO) return /rv:([^\);]+)(\)|;)/.exec(a2);
      if (goog.userAgent.EDGE) return /Edge\/([\d\.]+)/.exec(a2);
      if (goog.userAgent.IE) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a2);
      if (goog.userAgent.WEBKIT) return /WebKit\/(\S+)/.exec(a2);
      if (goog.userAgent.OPERA) return /(?:Version)[ \/]?(\S+)/.exec(a2);
    };
    goog.userAgent.getDocumentMode_ = function() {
      var a2 = goog.global.document;
      return a2 ? a2.documentMode : void 0;
    };
    goog.userAgent.VERSION = goog.userAgent.determineVersion_();
    goog.userAgent.compare = function(a2, b2) {
      return goog.string.internal.compareVersions(a2, b2);
    };
    goog.userAgent.isVersionOrHigherCache_ = {};
    goog.userAgent.isVersionOrHigher = function(a2) {
      return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, a2, function() {
        return 0 <= goog.string.internal.compareVersions(goog.userAgent.VERSION, a2);
      });
    };
    goog.userAgent.isDocumentModeOrHigher = function(a2) {
      return Number(goog.userAgent.DOCUMENT_MODE) >= a2;
    };
    goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher;
    goog.userAgent.DOCUMENT_MODE = (function() {
      if (goog.global.document && goog.userAgent.IE) {
        var a2 = goog.userAgent.getDocumentMode_();
        return a2 ? a2 : parseInt(goog.userAgent.VERSION, 10) || void 0;
      }
    })();
    goog.userAgent.product = {};
    goog.userAgent.product.ASSUME_FIREFOX = false;
    goog.userAgent.product.ASSUME_IPHONE = false;
    goog.userAgent.product.ASSUME_IPAD = false;
    goog.userAgent.product.ASSUME_ANDROID = false;
    goog.userAgent.product.ASSUME_CHROME = false;
    goog.userAgent.product.ASSUME_SAFARI = false;
    goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI;
    goog.userAgent.product.OPERA = goog.userAgent.OPERA;
    goog.userAgent.product.IE = goog.userAgent.IE;
    goog.userAgent.product.EDGE = goog.userAgent.EDGE;
    goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : module$contents$goog$labs$userAgent$browser_matchFirefox();
    goog.userAgent.product.isIphoneOrIpod_ = function() {
      return module$contents$goog$labs$userAgent$platform_isIphone() || module$contents$goog$labs$userAgent$platform_isIpod();
    };
    goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_();
    goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : module$contents$goog$labs$userAgent$platform_isIpad();
    goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : module$contents$goog$labs$userAgent$browser_matchAndroidBrowser();
    goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : module$contents$goog$labs$userAgent$browser_matchChrome();
    goog.userAgent.product.isSafariDesktop_ = function() {
      return module$contents$goog$labs$userAgent$browser_matchSafari() && !module$contents$goog$labs$userAgent$platform_isIos();
    };
    goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_();
    goog.crypt.base64 = {};
    goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=";
    goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.";
    goog.crypt.base64.Alphabet = { DEFAULT: 0, NO_PADDING: 1, WEBSAFE: 2, WEBSAFE_DOT_PADDING: 3, WEBSAFE_NO_PADDING: 4 };
    goog.crypt.base64.paddingChars_ = "=.";
    goog.crypt.base64.isPadding_ = function(a2) {
      return goog.string.internal.contains(goog.crypt.base64.paddingChars_, a2);
    };
    goog.crypt.base64.byteToCharMaps_ = {};
    goog.crypt.base64.charToByteMap_ = null;
    goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT;
    goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || "function" == typeof goog.global.btoa;
    goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && "function" == typeof goog.global.atob;
    goog.crypt.base64.encodeByteArray = function(a2, b2) {
      goog.asserts.assert(goog.isArrayLike(a2), "encodeByteArray takes an array as a parameter");
      void 0 === b2 && (b2 = goog.crypt.base64.Alphabet.DEFAULT);
      goog.crypt.base64.init_();
      b2 = goog.crypt.base64.byteToCharMaps_[b2];
      const c = Array(Math.floor(a2.length / 3)), d = b2[64] || "";
      let e = 0, f = 0;
      for (; e < a2.length - 2; e += 3) {
        var g = a2[e], h = a2[e + 1], l = a2[e + 2], k = b2[g >> 2];
        g = b2[(g & 3) << 4 | h >> 4];
        h = b2[(h & 15) << 2 | l >> 6];
        l = b2[l & 63];
        c[f++] = "" + k + g + h + l;
      }
      k = 0;
      l = d;
      switch (a2.length - e) {
        case 2:
          k = a2[e + 1], l = b2[(k & 15) << 2] || d;
        case 1:
          a2 = a2[e], c[f] = "" + b2[a2 >> 2] + b2[(a2 & 3) << 4 | k >> 4] + l + d;
      }
      return c.join("");
    };
    goog.crypt.base64.encodeBinaryString = function(a2, b2) {
      return goog.crypt.base64.encodeString(a2, b2, true);
    };
    goog.crypt.base64.encodeString = function(a2, b2, c) {
      return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !b2 ? goog.global.btoa(a2) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(a2, c), b2);
    };
    goog.crypt.base64.encodeStringUtf8 = function(a2, b2) {
      return goog.crypt.base64.encodeText(a2, b2);
    };
    goog.crypt.base64.encodeText = function(a2, b2) {
      return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !b2 ? goog.global.btoa(unescape(encodeURIComponent(a2))) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToUtf8ByteArray(a2), b2);
    };
    goog.crypt.base64.decodeToBinaryString = function(a2, b2) {
      if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !b2) return goog.global.atob(a2);
      var c = "";
      goog.crypt.base64.decodeStringInternal_(a2, function(d) {
        c += String.fromCharCode(d);
      });
      return c;
    };
    goog.crypt.base64.decodeString = goog.crypt.base64.decodeToBinaryString;
    goog.crypt.base64.decodeStringUtf8 = function(a2, b2) {
      return goog.crypt.base64.decodeToText(a2, b2);
    };
    goog.crypt.base64.decodeToText = function(a2, b2) {
      return decodeURIComponent(escape(goog.crypt.base64.decodeString(a2, b2)));
    };
    goog.crypt.base64.decodeStringToByteArray = function(a2, b2) {
      var c = [];
      goog.crypt.base64.decodeStringInternal_(a2, function(d) {
        c.push(d);
      });
      return c;
    };
    goog.crypt.base64.decodeStringToUint8Array = function(a2) {
      var b2 = a2.length, c = 3 * b2 / 4;
      c % 3 ? c = Math.floor(c) : goog.crypt.base64.isPadding_(a2[b2 - 1]) && (c = goog.crypt.base64.isPadding_(a2[b2 - 2]) ? c - 2 : c - 1);
      var d = new Uint8Array(c), e = 0;
      goog.crypt.base64.decodeStringInternal_(a2, function(f) {
        d[e++] = f;
      });
      return e !== c ? d.subarray(0, e) : d;
    };
    goog.crypt.base64.decodeStringInternal_ = function(a2, b2) {
      function c(l) {
        for (; d < a2.length; ) {
          var k = a2.charAt(d++), n = goog.crypt.base64.charToByteMap_[k];
          if (null != n) return n;
          if (!goog.string.internal.isEmptyOrWhitespace(k)) throw Error("Unknown base64 encoding at char: " + k);
        }
        return l;
      }
      goog.crypt.base64.init_();
      for (var d = 0; ; ) {
        var e = c(-1), f = c(0), g = c(64), h = c(64);
        if (64 === h && -1 === e) break;
        b2(e << 2 | f >> 4);
        64 != g && (b2(f << 4 & 240 | g >> 2), 64 != h && b2(g << 6 & 192 | h));
      }
    };
    goog.crypt.base64.init_ = function() {
      if (!goog.crypt.base64.charToByteMap_) {
        goog.crypt.base64.charToByteMap_ = {};
        for (var a2 = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), b2 = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
          var d = a2.concat(b2[c].split(""));
          goog.crypt.base64.byteToCharMaps_[c] = d;
          for (var e = 0; e < d.length; e++) {
            var f = d[e], g = goog.crypt.base64.charToByteMap_[f];
            void 0 === g ? goog.crypt.base64.charToByteMap_[f] = e : goog.asserts.assert(g === e);
          }
        }
      }
    };
    jspb.BinaryConstants = {};
    var module$contents$jspb$BinaryConstants_FieldType = { INVALID: -1, DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18 };
    var module$contents$jspb$BinaryConstants_WireType = { INVALID: -1, VARINT: 0, FIXED64: 1, DELIMITED: 2, START_GROUP: 3, END_GROUP: 4, FIXED32: 5 };
    function module$contents$jspb$BinaryConstants_isValidWireType(a2) {
      return 0 <= a2 && 5 >= a2;
    }
    function module$contents$jspb$BinaryConstants_FieldTypeToWireType(a2) {
      switch (a2) {
        case module$contents$jspb$BinaryConstants_FieldType.INT32:
        case module$contents$jspb$BinaryConstants_FieldType.INT64:
        case module$contents$jspb$BinaryConstants_FieldType.UINT32:
        case module$contents$jspb$BinaryConstants_FieldType.UINT64:
        case module$contents$jspb$BinaryConstants_FieldType.SINT32:
        case module$contents$jspb$BinaryConstants_FieldType.SINT64:
        case module$contents$jspb$BinaryConstants_FieldType.BOOL:
        case module$contents$jspb$BinaryConstants_FieldType.ENUM:
          return module$contents$jspb$BinaryConstants_WireType.VARINT;
        case module$contents$jspb$BinaryConstants_FieldType.DOUBLE:
        case module$contents$jspb$BinaryConstants_FieldType.FIXED64:
        case module$contents$jspb$BinaryConstants_FieldType.SFIXED64:
          return module$contents$jspb$BinaryConstants_WireType.FIXED64;
        case module$contents$jspb$BinaryConstants_FieldType.STRING:
        case module$contents$jspb$BinaryConstants_FieldType.MESSAGE:
        case module$contents$jspb$BinaryConstants_FieldType.BYTES:
          return module$contents$jspb$BinaryConstants_WireType.DELIMITED;
        case module$contents$jspb$BinaryConstants_FieldType.FLOAT:
        case module$contents$jspb$BinaryConstants_FieldType.FIXED32:
        case module$contents$jspb$BinaryConstants_FieldType.SFIXED32:
          return module$contents$jspb$BinaryConstants_WireType.FIXED32;
        default:
          return module$contents$jspb$BinaryConstants_WireType.INVALID;
      }
    }
    var module$contents$jspb$BinaryConstants_INVALID_FIELD_NUMBER = -1;
    var module$contents$jspb$BinaryConstants_INVALID_TAG = -1;
    var module$contents$jspb$BinaryConstants_FLOAT32_EPS = 1401298464324817e-60;
    var module$contents$jspb$BinaryConstants_FLOAT32_MIN = 11754943508222875e-54;
    var module$contents$jspb$BinaryConstants_FLOAT32_MAX = 34028234663852886e22;
    var module$contents$jspb$BinaryConstants_FLOAT64_EPS = 5e-324;
    var module$contents$jspb$BinaryConstants_FLOAT64_MIN = 22250738585072014e-324;
    var module$contents$jspb$BinaryConstants_FLOAT64_MAX = 17976931348623157e292;
    var module$contents$jspb$BinaryConstants_TWO_TO_20 = 1048576;
    var module$contents$jspb$BinaryConstants_TWO_TO_23 = 8388608;
    var module$contents$jspb$BinaryConstants_TWO_TO_31 = 2147483648;
    var module$contents$jspb$BinaryConstants_TWO_TO_32 = 4294967296;
    var module$contents$jspb$BinaryConstants_TWO_TO_52 = 4503599627370496;
    var module$contents$jspb$BinaryConstants_TWO_TO_63 = 9223372036854776e3;
    var module$contents$jspb$BinaryConstants_TWO_TO_64 = 18446744073709552e3;
    var module$contents$jspb$BinaryConstants_ZERO_HASH = "\0\0\0\0\0\0\0\0";
    var module$contents$jspb$BinaryConstants_MESSAGE_SET_GROUP_NUMBER = 1;
    var module$contents$jspb$BinaryConstants_MESSAGE_SET_TYPE_ID_FIELD_NUMBER = 2;
    var module$contents$jspb$BinaryConstants_MESSAGE_SET_MESSAGE_FIELD_NUMBER = 3;
    var module$contents$jspb$BinaryConstants_MESSAGE_SET_MAX_TYPE_ID = 4294967294;
    jspb.BinaryConstants.FieldType = module$contents$jspb$BinaryConstants_FieldType;
    jspb.BinaryConstants.FieldTypeToWireType = module$contents$jspb$BinaryConstants_FieldTypeToWireType;
    jspb.BinaryConstants.FLOAT32_EPS = module$contents$jspb$BinaryConstants_FLOAT32_EPS;
    jspb.BinaryConstants.FLOAT32_MIN = module$contents$jspb$BinaryConstants_FLOAT32_MIN;
    jspb.BinaryConstants.FLOAT32_MAX = module$contents$jspb$BinaryConstants_FLOAT32_MAX;
    jspb.BinaryConstants.FLOAT64_EPS = module$contents$jspb$BinaryConstants_FLOAT64_EPS;
    jspb.BinaryConstants.FLOAT64_MIN = module$contents$jspb$BinaryConstants_FLOAT64_MIN;
    jspb.BinaryConstants.FLOAT64_MAX = module$contents$jspb$BinaryConstants_FLOAT64_MAX;
    jspb.BinaryConstants.INVALID_FIELD_NUMBER = module$contents$jspb$BinaryConstants_INVALID_FIELD_NUMBER;
    jspb.BinaryConstants.INVALID_TAG = module$contents$jspb$BinaryConstants_INVALID_TAG;
    jspb.BinaryConstants.MESSAGE_SET_GROUP_NUMBER = module$contents$jspb$BinaryConstants_MESSAGE_SET_GROUP_NUMBER;
    jspb.BinaryConstants.MESSAGE_SET_MAX_TYPE_ID = module$contents$jspb$BinaryConstants_MESSAGE_SET_MAX_TYPE_ID;
    jspb.BinaryConstants.MESSAGE_SET_MESSAGE_FIELD_NUMBER = module$contents$jspb$BinaryConstants_MESSAGE_SET_MESSAGE_FIELD_NUMBER;
    jspb.BinaryConstants.MESSAGE_SET_TYPE_ID_FIELD_NUMBER = module$contents$jspb$BinaryConstants_MESSAGE_SET_TYPE_ID_FIELD_NUMBER;
    jspb.BinaryConstants.TWO_TO_20 = module$contents$jspb$BinaryConstants_TWO_TO_20;
    jspb.BinaryConstants.TWO_TO_23 = module$contents$jspb$BinaryConstants_TWO_TO_23;
    jspb.BinaryConstants.TWO_TO_31 = module$contents$jspb$BinaryConstants_TWO_TO_31;
    jspb.BinaryConstants.TWO_TO_32 = module$contents$jspb$BinaryConstants_TWO_TO_32;
    jspb.BinaryConstants.TWO_TO_52 = module$contents$jspb$BinaryConstants_TWO_TO_52;
    jspb.BinaryConstants.TWO_TO_63 = module$contents$jspb$BinaryConstants_TWO_TO_63;
    jspb.BinaryConstants.TWO_TO_64 = module$contents$jspb$BinaryConstants_TWO_TO_64;
    jspb.BinaryConstants.WireType = module$contents$jspb$BinaryConstants_WireType;
    jspb.BinaryConstants.ZERO_HASH = module$contents$jspb$BinaryConstants_ZERO_HASH;
    jspb.BinaryConstants.isValidWireType = module$contents$jspb$BinaryConstants_isValidWireType;
    var module$exports$jspb$binary$errors = {};
    function module$contents$jspb$binary$errors_messageLengthMismatchError(a2, b2) {
      return Error(`Message parsing ended unexpectedly. Expected to read ${a2} bytes, instead read ${b2} bytes, either the data ended unexpectedly or the message misreported its own length`);
    }
    function module$contents$jspb$binary$errors_invalidWireTypeError(a2, b2) {
      return Error(`Invalid wire type: ${a2} (at position ${b2})`);
    }
    function module$contents$jspb$binary$errors_invalidFieldNumberError(a2, b2) {
      return Error(`Invalid field number: ${a2} (at position ${b2})`);
    }
    function module$contents$jspb$binary$errors_malformedBinaryBytesForMessageSet() {
      return Error("Malformed binary bytes for message set");
    }
    function module$contents$jspb$binary$errors_unmatchedStartGroupEofError() {
      return Error("Unmatched start-group tag: stream EOF");
    }
    function module$contents$jspb$binary$errors_unmatchedStartGroupError() {
      return Error("Unmatched end-group tag");
    }
    function module$contents$jspb$binary$errors_groupDidNotEndWithEndGroupError() {
      return Error("Group submessage did not end with an END_GROUP tag");
    }
    function module$contents$jspb$binary$errors_invalidVarintError() {
      return Error("Failed to read varint, encoding is invalid.");
    }
    function module$contents$jspb$binary$errors_readTooFarError(a2, b2) {
      return Error(`Tried to read past the end of the data ${b2} > ${a2}`);
    }
    function module$contents$jspb$binary$errors_negativeByteLengthError(a2) {
      return Error(`Tried to read a negative byte length: ${a2}`);
    }
    module$exports$jspb$binary$errors.messageLengthMismatchError = module$contents$jspb$binary$errors_messageLengthMismatchError;
    module$exports$jspb$binary$errors.groupDidNotEndWithEndGroupError = module$contents$jspb$binary$errors_groupDidNotEndWithEndGroupError;
    module$exports$jspb$binary$errors.invalidFieldNumberError = module$contents$jspb$binary$errors_invalidFieldNumberError;
    module$exports$jspb$binary$errors.invalidVarintError = module$contents$jspb$binary$errors_invalidVarintError;
    module$exports$jspb$binary$errors.invalidWireTypeError = module$contents$jspb$binary$errors_invalidWireTypeError;
    module$exports$jspb$binary$errors.malformedBinaryBytesForMessageSet = module$contents$jspb$binary$errors_malformedBinaryBytesForMessageSet;
    module$exports$jspb$binary$errors.negativeByteLengthError = module$contents$jspb$binary$errors_negativeByteLengthError;
    module$exports$jspb$binary$errors.readTooFarError = module$contents$jspb$binary$errors_readTooFarError;
    module$exports$jspb$binary$errors.unmatchedStartGroupError = module$contents$jspb$binary$errors_unmatchedStartGroupError;
    module$exports$jspb$binary$errors.unmatchedStartGroupEofError = module$contents$jspb$binary$errors_unmatchedStartGroupEofError;
    var module$exports$jspb$internal_options = {};
    function module$contents$jspb$internal_options_isBigIntAvailable() {
      return 2021 <= goog.FEATURESET_YEAR || "function" === typeof BigInt;
    }
    module$exports$jspb$internal_options.isBigIntAvailable = module$contents$jspb$internal_options_isBigIntAvailable;
    var module$exports$jspb$binary$bytesource = {};
    var module$exports$jspb$internal_bytes = {};
    module$exports$jspb$internal_bytes.SUPPORTS_UINT8ARRAY = 2018 <= goog.FEATURESET_YEAR || "undefined" !== typeof Uint8Array;
    var module$contents$jspb$internal_bytes_HANDLE_WEB_SAFE_ENCODINGS_WITH_ATOB_AND_BTOA = true;
    var module$contents$jspb$internal_bytes_CAN_USE_ATOB_AND_BTOA = true;
    var module$contents$jspb$internal_bytes_ASSUME_ATOB_AND_BTOA_AVAILABLE = 2018 <= goog.FEATURESET_YEAR;
    module$exports$jspb$internal_bytes.USE_ATOB_BTOA = module$contents$jspb$internal_bytes_CAN_USE_ATOB_AND_BTOA && (module$contents$jspb$internal_bytes_ASSUME_ATOB_AND_BTOA_AVAILABLE || !goog.userAgent.IE && "function" === typeof btoa);
    var module$contents$jspb$internal_bytes_UINT8ARRAY_MAX_SIZE_FOR_SPREAD = 10240;
    function module$contents$jspb$internal_bytes_encodeByteArray(a2) {
      if (!module$exports$jspb$internal_bytes.USE_ATOB_BTOA) return goog.crypt.base64.encodeByteArray(a2);
      let b2 = "", c = 0;
      const d = a2.length - module$contents$jspb$internal_bytes_UINT8ARRAY_MAX_SIZE_FOR_SPREAD;
      for (; c < d; ) b2 += String.fromCharCode.apply(null, a2.subarray(c, c += module$contents$jspb$internal_bytes_UINT8ARRAY_MAX_SIZE_FOR_SPREAD));
      b2 += String.fromCharCode.apply(null, c ? a2.subarray(c) : a2);
      return btoa(b2);
    }
    var module$contents$jspb$internal_bytes_WEBSAFE_BASE64_CHARS = /[-_.]/g;
    var module$contents$jspb$internal_bytes_websafeReplacer = { "-": "+", _: "/", ".": "=" };
    function module$contents$jspb$internal_bytes_replaceWebsafe(a2) {
      return module$contents$jspb$internal_bytes_websafeReplacer[a2] || "";
    }
    function module$contents$jspb$internal_bytes_replaceWebsafeString(a2) {
      return module$contents$jspb$internal_bytes_WEBSAFE_BASE64_CHARS.test(a2) ? a2.replace(module$contents$jspb$internal_bytes_WEBSAFE_BASE64_CHARS, module$contents$jspb$internal_bytes_replaceWebsafe) : a2;
    }
    function module$contents$jspb$internal_bytes_decodeByteArray(a2) {
      if (!module$exports$jspb$internal_bytes.USE_ATOB_BTOA) return goog.crypt.base64.decodeStringToUint8Array(a2);
      var b2 = a2;
      module$contents$jspb$internal_bytes_HANDLE_WEB_SAFE_ENCODINGS_WITH_ATOB_AND_BTOA && (b2 = module$contents$jspb$internal_bytes_replaceWebsafeString(b2));
      let c;
      if (goog.DEBUG) try {
        c = atob(b2);
      } catch (d) {
        throw Error(`invalid encoding '${a2}': ${d}`);
      }
      else c = atob(b2);
      a2 = new Uint8Array(c.length);
      for (b2 = 0; b2 < c.length; b2++) a2[b2] = c.charCodeAt(b2);
      return a2;
    }
    function module$contents$jspb$internal_bytes_dataAsU8(a2) {
      if (null == a2 || module$contents$jspb$internal_bytes_isU8(a2)) return a2;
      if ("string" === typeof a2) return module$contents$jspb$internal_bytes_decodeByteArray(a2);
      (0, goog.asserts.fail)("Cannot coerce to Uint8Array: " + goog.typeOf(a2));
      return null;
    }
    function module$contents$jspb$internal_bytes_isU8(a2) {
      return module$exports$jspb$internal_bytes.SUPPORTS_UINT8ARRAY && null != a2 && a2 instanceof Uint8Array;
    }
    function module$contents$jspb$internal_bytes_uint8ArrayEquals(a2, b2) {
      const c = a2.length;
      if (c !== b2.length) return false;
      for (let d = 0; d < c; d++) if (a2[d] !== b2[d]) return false;
      return true;
    }
    module$exports$jspb$internal_bytes.I_AM_INTERNAL = {};
    module$exports$jspb$internal_bytes.encodeByteArray = module$contents$jspb$internal_bytes_encodeByteArray;
    module$exports$jspb$internal_bytes.decodeByteArray = module$contents$jspb$internal_bytes_decodeByteArray;
    module$exports$jspb$internal_bytes.dataAsU8 = module$contents$jspb$internal_bytes_dataAsU8;
    module$exports$jspb$internal_bytes.isU8 = module$contents$jspb$internal_bytes_isU8;
    module$exports$jspb$internal_bytes.replaceWebsafeString = module$contents$jspb$internal_bytes_replaceWebsafeString;
    module$exports$jspb$internal_bytes.uint8ArrayEquals = module$contents$jspb$internal_bytes_uint8ArrayEquals;
    jspb.binary = {};
    jspb.binary.utf8 = {};
    var module$contents$jspb$binary$utf8_USE_TEXT_ENCODING = true;
    var module$contents$jspb$binary$utf8_ASSUME_TEXT_ENCODING_AVAILABLE = 2020 <= goog.FEATURESET_YEAR;
    var module$contents$jspb$binary$utf8_MIN_SURROGATE = 55296;
    var module$contents$jspb$binary$utf8_MIN_HIGH_SURROGATE = module$contents$jspb$binary$utf8_MIN_SURROGATE;
    var module$contents$jspb$binary$utf8_MAX_HIGH_SURROGATE = 56319;
    var module$contents$jspb$binary$utf8_MIN_LOW_SURROGATE = 56320;
    var module$contents$jspb$binary$utf8_MAX_LOW_SURROGATE = 57343;
    var module$contents$jspb$binary$utf8_MAX_SURROGATE = module$contents$jspb$binary$utf8_MAX_LOW_SURROGATE;
    function module$contents$jspb$binary$utf8_isNotTrailingByte(a2) {
      return 128 !== (a2 & 192);
    }
    function module$contents$jspb$binary$utf8_invalid(a2, b2) {
      if (a2) throw Error("Invalid UTF8");
      b2.push(65533);
    }
    function module$contents$jspb$binary$utf8_codeUnitsToString(a2, b2) {
      b2 = String.fromCharCode.apply(null, b2);
      return null == a2 ? b2 : a2 + b2;
    }
    function module$contents$jspb$binary$utf8_polyfillDecodeUtf8(a2, b2, c, d) {
      c = b2 + c;
      const e = [];
      let f = null;
      let g, h, l;
      for (; b2 < c; ) {
        var k = a2[b2++];
        128 > k ? e.push(k) : 224 > k ? b2 >= c ? module$contents$jspb$binary$utf8_invalid(d, e) : (g = a2[b2++], 194 > k || module$contents$jspb$binary$utf8_isNotTrailingByte(g) ? (b2--, module$contents$jspb$binary$utf8_invalid(d, e)) : (k = (k & 31) << 6 | g & 63, (0, goog.asserts.assert)(128 <= k && 2047 >= k), e.push(k))) : 240 > k ? b2 >= c - 1 ? module$contents$jspb$binary$utf8_invalid(d, e) : (g = a2[b2++], module$contents$jspb$binary$utf8_isNotTrailingByte(g) || 224 === k && 160 > g || 237 === k && 160 <= g || module$contents$jspb$binary$utf8_isNotTrailingByte(h = a2[b2++]) ? (b2--, module$contents$jspb$binary$utf8_invalid(d, e)) : (k = (k & 15) << 12 | (g & 63) << 6 | h & 63, (0, goog.asserts.assert)(2048 <= k && 65535 >= k), (0, goog.asserts.assert)(k < module$contents$jspb$binary$utf8_MIN_SURROGATE || k > module$contents$jspb$binary$utf8_MAX_LOW_SURROGATE), e.push(k))) : 244 >= k ? b2 >= c - 2 ? module$contents$jspb$binary$utf8_invalid(d, e) : (g = a2[b2++], module$contents$jspb$binary$utf8_isNotTrailingByte(g) || 0 !== (k << 28) + (g - 144) >> 30 || module$contents$jspb$binary$utf8_isNotTrailingByte(h = a2[b2++]) || module$contents$jspb$binary$utf8_isNotTrailingByte(l = a2[b2++]) ? (b2--, module$contents$jspb$binary$utf8_invalid(d, e)) : (k = (k & 7) << 18 | (g & 63) << 12 | (h & 63) << 6 | l & 63, (0, goog.asserts.assert)(65536 <= k && 1114111 >= k), k -= 65536, e.push((k >> 10 & 1023) + module$contents$jspb$binary$utf8_MIN_SURROGATE, (k & 1023) + module$contents$jspb$binary$utf8_MIN_LOW_SURROGATE))) : module$contents$jspb$binary$utf8_invalid(d, e);
        8192 <= e.length && (f = module$contents$jspb$binary$utf8_codeUnitsToString(
          f,
          e
        ), e.length = 0);
      }
      (0, goog.asserts.assert)(b2 === c, `expected ${b2} === ${c}`);
      return module$contents$jspb$binary$utf8_codeUnitsToString(f, e);
    }
    var module$contents$jspb$binary$utf8_isFatalTextDecoderCachableAfterThrowing_ = 2020 <= goog.FEATURESET_YEAR ? true : void 0;
    function module$contents$jspb$binary$utf8_isFatalTextDecoderCachableAfterThrowing(a2) {
      if (void 0 === module$contents$jspb$binary$utf8_isFatalTextDecoderCachableAfterThrowing_) {
        try {
          a2.decode(new Uint8Array([128]));
        } catch (b2) {
        }
        try {
          a2.decode(new Uint8Array([97])), module$contents$jspb$binary$utf8_isFatalTextDecoderCachableAfterThrowing_ = true;
        } catch (b2) {
          module$contents$jspb$binary$utf8_isFatalTextDecoderCachableAfterThrowing_ = false;
        }
      }
      return module$contents$jspb$binary$utf8_isFatalTextDecoderCachableAfterThrowing_;
    }
    var module$contents$jspb$binary$utf8_fatalDecoderInstance;
    function module$contents$jspb$binary$utf8_getFatalDecoderInstance() {
      let a2 = module$contents$jspb$binary$utf8_fatalDecoderInstance;
      a2 ||= module$contents$jspb$binary$utf8_fatalDecoderInstance = new TextDecoder("utf-8", { fatal: true });
      return a2;
    }
    var module$contents$jspb$binary$utf8_nonFatalDecoderInstance;
    function module$contents$jspb$binary$utf8_getNonFatalDecoderInstance() {
      let a2 = module$contents$jspb$binary$utf8_nonFatalDecoderInstance;
      a2 ||= module$contents$jspb$binary$utf8_nonFatalDecoderInstance = new TextDecoder("utf-8", { fatal: false });
      return a2;
    }
    function module$contents$jspb$binary$utf8_subarray(a2, b2, c) {
      return 0 === b2 && c === a2.length ? a2 : a2.subarray(b2, c);
    }
    function module$contents$jspb$binary$utf8_textDecoderDecodeUtf8(a2, b2, c, d) {
      const e = d ? module$contents$jspb$binary$utf8_getFatalDecoderInstance() : module$contents$jspb$binary$utf8_getNonFatalDecoderInstance();
      a2 = module$contents$jspb$binary$utf8_subarray(a2, b2, b2 + c);
      try {
        return e.decode(a2);
      } catch (f) {
        throw d && !module$contents$jspb$binary$utf8_isFatalTextDecoderCachableAfterThrowing(e) && (module$contents$jspb$binary$utf8_fatalDecoderInstance = void 0), f;
      }
    }
    var module$contents$jspb$binary$utf8_useTextDecoderDecode = module$contents$jspb$binary$utf8_USE_TEXT_ENCODING && (module$contents$jspb$binary$utf8_ASSUME_TEXT_ENCODING_AVAILABLE || "undefined" !== typeof TextDecoder);
    function module$contents$jspb$binary$utf8_decodeUtf8(a2, b2, c, d) {
      return module$contents$jspb$binary$utf8_useTextDecoderDecode ? module$contents$jspb$binary$utf8_textDecoderDecodeUtf8(a2, b2, c, d) : module$contents$jspb$binary$utf8_polyfillDecodeUtf8(a2, b2, c, d);
    }
    var module$contents$jspb$binary$utf8_textEncoderInstance;
    function module$contents$jspb$binary$utf8_textEncoderEncode(a2, b2) {
      b2 && module$contents$jspb$binary$utf8_checkWellFormed(a2);
      return (module$contents$jspb$binary$utf8_textEncoderInstance ||= new TextEncoder()).encode(a2);
    }
    var module$contents$jspb$binary$utf8_IS_WELL_FORMED = "isWellFormed";
    var module$contents$jspb$binary$utf8_HAS_WELL_FORMED_METHOD = 2023 < goog.FEATURESET_YEAR || "function" === typeof String.prototype[module$contents$jspb$binary$utf8_IS_WELL_FORMED];
    function module$contents$jspb$binary$utf8_checkWellFormed(a2) {
      if (module$contents$jspb$binary$utf8_HAS_WELL_FORMED_METHOD ? !a2[module$contents$jspb$binary$utf8_IS_WELL_FORMED]() : /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(a2)) throw Error("Found an unpaired surrogate");
    }
    function module$contents$jspb$binary$utf8_polyfillEncode(a2, b2) {
      let c = 0;
      const d = new Uint8Array(3 * a2.length);
      for (let f = 0; f < a2.length; f++) {
        var e = a2.charCodeAt(f);
        if (128 > e) d[c++] = e;
        else {
          if (2048 > e) d[c++] = e >> 6 | 192;
          else {
            (0, goog.asserts.assert)(65536 > e);
            if (e >= module$contents$jspb$binary$utf8_MIN_SURROGATE && e <= module$contents$jspb$binary$utf8_MAX_LOW_SURROGATE) {
              if (e <= module$contents$jspb$binary$utf8_MAX_HIGH_SURROGATE && f < a2.length) {
                const g = a2.charCodeAt(++f);
                if (g >= module$contents$jspb$binary$utf8_MIN_LOW_SURROGATE && g <= module$contents$jspb$binary$utf8_MAX_LOW_SURROGATE) {
                  e = 1024 * (e - module$contents$jspb$binary$utf8_MIN_SURROGATE) + g - module$contents$jspb$binary$utf8_MIN_LOW_SURROGATE + 65536;
                  d[c++] = e >> 18 | 240;
                  d[c++] = e >> 12 & 63 | 128;
                  d[c++] = e >> 6 & 63 | 128;
                  d[c++] = e & 63 | 128;
                  continue;
                } else f--;
              }
              if (b2) throw Error("Found an unpaired surrogate");
              e = 65533;
            }
            d[c++] = e >> 12 | 224;
            d[c++] = e >> 6 & 63 | 128;
          }
          d[c++] = e & 63 | 128;
        }
      }
      return module$contents$jspb$binary$utf8_subarray(d, 0, c);
    }
    var module$contents$jspb$binary$utf8_useTextEncoderEncode = module$contents$jspb$binary$utf8_USE_TEXT_ENCODING && (module$contents$jspb$binary$utf8_ASSUME_TEXT_ENCODING_AVAILABLE || "undefined" !== typeof TextEncoder);
    function module$contents$jspb$binary$utf8_encodeUtf8(a2, b2 = false) {
      (0, goog.asserts.assertString)(a2);
      return module$contents$jspb$binary$utf8_useTextEncoderEncode ? module$contents$jspb$binary$utf8_textEncoderEncode(a2, b2) : module$contents$jspb$binary$utf8_polyfillEncode(a2, b2);
    }
    jspb.binary.utf8.decodeUtf8 = module$contents$jspb$binary$utf8_decodeUtf8;
    jspb.binary.utf8.encodeUtf8 = module$contents$jspb$binary$utf8_encodeUtf8;
    jspb.binary.utf8.checkWellFormed = module$contents$jspb$binary$utf8_checkWellFormed;
    jspb.binary.utf8.textDecoderDecodeUtf8 = module$contents$jspb$binary$utf8_textDecoderDecodeUtf8;
    jspb.binary.utf8.polyfillDecodeUtf8 = module$contents$jspb$binary$utf8_polyfillDecodeUtf8;
    jspb.binary.utf8.textEncoderEncode = module$contents$jspb$binary$utf8_textEncoderEncode;
    jspb.binary.utf8.polyfillEncode = module$contents$jspb$binary$utf8_polyfillEncode;
    jspb.bytestring = {};
    var module$contents$jspb$bytestring_ByteString = class _module$contents$jspb$bytestring_ByteString {
      static fromBase64(a2) {
        (0, goog.asserts.assertString)(a2);
        return a2 ? new _module$contents$jspb$bytestring_ByteString(a2, module$exports$jspb$internal_bytes.I_AM_INTERNAL) : _module$contents$jspb$bytestring_ByteString.empty();
      }
      static fromUint8Array(a2) {
        (0, goog.asserts.assert)(a2 instanceof Uint8Array || Array.isArray(a2));
        return a2.length ? new _module$contents$jspb$bytestring_ByteString(new Uint8Array(a2), module$exports$jspb$internal_bytes.I_AM_INTERNAL) : _module$contents$jspb$bytestring_ByteString.empty();
      }
      static fromStringUtf8(a2) {
        (0, goog.asserts.assertString)(a2);
        return a2.length ? new _module$contents$jspb$bytestring_ByteString(module$contents$jspb$binary$utf8_encodeUtf8(a2, true), module$exports$jspb$internal_bytes.I_AM_INTERNAL) : _module$contents$jspb$bytestring_ByteString.empty();
      }
      static async fromBlob(a2) {
        (0, goog.asserts.assertInstanceof)(a2, Blob);
        if (0 === a2.size) return _module$contents$jspb$bytestring_ByteString.empty();
        a2 = await a2.arrayBuffer();
        return new _module$contents$jspb$bytestring_ByteString(new Uint8Array(a2), module$exports$jspb$internal_bytes.I_AM_INTERNAL);
      }
      static empty() {
        return module$contents$jspb$bytestring_emptyByteString ||= new _module$contents$jspb$bytestring_ByteString(null, module$exports$jspb$internal_bytes.I_AM_INTERNAL);
      }
      asBase64() {
        const a2 = this.value_;
        return null == a2 ? "" : "string" === typeof a2 ? a2 : this.value_ = module$contents$jspb$internal_bytes_encodeByteArray(a2);
      }
      asUint8Array() {
        return new Uint8Array(this.internalBytesUnsafe(module$exports$jspb$internal_bytes.I_AM_INTERNAL) || 0);
      }
      isEmpty() {
        return null == this.value_;
      }
      sizeBytes() {
        const a2 = this.internalBytesUnsafe(module$exports$jspb$internal_bytes.I_AM_INTERNAL);
        return a2 ? a2.length : 0;
      }
      unsignedByteAt(a2) {
        (0, goog.asserts.assertNumber)(a2);
        (0, goog.asserts.assert)(0 <= a2, "index %s should be non-negative", a2);
        const b2 = this.internalBytesUnsafe(module$exports$jspb$internal_bytes.I_AM_INTERNAL);
        (0, goog.asserts.assert)(a2 < b2.length, "index %s must be less than %s", a2, b2.length);
        return b2[a2];
      }
      signedByteAt(a2) {
        return this.unsignedByteAt(a2) << 24 >> 24;
      }
      asStringUtf8({ parsingErrorsAreFatal: a2 = true } = {}) {
        const b2 = this.internalBytesUnsafe(module$exports$jspb$internal_bytes.I_AM_INTERNAL);
        return b2 ? module$contents$jspb$binary$utf8_decodeUtf8(
          b2,
          0,
          b2.length,
          a2
        ) : "";
      }
      asBlob(a2) {
        const b2 = this.internalBytesUnsafe(module$exports$jspb$internal_bytes.I_AM_INTERNAL);
        return b2 ? new Blob([b2], a2) : new Blob([], a2);
      }
      internalBytesUnsafe(a2) {
        module$contents$jspb$bytestring_checkAllowedCaller(a2);
        a2 = module$contents$jspb$internal_bytes_dataAsU8(this.value_);
        return null == a2 ? a2 : this.value_ = a2;
      }
      internalUnwrap(a2) {
        module$contents$jspb$bytestring_checkAllowedCaller(a2);
        return this.value_ || "";
      }
      constructor(a2, b2) {
        module$contents$jspb$bytestring_checkAllowedCaller(b2);
        this.value_ = a2;
        if (null != a2 && 0 === a2.length) throw Error("ByteString should be constructed with non-empty values");
      }
    };
    var module$contents$jspb$bytestring_emptyByteString;
    function module$contents$jspb$bytestring_checkAllowedCaller(a2) {
      if (a2 !== module$exports$jspb$internal_bytes.I_AM_INTERNAL) throw Error("illegal external caller");
    }
    jspb.bytestring.ByteString = module$contents$jspb$bytestring_ByteString;
    var module$exports$jspb$unsafe_bytestring = {};
    function module$contents$jspb$unsafe_bytestring_unsafeByteStringFromUint8Array(a2) {
      (0, goog.asserts.assertInstanceof)(a2, Uint8Array);
      return 0 == a2.length ? module$contents$jspb$bytestring_ByteString.empty() : new module$contents$jspb$bytestring_ByteString(a2, module$exports$jspb$internal_bytes.I_AM_INTERNAL);
    }
    function module$contents$jspb$unsafe_bytestring_unsafeUint8ArrayFromByteString(a2) {
      (0, goog.asserts.assertInstanceof)(a2, module$contents$jspb$bytestring_ByteString);
      return a2.internalBytesUnsafe(module$exports$jspb$internal_bytes.I_AM_INTERNAL) || new Uint8Array(0);
    }
    function module$contents$jspb$unsafe_bytestring_unsafeUnwrapByteString(a2) {
      (0, goog.asserts.assertInstanceof)(a2, module$contents$jspb$bytestring_ByteString);
      return a2.internalUnwrap(module$exports$jspb$internal_bytes.I_AM_INTERNAL);
    }
    module$exports$jspb$unsafe_bytestring.unsafeByteStringFromUint8Array = module$contents$jspb$unsafe_bytestring_unsafeByteStringFromUint8Array;
    module$exports$jspb$unsafe_bytestring.unsafeUint8ArrayFromByteString = module$contents$jspb$unsafe_bytestring_unsafeUint8ArrayFromByteString;
    module$exports$jspb$unsafe_bytestring.unsafeUnwrapByteString = module$contents$jspb$unsafe_bytestring_unsafeUnwrapByteString;
    jspb.utils = {};
    var module$contents$jspb$utils_SUPPORTS_UINT8ARRAY_SLICING = 2018 <= goog.FEATURESET_YEAR || "function" === typeof Uint8Array.prototype.slice;
    var module$contents$jspb$utils_MAX_SCRATCHPAD_BYTES = 8;
    function module$contents$jspb$utils_sliceUint8Array(a2, b2, c) {
      return b2 === c ? new Uint8Array(0) : module$contents$jspb$utils_SUPPORTS_UINT8ARRAY_SLICING ? a2.slice(b2, c) : new Uint8Array(a2.subarray(b2, c));
    }
    var module$contents$jspb$utils_split64Low = 0;
    var module$contents$jspb$utils_split64High = 0;
    var module$contents$jspb$utils_scratchpad;
    function module$contents$jspb$utils_splitUint64(a2) {
      const b2 = a2 >>> 0;
      a2 = (a2 - b2) / module$contents$jspb$BinaryConstants_TWO_TO_32 >>> 0;
      module$contents$jspb$utils_split64Low = b2;
      module$contents$jspb$utils_split64High = a2;
    }
    function module$contents$jspb$utils_splitInt64(a2) {
      if (0 > a2) {
        module$contents$jspb$utils_splitUint64(0 - a2);
        const [b2, c] = module$contents$jspb$utils_negate(module$contents$jspb$utils_split64Low, module$contents$jspb$utils_split64High);
        module$contents$jspb$utils_split64Low = b2 >>> 0;
        module$contents$jspb$utils_split64High = c >>> 0;
      } else module$contents$jspb$utils_splitUint64(a2);
    }
    function module$contents$jspb$utils_splitZigzag64(a2) {
      const b2 = 0 > a2;
      a2 = 2 * Math.abs(a2);
      module$contents$jspb$utils_splitUint64(a2);
      a2 = module$contents$jspb$utils_split64Low;
      let c = module$contents$jspb$utils_split64High;
      b2 && (0 == a2 ? 0 == c ? c = a2 = 4294967295 : (c--, a2 = 4294967295) : a2--);
      module$contents$jspb$utils_split64Low = a2;
      module$contents$jspb$utils_split64High = c;
    }
    function module$contents$jspb$utils_getScratchpad(a2) {
      (0, goog.asserts.assert)(a2 <= module$contents$jspb$utils_MAX_SCRATCHPAD_BYTES);
      return module$contents$jspb$utils_scratchpad ||= new DataView(new ArrayBuffer(module$contents$jspb$utils_MAX_SCRATCHPAD_BYTES));
    }
    function module$contents$jspb$utils_splitFloat32(a2) {
      const b2 = module$contents$jspb$utils_getScratchpad(4);
      b2.setFloat32(0, +a2, true);
      module$contents$jspb$utils_split64High = 0;
      module$contents$jspb$utils_split64Low = b2.getUint32(0, true);
    }
    function module$contents$jspb$utils_splitFloat64(a2) {
      const b2 = module$contents$jspb$utils_getScratchpad(8);
      b2.setFloat64(0, +a2, true);
      module$contents$jspb$utils_split64Low = b2.getUint32(0, true);
      module$contents$jspb$utils_split64High = b2.getUint32(4, true);
    }
    function module$contents$jspb$utils_splitBytes64(a2) {
      const [b2, c, d, e, f, g, h, l] = a2;
      module$contents$jspb$utils_split64Low = b2 + (c << 8) + (d << 16) + (e << 24) >>> 0;
      module$contents$jspb$utils_split64High = f + (g << 8) + (h << 16) + (l << 24) >>> 0;
    }
    function module$contents$jspb$utils_joinUint64(a2, b2) {
      const c = b2 * module$contents$jspb$BinaryConstants_TWO_TO_32 + (a2 >>> 0);
      return Number.isSafeInteger(c) ? c : module$contents$jspb$utils_joinUnsignedDecimalString(a2, b2);
    }
    function module$contents$jspb$utils_joinInt64(a2, b2) {
      const c = b2 & 2147483648;
      c && (a2 = ~a2 + 1 >>> 0, b2 = ~b2 >>> 0, 0 == a2 && (b2 = b2 + 1 >>> 0));
      a2 = module$contents$jspb$utils_joinUint64(a2, b2);
      return "number" === typeof a2 ? c ? -a2 : a2 : c ? "-" + a2 : a2;
    }
    function module$contents$jspb$utils_toZigzag32(a2) {
      return (a2 << 1 ^ a2 >> 31) >>> 0;
    }
    function module$contents$jspb$utils_toZigzag64(a2, b2, c) {
      const d = b2 >> 31;
      b2 = (b2 << 1 | a2 >>> 31) ^ d;
      a2 = a2 << 1 ^ d;
      return c(a2, b2);
    }
    function module$contents$jspb$utils_joinZigzag64(a2, b2) {
      return module$contents$jspb$utils_fromZigzag64(a2, b2, module$contents$jspb$utils_joinInt64);
    }
    function module$contents$jspb$utils_fromZigzag32(a2) {
      return a2 >>> 1 ^ -(a2 & 1);
    }
    function module$contents$jspb$utils_fromZigzag64(a2, b2, c) {
      const d = -(a2 & 1);
      a2 = (a2 >>> 1 | b2 << 31) ^ d;
      b2 = b2 >>> 1 ^ d;
      return c(a2, b2);
    }
    function module$contents$jspb$utils_joinFloat32(a2, b2) {
      b2 = 2 * (a2 >> 31) + 1;
      const c = a2 >>> 23 & 255;
      a2 &= 8388607;
      return 255 == c ? a2 ? NaN : Infinity * b2 : 0 == c ? b2 * Math.pow(2, -149) * a2 : b2 * Math.pow(2, c - 150) * (a2 + Math.pow(2, 23));
    }
    function module$contents$jspb$utils_joinFloat64(a2, b2) {
      const c = 2 * (b2 >> 31) + 1, d = b2 >>> 20 & 2047;
      a2 = module$contents$jspb$BinaryConstants_TWO_TO_32 * (b2 & 1048575) + a2;
      return 2047 == d ? a2 ? NaN : Infinity * c : 0 == d ? c * Math.pow(2, -1074) * a2 : c * Math.pow(2, d - 1075) * (a2 + module$contents$jspb$BinaryConstants_TWO_TO_52);
    }
    function module$contents$jspb$utils_joinUnsignedDecimalString(a2, b2) {
      b2 >>>= 0;
      a2 >>>= 0;
      return 2097151 >= b2 ? "" + (module$contents$jspb$BinaryConstants_TWO_TO_32 * b2 + a2) : module$contents$jspb$internal_options_isBigIntAvailable() ? "" + (BigInt(b2) << BigInt(32) | BigInt(a2)) : module$contents$jspb$utils_joinUnsignedDecimalStringFallback(a2, b2);
    }
    function module$contents$jspb$utils_joinUnsignedDecimalStringFallback(a2, b2) {
      var c = (a2 >>> 24 | b2 << 8) & module$contents$jspb$utils_LOW_24_BITS;
      b2 = b2 >> 16 & module$contents$jspb$utils_LOW_16_BITS;
      a2 = (a2 & module$contents$jspb$utils_LOW_24_BITS) + 6777216 * c + 6710656 * b2;
      c += 8147497 * b2;
      b2 *= 2;
      1e7 <= a2 && (c += a2 / 1e7 >>> 0, a2 %= 1e7);
      1e7 <= c && (b2 += c / 1e7 >>> 0, c %= 1e7);
      (0, goog.asserts.assert)(b2);
      return b2 + module$contents$jspb$utils_decimalFrom1e7WithLeadingZeros(c) + module$contents$jspb$utils_decimalFrom1e7WithLeadingZeros(a2);
    }
    function module$contents$jspb$utils_decimalFrom1e7WithLeadingZeros(a2) {
      a2 = String(a2);
      return "0000000".slice(a2.length) + a2;
    }
    function module$contents$jspb$utils_joinSignedDecimalString(a2, b2) {
      return b2 & 2147483648 ? module$contents$jspb$internal_options_isBigIntAvailable() ? "" + (BigInt(b2 | 0) << BigInt(32) | BigInt(a2 >>> 0)) : module$contents$jspb$utils_joinNegativeDecimalStringFallback(a2, b2) : module$contents$jspb$utils_joinUnsignedDecimalString(a2, b2);
    }
    function module$contents$jspb$utils_joinSignedNumberOrDecimalString(a2, b2) {
      const c = module$contents$jspb$utils_joinInt64(a2, b2);
      return Number.isSafeInteger(c) ? c : module$contents$jspb$utils_joinSignedDecimalString(a2, b2);
    }
    function module$contents$jspb$utils_joinUnsignedNumberOrDecimalString(a2, b2) {
      b2 >>>= 0;
      const c = module$contents$jspb$utils_joinUint64(a2, b2);
      return Number.isSafeInteger(c) ? c : module$contents$jspb$utils_joinUnsignedDecimalString(a2, b2);
    }
    function module$contents$jspb$utils_joinNegativeDecimalStringFallback(a2, b2) {
      const [c, d] = module$contents$jspb$utils_negate(a2, b2);
      a2 = c;
      b2 = d;
      return "-" + module$contents$jspb$utils_joinUnsignedDecimalString(a2, b2);
    }
    function module$contents$jspb$utils_splitDecimalString(a2) {
      (0, goog.asserts.assert)(0 < a2.length);
      a2.length < module$contents$jspb$utils_MAX_SAFE_INTEGER_DECIMAL_LENGTH ? module$contents$jspb$utils_splitInt64(Number(a2)) : module$contents$jspb$internal_options_isBigIntAvailable() ? (a2 = BigInt(a2), module$contents$jspb$utils_split64Low = Number(a2 & BigInt(module$contents$jspb$utils_ALL_32_BITS)) >>> 0, module$contents$jspb$utils_split64High = Number(a2 >> BigInt(32) & BigInt(module$contents$jspb$utils_ALL_32_BITS))) : module$contents$jspb$utils_splitDecimalStringFallback(a2);
    }
    function module$contents$jspb$utils_splitDecimalStringFallback(a2) {
      (0, goog.asserts.assert)(0 < a2.length);
      const b2 = +("-" === a2[0]);
      module$contents$jspb$utils_split64High = module$contents$jspb$utils_split64Low = 0;
      const c = a2.length;
      for (let d = 0 + b2, e = (c - b2) % 6 + b2; e <= c; d = e, e += 6) {
        const f = Number(a2.slice(d, e));
        module$contents$jspb$utils_split64High *= 1e6;
        module$contents$jspb$utils_split64Low = 1e6 * module$contents$jspb$utils_split64Low + f;
        module$contents$jspb$utils_split64Low >= module$contents$jspb$BinaryConstants_TWO_TO_32 && (module$contents$jspb$utils_split64High += Math.trunc(module$contents$jspb$utils_split64Low / module$contents$jspb$BinaryConstants_TWO_TO_32), module$contents$jspb$utils_split64High >>>= 0, module$contents$jspb$utils_split64Low >>>= 0);
      }
      if (b2) {
        const [d, e] = module$contents$jspb$utils_negate(module$contents$jspb$utils_split64Low, module$contents$jspb$utils_split64High);
        module$contents$jspb$utils_split64Low = d;
        module$contents$jspb$utils_split64High = e;
      }
    }
    function module$contents$jspb$utils_negate(a2, b2) {
      b2 = ~b2;
      a2 ? a2 = ~a2 + 1 : b2 += 1;
      return [a2, b2];
    }
    function module$contents$jspb$utils_countVarints(a2, b2, c) {
      let d = 0;
      for (let e = b2; e < c; e++) d += a2[e] >> 7;
      return c - b2 - d;
    }
    function module$contents$jspb$utils_countVarintFields(a2, b2, c, d) {
      let e = 0;
      d = 8 * d + module$contents$jspb$BinaryConstants_WireType.VARINT;
      if (128 > d) for (; b2 < c && a2[b2++] == d; ) for (e++; 0 != (a2[b2++] & 128); ) ;
      else for (; b2 < c; ) {
        let f = d;
        for (; 128 < f; ) {
          if (a2[b2] != (f & 127 | 128)) return e;
          b2++;
          f >>= 7;
        }
        if (a2[b2++] != f) break;
        for (e++; 0 != (a2[b2++] & 128); ) ;
      }
      return e;
    }
    function module$contents$jspb$utils_countFixedFields_(a2, b2, c, d, e) {
      let f = 0;
      if (128 > d) for (; b2 < c && a2[b2++] == d; ) f++, b2 += e;
      else for (; b2 < c; ) {
        let g = d;
        for (; 128 < g; ) {
          if (a2[b2++] != (g & 127 | 128)) return f;
          g >>= 7;
        }
        if (a2[b2++] != g) break;
        f++;
        b2 += e;
      }
      return f;
    }
    function module$contents$jspb$utils_countFixed32Fields(a2, b2, c, d) {
      return module$contents$jspb$utils_countFixedFields_(a2, b2, c, 8 * d + module$contents$jspb$BinaryConstants_WireType.FIXED32, 4);
    }
    function module$contents$jspb$utils_countFixed64Fields(a2, b2, c, d) {
      return module$contents$jspb$utils_countFixedFields_(a2, b2, c, 8 * d + module$contents$jspb$BinaryConstants_WireType.FIXED64, 8);
    }
    function module$contents$jspb$utils_countDelimitedFields(a2, b2, c, d) {
      let e = 0;
      for (d = 8 * d + module$contents$jspb$BinaryConstants_WireType.DELIMITED; b2 < c; ) {
        let f = d;
        for (; 128 < f; ) {
          if (a2[b2++] != (f & 127 | 128)) return e;
          f >>= 7;
        }
        if (a2[b2++] != f) break;
        e++;
        let g = 0, h = 1;
        for (; f = a2[b2++], g += (f & 127) * h, h *= 128, 0 != (f & 128); ) ;
        b2 += g;
      }
      return e;
    }
    function module$contents$jspb$utils_byteSourceToUint8Array(a2, b2) {
      if (a2.constructor === Uint8Array) return a2;
      if (a2.constructor === ArrayBuffer || a2.constructor === Array) return new Uint8Array(a2);
      if (a2.constructor === String) return (0, goog.crypt.base64.decodeStringToUint8Array)(a2);
      if (a2.constructor === module$contents$jspb$bytestring_ByteString) return b2 ? a2.asUint8Array() : module$contents$jspb$unsafe_bytestring_unsafeUint8ArrayFromByteString(a2);
      if (a2 instanceof Uint8Array) return new Uint8Array(a2.buffer, a2.byteOffset, a2.byteLength);
      throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
    }
    function module$contents$jspb$utils_getSplit64Low() {
      return module$contents$jspb$utils_split64Low;
    }
    function module$contents$jspb$utils_getSplit64High() {
      return module$contents$jspb$utils_split64High;
    }
    function module$contents$jspb$utils_makeTag(a2, b2) {
      return 8 * a2 + b2;
    }
    var module$contents$jspb$utils_LOW_16_BITS = 65535;
    var module$contents$jspb$utils_LOW_24_BITS = 16777215;
    var module$contents$jspb$utils_ALL_32_BITS = 4294967295;
    var module$contents$jspb$utils_MAX_SAFE_INTEGER_DECIMAL_LENGTH = 16;
    jspb.utils.byteSourceToUint8Array = module$contents$jspb$utils_byteSourceToUint8Array;
    jspb.utils.countDelimitedFields = module$contents$jspb$utils_countDelimitedFields;
    jspb.utils.countFixed32Fields = module$contents$jspb$utils_countFixed32Fields;
    jspb.utils.countFixed64Fields = module$contents$jspb$utils_countFixed64Fields;
    jspb.utils.countVarintFields = module$contents$jspb$utils_countVarintFields;
    jspb.utils.countVarints = module$contents$jspb$utils_countVarints;
    jspb.utils.fromZigzag32 = module$contents$jspb$utils_fromZigzag32;
    jspb.utils.fromZigzag64 = module$contents$jspb$utils_fromZigzag64;
    jspb.utils.getSplit64High = module$contents$jspb$utils_getSplit64High;
    jspb.utils.getSplit64Low = module$contents$jspb$utils_getSplit64Low;
    jspb.utils.joinFloat32 = module$contents$jspb$utils_joinFloat32;
    jspb.utils.joinFloat64 = module$contents$jspb$utils_joinFloat64;
    jspb.utils.joinInt64 = module$contents$jspb$utils_joinInt64;
    jspb.utils.joinNegativeDecimalStringFallback = module$contents$jspb$utils_joinNegativeDecimalStringFallback;
    jspb.utils.joinSignedDecimalString = module$contents$jspb$utils_joinSignedDecimalString;
    jspb.utils.joinSignedNumberOrDecimalString = module$contents$jspb$utils_joinSignedNumberOrDecimalString;
    jspb.utils.joinUint64 = module$contents$jspb$utils_joinUint64;
    jspb.utils.joinUnsignedDecimalString = module$contents$jspb$utils_joinUnsignedDecimalString;
    jspb.utils.joinUnsignedDecimalStringFallback = module$contents$jspb$utils_joinUnsignedDecimalStringFallback;
    jspb.utils.joinUnsignedNumberOrDecimalString = module$contents$jspb$utils_joinUnsignedNumberOrDecimalString;
    jspb.utils.joinZigzag64 = module$contents$jspb$utils_joinZigzag64;
    jspb.utils.makeTag = module$contents$jspb$utils_makeTag;
    jspb.utils.sliceUint8Array = module$contents$jspb$utils_sliceUint8Array;
    jspb.utils.splitDecimalString = module$contents$jspb$utils_splitDecimalString;
    jspb.utils.splitDecimalStringFallback = module$contents$jspb$utils_splitDecimalStringFallback;
    jspb.utils.splitFloat32 = module$contents$jspb$utils_splitFloat32;
    jspb.utils.splitFloat64 = module$contents$jspb$utils_splitFloat64;
    jspb.utils.splitInt64 = module$contents$jspb$utils_splitInt64;
    jspb.utils.splitUint64 = module$contents$jspb$utils_splitUint64;
    jspb.utils.splitZigzag64 = module$contents$jspb$utils_splitZigzag64;
    jspb.utils.toZigzag32 = module$contents$jspb$utils_toZigzag32;
    jspb.utils.toZigzag64 = module$contents$jspb$utils_toZigzag64;
    var module$exports$jspb$binary$internal_buffer = { Buffer: class {
      constructor(a2, b2, c) {
        this.buffer = a2;
        if ((this.bufferAsByteStringInternal = c) && !b2) throw goog.DEBUG ? Error("Buffer must be immutable if a ByteString is provided.") : Error();
        this.isImmutable = b2;
      }
      getBufferAsByteStringIfImmutable() {
        if (!this.isImmutable) throw goog.DEBUG ? Error("Cannot get ByteString from mutable buffer.") : Error();
        return null == this.buffer ? null : this.bufferAsByteStringInternal ?? (this.bufferAsByteStringInternal = module$contents$jspb$unsafe_bytestring_unsafeByteStringFromUint8Array(this.buffer));
      }
    } };
    function module$contents$jspb$binary$internal_buffer_bufferFromSource(a2, b2) {
      if ("string" === typeof a2) return new module$exports$jspb$binary$internal_buffer.Buffer(module$contents$jspb$internal_bytes_decodeByteArray(a2), b2);
      if (Array.isArray(a2)) return new module$exports$jspb$binary$internal_buffer.Buffer(new Uint8Array(a2), b2);
      if (a2.constructor === Uint8Array) return new module$exports$jspb$binary$internal_buffer.Buffer(a2, false);
      if (a2.constructor === ArrayBuffer) return a2 = new Uint8Array(a2), new module$exports$jspb$binary$internal_buffer.Buffer(
        a2,
        false
      );
      if (a2.constructor === module$contents$jspb$bytestring_ByteString) return b2 = module$contents$jspb$unsafe_bytestring_unsafeUint8ArrayFromByteString(a2), new module$exports$jspb$binary$internal_buffer.Buffer(b2, true, a2);
      if (a2 instanceof Uint8Array) return a2 = a2.constructor === Uint8Array ? a2 : new Uint8Array(a2.buffer, a2.byteOffset, a2.byteLength), new module$exports$jspb$binary$internal_buffer.Buffer(a2, false);
      throw goog.DEBUG ? Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, a ByteString or an Array of numbers") : Error();
    }
    module$exports$jspb$binary$internal_buffer.bufferFromSource = module$contents$jspb$binary$internal_buffer_bufferFromSource;
    jspb.binary.decoder = {};
    var module$contents$jspb$binary$decoder_MAX_VARINT_SIZE = 10;
    var module$contents$jspb$binary$decoder_BinaryDecoder = class _module$contents$jspb$binary$decoder_BinaryDecoder {
      constructor(a2, b2, c, d) {
        this.buffer_ = this.bytes_ = null;
        this.bytesAreImmutable_ = false;
        module$contents$jspb$binary$decoder_ASSUME_DATAVIEW_IS_FAST && (this.dataView_ = null);
        this.cursor_ = this.end_ = this.start_ = 0;
        this.init(a2, b2, c, d);
      }
      init(a2, b2, c, { aliasBytesFields: d = false, treatNewDataAsImmutable: e = false } = {}) {
        this.aliasBytesFields = d;
        this.treatNewDataAsImmutable = e;
        a2 && this.setBlock(a2, b2, c);
      }
      static alloc(a2, b2, c, d) {
        if (_module$contents$jspb$binary$decoder_BinaryDecoder.instanceCache_.length) {
          const e = _module$contents$jspb$binary$decoder_BinaryDecoder.instanceCache_.pop();
          e.init(a2, b2, c, d);
          return e;
        }
        return new _module$contents$jspb$binary$decoder_BinaryDecoder(a2, b2, c, d);
      }
      free() {
        this.clear();
        100 > _module$contents$jspb$binary$decoder_BinaryDecoder.instanceCache_.length && _module$contents$jspb$binary$decoder_BinaryDecoder.instanceCache_.push(this);
      }
      clear() {
        this.buffer_ = this.bytes_ = null;
        this.bytesAreImmutable_ = false;
        module$contents$jspb$binary$decoder_ASSUME_DATAVIEW_IS_FAST && (this.dataView_ = null);
        this.cursor_ = this.end_ = this.start_ = 0;
        this.aliasBytesFields = false;
      }
      dataIsImmutable() {
        return this.bytesAreImmutable_;
      }
      getBuffer() {
        if (this.bytesAreImmutable_) throw goog.DEBUG ? Error("cannot access the buffer of decoders over immutable data.") : Error();
        return this.bytes_;
      }
      getBufferAsByteString() {
        if (null == this.buffer_) return null;
        if (!this.bytesAreImmutable_) throw goog.DEBUG ? Error("cannot access the buffer of decoders over immutable data.") : Error();
        return this.buffer_.getBufferAsByteStringIfImmutable();
      }
      setBlock(a2, b2, c) {
        this.buffer_ = a2 = module$contents$jspb$binary$internal_buffer_bufferFromSource(a2, this.treatNewDataAsImmutable);
        this.bytes_ = a2.buffer;
        this.bytesAreImmutable_ = a2.isImmutable;
        module$contents$jspb$binary$decoder_ASSUME_DATAVIEW_IS_FAST && (this.dataView_ = null);
        this.start_ = b2 || 0;
        this.end_ = void 0 !== c ? this.start_ + c : this.bytes_.length;
        this.cursor_ = this.start_;
      }
      getEnd() {
        return this.end_;
      }
      setEnd(a2) {
        this.end_ = a2;
      }
      reset() {
        this.cursor_ = this.start_;
      }
      getCursor() {
        return this.cursor_;
      }
      setCursor(a2) {
        this.cursor_ = a2;
      }
      advance(a2) {
        this.setCursorAndCheck(this.cursor_ + a2);
      }
      atEnd() {
        return this.cursor_ == this.end_;
      }
      pastEnd() {
        return this.cursor_ > this.end_;
      }
      static readSplitVarint64(a2, b2) {
        let c, d = 0, e = 0, f = 0;
        const g = a2.bytes_;
        let h = a2.cursor_;
        do
          c = g[h++], d |= (c & 127) << f, f += 7;
        while (32 > f && c & 128);
        32 < f && (e |= (c & 127) >> 4);
        for (f = 3; 32 > f && c & 128; f += 7) c = g[h++], e |= (c & 127) << f;
        a2.setCursorAndCheck(h);
        if (128 > c) return b2(d >>> 0, e >>> 0);
        throw module$contents$jspb$binary$errors_invalidVarintError();
      }
      static readSplitZigzagVarint64(a2, b2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64(
          a2,
          (c, d) => module$contents$jspb$utils_fromZigzag64(c, d, b2)
        );
      }
      static readSplitFixed64(a2, b2) {
        const c = a2.bytes_, d = a2.cursor_;
        a2.advance(8);
        let e = a2 = 0;
        for (let f = d + 7; f >= d; f--) a2 = a2 << 8 | c[f], e = e << 8 | c[f + 4];
        return b2(a2, e);
      }
      skipVarint() {
        _module$contents$jspb$binary$decoder_BinaryDecoder.readBool(this);
      }
      setCursorAndCheck(a2) {
        this.cursor_ = a2;
        if (a2 > this.end_) throw module$contents$jspb$binary$errors_readTooFarError(this.end_, a2);
      }
      static readSignedVarint32(a2) {
        const b2 = a2.bytes_;
        let c = a2.cursor_, d = b2[c++], e = d & 127;
        if (d & 128 && (d = b2[c++], e |= (d & 127) << 7, d & 128 && (d = b2[c++], e |= (d & 127) << 14, d & 128 && (d = b2[c++], e |= (d & 127) << 21, d & 128 && (d = b2[c++], e |= d << 28, d & 128 && b2[c++] & 128 && b2[c++] & 128 && b2[c++] & 128 && b2[c++] & 128 && b2[c++] & 128))))) throw module$contents$jspb$binary$errors_invalidVarintError();
        a2.setCursorAndCheck(c);
        return e;
      }
      static readUnsignedVarint32(a2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint32(a2) >>> 0;
      }
      readUnsignedVarint32IfEqualTo(a2) {
        goog.asserts.assert(a2 === a2 >>> 0);
        const b2 = this.cursor_;
        let c = b2;
        const d = this.end_, e = this.bytes_;
        for (; c < d; ) if (127 < a2) {
          const f = 128 | a2 & 127;
          if (e[c++] !== f) break;
          a2 >>>= 7;
        } else {
          if (e[c++] === a2) return this.cursor_ = c, b2;
          break;
        }
        return -1;
      }
      static readZigzagVarint32(a2) {
        return module$contents$jspb$utils_fromZigzag32(_module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(a2));
      }
      static readUnsignedVarint64(a2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64(a2, module$contents$jspb$utils_joinUint64);
      }
      static readUnsignedVarint64String(a2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64(
          a2,
          module$contents$jspb$utils_joinUnsignedDecimalString
        );
      }
      static readSignedVarint64(a2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64(a2, module$contents$jspb$utils_joinInt64);
      }
      static readSignedVarint64String(a2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64(a2, module$contents$jspb$utils_joinSignedDecimalString);
      }
      static readZigzagVarint64(a2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64(a2, module$contents$jspb$utils_joinZigzag64);
      }
      static readZigzagVarint64String(a2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSplitZigzagVarint64(
          a2,
          module$contents$jspb$utils_joinSignedDecimalString
        );
      }
      static readUint8(a2) {
        const b2 = a2.bytes_[a2.cursor_ + 0];
        a2.advance(1);
        return b2;
      }
      static readUint16(a2) {
        const b2 = a2.bytes_[a2.cursor_ + 0], c = a2.bytes_[a2.cursor_ + 1];
        a2.advance(2);
        return b2 << 0 | c << 8;
      }
      static readUint32(a2) {
        var b2 = a2.bytes_;
        const c = a2.cursor_, d = b2[c + 0], e = b2[c + 1], f = b2[c + 2];
        b2 = b2[c + 3];
        a2.advance(4);
        return (d << 0 | e << 8 | f << 16 | b2 << 24) >>> 0;
      }
      static readUint64(a2) {
        const b2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        a2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        return module$contents$jspb$utils_joinUint64(b2, a2);
      }
      static readUint64String(a2) {
        const b2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        a2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        return module$contents$jspb$utils_joinUnsignedDecimalString(b2, a2);
      }
      static readInt8(a2) {
        const b2 = a2.bytes_[a2.cursor_ + 0];
        a2.advance(1);
        return b2 << 24 >> 24;
      }
      static readInt16(a2) {
        const b2 = a2.bytes_[a2.cursor_ + 0], c = a2.bytes_[a2.cursor_ + 1];
        a2.advance(2);
        return (b2 << 0 | c << 8) << 16 >> 16;
      }
      static readInt32(a2) {
        var b2 = a2.bytes_;
        const c = a2.cursor_, d = b2[c + 0], e = b2[c + 1], f = b2[c + 2];
        b2 = b2[c + 3];
        a2.advance(4);
        return d << 0 | e << 8 | f << 16 | b2 << 24;
      }
      static readInt64(a2) {
        const b2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        a2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        return module$contents$jspb$utils_joinInt64(b2, a2);
      }
      static readInt64String(a2) {
        const b2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        a2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        return module$contents$jspb$utils_joinSignedDecimalString(
          b2,
          a2
        );
      }
      static readFloat(a2) {
        a2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        return module$contents$jspb$utils_joinFloat32(a2, 0);
      }
      static readDouble(a2) {
        if (module$contents$jspb$binary$decoder_ASSUME_DATAVIEW_IS_FAST) {
          var b2 = a2.getDataView().getFloat64(a2.cursor_, true);
          a2.advance(8);
          return b2;
        }
        b2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        a2 = _module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(a2);
        return module$contents$jspb$utils_joinFloat64(b2, a2);
      }
      readDoubleArrayInto(a2, b2) {
        var c = this.cursor_, d = 8 * a2;
        if (c + d > this.end_) throw module$contents$jspb$binary$errors_readTooFarError(d, this.end_ - c);
        var e = this.bytes_;
        c += e.byteOffset;
        if (module$contents$jspb$binary$decoder_ASSUME_DATAVIEW_IS_FAST) for (this.cursor_ += d, a2 = new DataView(e.buffer, c, d), d = 0; ; ) {
          e = d + 8;
          if (e > a2.byteLength) break;
          b2.push(a2.getFloat64(d, true));
          d = e;
        }
        else if (module$contents$jspb$binary$decoder_OPTIMIZE_LITTLE_ENDIAN_MACHINES && module$contents$jspb$binary$decoder_isLittleEndian()) for (this.cursor_ += d, a2 = new Float64Array(e.buffer.slice(
          c,
          c + d
        )), d = 0; d < a2.length; d++) b2.push(a2[d]);
        else for (d = 0; d < a2; d++) b2.push(_module$contents$jspb$binary$decoder_BinaryDecoder.readDouble(this));
      }
      static readBool(a2) {
        let b2 = 0, c = a2.cursor_;
        const d = c + module$contents$jspb$binary$decoder_MAX_VARINT_SIZE, e = a2.bytes_;
        for (; c < d; ) {
          const f = e[c++];
          b2 |= f;
          if (0 === (f & 128)) return a2.setCursorAndCheck(c), !!(b2 & 127);
        }
        throw module$contents$jspb$binary$errors_invalidVarintError();
      }
      static readEnum(a2) {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint32(a2);
      }
      checkReadLengthAndAdvance(a2) {
        if (0 > a2) throw module$contents$jspb$binary$errors_negativeByteLengthError(a2);
        const b2 = this.cursor_, c = b2 + a2;
        if (c > this.end_) throw module$contents$jspb$binary$errors_readTooFarError(a2, this.end_ - b2);
        this.cursor_ = c;
        return b2;
      }
      readString(a2, b2) {
        const c = this.checkReadLengthAndAdvance(a2);
        return module$contents$jspb$binary$utf8_decodeUtf8(goog.asserts.assert(this.bytes_), c, a2, b2);
      }
      readBytes(a2) {
        const b2 = this.checkReadLengthAndAdvance(a2);
        return this.aliasBytesFields && !this.bytesAreImmutable_ ? this.bytes_.subarray(b2, b2 + a2) : module$contents$jspb$utils_sliceUint8Array(
          goog.asserts.assert(this.bytes_),
          b2,
          b2 + a2
        );
      }
      readByteString(a2) {
        if (0 == a2) return module$contents$jspb$bytestring_ByteString.empty();
        const b2 = this.checkReadLengthAndAdvance(a2);
        a2 = this.aliasBytesFields && this.bytesAreImmutable_ ? this.bytes_.subarray(b2, b2 + a2) : module$contents$jspb$utils_sliceUint8Array(goog.asserts.assert(this.bytes_), b2, b2 + a2);
        return module$contents$jspb$unsafe_bytestring_unsafeByteStringFromUint8Array(a2);
      }
      getDataView() {
        var a2 = this.dataView_;
        a2 || (a2 = this.bytes_, a2 = this.dataView_ = new DataView(a2.buffer, a2.byteOffset, a2.byteLength));
        return a2;
      }
      static resetInstanceCache() {
        _module$contents$jspb$binary$decoder_BinaryDecoder.instanceCache_ = [];
      }
      static getInstanceCache() {
        return _module$contents$jspb$binary$decoder_BinaryDecoder.instanceCache_;
      }
    };
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "getInstanceCache", module$contents$jspb$binary$decoder_BinaryDecoder.getInstanceCache);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "resetInstanceCache", module$contents$jspb$binary$decoder_BinaryDecoder.resetInstanceCache);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "readByteString", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.readByteString);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "readBytes", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.readBytes);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "readString", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.readString);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readEnum", module$contents$jspb$binary$decoder_BinaryDecoder.readEnum);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readBool", module$contents$jspb$binary$decoder_BinaryDecoder.readBool);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "readDoubleArrayInto", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.readDoubleArrayInto);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readDouble", module$contents$jspb$binary$decoder_BinaryDecoder.readDouble);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readFloat", module$contents$jspb$binary$decoder_BinaryDecoder.readFloat);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readInt64String", module$contents$jspb$binary$decoder_BinaryDecoder.readInt64String);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readInt64", module$contents$jspb$binary$decoder_BinaryDecoder.readInt64);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readInt32", module$contents$jspb$binary$decoder_BinaryDecoder.readInt32);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readInt16", module$contents$jspb$binary$decoder_BinaryDecoder.readInt16);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readInt8", module$contents$jspb$binary$decoder_BinaryDecoder.readInt8);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readUint64String", module$contents$jspb$binary$decoder_BinaryDecoder.readUint64String);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readUint64", module$contents$jspb$binary$decoder_BinaryDecoder.readUint64);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readUint32", module$contents$jspb$binary$decoder_BinaryDecoder.readUint32);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readUint16", module$contents$jspb$binary$decoder_BinaryDecoder.readUint16);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readUint8", module$contents$jspb$binary$decoder_BinaryDecoder.readUint8);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readZigzagVarint64String", module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint64String);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readZigzagVarint64", module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint64);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readSignedVarint64String", module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint64String);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readSignedVarint64", module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint64);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readUnsignedVarint64String", module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint64String);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readUnsignedVarint64", module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint64);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readZigzagVarint32", module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint32);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "readUnsignedVarint32IfEqualTo", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.readUnsignedVarint32IfEqualTo);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readUnsignedVarint32", module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readSignedVarint32", module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint32);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "skipVarint", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.skipVarint);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readSplitFixed64", module$contents$jspb$binary$decoder_BinaryDecoder.readSplitFixed64);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readSplitZigzagVarint64", module$contents$jspb$binary$decoder_BinaryDecoder.readSplitZigzagVarint64);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "readSplitVarint64", module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "pastEnd", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.pastEnd);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "atEnd", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.atEnd);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "advance", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.advance);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "setCursor", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.setCursor);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "getCursor", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.getCursor);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "reset", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.reset);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "setEnd", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.setEnd);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "getEnd", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.getEnd);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "setBlock", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.setBlock);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "getBufferAsByteString", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.getBufferAsByteString);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "getBuffer", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.getBuffer);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "dataIsImmutable", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.dataIsImmutable);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "clear", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.clear);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder.prototype, "free", module$contents$jspb$binary$decoder_BinaryDecoder.prototype.free);
    goog.exportProperty(module$contents$jspb$binary$decoder_BinaryDecoder, "alloc", module$contents$jspb$binary$decoder_BinaryDecoder.alloc);
    module$contents$jspb$binary$decoder_BinaryDecoder.instanceCache_ = [];
    function module$contents$jspb$binary$decoder_isLittleEndian() {
      void 0 === module$contents$jspb$binary$decoder_isLittleEndianCache && (module$contents$jspb$binary$decoder_isLittleEndianCache = 513 == new Uint16Array(new Uint8Array([1, 2]).buffer)[0]);
      return goog.asserts.assertBoolean(module$contents$jspb$binary$decoder_isLittleEndianCache);
    }
    var module$contents$jspb$binary$decoder_isLittleEndianCache = void 0;
    var module$contents$jspb$binary$decoder_ASSUME_DATAVIEW_IS_FAST = 2019 <= goog.FEATURESET_YEAR;
    var module$contents$jspb$binary$decoder_OPTIMIZE_LITTLE_ENDIAN_MACHINES = true;
    jspb.binary.decoder.BinaryDecoder = module$contents$jspb$binary$decoder_BinaryDecoder;
    jspb.binary.reader = {};
    var module$contents$jspb$binary$reader_ENFORCE_UTF8 = "ALWAYS";
    goog.asserts.assert("DEPRECATED_PROTO3_ONLY" === module$contents$jspb$binary$reader_ENFORCE_UTF8 || "ALWAYS" === module$contents$jspb$binary$reader_ENFORCE_UTF8);
    var module$contents$jspb$binary$reader_UTF8_PARSING_ERRORS_ARE_FATAL = "ALWAYS" === module$contents$jspb$binary$reader_ENFORCE_UTF8;
    var module$contents$jspb$binary$reader_BinaryReaderOptions = class {
      constructor() {
      }
    };
    var module$contents$jspb$binary$reader_BinaryReader = class _module$contents$jspb$binary$reader_BinaryReader {
      constructor(a2, b2, c, d) {
        this.decoder_ = module$contents$jspb$binary$decoder_BinaryDecoder.alloc(a2, b2, c, d);
        this.fieldCursor_ = this.decoder_.getCursor();
        this.nextField_ = module$contents$jspb$BinaryConstants_INVALID_FIELD_NUMBER;
        this.nextTag_ = module$contents$jspb$BinaryConstants_INVALID_TAG;
        this.nextWireType_ = module$contents$jspb$BinaryConstants_WireType.INVALID;
        this.setOptions(d);
      }
      setOptions({ discardUnknownFields: a2 = false } = {}) {
        this.discardUnknownFields = a2;
      }
      static alloc(a2, b2, c, d) {
        if (_module$contents$jspb$binary$reader_BinaryReader.instanceCache_.length) {
          const e = _module$contents$jspb$binary$reader_BinaryReader.instanceCache_.pop();
          e.setOptions(d);
          e.decoder_.init(a2, b2, c, d);
          return e;
        }
        return new _module$contents$jspb$binary$reader_BinaryReader(a2, b2, c, d);
      }
      free() {
        this.decoder_.clear();
        this.nextTag_ = module$contents$jspb$BinaryConstants_INVALID_TAG;
        this.nextField_ = module$contents$jspb$BinaryConstants_INVALID_FIELD_NUMBER;
        this.nextWireType_ = module$contents$jspb$BinaryConstants_WireType.INVALID;
        100 > _module$contents$jspb$binary$reader_BinaryReader.instanceCache_.length && _module$contents$jspb$binary$reader_BinaryReader.instanceCache_.push(this);
      }
      getFieldCursor() {
        return this.fieldCursor_;
      }
      getCursor() {
        return this.decoder_.getCursor();
      }
      dataIsImmutable() {
        return this.decoder_.dataIsImmutable();
      }
      getBuffer() {
        return this.decoder_.getBuffer();
      }
      getBufferAsByteString() {
        return this.decoder_.getBufferAsByteString();
      }
      getTag() {
        return this.nextTag_;
      }
      getFieldNumber() {
        return this.nextField_;
      }
      getWireType() {
        return this.nextWireType_;
      }
      isEndGroup() {
        return this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.END_GROUP;
      }
      isDelimited() {
        return this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.DELIMITED;
      }
      reset() {
        this.decoder_.reset();
        this.fieldCursor_ = this.decoder_.getCursor();
        this.nextTag_ = module$contents$jspb$BinaryConstants_INVALID_TAG;
        this.nextField_ = module$contents$jspb$BinaryConstants_INVALID_FIELD_NUMBER;
        this.nextWireType_ = module$contents$jspb$BinaryConstants_WireType.INVALID;
      }
      advance(a2) {
        this.decoder_.advance(a2);
      }
      nextField() {
        if (this.decoder_.atEnd()) return false;
        this.assertPriorFieldWasRead();
        this.fieldCursor_ = this.decoder_.getCursor();
        const a2 = module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_), b2 = module$contents$jspb$binary$reader_parseFieldNumber(a2), c = module$contents$jspb$binary$reader_parseWireType(a2);
        if (!module$contents$jspb$BinaryConstants_isValidWireType(c)) throw module$contents$jspb$binary$errors_invalidWireTypeError(c, this.fieldCursor_);
        if (1 > b2) throw module$contents$jspb$binary$errors_invalidFieldNumberError(b2, this.fieldCursor_);
        this.nextTag_ = a2;
        this.nextField_ = b2;
        this.nextWireType_ = c;
        return true;
      }
      nextFieldIfTagEqualTo(a2) {
        this.assertPriorFieldWasRead();
        goog.asserts.assert(module$contents$jspb$BinaryConstants_isValidWireType(module$contents$jspb$binary$reader_parseWireType(a2)) && 0 < module$contents$jspb$binary$reader_parseFieldNumber(a2), "Must pass a valid tag.");
        const b2 = this.decoder_.readUnsignedVarint32IfEqualTo(a2), c = 0 <= b2;
        c && (this.fieldCursor_ = b2, this.nextTag_ = a2, this.nextField_ = module$contents$jspb$binary$reader_parseFieldNumber(a2), this.nextWireType_ = module$contents$jspb$binary$reader_parseWireType(a2));
        return c;
      }
      assertPriorFieldWasRead() {
        if (goog.asserts.ENABLE_ASSERTS && this.nextTag_ !== module$contents$jspb$BinaryConstants_INVALID_TAG) {
          const a2 = this.decoder_.getCursor();
          this.decoder_.setCursor(this.fieldCursor_);
          module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_);
          this.nextWireType_ === module$contents$jspb$BinaryConstants_WireType.END_GROUP || this.nextWireType_ === module$contents$jspb$BinaryConstants_WireType.START_GROUP ? goog.asserts.assert(a2 === this.decoder_.getCursor(), "Expected to not advance the cursor.  Group tags do not have values.") : goog.asserts.assert(a2 > this.decoder_.getCursor(), "Expected to read the field, did you forget to call a read or skip method?");
          this.decoder_.setCursor(a2);
        }
      }
      skipVarintField() {
        this.nextWireType_ != module$contents$jspb$BinaryConstants_WireType.VARINT ? (goog.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
      }
      skipDelimitedField() {
        if (this.nextWireType_ != module$contents$jspb$BinaryConstants_WireType.DELIMITED) return goog.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField(), 0;
        const a2 = module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_);
        this.decoder_.advance(a2);
        return a2;
      }
      skipFixed32Field() {
        goog.asserts.assert(this.nextWireType_ === module$contents$jspb$BinaryConstants_WireType.FIXED32);
        this.decoder_.advance(4);
      }
      skipFixed64Field() {
        goog.asserts.assert(this.nextWireType_ === module$contents$jspb$BinaryConstants_WireType.FIXED64);
        this.decoder_.advance(8);
      }
      skipGroup() {
        const a2 = this.nextField_;
        do {
          if (!this.nextField()) throw module$contents$jspb$binary$errors_unmatchedStartGroupEofError();
          if (this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.END_GROUP) {
            if (this.nextField_ != a2) throw module$contents$jspb$binary$errors_unmatchedStartGroupError();
            break;
          }
          this.skipField();
        } while (1);
      }
      skipField() {
        switch (this.nextWireType_) {
          case module$contents$jspb$BinaryConstants_WireType.VARINT:
            this.skipVarintField();
            break;
          case module$contents$jspb$BinaryConstants_WireType.FIXED64:
            this.skipFixed64Field();
            break;
          case module$contents$jspb$BinaryConstants_WireType.DELIMITED:
            this.skipDelimitedField();
            break;
          case module$contents$jspb$BinaryConstants_WireType.FIXED32:
            this.skipFixed32Field();
            break;
          case module$contents$jspb$BinaryConstants_WireType.START_GROUP:
            this.skipGroup();
            break;
          default:
            throw module$contents$jspb$binary$errors_invalidWireTypeError(this.nextWireType_, this.fieldCursor_);
        }
      }
      skipToEnd() {
        this.decoder_.setCursor(this.decoder_.getEnd());
      }
      readUnknownField() {
        const a2 = this.getFieldCursor();
        this.skipField();
        return this.readUnknownFieldsStartingFrom(a2);
      }
      readUnknownFieldsStartingFrom(a2) {
        if (!this.discardUnknownFields) {
          const b2 = this.decoder_.getCursor(), c = b2 - a2;
          this.decoder_.setCursor(a2);
          a2 = this.decoder_.readByteString(c);
          goog.asserts.assert(b2 == this.decoder_.getCursor());
          return a2;
        }
      }
      readAny(a2) {
        if (module$contents$jspb$BinaryConstants_FieldTypeToWireType(a2) !== this.nextWireType_) return null;
        const b2 = module$contents$jspb$BinaryConstants_FieldType;
        switch (a2) {
          case b2.DOUBLE:
            return this.readDouble();
          case b2.FLOAT:
            return this.readFloat();
          case b2.INT64:
            return this.readInt64();
          case b2.UINT64:
            return this.readUint64();
          case b2.INT32:
            return this.readInt32();
          case b2.FIXED64:
            return this.readFixed64();
          case b2.FIXED32:
            return this.readFixed32();
          case b2.BOOL:
            return this.readBool();
          case b2.STRING:
            return this.readString();
          case b2.GROUP:
            goog.asserts.fail("Group field type not supported in readAny()");
          case b2.MESSAGE:
            goog.asserts.fail("Message field type not supported in readAny()");
          case b2.BYTES:
            return this.readBytes();
          case b2.UINT32:
            return this.readUint32();
          case b2.ENUM:
            return this.readEnum();
          case b2.SFIXED32:
            return this.readSfixed32();
          case b2.SFIXED64:
            return this.readSfixed64();
          case b2.SINT32:
            return this.readSint32();
          case b2.SINT64:
            return this.readSint64();
          default:
            goog.asserts.fail("Invalid field type in readAny()");
        }
        return null;
      }
      readMessage(a2, b2, c, d, e) {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.DELIMITED);
        const f = this.decoder_.getEnd(), g = module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_), h = this.decoder_.getCursor() + g;
        let l = h - f;
        0 >= l && (this.decoder_.setEnd(h), b2(a2, this, c, d, e), l = h - this.decoder_.getCursor());
        if (l) throw module$contents$jspb$binary$errors_messageLengthMismatchError(g, g - l);
        this.decoder_.setCursor(h);
        this.decoder_.setEnd(f);
        return a2;
      }
      readGroup(a2, b2, c) {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.START_GROUP);
        goog.asserts.assert(this.nextField_ == a2);
        c(b2, this);
        if (this.nextWireType_ !== module$contents$jspb$BinaryConstants_WireType.END_GROUP) throw module$contents$jspb$binary$errors_groupDidNotEndWithEndGroupError();
        if (this.nextField_ !== a2) throw module$contents$jspb$binary$errors_unmatchedStartGroupError();
        return b2;
      }
      isMessageSetGroup() {
        return this.getTag() === module$contents$jspb$binary$reader_MESSAGE_SET_START_GROUP_TAG;
      }
      readMessageSetGroup(a2) {
        goog.asserts.assert(this.isMessageSetGroup());
        let b2 = 0, c = 0;
        for (; this.nextField() && !this.isEndGroup(); ) this.getTag() !== module$contents$jspb$binary$reader_MESSAGE_SET_TYPE_ID_TAG || b2 ? this.getTag() !== module$contents$jspb$binary$reader_MESSAGE_SET_MESSAGE_TAG || c ? this.skipField() : b2 ? (c = -1, this.readMessage(b2, a2)) : (c = this.getFieldCursor(), this.skipDelimitedField()) : (b2 = this.readUint32(), c && (goog.asserts.assert(0 < c), goog.asserts.ENABLE_ASSERTS && (this.nextTag_ = module$contents$jspb$BinaryConstants_INVALID_TAG, this.nextWireType_ = module$contents$jspb$BinaryConstants_WireType.INVALID), this.decoder_.setCursor(c), c = 0));
        if (this.getTag() !== module$contents$jspb$binary$reader_MESSAGE_SET_END_TAG || !c || !b2) throw module$contents$jspb$binary$errors_malformedBinaryBytesForMessageSet();
      }
      readInt32() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint32(this.decoder_);
      }
      readInt64() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint64(this.decoder_);
      }
      readInt64String() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint64String(this.decoder_);
      }
      readUint32() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_);
      }
      readUint64() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint64(this.decoder_);
      }
      readUint64String() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint64String(this.decoder_);
      }
      readSint32() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint32(this.decoder_);
      }
      readSint64() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint64(this.decoder_);
      }
      readSint64String() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint64String(this.decoder_);
      }
      readFixed32() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED32);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readUint32(this.decoder_);
      }
      readFixed64() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED64);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readUint64(this.decoder_);
      }
      readFixed64String() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED64);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readUint64String(this.decoder_);
      }
      readSfixed32() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED32);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readInt32(this.decoder_);
      }
      readSfixed32String() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED32);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readInt32(this.decoder_).toString();
      }
      readSfixed64() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED64);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readInt64(this.decoder_);
      }
      readSfixed64String() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED64);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readInt64String(this.decoder_);
      }
      readFloat() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED32);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readFloat(this.decoder_);
      }
      readDouble() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED64);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readDouble(this.decoder_);
      }
      readBool() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readBool(this.decoder_);
      }
      readEnum() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint32(this.decoder_);
      }
      readString() {
        if (module$contents$jspb$binary$reader_UTF8_PARSING_ERRORS_ARE_FATAL) return this.readStringRequireUtf8();
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.DELIMITED);
        const a2 = module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_);
        return this.decoder_.readString(a2, false);
      }
      readStringRequireUtf8() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.DELIMITED);
        const a2 = module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_);
        return this.decoder_.readString(a2, true);
      }
      readBytes() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.DELIMITED);
        const a2 = module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_);
        return this.decoder_.readBytes(a2);
      }
      readByteString() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.DELIMITED);
        const a2 = module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_);
        return this.decoder_.readByteString(a2);
      }
      readSplitVarint64(a2) {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64(
          this.decoder_,
          a2
        );
      }
      readSplitZigzagVarint64(a2) {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.VARINT);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readSplitVarint64(this.decoder_, (b2, c) => module$contents$jspb$utils_fromZigzag64(b2, c, a2));
      }
      readSplitFixed64(a2) {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.FIXED64);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readSplitFixed64(this.decoder_, a2);
      }
      readPackedFieldInto_(a2, b2) {
        var c = this.readPackedFieldLength_();
        for (c = this.decoder_.getCursor() + c; this.decoder_.getCursor() < c; ) b2.push(a2(this.decoder_));
      }
      readPackedFieldLength_() {
        goog.asserts.assert(this.nextWireType_ == module$contents$jspb$BinaryConstants_WireType.DELIMITED);
        return module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32(this.decoder_);
      }
      readPackableInt32Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint32, a2) : a2.push(this.readInt32());
      }
      readPackableInt64Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint64, a2) : a2.push(this.readInt64());
      }
      readPackableInt64StringInto(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readSignedVarint64String, a2) : a2.push(this.readInt64String());
      }
      readPackableUint32Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint32, a2) : a2.push(this.readUint32());
      }
      readPackableUint64Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint64, a2) : a2.push(this.readUint64());
      }
      readPackableUint64StringInto(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readUnsignedVarint64String, a2) : a2.push(this.readUint64String());
      }
      readPackableSint32Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint32, a2) : a2.push(this.readSint32());
      }
      readPackableSint64Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint64, a2) : a2.push(this.readSint64());
      }
      readPackableSint64StringInto(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readZigzagVarint64String, a2) : a2.push(this.readSint64String());
      }
      readPackableFixed32Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readUint32, a2) : a2.push(this.readFixed32());
      }
      readPackableFixed64Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readUint64, a2) : a2.push(this.readFixed64());
      }
      readPackableFixed64StringInto(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readUint64String, a2) : a2.push(this.readFixed64String());
      }
      readPackableSfixed32Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readInt32, a2) : a2.push(this.readSfixed32());
      }
      readPackableSfixed64Into(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readInt64, a2) : a2.push(this.readSfixed64());
      }
      readPackableSfixed64StringInto(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readInt64String, a2) : a2.push(this.readSfixed64String());
      }
      readPackedFixed32() {
        const a2 = [];
        this.readPackableFixed32Into(a2);
        return a2;
      }
      readPackedFixed64() {
        const a2 = [];
        this.readPackableFixed64Into(a2);
        return a2;
      }
      readPackedFixed64String() {
        const a2 = [];
        this.readPackableFixed64StringInto(a2);
        return a2;
      }
      readPackedSfixed32() {
        const a2 = [];
        this.readPackableSfixed32Into(a2);
        return a2;
      }
      readPackedSfixed64String() {
        const a2 = [];
        this.readPackableSfixed64StringInto(a2);
        return a2;
      }
      readPackableFloatInto(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readFloat, a2) : a2.push(this.readFloat());
      }
      readPackableDoubleInto(a2) {
        this.isDelimited() ? this.decoder_.readDoubleArrayInto(this.readPackedFieldLength_() / 8, a2) : a2.push(this.readDouble());
      }
      readPackableBoolInto(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readBool, a2) : a2.push(this.readBool());
      }
      readPackableEnumInto(a2) {
        this.isDelimited() ? this.readPackedFieldInto_(module$contents$jspb$binary$decoder_BinaryDecoder.readEnum, a2) : a2.push(this.readEnum());
      }
      static resetInstanceCache() {
        _module$contents$jspb$binary$reader_BinaryReader.instanceCache_ = [];
      }
      static getInstanceCache() {
        return _module$contents$jspb$binary$reader_BinaryReader.instanceCache_;
      }
    };
    goog.exportProperty(module$contents$jspb$binary$reader_BinaryReader.prototype, "readPackedSfixed64String", module$contents$jspb$binary$reader_BinaryReader.prototype.readPackedSfixed64String);
    goog.exportProperty(module$contents$jspb$binary$reader_BinaryReader.prototype, "readPackedSfixed32", module$contents$jspb$binary$reader_BinaryReader.prototype.readPackedSfixed32);
    goog.exportProperty(module$contents$jspb$binary$reader_BinaryReader.prototype, "readPackedFixed64String", module$contents$jspb$binary$reader_BinaryReader.prototype.readPackedFixed64String);
    goog.exportProperty(module$contents$jspb$binary$reader_BinaryReader.prototype, "readPackedFixed64", module$contents$jspb$binary$reader_BinaryReader.prototype.readPackedFixed64);
    goog.exportProperty(module$contents$jspb$binary$reader_BinaryReader.prototype, "readPackedFixed32", module$contents$jspb$binary$reader_BinaryReader.prototype.readPackedFixed32);
    function module$contents$jspb$binary$reader_parseWireType(a2) {
      return a2 & 7;
    }
    function module$contents$jspb$binary$reader_parseFieldNumber(a2) {
      return a2 >>> 3;
    }
    module$contents$jspb$binary$reader_BinaryReader.instanceCache_ = [];
    var module$contents$jspb$binary$reader_MESSAGE_SET_START_GROUP_TAG = module$contents$jspb$utils_makeTag(module$contents$jspb$BinaryConstants_MESSAGE_SET_GROUP_NUMBER, module$contents$jspb$BinaryConstants_WireType.START_GROUP);
    var module$contents$jspb$binary$reader_MESSAGE_SET_TYPE_ID_TAG = module$contents$jspb$utils_makeTag(module$contents$jspb$BinaryConstants_MESSAGE_SET_TYPE_ID_FIELD_NUMBER, module$contents$jspb$BinaryConstants_WireType.VARINT);
    var module$contents$jspb$binary$reader_MESSAGE_SET_MESSAGE_TAG = module$contents$jspb$utils_makeTag(module$contents$jspb$BinaryConstants_MESSAGE_SET_MESSAGE_FIELD_NUMBER, module$contents$jspb$BinaryConstants_WireType.DELIMITED);
    var module$contents$jspb$binary$reader_MESSAGE_SET_END_TAG = module$contents$jspb$utils_makeTag(module$contents$jspb$BinaryConstants_MESSAGE_SET_GROUP_NUMBER, module$contents$jspb$BinaryConstants_WireType.END_GROUP);
    jspb.binary.reader.BinaryReader = module$contents$jspb$binary$reader_BinaryReader;
    jspb.binary.reader.BinaryReaderOptions = module$contents$jspb$binary$reader_BinaryReaderOptions;
    jspb.binary.reader.UTF8_PARSING_ERRORS_ARE_FATAL = module$contents$jspb$binary$reader_UTF8_PARSING_ERRORS_ARE_FATAL;
    var module$contents$jspb$ExtensionFieldInfo_ExtensionFieldInfo = function(a2, b2, c, d, e) {
      this.fieldIndex = a2;
      this.fieldName = b2;
      this.ctor = c;
      this.toObjectFn = d;
      this.isRepeated = e;
    };
    module$contents$jspb$ExtensionFieldInfo_ExtensionFieldInfo.prototype.isMessageType = function() {
      return !!this.ctor;
    };
    goog.exportProperty(module$contents$jspb$ExtensionFieldInfo_ExtensionFieldInfo.prototype, "isMessageType", module$contents$jspb$ExtensionFieldInfo_ExtensionFieldInfo.prototype.isMessageType);
    jspb.ExtensionFieldInfo = module$contents$jspb$ExtensionFieldInfo_ExtensionFieldInfo;
    var module$contents$jspb$ExtensionFieldBinaryInfo_ExtensionFieldBinaryInfo = function(a2, b2, c, d, e, f) {
      this.fieldInfo = a2;
      this.binaryReaderFn = b2;
      this.binaryWriterFn = c;
      this.binaryMessageSerializeFn = d;
      this.binaryMessageDeserializeFn = e;
      this.isPacked = f;
    };
    jspb.ExtensionFieldBinaryInfo = module$contents$jspb$ExtensionFieldBinaryInfo_ExtensionFieldBinaryInfo;
    var module$contents$jspb$Message_Message = function() {
    };
    module$contents$jspb$Message_Message.GENERATE_TO_OBJECT = true;
    goog.exportSymbol("module$contents$jspb$Message_Message.GENERATE_TO_OBJECT", module$contents$jspb$Message_Message.GENERATE_TO_OBJECT);
    module$contents$jspb$Message_Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE;
    goog.exportSymbol("module$contents$jspb$Message_Message.GENERATE_FROM_OBJECT", module$contents$jspb$Message_Message.GENERATE_FROM_OBJECT);
    module$contents$jspb$Message_Message.GENERATE_TO_STRING = true;
    module$contents$jspb$Message_Message.ASSUME_LOCAL_ARRAYS = false;
    module$contents$jspb$Message_Message.SERIALIZE_EMPTY_TRAILING_FIELDS = true;
    module$contents$jspb$Message_Message.SUPPORTS_UINT8ARRAY_ = "function" == typeof Uint8Array;
    module$contents$jspb$Message_Message.prototype.getJsPbMessageId = function() {
      return this.messageId_;
    };
    goog.exportProperty(module$contents$jspb$Message_Message.prototype, "getJsPbMessageId", module$contents$jspb$Message_Message.prototype.getJsPbMessageId);
    module$contents$jspb$Message_Message.getIndex_ = function(a2, b2) {
      return b2 + a2.arrayIndexOffset_;
    };
    module$contents$jspb$Message_Message.hiddenES6Property_ = class {
    };
    module$contents$jspb$Message_Message.getFieldNumber_ = function(a2, b2) {
      return b2 - a2.arrayIndexOffset_;
    };
    module$contents$jspb$Message_Message.initialize = function(a2, b2, c, d, e, f) {
      a2.wrappers_ = null;
      b2 ||= c ? [c] : [];
      a2.messageId_ = c ? String(c) : void 0;
      a2.arrayIndexOffset_ = 0 === c ? -1 : 0;
      a2.array = b2;
      module$contents$jspb$Message_Message.initPivotAndExtensionObject_(a2, d);
      a2.convertedPrimitiveFields_ = {};
      module$contents$jspb$Message_Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (a2.repeatedFields = e);
      if (e) for (b2 = 0; b2 < e.length; b2++) c = e[b2], c < a2.pivot_ ? (c = module$contents$jspb$Message_Message.getIndex_(a2, c), a2.array[c] = a2.array[c] || module$contents$jspb$Message_Message.EMPTY_LIST_SENTINEL_) : (module$contents$jspb$Message_Message.maybeInitEmptyExtensionObject_(a2), a2.extensionObject_[c] = a2.extensionObject_[c] || module$contents$jspb$Message_Message.EMPTY_LIST_SENTINEL_);
      if (f && f.length) for (b2 = 0; b2 < f.length; b2++) module$contents$jspb$Message_Message.computeOneofCase(a2, f[b2]);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.initialize", module$contents$jspb$Message_Message.initialize);
    module$contents$jspb$Message_Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [];
    module$contents$jspb$Message_Message.isArray_ = function(a2) {
      return module$contents$jspb$Message_Message.ASSUME_LOCAL_ARRAYS ? a2 instanceof Array : Array.isArray(a2);
    };
    module$contents$jspb$Message_Message.isExtensionObject_ = function(a2) {
      return null !== a2 && "object" == typeof a2 && !module$contents$jspb$Message_Message.isArray_(a2) && !(module$contents$jspb$Message_Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array);
    };
    module$contents$jspb$Message_Message.initPivotAndExtensionObject_ = function(a2, b2) {
      var c = a2.array.length, d = -1;
      if (c && (d = c - 1, c = a2.array[d], module$contents$jspb$Message_Message.isExtensionObject_(c))) {
        a2.pivot_ = module$contents$jspb$Message_Message.getFieldNumber_(a2, d);
        a2.extensionObject_ = c;
        return;
      }
      -1 < b2 ? (a2.pivot_ = Math.max(b2, module$contents$jspb$Message_Message.getFieldNumber_(a2, d + 1)), a2.extensionObject_ = null) : a2.pivot_ = Number.MAX_VALUE;
    };
    module$contents$jspb$Message_Message.maybeInitEmptyExtensionObject_ = function(a2) {
      var b2 = module$contents$jspb$Message_Message.getIndex_(a2, a2.pivot_);
      a2.array[b2] || (a2.extensionObject_ = a2.array[b2] = {});
    };
    module$contents$jspb$Message_Message.toObjectList = function(a2, b2, c) {
      for (var d = [], e = 0; e < a2.length; e++) d[e] = b2.call(a2[e], c, a2[e]);
      return d;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.toObjectList", module$contents$jspb$Message_Message.toObjectList);
    module$contents$jspb$Message_Message.toObjectExtension = function(a2, b2, c, d, e) {
      for (var f in c) {
        var g = c[f], h = d.call(a2, g);
        if (null != h) {
          for (var l in g.fieldName) if (g.fieldName.hasOwnProperty(l)) break;
          b2[l] = g.toObjectFn ? g.isRepeated ? module$contents$jspb$Message_Message.toObjectList(h, g.toObjectFn, e) : g.toObjectFn(e, h) : h;
        }
      }
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.toObjectExtension", module$contents$jspb$Message_Message.toObjectExtension);
    module$contents$jspb$Message_Message.serializeBinaryExtensions = function(a2, b2, c, d) {
      for (var e in c) {
        var f = c[e], g = f.fieldInfo;
        if (!f.binaryWriterFn) throw Error("Message extension present that was generated without binary serialization support");
        var h = d.call(a2, g);
        if (null != h) if (g.isMessageType()) if (f.binaryMessageSerializeFn) f.binaryWriterFn.call(b2, g.fieldIndex, h, f.binaryMessageSerializeFn);
        else throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
        else f.binaryWriterFn.call(b2, g.fieldIndex, h);
      }
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.serializeBinaryExtensions", module$contents$jspb$Message_Message.serializeBinaryExtensions);
    module$contents$jspb$Message_Message.readBinaryExtension = function(a2, b2, c, d, e) {
      var f = c[b2.getFieldNumber()];
      if (f) {
        c = f.fieldInfo;
        if (!f.binaryReaderFn) throw Error("Deserializing extension whose generated code does not support binary format");
        if (c.isMessageType()) {
          var g = new c.ctor();
          f.binaryReaderFn.call(b2, g, f.binaryMessageDeserializeFn);
        } else {
          if (c.isRepeated && f.isPacked) {
            g = d.call(a2, c) ?? [];
            f.binaryReaderFn.call(b2, g);
            e.call(a2, c, g);
            return;
          }
          g = f.binaryReaderFn.call(b2);
        }
        c.isRepeated && !f.isPacked ? (b2 = d.call(a2, c)) ? b2.push(g) : e.call(a2, c, [g]) : e.call(a2, c, g);
      } else b2.skipField();
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.readBinaryExtension", module$contents$jspb$Message_Message.readBinaryExtension);
    module$contents$jspb$Message_Message.getField = function(a2, b2) {
      if (b2 < a2.pivot_) {
        b2 = module$contents$jspb$Message_Message.getIndex_(a2, b2);
        var c = a2.array[b2];
        return c === module$contents$jspb$Message_Message.EMPTY_LIST_SENTINEL_ ? a2.array[b2] = [] : c;
      }
      if (a2.extensionObject_) return c = a2.extensionObject_[b2], c === module$contents$jspb$Message_Message.EMPTY_LIST_SENTINEL_ ? a2.extensionObject_[b2] = [] : c;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getField", module$contents$jspb$Message_Message.getField);
    module$contents$jspb$Message_Message.getRepeatedField = function(a2, b2) {
      return module$contents$jspb$Message_Message.getField(a2, b2);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getRepeatedField", module$contents$jspb$Message_Message.getRepeatedField);
    module$contents$jspb$Message_Message.getOptionalFloatingPointField = function(a2, b2) {
      a2 = module$contents$jspb$Message_Message.getField(a2, b2);
      return null == a2 ? a2 : +a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getOptionalFloatingPointField", module$contents$jspb$Message_Message.getOptionalFloatingPointField);
    module$contents$jspb$Message_Message.getBooleanField = function(a2, b2) {
      a2 = module$contents$jspb$Message_Message.getField(a2, b2);
      return null == a2 ? a2 : !!a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getBooleanField", module$contents$jspb$Message_Message.getBooleanField);
    module$contents$jspb$Message_Message.getRepeatedFloatingPointField = function(a2, b2) {
      var c = module$contents$jspb$Message_Message.getRepeatedField(a2, b2);
      a2.convertedPrimitiveFields_ || (a2.convertedPrimitiveFields_ = {});
      if (!a2.convertedPrimitiveFields_[b2]) {
        for (var d = 0; d < c.length; d++) c[d] = +c[d];
        a2.convertedPrimitiveFields_[b2] = true;
      }
      return c;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getRepeatedFloatingPointField", module$contents$jspb$Message_Message.getRepeatedFloatingPointField);
    module$contents$jspb$Message_Message.getRepeatedBooleanField = function(a2, b2) {
      var c = module$contents$jspb$Message_Message.getRepeatedField(a2, b2);
      a2.convertedPrimitiveFields_ || (a2.convertedPrimitiveFields_ = {});
      if (!a2.convertedPrimitiveFields_[b2]) {
        for (var d = 0; d < c.length; d++) c[d] = !!c[d];
        a2.convertedPrimitiveFields_[b2] = true;
      }
      return c;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getRepeatedBooleanField", module$contents$jspb$Message_Message.getRepeatedBooleanField);
    module$contents$jspb$Message_Message.bytesAsB64 = function(a2) {
      if (null == a2 || "string" === typeof a2) return a2;
      if (module$contents$jspb$Message_Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array) return goog.crypt.base64.encodeByteArray(a2);
      module$contents$jspb$asserts_fail("Cannot coerce to b64 string: " + goog.typeOf(a2));
      return null;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.bytesAsB64", module$contents$jspb$Message_Message.bytesAsB64);
    module$contents$jspb$Message_Message.bytesAsU8 = function(a2) {
      if (null == a2 || a2 instanceof Uint8Array) return a2;
      if ("string" === typeof a2) return goog.crypt.base64.decodeStringToUint8Array(a2);
      module$contents$jspb$asserts_fail("Cannot coerce to Uint8Array: " + goog.typeOf(a2));
      return null;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.bytesAsU8", module$contents$jspb$Message_Message.bytesAsU8);
    module$contents$jspb$Message_Message.bytesListAsB64 = function(a2) {
      module$contents$jspb$Message_Message.assertConsistentTypes_(a2);
      return a2.length && "string" !== typeof a2[0] ? module$contents$goog$array_map(a2, module$contents$jspb$Message_Message.bytesAsB64) : a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.bytesListAsB64", module$contents$jspb$Message_Message.bytesListAsB64);
    module$contents$jspb$Message_Message.bytesListAsU8 = function(a2) {
      module$contents$jspb$Message_Message.assertConsistentTypes_(a2);
      return !a2.length || a2[0] instanceof Uint8Array ? a2 : module$contents$goog$array_map(a2, module$contents$jspb$Message_Message.bytesAsU8);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.bytesListAsU8", module$contents$jspb$Message_Message.bytesListAsU8);
    module$contents$jspb$Message_Message.assertConsistentTypes_ = function(a2) {
      if (goog.DEBUG && a2 && 1 < a2.length) {
        var b2 = goog.typeOf(a2[0]);
        module$contents$goog$array_forEach(a2, function(c) {
          goog.typeOf(c) != b2 && module$contents$jspb$asserts_fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(c) + " expected " + b2);
        });
      }
    };
    module$contents$jspb$Message_Message.getFieldWithDefault = function(a2, b2, c) {
      a2 = module$contents$jspb$Message_Message.getField(a2, b2);
      return null == a2 ? c : a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getFieldWithDefault", module$contents$jspb$Message_Message.getFieldWithDefault);
    module$contents$jspb$Message_Message.getBooleanFieldWithDefault = function(a2, b2, c) {
      a2 = module$contents$jspb$Message_Message.getBooleanField(a2, b2);
      return null == a2 ? c : a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getBooleanFieldWithDefault", module$contents$jspb$Message_Message.getBooleanFieldWithDefault);
    module$contents$jspb$Message_Message.getFloatingPointFieldWithDefault = function(a2, b2, c) {
      a2 = module$contents$jspb$Message_Message.getOptionalFloatingPointField(a2, b2);
      return null == a2 ? c : a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getFloatingPointFieldWithDefault", module$contents$jspb$Message_Message.getFloatingPointFieldWithDefault);
    module$contents$jspb$Message_Message.getFieldProto3 = module$contents$jspb$Message_Message.getFieldWithDefault;
    goog.exportSymbol("module$contents$jspb$Message_Message.getFieldProto3", module$contents$jspb$Message_Message.getFieldProto3);
    module$contents$jspb$Message_Message.getMapField = function(a2, b2, c, d) {
      a2.wrappers_ || (a2.wrappers_ = {});
      if (b2 in a2.wrappers_) return a2.wrappers_[b2];
      var e = module$contents$jspb$Message_Message.getField(a2, b2);
      if (!e) {
        if (c) return;
        e = [];
        module$contents$jspb$Message_Message.setField(a2, b2, e);
      }
      return a2.wrappers_[b2] = new module$contents$jspb$Map_Map(e, d);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getMapField", module$contents$jspb$Message_Message.getMapField);
    module$contents$jspb$Message_Message.setField = function(a2, b2, c) {
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message);
      b2 < a2.pivot_ ? a2.array[module$contents$jspb$Message_Message.getIndex_(a2, b2)] = c : (module$contents$jspb$Message_Message.maybeInitEmptyExtensionObject_(a2), a2.extensionObject_[b2] = c);
      return a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setField", module$contents$jspb$Message_Message.setField);
    module$contents$jspb$Message_Message.setProto3IntField = function(a2, b2, c) {
      return module$contents$jspb$Message_Message.setFieldIgnoringDefault_(a2, b2, c, 0);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setProto3IntField", module$contents$jspb$Message_Message.setProto3IntField);
    module$contents$jspb$Message_Message.setProto3FloatField = function(a2, b2, c) {
      return module$contents$jspb$Message_Message.setFieldIgnoringDefault_(a2, b2, c, 0);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setProto3FloatField", module$contents$jspb$Message_Message.setProto3FloatField);
    module$contents$jspb$Message_Message.setProto3BooleanField = function(a2, b2, c) {
      return module$contents$jspb$Message_Message.setFieldIgnoringDefault_(a2, b2, c, false);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setProto3BooleanField", module$contents$jspb$Message_Message.setProto3BooleanField);
    module$contents$jspb$Message_Message.setProto3StringField = function(a2, b2, c) {
      return module$contents$jspb$Message_Message.setFieldIgnoringDefault_(a2, b2, c, "");
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setProto3StringField", module$contents$jspb$Message_Message.setProto3StringField);
    module$contents$jspb$Message_Message.setProto3BytesField = function(a2, b2, c) {
      return module$contents$jspb$Message_Message.setFieldIgnoringDefault_(a2, b2, c, "");
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setProto3BytesField", module$contents$jspb$Message_Message.setProto3BytesField);
    module$contents$jspb$Message_Message.setProto3EnumField = function(a2, b2, c) {
      return module$contents$jspb$Message_Message.setFieldIgnoringDefault_(a2, b2, c, 0);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setProto3EnumField", module$contents$jspb$Message_Message.setProto3EnumField);
    module$contents$jspb$Message_Message.setProto3StringIntField = function(a2, b2, c) {
      return module$contents$jspb$Message_Message.setFieldIgnoringDefault_(a2, b2, c, "0");
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setProto3StringIntField", module$contents$jspb$Message_Message.setProto3StringIntField);
    module$contents$jspb$Message_Message.setFieldIgnoringDefault_ = function(a2, b2, c, d) {
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message);
      c !== d ? module$contents$jspb$Message_Message.setField(a2, b2, c) : b2 < a2.pivot_ ? a2.array[module$contents$jspb$Message_Message.getIndex_(a2, b2)] = null : (module$contents$jspb$Message_Message.maybeInitEmptyExtensionObject_(a2), delete a2.extensionObject_[b2]);
      return a2;
    };
    module$contents$jspb$Message_Message.addToRepeatedField = function(a2, b2, c, d) {
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message);
      b2 = module$contents$jspb$Message_Message.getRepeatedField(a2, b2);
      void 0 != d ? b2.splice(d, 0, c) : b2.push(c);
      return a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.addToRepeatedField", module$contents$jspb$Message_Message.addToRepeatedField);
    module$contents$jspb$Message_Message.setOneofField = function(a2, b2, c, d) {
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message);
      (c = module$contents$jspb$Message_Message.computeOneofCase(a2, c)) && c !== b2 && void 0 !== d && (a2.wrappers_ && c in a2.wrappers_ && (a2.wrappers_[c] = void 0), module$contents$jspb$Message_Message.setField(a2, c, void 0));
      return module$contents$jspb$Message_Message.setField(a2, b2, d);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setOneofField", module$contents$jspb$Message_Message.setOneofField);
    module$contents$jspb$Message_Message.computeOneofCase = function(a2, b2) {
      for (var c, d, e = 0; e < b2.length; e++) {
        var f = b2[e], g = module$contents$jspb$Message_Message.getField(a2, f);
        null != g && (c = f, d = g, module$contents$jspb$Message_Message.setField(a2, f, void 0));
      }
      return c ? (module$contents$jspb$Message_Message.setField(a2, c, d), c) : 0;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.computeOneofCase", module$contents$jspb$Message_Message.computeOneofCase);
    module$contents$jspb$Message_Message.getWrapperField = function(a2, b2, c, d) {
      a2.wrappers_ || (a2.wrappers_ = {});
      if (!a2.wrappers_[c]) {
        var e = module$contents$jspb$Message_Message.getField(a2, c);
        if (d || e) a2.wrappers_[c] = new b2(e);
      }
      return a2.wrappers_[c];
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getWrapperField", module$contents$jspb$Message_Message.getWrapperField);
    module$contents$jspb$Message_Message.getRepeatedWrapperField = function(a2, b2, c) {
      module$contents$jspb$Message_Message.wrapRepeatedField_(a2, b2, c);
      b2 = a2.wrappers_[c];
      b2 == module$contents$jspb$Message_Message.EMPTY_LIST_SENTINEL_ && (b2 = a2.wrappers_[c] = []);
      return b2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.getRepeatedWrapperField", module$contents$jspb$Message_Message.getRepeatedWrapperField);
    module$contents$jspb$Message_Message.wrapRepeatedField_ = function(a2, b2, c) {
      a2.wrappers_ || (a2.wrappers_ = {});
      if (!a2.wrappers_[c]) {
        for (var d = module$contents$jspb$Message_Message.getRepeatedField(a2, c), e = [], f = 0; f < d.length; f++) e[f] = new b2(d[f]);
        a2.wrappers_[c] = e;
      }
    };
    module$contents$jspb$Message_Message.setWrapperField = function(a2, b2, c) {
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message);
      a2.wrappers_ || (a2.wrappers_ = {});
      var d = c ? c.toArray() : c;
      a2.wrappers_[b2] = c;
      return module$contents$jspb$Message_Message.setField(a2, b2, d);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setWrapperField", module$contents$jspb$Message_Message.setWrapperField);
    module$contents$jspb$Message_Message.setOneofWrapperField = function(a2, b2, c, d) {
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message);
      a2.wrappers_ || (a2.wrappers_ = {});
      var e = d ? d.toArray() : d;
      a2.wrappers_[b2] = d;
      return module$contents$jspb$Message_Message.setOneofField(a2, b2, c, e);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setOneofWrapperField", module$contents$jspb$Message_Message.setOneofWrapperField);
    module$contents$jspb$Message_Message.setRepeatedWrapperField = function(a2, b2, c) {
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message);
      a2.wrappers_ || (a2.wrappers_ = {});
      c = c || [];
      for (var d = [], e = 0; e < c.length; e++) d[e] = c[e].toArray();
      a2.wrappers_[b2] = c;
      return module$contents$jspb$Message_Message.setField(a2, b2, d);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.setRepeatedWrapperField", module$contents$jspb$Message_Message.setRepeatedWrapperField);
    module$contents$jspb$Message_Message.addToRepeatedWrapperField = function(a2, b2, c, d, e) {
      module$contents$jspb$Message_Message.wrapRepeatedField_(a2, d, b2);
      var f = a2.wrappers_[b2];
      f ||= a2.wrappers_[b2] = [];
      c = c ? c : new d();
      a2 = module$contents$jspb$Message_Message.getRepeatedField(a2, b2);
      void 0 != e ? (f.splice(e, 0, c), a2.splice(e, 0, c.toArray())) : (f.push(c), a2.push(c.toArray()));
      return c;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.addToRepeatedWrapperField", module$contents$jspb$Message_Message.addToRepeatedWrapperField);
    module$contents$jspb$Message_Message.toMap = function(a2, b2, c, d) {
      for (var e = {}, f = 0; f < a2.length; f++) e[b2.call(a2[f])] = c ? c.call(a2[f], d, a2[f]) : a2[f];
      return e;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.toMap", module$contents$jspb$Message_Message.toMap);
    module$contents$jspb$Message_Message.prototype.syncMapFields_ = function() {
      if (this.wrappers_) for (var a2 in this.wrappers_) {
        var b2 = this.wrappers_[a2];
        if (Array.isArray(b2)) for (var c = 0; c < b2.length; c++) b2[c] && b2[c].toArray();
        else b2 && b2.toArray();
      }
    };
    module$contents$jspb$Message_Message.prototype.toArray = function() {
      this.syncMapFields_();
      return this.array;
    };
    goog.exportProperty(module$contents$jspb$Message_Message.prototype, "toArray", module$contents$jspb$Message_Message.prototype.toArray);
    module$contents$jspb$Message_Message.GENERATE_TO_STRING && (module$contents$jspb$Message_Message.prototype.toString = function() {
      this.syncMapFields_();
      return this.array.toString();
    });
    module$contents$jspb$Message_Message.prototype.getExtension = function(a2) {
      if (this.extensionObject_) {
        this.wrappers_ || (this.wrappers_ = {});
        var b2 = a2.fieldIndex;
        if (a2.isRepeated) {
          if (a2.isMessageType()) return this.wrappers_[b2] || (this.wrappers_[b2] = module$contents$goog$array_map(this.extensionObject_[b2] || [], function(c) {
            return new a2.ctor(c);
          })), this.wrappers_[b2];
        } else if (a2.isMessageType()) return !this.wrappers_[b2] && this.extensionObject_[b2] && (this.wrappers_[b2] = new a2.ctor(this.extensionObject_[b2])), this.wrappers_[b2];
        return this.extensionObject_[b2];
      }
    };
    goog.exportProperty(module$contents$jspb$Message_Message.prototype, "getExtension", module$contents$jspb$Message_Message.prototype.getExtension);
    module$contents$jspb$Message_Message.prototype.setExtension = function(a2, b2) {
      this.wrappers_ || (this.wrappers_ = {});
      module$contents$jspb$Message_Message.maybeInitEmptyExtensionObject_(this);
      var c = a2.fieldIndex;
      a2.isRepeated ? (b2 = b2 || [], a2.isMessageType() ? (this.wrappers_[c] = b2, this.extensionObject_[c] = module$contents$goog$array_map(b2, function(d) {
        return d.toArray();
      })) : this.extensionObject_[c] = b2) : a2.isMessageType() ? (this.wrappers_[c] = b2, this.extensionObject_[c] = b2 ? b2.toArray() : b2) : this.extensionObject_[c] = b2;
      return this;
    };
    goog.exportProperty(module$contents$jspb$Message_Message.prototype, "setExtension", module$contents$jspb$Message_Message.prototype.setExtension);
    module$contents$jspb$Message_Message.difference = function(a2, b2) {
      if (!(a2 instanceof b2.constructor)) throw Error("Messages have different types.");
      var c = a2.toArray();
      b2 = b2.toArray();
      var d = [], e = 0, f = c.length > b2.length ? c.length : b2.length;
      a2.getJsPbMessageId() && (d[0] = a2.getJsPbMessageId(), e = 1);
      for (; e < f; e++) module$contents$jspb$Message_Message.compareFields(c[e], b2[e]) || (d[e] = b2[e]);
      return new a2.constructor(d);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.difference", module$contents$jspb$Message_Message.difference);
    module$contents$jspb$Message_Message.equals = function(a2, b2) {
      return a2 == b2 || !(!a2 || !b2) && a2 instanceof b2.constructor && module$contents$jspb$Message_Message.compareFields(a2.toArray(), b2.toArray());
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.equals", module$contents$jspb$Message_Message.equals);
    module$contents$jspb$Message_Message.compareExtensions = function(a2, b2) {
      a2 = a2 || {};
      b2 = b2 || {};
      var c = {}, d;
      for (d in a2) c[d] = 0;
      for (d in b2) c[d] = 0;
      for (d in c) if (!module$contents$jspb$Message_Message.compareFields(a2[d], b2[d])) return false;
      return true;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.compareExtensions", module$contents$jspb$Message_Message.compareExtensions);
    module$contents$jspb$Message_Message.compareFields = function(a2, b2) {
      if (a2 == b2) return true;
      if (!goog.isObject(a2) || !goog.isObject(b2)) return "number" === typeof a2 && isNaN(a2) || "number" === typeof b2 && isNaN(b2) ? String(a2) == String(b2) : false;
      if (a2.constructor != b2.constructor) return false;
      if (module$contents$jspb$Message_Message.SUPPORTS_UINT8ARRAY_ && a2.constructor === Uint8Array) {
        if (a2.length != b2.length) return false;
        for (var c = 0; c < a2.length; c++) if (a2[c] != b2[c]) return false;
        return true;
      }
      if (a2.constructor === Array) {
        var d = void 0, e = void 0, f = Math.max(
          a2.length,
          b2.length
        );
        for (c = 0; c < f; c++) {
          var g = a2[c], h = b2[c];
          g && g.constructor == Object && (module$contents$jspb$asserts_assert(void 0 === d), module$contents$jspb$asserts_assert(c === a2.length - 1), d = g, g = void 0);
          h && h.constructor == Object && (module$contents$jspb$asserts_assert(void 0 === e), module$contents$jspb$asserts_assert(c === b2.length - 1), e = h, h = void 0);
          if (!module$contents$jspb$Message_Message.compareFields(g, h)) return false;
        }
        return d || e ? (d = d || {}, e = e || {}, module$contents$jspb$Message_Message.compareExtensions(d, e)) : true;
      }
      if (a2.constructor === Object) return module$contents$jspb$Message_Message.compareExtensions(a2, b2);
      throw Error("Invalid type in JSPB array");
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.compareFields", module$contents$jspb$Message_Message.compareFields);
    module$contents$jspb$Message_Message.prototype.cloneMessage = function() {
      return module$contents$jspb$Message_Message.cloneMessage(this);
    };
    goog.exportProperty(module$contents$jspb$Message_Message.prototype, "cloneMessage", module$contents$jspb$Message_Message.prototype.cloneMessage);
    module$contents$jspb$Message_Message.prototype.clone = function() {
      return module$contents$jspb$Message_Message.cloneMessage(this);
    };
    goog.exportProperty(module$contents$jspb$Message_Message.prototype, "clone", module$contents$jspb$Message_Message.prototype.clone);
    module$contents$jspb$Message_Message.clone = function(a2) {
      return module$contents$jspb$Message_Message.cloneMessage(a2);
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.clone", module$contents$jspb$Message_Message.clone);
    module$contents$jspb$Message_Message.cloneMessage = function(a2) {
      return new a2.constructor(module$contents$jspb$Message_Message.clone_(a2.toArray()));
    };
    module$contents$jspb$Message_Message.copyInto = function(a2, b2) {
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message);
      module$contents$jspb$asserts_assertInstanceof(b2, module$contents$jspb$Message_Message);
      module$contents$jspb$asserts_assert(a2.constructor == b2.constructor, "Copy source and target message should have the same type.");
      a2 = module$contents$jspb$Message_Message.clone(a2);
      for (var c = b2.toArray(), d = a2.toArray(), e = c.length = 0; e < d.length; e++) c[e] = d[e];
      b2.wrappers_ = a2.wrappers_;
      b2.extensionObject_ = a2.extensionObject_;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.copyInto", module$contents$jspb$Message_Message.copyInto);
    module$contents$jspb$Message_Message.clone_ = function(a2) {
      if (Array.isArray(a2)) {
        for (var b2 = Array(a2.length), c = 0; c < a2.length; c++) {
          var d = a2[c];
          null != d && (b2[c] = "object" == typeof d ? module$contents$jspb$Message_Message.clone_(module$contents$jspb$asserts_assert(d)) : d);
        }
        return b2;
      }
      if (module$contents$jspb$Message_Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array) return new Uint8Array(a2);
      b2 = {};
      for (c in a2) d = a2[c], null != d && (b2[c] = "object" == typeof d ? module$contents$jspb$Message_Message.clone_(module$contents$jspb$asserts_assert(d)) : d);
      return b2;
    };
    module$contents$jspb$Message_Message.registerMessageType = function(a2, b2) {
      b2.messageId = a2;
    };
    goog.exportSymbol("module$contents$jspb$Message_Message.registerMessageType", module$contents$jspb$Message_Message.registerMessageType);
    module$contents$jspb$Message_Message.messageSetExtensions = {};
    module$contents$jspb$Message_Message.messageSetExtensionsBinary = {};
    jspb.Message = module$contents$jspb$Message_Message;
    jspb.debug = {};
    function module$contents$jspb$debug_dump(a2) {
      if (!goog.DEBUG) return null;
      module$contents$jspb$asserts_assertInstanceof(a2, module$contents$jspb$Message_Message, "jspb.Message instance expected");
      module$contents$jspb$asserts_assert(a2.getExtension, "Only unobfuscated and unoptimized compilation modes supported.");
      return module$contents$jspb$debug_dump_(a2);
    }
    function module$contents$jspb$debug_dump_(a2) {
      var b2 = goog.typeOf(a2);
      if ("number" == b2 || "string" == b2 || "boolean" == b2 || "null" == b2 || "undefined" == b2 || "undefined" !== typeof Uint8Array && a2 instanceof Uint8Array) return a2;
      if ("array" == b2) return module$contents$jspb$asserts_assertArray(a2), module$contents$goog$array_map(a2, module$contents$jspb$debug_dump_);
      if (a2 instanceof module$contents$jspb$Map_Map) {
        var c = {};
        a2 = a2.entries();
        for (var d = a2.next(); !d.done; d = a2.next()) c[d.value[0]] = module$contents$jspb$debug_dump_(d.value[1]);
        return c;
      }
      module$contents$jspb$asserts_assertInstanceof(
        a2,
        module$contents$jspb$Message_Message,
        "Only messages expected: " + a2
      );
      b2 = a2.constructor;
      var e = { $name: b2.name || b2.displayName };
      for (h in b2.prototype) {
        var f = /^get([A-Z]\w*)/.exec(h);
        if (f && "getExtension" != h && "getJsPbMessageId" != h) {
          var g = "has" + f[1];
          if (!a2[g] || a2[g]()) g = a2[h](), e[module$contents$jspb$debug_formatFieldName_(f[1])] = module$contents$jspb$debug_dump_(g);
        }
      }
      if (COMPILED && a2.extensionObject_) return e.$extensions = "Recursive dumping of extensions not supported in compiled code. Switch to uncompiled or dump extension object directly", e;
      for (d in b2.extensions) if (/^\d+$/.test(d)) {
        f = b2.extensions[d];
        var h = a2.getExtension(f);
        f = module$contents$goog$object_getKeys(f.fieldName)[0];
        null != h && (c ||= e.$extensions = {}, c[module$contents$jspb$debug_formatFieldName_(f)] = module$contents$jspb$debug_dump_(h));
      }
      return e;
    }
    function module$contents$jspb$debug_formatFieldName_(a2) {
      return a2.replace(/^[A-Z]/, function(b2) {
        return b2.toLowerCase();
      });
    }
    jspb.debug.dump = module$contents$jspb$debug_dump;
    jspb.BinaryReader = module$contents$jspb$binary$reader_BinaryReader;
    jspb.binary.encoder = {};
    var module$contents$jspb$binary$encoder_MAX_PUSH = 8192;
    var module$contents$jspb$binary$encoder_BinaryEncoder = class {
      constructor() {
        this.buffer_ = [];
      }
      length() {
        return this.buffer_.length;
      }
      end() {
        const a2 = this.buffer_;
        this.buffer_ = [];
        return a2;
      }
      writeSplitVarint64(a2, b2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(b2 == Math.floor(b2));
        goog.asserts.assert(0 <= a2 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_32);
        for (goog.asserts.assert(0 <= b2 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_32); 0 < b2 || 127 < a2; ) this.buffer_.push(a2 & 127 | 128), a2 = (a2 >>> 7 | b2 << 25) >>> 0, b2 >>>= 7;
        this.buffer_.push(a2);
      }
      writeSplitFixed64(a2, b2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(b2 == Math.floor(b2));
        goog.asserts.assert(0 <= a2 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_32);
        goog.asserts.assert(0 <= b2 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_32);
        this.writeUint32(a2);
        this.writeUint32(b2);
      }
      writeSplitZigzagVarint64(a2, b2) {
        module$contents$jspb$utils_toZigzag64(a2, b2, (c, d) => {
          this.writeSplitVarint64(c >>> 0, d >>> 0);
        });
      }
      writeUnsignedVarint32(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        for (goog.asserts.assert(0 <= a2 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_32); 127 < a2; ) this.buffer_.push(a2 & 127 | 128), a2 >>>= 7;
        this.buffer_.push(a2);
      }
      writeSignedVarint32(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(a2 >= -module$contents$jspb$BinaryConstants_TWO_TO_31 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_31);
        if (0 <= a2) this.writeUnsignedVarint32(a2);
        else {
          for (let b2 = 0; 9 > b2; b2++) this.buffer_.push(a2 & 127 | 128), a2 >>= 7;
          this.buffer_.push(1);
        }
      }
      writeUnsignedVarint64(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(0 <= a2 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_64);
        module$contents$jspb$utils_splitInt64(a2);
        this.writeSplitVarint64(module$contents$jspb$utils_getSplit64Low(), module$contents$jspb$utils_getSplit64High());
      }
      writeSignedVarint64(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(a2 >= -module$contents$jspb$BinaryConstants_TWO_TO_63 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_63);
        module$contents$jspb$utils_splitInt64(a2);
        this.writeSplitVarint64(module$contents$jspb$utils_getSplit64Low(), module$contents$jspb$utils_getSplit64High());
      }
      writeZigzagVarint32(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(a2 >= -module$contents$jspb$BinaryConstants_TWO_TO_31 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_31);
        this.writeUnsignedVarint32(module$contents$jspb$utils_toZigzag32(a2));
      }
      writeZigzagVarint64(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(a2 >= -module$contents$jspb$BinaryConstants_TWO_TO_63 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_63);
        module$contents$jspb$utils_splitZigzag64(a2);
        this.writeSplitVarint64(module$contents$jspb$utils_getSplit64Low(), module$contents$jspb$utils_getSplit64High());
      }
      writeZigzagVarint64String(a2) {
        module$contents$jspb$utils_splitDecimalString(a2);
        module$contents$jspb$utils_toZigzag64(module$contents$jspb$utils_getSplit64Low(), module$contents$jspb$utils_getSplit64High(), (b2, c) => {
          this.writeSplitVarint64(b2 >>> 0, c >>> 0);
        });
      }
      writeUint8(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(0 <= a2 && 256 > a2);
        this.buffer_.push(a2 >>> 0 & 255);
      }
      writeUint16(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(0 <= a2 && 65536 > a2);
        this.buffer_.push(a2 >>> 0 & 255);
        this.buffer_.push(a2 >>> 8 & 255);
      }
      writeUint32(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(0 <= a2 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_32);
        this.buffer_.push(a2 >>> 0 & 255);
        this.buffer_.push(a2 >>> 8 & 255);
        this.buffer_.push(a2 >>> 16 & 255);
        this.buffer_.push(a2 >>> 24 & 255);
      }
      writeUint64(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(0 <= a2 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_64);
        module$contents$jspb$utils_splitUint64(a2);
        this.writeUint32(module$contents$jspb$utils_getSplit64Low());
        this.writeUint32(module$contents$jspb$utils_getSplit64High());
      }
      writeInt8(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(-128 <= a2 && 128 > a2);
        this.buffer_.push(a2 >>> 0 & 255);
      }
      writeInt16(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(-32768 <= a2 && 32768 > a2);
        this.buffer_.push(a2 >>> 0 & 255);
        this.buffer_.push(a2 >>> 8 & 255);
      }
      writeInt32(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(a2 >= -module$contents$jspb$BinaryConstants_TWO_TO_31 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_31);
        this.buffer_.push(a2 >>> 0 & 255);
        this.buffer_.push(a2 >>> 8 & 255);
        this.buffer_.push(a2 >>> 16 & 255);
        this.buffer_.push(a2 >>> 24 & 255);
      }
      writeInt64(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(a2 >= -module$contents$jspb$BinaryConstants_TWO_TO_63 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_63);
        module$contents$jspb$utils_splitInt64(a2);
        this.writeSplitFixed64(module$contents$jspb$utils_getSplit64Low(), module$contents$jspb$utils_getSplit64High());
      }
      writeFloat(a2) {
        goog.asserts.assert(Infinity == a2 || -Infinity == a2 || isNaN(a2) || "number" === typeof a2 && a2 >= -module$contents$jspb$BinaryConstants_FLOAT32_MAX && a2 <= module$contents$jspb$BinaryConstants_FLOAT32_MAX);
        module$contents$jspb$utils_splitFloat32(a2);
        this.writeUint32(module$contents$jspb$utils_getSplit64Low());
      }
      writeDouble(a2) {
        goog.asserts.assert("number" === typeof a2 || "Infinity" === a2 || "-Infinity" === a2 || "NaN" === a2);
        module$contents$jspb$utils_splitFloat64(a2);
        this.writeUint32(module$contents$jspb$utils_getSplit64Low());
        this.writeUint32(module$contents$jspb$utils_getSplit64High());
      }
      writeBool(a2) {
        goog.asserts.assert("boolean" === typeof a2 || "number" === typeof a2);
        this.buffer_.push(a2 ? 1 : 0);
      }
      writeEnum(a2) {
        goog.asserts.assert(a2 == Math.floor(a2));
        goog.asserts.assert(a2 >= -module$contents$jspb$BinaryConstants_TWO_TO_31 && a2 < module$contents$jspb$BinaryConstants_TWO_TO_31);
        this.writeSignedVarint32(a2);
      }
      writeBytes(a2) {
        for (; a2.length > module$contents$jspb$binary$encoder_MAX_PUSH; ) Array.prototype.push.apply(this.buffer_, a2.subarray(0, module$contents$jspb$binary$encoder_MAX_PUSH)), a2 = a2.subarray(module$contents$jspb$binary$encoder_MAX_PUSH);
        Array.prototype.push.apply(this.buffer_, a2);
      }
    };
    jspb.binary.encoder.BinaryEncoder = module$contents$jspb$binary$encoder_BinaryEncoder;
    jspb.arith = {};
    var module$contents$jspb$arith_UInt64 = class _module$contents$jspb$arith_UInt64 {
      constructor(a2, b2) {
        this.lo = a2 >>> 0;
        this.hi = b2 >>> 0;
      }
      toDecimalString() {
        return module$contents$jspb$utils_joinUnsignedDecimalString(this.lo, this.hi);
      }
      negateInTwosComplement() {
        return 0 === this.lo ? new _module$contents$jspb$arith_UInt64(0, 1 + ~this.hi) : new _module$contents$jspb$arith_UInt64(~this.lo + 1, ~this.hi);
      }
      static fromBigInt(a2) {
        a2 = BigInt.asUintN(64, a2);
        return new _module$contents$jspb$arith_UInt64(Number(a2 & BigInt(4294967295)), Number(a2 >> BigInt(32)));
      }
      static fromString(a2) {
        if (!a2) return _module$contents$jspb$arith_UInt64.getZero();
        if (!/^\d+$/.test(a2)) return null;
        module$contents$jspb$utils_splitDecimalString(a2);
        return new _module$contents$jspb$arith_UInt64(module$contents$jspb$utils_getSplit64Low(), module$contents$jspb$utils_getSplit64High());
      }
      static fromNumber(a2) {
        return new _module$contents$jspb$arith_UInt64(a2 & module$contents$jspb$arith_ALL_32_BITS, a2 / module$contents$jspb$arith_TWO_PWR_32_DBL);
      }
      static getZero() {
        return module$contents$jspb$arith_uint64Zero ||= new _module$contents$jspb$arith_UInt64(0, 0);
      }
    };
    var module$contents$jspb$arith_uint64Zero;
    var module$contents$jspb$arith_Int64 = class _module$contents$jspb$arith_Int64 {
      constructor(a2, b2) {
        this.lo = a2 >>> 0;
        this.hi = b2 >>> 0;
      }
      toDecimalString() {
        return module$contents$jspb$utils_joinSignedDecimalString(this.lo, this.hi);
      }
      static fromBigInt(a2) {
        a2 = BigInt.asUintN(64, a2);
        return new _module$contents$jspb$arith_Int64(Number(a2 & BigInt(4294967295)), Number(a2 >> BigInt(32)));
      }
      static fromString(a2) {
        if (!a2) return _module$contents$jspb$arith_Int64.getZero();
        if (!/^-?\d+$/.test(a2)) return null;
        module$contents$jspb$utils_splitDecimalString(a2);
        return new _module$contents$jspb$arith_Int64(
          module$contents$jspb$utils_getSplit64Low(),
          module$contents$jspb$utils_getSplit64High()
        );
      }
      static fromNumber(a2) {
        return new _module$contents$jspb$arith_Int64(a2 & module$contents$jspb$arith_ALL_32_BITS, a2 / module$contents$jspb$arith_TWO_PWR_32_DBL);
      }
      static getZero() {
        return module$contents$jspb$arith_int64Zero ||= new _module$contents$jspb$arith_Int64(0, 0);
      }
    };
    var module$contents$jspb$arith_int64Zero;
    var module$contents$jspb$arith_ALL_32_BITS = 4294967295;
    var module$contents$jspb$arith_TWO_PWR_32_DBL = 4294967296;
    jspb.arith.UInt64 = module$contents$jspb$arith_UInt64;
    jspb.arith.Int64 = module$contents$jspb$arith_Int64;
    jspb.binary.writer = {};
    var module$contents$jspb$binary$writer_REJECT_UNPAIRED_SURROGATES = goog.DEBUG;
    var module$contents$jspb$binary$writer_BinaryWriter = class {
      constructor() {
        this.blocks_ = [];
        this.totalLength_ = 0;
        this.encoder_ = new module$contents$jspb$binary$encoder_BinaryEncoder();
      }
      pushBlock(a2) {
        0 !== a2.length && (this.blocks_.push(a2), this.totalLength_ += a2.length);
      }
      appendUint8Array_(a2) {
        this.pushBlock(this.encoder_.end());
        this.pushBlock(a2);
      }
      beginDelimited_(a2) {
        this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.DELIMITED);
        a2 = this.encoder_.end();
        this.pushBlock(a2);
        a2.push(this.totalLength_);
        return a2;
      }
      endDelimited_(a2) {
        var b2 = a2.pop();
        b2 = this.totalLength_ + this.encoder_.length() - b2;
        for ((0, goog.asserts.assert)(0 <= b2); 127 < b2; ) a2.push(b2 & 127 | 128), b2 >>>= 7, this.totalLength_++;
        a2.push(b2);
        this.totalLength_++;
      }
      writeUnknownFields(a2) {
        this.pushBlock(this.encoder_.end());
        for (let b2 = 0; b2 < a2.length; b2++) this.pushBlock(module$contents$jspb$unsafe_bytestring_unsafeUint8ArrayFromByteString(a2[b2]));
      }
      writeSerializedMessage(a2, b2, c) {
        this.appendUint8Array_(a2.subarray(b2, c));
      }
      maybeWriteSerializedMessage(a2, b2, c) {
        null != a2 && null != b2 && null != c && this.writeSerializedMessage(
          a2,
          b2,
          c
        );
      }
      reset() {
        this.blocks_ = [];
        this.encoder_.end();
        this.totalLength_ = 0;
      }
      getResultBuffer() {
        this.pushBlock(this.encoder_.end());
        const a2 = new Uint8Array(this.totalLength_), b2 = this.blocks_, c = b2.length;
        let d = 0;
        for (let e = 0; e < c; e++) {
          const f = b2[e];
          a2.set(f, d);
          d += f.length;
        }
        (0, goog.asserts.assert)(d == a2.length);
        this.blocks_ = [a2];
        return a2;
      }
      getResultBufferAsByteString() {
        return module$contents$jspb$unsafe_bytestring_unsafeByteStringFromUint8Array(this.getResultBuffer());
      }
      getResultBase64String(a2) {
        return void 0 === a2 ? module$contents$jspb$internal_bytes_encodeByteArray(this.getResultBuffer()) : (0, goog.crypt.base64.encodeByteArray)(this.getResultBuffer(), a2);
      }
      writeFieldHeader_(a2, b2) {
        (0, goog.asserts.assert)(1 <= a2 && a2 == Math.floor(a2));
        this.encoder_.writeUnsignedVarint32(module$contents$jspb$utils_makeTag(a2, b2));
      }
      writeAny(a2, b2, c) {
        switch (a2) {
          case module$contents$jspb$BinaryConstants_FieldType.DOUBLE:
            this.writeDouble(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.FLOAT:
            this.writeFloat(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.INT64:
            this.writeInt64(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.UINT64:
            this.writeUint64(
              b2,
              c
            );
            break;
          case module$contents$jspb$BinaryConstants_FieldType.INT32:
            this.writeInt32(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.FIXED64:
            this.writeFixed64(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.FIXED32:
            this.writeFixed32(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.BOOL:
            this.writeBool(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.STRING:
            this.writeString(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.GROUP:
            (0, goog.asserts.fail)("Group field type not supported in writeAny()");
            break;
          case module$contents$jspb$BinaryConstants_FieldType.MESSAGE:
            (0, goog.asserts.fail)("Message field type not supported in writeAny()");
            break;
          case module$contents$jspb$BinaryConstants_FieldType.BYTES:
            this.writeBytes(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.UINT32:
            this.writeUint32(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.ENUM:
            this.writeEnum(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.SFIXED32:
            this.writeSfixed32(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.SFIXED64:
            this.writeSfixed64(
              b2,
              c
            );
            break;
          case module$contents$jspb$BinaryConstants_FieldType.SINT32:
            this.writeSint32(b2, c);
            break;
          case module$contents$jspb$BinaryConstants_FieldType.SINT64:
            this.writeSint64(b2, c);
            break;
          default:
            (0, goog.asserts.fail)("Invalid field type in writeAny()");
        }
      }
      writeUnsignedVarint32_(a2, b2) {
        null != b2 && (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT), this.encoder_.writeUnsignedVarint32(b2));
      }
      writeSignedVarint32_(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertSignedInteger(a2, b2), this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT), this.encoder_.writeSignedVarint32(b2));
      }
      writeUnsignedVarint64_(a2, b2) {
        if (null != b2) switch (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT), typeof b2) {
          case "number":
            this.encoder_.writeUnsignedVarint64(b2);
            break;
          case "bigint":
            a2 = module$contents$jspb$arith_UInt64.fromBigInt(b2);
            this.encoder_.writeSplitVarint64(a2.lo, a2.hi);
            break;
          default:
            a2 = module$contents$jspb$arith_UInt64.fromString(b2), this.encoder_.writeSplitVarint64(
              a2.lo,
              a2.hi
            );
        }
      }
      writeSignedVarint64_(a2, b2) {
        if (null != b2) switch (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT), typeof b2) {
          case "number":
            this.encoder_.writeSignedVarint64(b2);
            break;
          case "bigint":
            a2 = module$contents$jspb$arith_Int64.fromBigInt(b2);
            this.encoder_.writeSplitVarint64(a2.lo, a2.hi);
            break;
          default:
            a2 = module$contents$jspb$arith_Int64.fromString(b2), this.encoder_.writeSplitVarint64(a2.lo, a2.hi);
        }
      }
      writeZigzagVarint32_(a2, b2) {
        null != b2 && (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT), this.encoder_.writeZigzagVarint32(b2));
      }
      writeZigzagVarint64_(a2, b2) {
        if (null != b2) switch (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT), typeof b2) {
          case "number":
            this.encoder_.writeZigzagVarint64(b2);
            break;
          default:
            this.encoder_.writeZigzagVarint64String(b2);
        }
      }
      writeInt32(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertThat(a2, b2, b2 >= -module$contents$jspb$BinaryConstants_TWO_TO_31 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_31), this.writeSignedVarint32_(a2, b2));
      }
      writeInt64(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertSignedInt64(a2, b2), this.writeSignedVarint64_(a2, b2));
      }
      writeInt64String(a2, b2) {
        this.writeInt64(a2, b2);
      }
      writeUint32(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertThat(a2, b2, 0 <= b2 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_32), this.writeUnsignedVarint32_(a2, b2));
      }
      writeUint64(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertUnsignedInt64(a2, b2), this.writeUnsignedVarint64_(a2, b2));
      }
      writeUint64String(a2, b2) {
        this.writeUint64(a2, b2);
      }
      writeSint32(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertThat(a2, b2, b2 >= -module$contents$jspb$BinaryConstants_TWO_TO_31 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_31), this.writeZigzagVarint32_(a2, b2));
      }
      writeSint64(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertSignedInt64(a2, b2), this.writeZigzagVarint64_(a2, b2));
      }
      writeSint64String(a2, b2) {
        this.writeSint64(a2, b2);
      }
      writeFixed32(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertThat(a2, b2, 0 <= b2 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_32), this.writeFieldHeader_(
          a2,
          module$contents$jspb$BinaryConstants_WireType.FIXED32
        ), this.encoder_.writeUint32(b2));
      }
      writeFixed64(a2, b2) {
        if (null != b2) switch (module$contents$jspb$binary$writer_assertUnsignedInt64(a2, b2), this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.FIXED64), typeof b2) {
          case "number":
            this.encoder_.writeUint64(b2);
            break;
          case "bigint":
            a2 = module$contents$jspb$arith_UInt64.fromBigInt(b2);
            this.encoder_.writeSplitFixed64(a2.lo, a2.hi);
            break;
          default:
            a2 = module$contents$jspb$arith_UInt64.fromString(b2), this.encoder_.writeSplitFixed64(
              a2.lo,
              a2.hi
            );
        }
      }
      writeFixed64String(a2, b2) {
        this.writeFixed64(a2, b2);
      }
      writeSfixed32(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertThat(a2, b2, b2 >= -module$contents$jspb$BinaryConstants_TWO_TO_31 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_31), this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.FIXED32), this.encoder_.writeInt32(b2));
      }
      writeSfixed64(a2, b2) {
        if (null != b2) switch (module$contents$jspb$binary$writer_assertSignedInt64(a2, b2), this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.FIXED64), typeof b2) {
          case "number":
            this.encoder_.writeInt64(b2);
            break;
          case "bigint":
            a2 = module$contents$jspb$arith_Int64.fromBigInt(b2);
            this.encoder_.writeSplitFixed64(a2.lo, a2.hi);
            break;
          default:
            a2 = module$contents$jspb$arith_Int64.fromString(b2), this.encoder_.writeSplitFixed64(a2.lo, a2.hi);
        }
      }
      writeSfixed64String(a2, b2) {
        this.writeSfixed64(a2, b2);
      }
      writeFloat(a2, b2) {
        null != b2 && (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.FIXED32), this.encoder_.writeFloat(b2));
      }
      writeDouble(a2, b2) {
        null != b2 && (this.writeFieldHeader_(
          a2,
          module$contents$jspb$BinaryConstants_WireType.FIXED64
        ), this.encoder_.writeDouble(b2));
      }
      writeBool(a2, b2) {
        null != b2 && (module$contents$jspb$binary$writer_assertThat(a2, b2, "boolean" === typeof b2 || "number" === typeof b2), this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT), this.encoder_.writeBool(b2));
      }
      writeEnum(a2, b2) {
        null != b2 && (b2 = parseInt(b2, 10), module$contents$jspb$binary$writer_assertSignedInteger(a2, b2), this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT), this.encoder_.writeSignedVarint32(b2));
      }
      writeString(a2, b2) {
        null != b2 && this.writeUint8Array(a2, module$contents$jspb$binary$utf8_encodeUtf8(b2, module$contents$jspb$binary$writer_REJECT_UNPAIRED_SURROGATES));
      }
      writeBytes(a2, b2) {
        null != b2 && this.writeUint8Array(a2, module$contents$jspb$binary$internal_buffer_bufferFromSource(b2, true).buffer);
      }
      writeUint8Array(a2, b2) {
        this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.DELIMITED);
        this.encoder_.writeUnsignedVarint32(b2.length);
        this.appendUint8Array_(b2);
      }
      writeMessage(a2, b2, c) {
        null != b2 && (a2 = this.beginDelimited_(a2), c(
          b2,
          this
        ), this.endDelimited_(a2));
      }
      writeMessageSet(a2, b2, c) {
        null != b2 && (this.writeFieldHeader_(1, module$contents$jspb$BinaryConstants_WireType.START_GROUP), this.writeFieldHeader_(2, module$contents$jspb$BinaryConstants_WireType.VARINT), this.encoder_.writeSignedVarint32(a2), a2 = this.beginDelimited_(3), c(b2, this), this.endDelimited_(a2), this.writeFieldHeader_(1, module$contents$jspb$BinaryConstants_WireType.END_GROUP));
      }
      writeGroup(a2, b2, c) {
        null != b2 && (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.START_GROUP), c(b2, this), this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.END_GROUP));
      }
      writeSplitFixed64(a2, b2, c) {
        this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.FIXED64);
        this.encoder_.writeSplitFixed64(b2, c);
      }
      writeSplitVarint64(a2, b2, c) {
        this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT);
        this.encoder_.writeSplitVarint64(b2, c);
      }
      writeSplitZigzagVarint64(a2, b2, c) {
        this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.VARINT);
        this.encoder_.writeSplitZigzagVarint64(b2 >>> 0, c >>> 0);
      }
      writeRepeatedInt32(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeSignedVarint32_(a2, b2[c]);
      }
      writeRepeatedInt64(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeSignedVarint64_(a2, b2[c]);
      }
      writeRepeatedSplitFixed64(a2, b2, c, d) {
        if (null != b2) for (let e = 0; e < b2.length; e++) this.writeSplitFixed64(a2, c(b2[e]), d(b2[e]));
      }
      writeRepeatedSplitVarint64(a2, b2, c, d) {
        if (null != b2) for (let e = 0; e < b2.length; e++) this.writeSplitVarint64(a2, c(b2[e]), d(b2[e]));
      }
      writeRepeatedSplitZigzagVarint64(a2, b2, c, d) {
        if (null != b2) for (let e = 0; e < b2.length; e++) this.writeSplitZigzagVarint64(
          a2,
          c(b2[e]),
          d(b2[e])
        );
      }
      writeRepeatedInt64String(a2, b2) {
        this.writeRepeatedInt64(a2, b2);
      }
      writeRepeatedUint32(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeUnsignedVarint32_(a2, b2[c]);
      }
      writeRepeatedUint64(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeUnsignedVarint64_(a2, b2[c]);
      }
      writeRepeatedUint64String(a2, b2) {
        this.writeRepeatedUint64(a2, b2);
      }
      writeRepeatedSint32(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeZigzagVarint32_(a2, b2[c]);
      }
      writeRepeatedSint64(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeZigzagVarint64_(
          a2,
          b2[c]
        );
      }
      writeRepeatedSint64String(a2, b2) {
        this.writeRepeatedSint64(a2, b2);
      }
      writeRepeatedFixed32(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeFixed32(a2, b2[c]);
      }
      writeRepeatedFixed64(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeFixed64(a2, b2[c]);
      }
      writeRepeatedFixed64String(a2, b2) {
        this.writeRepeatedFixed64(a2, b2);
      }
      writeRepeatedSfixed32(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeSfixed32(a2, b2[c]);
      }
      writeRepeatedSfixed64(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeSfixed64(a2, b2[c]);
      }
      writeRepeatedSfixed64String(a2, b2) {
        this.writeRepeatedSfixed64(a2, b2);
      }
      writeRepeatedFloat(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeFloat(a2, b2[c]);
      }
      writeRepeatedDouble(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeDouble(a2, b2[c]);
      }
      writeRepeatedBool(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeBool(a2, b2[c]);
      }
      writeRepeatedEnum(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeEnum(a2, b2[c]);
      }
      writeRepeatedString(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeString(a2, b2[c]);
      }
      writeRepeatedBytes(a2, b2) {
        if (null != b2) for (let c = 0; c < b2.length; c++) this.writeBytes(a2, b2[c]);
      }
      writeRepeatedMessage(a2, b2, c) {
        if (null != b2) for (let d = 0; d < b2.length; d++) {
          const e = this.beginDelimited_(a2);
          c(b2[d], this);
          this.endDelimited_(e);
        }
      }
      writeRepeatedGroup(a2, b2, c) {
        if (null != b2) for (let d = 0; d < b2.length; d++) this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.START_GROUP), c(b2[d], this), this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.END_GROUP);
      }
      writePackedInt32(a2, b2) {
        if (null != b2 && b2.length) {
          var c = this.beginDelimited_(a2);
          for (let d = 0; d < b2.length; d++) module$contents$jspb$binary$writer_assertSignedInteger(a2, b2[d]), this.encoder_.writeSignedVarint32(b2[d]);
          this.endDelimited_(c);
        }
      }
      writePackedInt32String(a2, b2) {
        if (null != b2 && b2.length) {
          var c = this.beginDelimited_(a2);
          for (let d = 0; d < b2.length; d++) {
            const e = parseInt(b2[d], 10);
            module$contents$jspb$binary$writer_assertSignedInteger(a2, e);
            this.encoder_.writeSignedVarint32(e);
          }
          this.endDelimited_(c);
        }
      }
      writePackedInt64(a2, b2) {
        if (null != b2 && b2.length) {
          a2 = this.beginDelimited_(a2);
          for (let d = 0; d < b2.length; d++) {
            var c = b2[d];
            switch (typeof c) {
              case "number":
                this.encoder_.writeSignedVarint64(c);
                break;
              case "bigint":
                c = module$contents$jspb$arith_Int64.fromBigInt(c);
                this.encoder_.writeSplitVarint64(c.lo, c.hi);
                break;
              default:
                c = module$contents$jspb$arith_Int64.fromString(c), this.encoder_.writeSplitVarint64(c.lo, c.hi);
            }
          }
          this.endDelimited_(a2);
        }
      }
      writePackedSplitFixed64(a2, b2, c, d) {
        if (null != b2) {
          a2 = this.beginDelimited_(a2);
          for (let e = 0; e < b2.length; e++) this.encoder_.writeSplitFixed64(c(b2[e]), d(b2[e]));
          this.endDelimited_(a2);
        }
      }
      writePackedSplitVarint64(a2, b2, c, d) {
        if (null != b2) {
          a2 = this.beginDelimited_(a2);
          for (let e = 0; e < b2.length; e++) this.encoder_.writeSplitVarint64(c(b2[e]), d(b2[e]));
          this.endDelimited_(a2);
        }
      }
      writePackedSplitZigzagVarint64(a2, b2, c, d) {
        if (null != b2) {
          a2 = this.beginDelimited_(a2);
          var e = this.encoder_;
          for (let f = 0; f < b2.length; f++) e.writeSplitZigzagVarint64(c(b2[f]), d(b2[f]));
          this.endDelimited_(a2);
        }
      }
      writePackedInt64String(a2, b2) {
        this.writePackedInt64(a2, b2);
      }
      writePackedUint32(a2, b2) {
        if (null != b2 && b2.length) {
          a2 = this.beginDelimited_(a2);
          for (let c = 0; c < b2.length; c++) this.encoder_.writeUnsignedVarint32(b2[c]);
          this.endDelimited_(a2);
        }
      }
      writePackedUint64(a2, b2) {
        if (null != b2 && b2.length) {
          a2 = this.beginDelimited_(a2);
          for (let d = 0; d < b2.length; d++) {
            var c = b2[d];
            switch (typeof c) {
              case "number":
                this.encoder_.writeUnsignedVarint64(c);
                break;
              case "bigint":
                const e = Number(c);
                Number.isSafeInteger(e) ? this.encoder_.writeUnsignedVarint64(e) : (c = module$contents$jspb$arith_UInt64.fromBigInt(c), this.encoder_.writeSplitVarint64(c.lo, c.hi));
                break;
              default:
                c = module$contents$jspb$arith_UInt64.fromString(c), this.encoder_.writeSplitVarint64(
                  c.lo,
                  c.hi
                );
            }
          }
          this.endDelimited_(a2);
        }
      }
      writePackedUint64String(a2, b2) {
        this.writePackedUint64(a2, b2);
      }
      writePackedSint32(a2, b2) {
        if (null != b2 && b2.length) {
          a2 = this.beginDelimited_(a2);
          for (let c = 0; c < b2.length; c++) this.encoder_.writeZigzagVarint32(b2[c]);
          this.endDelimited_(a2);
        }
      }
      writePackedSint64(a2, b2) {
        if (null != b2 && b2.length) {
          a2 = this.beginDelimited_(a2);
          for (let c = 0; c < b2.length; c++) {
            const d = b2[c];
            switch (typeof d) {
              case "number":
                this.encoder_.writeZigzagVarint64(d);
                break;
              default:
                this.encoder_.writeZigzagVarint64String(d);
            }
          }
          this.endDelimited_(a2);
        }
      }
      writePackedSint64String(a2, b2) {
        this.writePackedSint64(a2, b2);
      }
      writePackedFixed32(a2, b2) {
        if (null != b2 && b2.length) for (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b2.length), a2 = 0; a2 < b2.length; a2++) this.encoder_.writeUint32(b2[a2]);
      }
      writePackedFixed64(a2, b2) {
        if (null != b2 && b2.length) for (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b2.length), a2 = 0; a2 < b2.length; a2++) {
          var c = b2[a2];
          switch (typeof c) {
            case "number":
              this.encoder_.writeUint64(c);
              break;
            case "bigint":
              c = module$contents$jspb$arith_UInt64.fromBigInt(c);
              this.encoder_.writeSplitFixed64(c.lo, c.hi);
              break;
            default:
              c = module$contents$jspb$arith_UInt64.fromString(c), this.encoder_.writeSplitFixed64(c.lo, c.hi);
          }
        }
      }
      writePackedFixed64String(a2, b2) {
        this.writePackedFixed64(a2, b2);
      }
      writePackedSfixed32(a2, b2) {
        if (null != b2 && b2.length) for (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b2.length), a2 = 0; a2 < b2.length; a2++) this.encoder_.writeInt32(b2[a2]);
      }
      writePackedSfixed64(a2, b2) {
        if (null != b2 && b2.length) for (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b2.length), a2 = 0; a2 < b2.length; a2++) {
          var c = b2[a2];
          switch (typeof c) {
            case "number":
              this.encoder_.writeInt64(c);
              break;
            case "bigint":
              c = module$contents$jspb$arith_Int64.fromBigInt(c);
              this.encoder_.writeSplitFixed64(c.lo, c.hi);
              break;
            default:
              c = module$contents$jspb$arith_Int64.fromString(c), this.encoder_.writeSplitFixed64(c.lo, c.hi);
          }
        }
      }
      writePackedSfixed64String(a2, b2) {
        this.writePackedSfixed64(
          a2,
          b2
        );
      }
      writePackedFloat(a2, b2) {
        if (null != b2 && b2.length) for (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b2.length), a2 = 0; a2 < b2.length; a2++) this.encoder_.writeFloat(b2[a2]);
      }
      writePackedDouble(a2, b2) {
        if (null != b2 && b2.length) for (this.writeFieldHeader_(a2, module$contents$jspb$BinaryConstants_WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b2.length), a2 = 0; a2 < b2.length; a2++) this.encoder_.writeDouble(b2[a2]);
      }
      writePackedBool(a2, b2) {
        if (null != b2 && b2.length) for (this.writeFieldHeader_(
          a2,
          module$contents$jspb$BinaryConstants_WireType.DELIMITED
        ), this.encoder_.writeUnsignedVarint32(b2.length), a2 = 0; a2 < b2.length; a2++) this.encoder_.writeBool(b2[a2]);
      }
      writePackedEnum(a2, b2) {
        if (null != b2 && b2.length) {
          a2 = this.beginDelimited_(a2);
          for (let c = 0; c < b2.length; c++) this.encoder_.writeEnum(b2[c]);
          this.endDelimited_(a2);
        }
      }
    };
    function module$contents$jspb$binary$writer_assertSignedInteger(a2, b2) {
      module$contents$jspb$binary$writer_assertThat(a2, b2, b2 === Math.floor(b2));
      module$contents$jspb$binary$writer_assertThat(a2, b2, b2 >= -module$contents$jspb$BinaryConstants_TWO_TO_31 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_31);
    }
    function module$contents$jspb$binary$writer_assertSignedInt64(a2, b2) {
      switch (typeof b2) {
        case "string":
          module$contents$jspb$binary$writer_assertThat(a2, b2, module$contents$jspb$arith_Int64.fromString(b2));
          break;
        case "number":
          module$contents$jspb$binary$writer_assertThat(a2, b2, b2 >= -module$contents$jspb$BinaryConstants_TWO_TO_63 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_63);
          break;
        default:
          module$contents$jspb$binary$writer_assertThat(a2, b2, b2 >= BigInt(-module$contents$jspb$BinaryConstants_TWO_TO_63) && b2 < BigInt(module$contents$jspb$BinaryConstants_TWO_TO_63));
      }
    }
    function module$contents$jspb$binary$writer_assertUnsignedInt64(a2, b2) {
      switch (typeof b2) {
        case "string":
          module$contents$jspb$binary$writer_assertThat(a2, b2, module$contents$jspb$arith_UInt64.fromString(b2));
          break;
        case "number":
          module$contents$jspb$binary$writer_assertThat(a2, b2, 0 <= b2 && b2 < module$contents$jspb$BinaryConstants_TWO_TO_64);
          break;
        default:
          module$contents$jspb$binary$writer_assertThat(a2, b2, b2 >= BigInt(0) && b2 < BigInt(module$contents$jspb$BinaryConstants_TWO_TO_64));
      }
    }
    function module$contents$jspb$binary$writer_assertThat(a2, b2, c) {
      c || (0, goog.asserts.fail)(`for [${b2}] at [${a2}]`);
    }
    jspb.binary.writer.BinaryWriter = module$contents$jspb$binary$writer_BinaryWriter;
    jspb.BinaryWriter = module$contents$jspb$binary$writer_BinaryWriter;
    jspb.internal = {};
    jspb.internal.public_for_gencode = {};
    function module$contents$jspb$internal$public_for_gencode_serializeMapToBinary(a2, b2, c, d, e, f) {
      a2 && a2.forEach((g, h) => {
        c.writeMessage(b2, a2, (l, k) => {
          d.call(k, 1, h);
          e.call(k, 2, g, f);
        });
      });
    }
    function module$contents$jspb$internal$public_for_gencode_deserializeMapFromBinary(a2, b2, c, d, e, f) {
      b2.readMessage(a2, (g, h) => {
        g = d;
        let l = f;
        for (; h.nextField() && !h.isEndGroup(); ) {
          const k = h.getFieldNumber();
          1 == k ? g = c.call(h) : 2 == k && (a2.valueCtor ? h.readMessage(l, e) : l = e.call(h));
        }
        goog.asserts.assert(void 0 != g);
        goog.asserts.assert(void 0 != l);
        a2.set(g, l);
      });
    }
    jspb.internal.public_for_gencode.deserializeMapFromBinary = module$contents$jspb$internal$public_for_gencode_deserializeMapFromBinary;
    jspb.internal.public_for_gencode.serializeMapToBinary = module$contents$jspb$internal$public_for_gencode_serializeMapToBinary;
    jspb.Export = {};
    "object" === typeof exports && (exports.debug = jspb.debug, exports.Map = module$contents$jspb$Map_Map, exports.Message = module$contents$jspb$Message_Message, exports.BinaryReader = module$contents$jspb$binary$reader_BinaryReader, exports.BinaryWriter = module$contents$jspb$binary$writer_BinaryWriter, exports.ExtensionFieldInfo = module$contents$jspb$ExtensionFieldInfo_ExtensionFieldInfo, exports.ExtensionFieldBinaryInfo = module$contents$jspb$ExtensionFieldBinaryInfo_ExtensionFieldBinaryInfo, exports.internal = { public_for_gencode: jspb.internal.public_for_gencode }, exports.exportSymbol = goog.exportSymbol, exports.inherits = goog.inherits, exports.object = { extend: module$contents$goog$object_extend }, exports.typeOf = goog.typeOf);
  }
});

// node_modules/google-protobuf/google/protobuf/timestamp_pb.js
var require_timestamp_pb = __commonJS({
  "node_modules/google-protobuf/google/protobuf/timestamp_pb.js"(exports2) {
    var jspb2 = require_google_protobuf();
    var goog2 = jspb2;
    var global = globalThis;
    goog2.exportSymbol("proto.google.protobuf.Timestamp", null, global);
    proto.google.protobuf.Timestamp = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.google.protobuf.Timestamp, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.google.protobuf.Timestamp.displayName = "proto.google.protobuf.Timestamp";
    }
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.google.protobuf.Timestamp.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.Timestamp.toObject(opt_includeInstance, this);
      };
      proto.google.protobuf.Timestamp.toObject = function(includeInstance, msg) {
        var f, obj = {
          seconds: jspb2.Message.getFieldWithDefault(msg, 1, 0),
          nanos: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.google.protobuf.Timestamp.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.google.protobuf.Timestamp();
      return proto.google.protobuf.Timestamp.deserializeBinaryFromReader(msg, reader);
    };
    proto.google.protobuf.Timestamp.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {number} */
              reader.readInt64()
            );
            msg.setSeconds(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setNanos(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.google.protobuf.Timestamp.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.google.protobuf.Timestamp.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.google.protobuf.Timestamp.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getSeconds();
      if (f !== 0) {
        writer.writeInt64(
          1,
          f
        );
      }
      f = message.getNanos();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.google.protobuf.Timestamp.prototype.getSeconds = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    proto.google.protobuf.Timestamp.prototype.setSeconds = function(value) {
      return jspb2.Message.setProto3IntField(this, 1, value);
    };
    proto.google.protobuf.Timestamp.prototype.getNanos = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.google.protobuf.Timestamp.prototype.setNanos = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    goog2.object.extend(exports2, proto.google.protobuf);
    proto.google.protobuf.Timestamp.prototype.toDate = function() {
      var seconds = this.getSeconds();
      var nanos = this.getNanos();
      return new Date(seconds * 1e3 + nanos / 1e6);
    };
    proto.google.protobuf.Timestamp.prototype.fromDate = function(value) {
      this.setSeconds(Math.floor(value.getTime() / 1e3));
      this.setNanos(value.getMilliseconds() * 1e6);
    };
    proto.google.protobuf.Timestamp.fromDate = function(value) {
      var timestamp = new proto.google.protobuf.Timestamp();
      timestamp.fromDate(value);
      return timestamp;
    };
  }
});

// src/generated/console_pb.js
var require_console_pb = __commonJS({
  "src/generated/console_pb.js"(exports2) {
    var jspb2 = require_google_protobuf();
    var goog2 = jspb2;
    var global = typeof globalThis !== "undefined" && globalThis || typeof window !== "undefined" && window || typeof global !== "undefined" && global || typeof self !== "undefined" && self || (function() {
      return this;
    }).call(null) || Function("return this")();
    var google_protobuf_timestamp_pb = require_timestamp_pb();
    goog2.object.extend(proto, google_protobuf_timestamp_pb);
    goog2.exportSymbol("proto.atfai.console.v1.AcceptInviteRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AcceptInviteResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.Account", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AccountMember", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AccountRole", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AcknowledgeCustomerRequestRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AcknowledgeCustomerRequestResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AssignLicenseRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AssignLicenseResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AuditAction", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.AuditEvent", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.BillingModel", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.BillingState", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CancelContractRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CancelContractResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ChangeMyPasswordRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ChangeMyPasswordResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ConnectivityMode", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ConsoleApiKeyMetadata", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ConsoleOperator", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ConsoleOperatorRole", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateAccountRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateAccountResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateApiKeyRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateApiKeyResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateContractRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateContractResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateOperatorRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateOperatorResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateOrgRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CreateOrgResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.CustomerRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DataClassification", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DeleteAccountRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DeleteAccountResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DeleteOrgRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DeleteOrgResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DeploymentType", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DisableOperatorRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DisableOperatorResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DownloadMyLicenseRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.DownloadMyLicenseResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetAccountRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetAccountResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetContractStatusRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetContractStatusResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetInstanceRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetInstanceResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetLicenseRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetLicenseResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetMyContractStatusRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetMyContractStatusResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetMyLicenseRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetMyLicenseResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetOrgRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetOrgResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetOrgUsageRollupRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetOrgUsageRollupResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetRevenueOverviewRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.GetRevenueOverviewResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.IngestUsageEventsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.IngestUsageEventsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.Instance", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.InstanceEnrollmentStatus", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.InstanceEnvironment", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.InstanceHeartbeatRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.InstanceHeartbeatResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.InviteFirstCustomerRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.InviteFirstCustomerResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.InviteMemberRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.InviteMemberResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.IssueLicenseRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.IssueLicenseResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.License", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.LicenseHealthAlert", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.LicenseStatus", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.LicenseTier", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListAccountsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListAccountsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListApiKeysRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListApiKeysResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListCustomerRequestsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListCustomerRequestsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListInstancesRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListInstancesResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListLicenseHealthAlertsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListLicenseHealthAlertsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListLicensesRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListLicensesResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListMembersRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListMembersResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListMyLicensesRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListMyLicensesResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListMyOrgBillingPortalsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListMyOrgBillingPortalsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListMyUsageEventsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListMyUsageEventsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListOperatorsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListOperatorsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListOrgsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListOrgsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListPurgeEligibleOrgsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListPurgeEligibleOrgsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListUsageEventsRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ListUsageEventsResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.MarkOrgPurgedRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.MarkOrgPurgedResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.MintInstanceTokenRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.MintInstanceTokenResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.MintSignupRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.MintSignupResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.Org", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.OrgBillingPortal", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.OrgScope", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.OrgScopeAlert", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.OrgUsageSummary", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RegisterInstanceRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RegisterInstanceResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RemoveMemberRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RemoveMemberResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ReportingSource", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RequestCancellationRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RequestCancellationResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RequestSeatChangeRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RequestSeatChangeResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RequestSupportRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RequestSupportResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ResolveCustomerRequestRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ResolveCustomerRequestResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RestoreOrgRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RestoreOrgResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ResumeLicenseRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.ResumeLicenseResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RevenueTierBucket", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RevokeApiKeyRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RevokeApiKeyResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RevokeLicenseRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.RevokeLicenseResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.SetMemberRoleRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.SetMemberRoleResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.SetOperatorPasswordRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.SetOperatorPasswordResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.StaleHeartbeatAlert", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.SubmitInstanceSupportRequestRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.SubmitInstanceSupportRequestResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.SuspendLicenseRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.SuspendLicenseResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.UpdateAccountRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.UpdateAccountResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.UpdateInstanceRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.UpdateInstanceResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.UpdateMask", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.UpdateOrgRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.UpdateOrgResponse", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.UsageEvent", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.WhoAmICustomer", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.WhoAmIInstance", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.WhoAmIOperator", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.WhoAmIRequest", null, global);
    goog2.exportSymbol("proto.atfai.console.v1.WhoAmIResponse", null, global);
    proto.atfai.console.v1.Account = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.Account, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.Account.displayName = "proto.atfai.console.v1.Account";
    }
    proto.atfai.console.v1.Org = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.Org, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.Org.displayName = "proto.atfai.console.v1.Org";
    }
    proto.atfai.console.v1.Instance = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.Instance, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.Instance.displayName = "proto.atfai.console.v1.Instance";
    }
    proto.atfai.console.v1.License = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.License.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.License, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.License.displayName = "proto.atfai.console.v1.License";
    }
    proto.atfai.console.v1.UsageEvent = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.UsageEvent, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.UsageEvent.displayName = "proto.atfai.console.v1.UsageEvent";
    }
    proto.atfai.console.v1.AuditEvent = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.AuditEvent, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.AuditEvent.displayName = "proto.atfai.console.v1.AuditEvent";
    }
    proto.atfai.console.v1.UpdateMask = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.UpdateMask.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.UpdateMask, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.UpdateMask.displayName = "proto.atfai.console.v1.UpdateMask";
    }
    proto.atfai.console.v1.CreateAccountRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateAccountRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateAccountRequest.displayName = "proto.atfai.console.v1.CreateAccountRequest";
    }
    proto.atfai.console.v1.CreateAccountResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateAccountResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateAccountResponse.displayName = "proto.atfai.console.v1.CreateAccountResponse";
    }
    proto.atfai.console.v1.GetAccountRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetAccountRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetAccountRequest.displayName = "proto.atfai.console.v1.GetAccountRequest";
    }
    proto.atfai.console.v1.GetAccountResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetAccountResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetAccountResponse.displayName = "proto.atfai.console.v1.GetAccountResponse";
    }
    proto.atfai.console.v1.ListAccountsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListAccountsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListAccountsRequest.displayName = "proto.atfai.console.v1.ListAccountsRequest";
    }
    proto.atfai.console.v1.ListAccountsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListAccountsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListAccountsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListAccountsResponse.displayName = "proto.atfai.console.v1.ListAccountsResponse";
    }
    proto.atfai.console.v1.UpdateAccountRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.UpdateAccountRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.UpdateAccountRequest.displayName = "proto.atfai.console.v1.UpdateAccountRequest";
    }
    proto.atfai.console.v1.UpdateAccountResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.UpdateAccountResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.UpdateAccountResponse.displayName = "proto.atfai.console.v1.UpdateAccountResponse";
    }
    proto.atfai.console.v1.DeleteAccountRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.DeleteAccountRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.DeleteAccountRequest.displayName = "proto.atfai.console.v1.DeleteAccountRequest";
    }
    proto.atfai.console.v1.DeleteAccountResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.DeleteAccountResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.DeleteAccountResponse.displayName = "proto.atfai.console.v1.DeleteAccountResponse";
    }
    proto.atfai.console.v1.CreateOrgRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateOrgRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateOrgRequest.displayName = "proto.atfai.console.v1.CreateOrgRequest";
    }
    proto.atfai.console.v1.CreateOrgResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateOrgResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateOrgResponse.displayName = "proto.atfai.console.v1.CreateOrgResponse";
    }
    proto.atfai.console.v1.GetOrgRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetOrgRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetOrgRequest.displayName = "proto.atfai.console.v1.GetOrgRequest";
    }
    proto.atfai.console.v1.GetOrgResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetOrgResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetOrgResponse.displayName = "proto.atfai.console.v1.GetOrgResponse";
    }
    proto.atfai.console.v1.ListOrgsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListOrgsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListOrgsRequest.displayName = "proto.atfai.console.v1.ListOrgsRequest";
    }
    proto.atfai.console.v1.ListOrgsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListOrgsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListOrgsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListOrgsResponse.displayName = "proto.atfai.console.v1.ListOrgsResponse";
    }
    proto.atfai.console.v1.UpdateOrgRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.UpdateOrgRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.UpdateOrgRequest.displayName = "proto.atfai.console.v1.UpdateOrgRequest";
    }
    proto.atfai.console.v1.UpdateOrgResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.UpdateOrgResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.UpdateOrgResponse.displayName = "proto.atfai.console.v1.UpdateOrgResponse";
    }
    proto.atfai.console.v1.DeleteOrgRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.DeleteOrgRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.DeleteOrgRequest.displayName = "proto.atfai.console.v1.DeleteOrgRequest";
    }
    proto.atfai.console.v1.DeleteOrgResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.DeleteOrgResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.DeleteOrgResponse.displayName = "proto.atfai.console.v1.DeleteOrgResponse";
    }
    proto.atfai.console.v1.RestoreOrgRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RestoreOrgRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RestoreOrgRequest.displayName = "proto.atfai.console.v1.RestoreOrgRequest";
    }
    proto.atfai.console.v1.RestoreOrgResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RestoreOrgResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RestoreOrgResponse.displayName = "proto.atfai.console.v1.RestoreOrgResponse";
    }
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListPurgeEligibleOrgsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.displayName = "proto.atfai.console.v1.ListPurgeEligibleOrgsRequest";
    }
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListPurgeEligibleOrgsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.displayName = "proto.atfai.console.v1.ListPurgeEligibleOrgsResponse";
    }
    proto.atfai.console.v1.MarkOrgPurgedRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.MarkOrgPurgedRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.MarkOrgPurgedRequest.displayName = "proto.atfai.console.v1.MarkOrgPurgedRequest";
    }
    proto.atfai.console.v1.MarkOrgPurgedResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.MarkOrgPurgedResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.MarkOrgPurgedResponse.displayName = "proto.atfai.console.v1.MarkOrgPurgedResponse";
    }
    proto.atfai.console.v1.MintSignupRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.MintSignupRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.MintSignupRequest.displayName = "proto.atfai.console.v1.MintSignupRequest";
    }
    proto.atfai.console.v1.MintSignupResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.MintSignupResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.MintSignupResponse.displayName = "proto.atfai.console.v1.MintSignupResponse";
    }
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.SubmitInstanceSupportRequestRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.displayName = "proto.atfai.console.v1.SubmitInstanceSupportRequestRequest";
    }
    proto.atfai.console.v1.SubmitInstanceSupportRequestResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.SubmitInstanceSupportRequestResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.displayName = "proto.atfai.console.v1.SubmitInstanceSupportRequestResponse";
    }
    proto.atfai.console.v1.RegisterInstanceRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RegisterInstanceRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RegisterInstanceRequest.displayName = "proto.atfai.console.v1.RegisterInstanceRequest";
    }
    proto.atfai.console.v1.RegisterInstanceResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RegisterInstanceResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RegisterInstanceResponse.displayName = "proto.atfai.console.v1.RegisterInstanceResponse";
    }
    proto.atfai.console.v1.InstanceHeartbeatRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.InstanceHeartbeatRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.InstanceHeartbeatRequest.displayName = "proto.atfai.console.v1.InstanceHeartbeatRequest";
    }
    proto.atfai.console.v1.InstanceHeartbeatResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.InstanceHeartbeatResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.InstanceHeartbeatResponse.displayName = "proto.atfai.console.v1.InstanceHeartbeatResponse";
    }
    proto.atfai.console.v1.GetInstanceRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetInstanceRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetInstanceRequest.displayName = "proto.atfai.console.v1.GetInstanceRequest";
    }
    proto.atfai.console.v1.GetInstanceResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetInstanceResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetInstanceResponse.displayName = "proto.atfai.console.v1.GetInstanceResponse";
    }
    proto.atfai.console.v1.ListInstancesRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListInstancesRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListInstancesRequest.displayName = "proto.atfai.console.v1.ListInstancesRequest";
    }
    proto.atfai.console.v1.ListInstancesResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListInstancesResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListInstancesResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListInstancesResponse.displayName = "proto.atfai.console.v1.ListInstancesResponse";
    }
    proto.atfai.console.v1.UpdateInstanceRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.UpdateInstanceRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.UpdateInstanceRequest.displayName = "proto.atfai.console.v1.UpdateInstanceRequest";
    }
    proto.atfai.console.v1.UpdateInstanceResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.UpdateInstanceResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.UpdateInstanceResponse.displayName = "proto.atfai.console.v1.UpdateInstanceResponse";
    }
    proto.atfai.console.v1.MintInstanceTokenRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.MintInstanceTokenRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.MintInstanceTokenRequest.displayName = "proto.atfai.console.v1.MintInstanceTokenRequest";
    }
    proto.atfai.console.v1.MintInstanceTokenResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.MintInstanceTokenResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.MintInstanceTokenResponse.displayName = "proto.atfai.console.v1.MintInstanceTokenResponse";
    }
    proto.atfai.console.v1.IssueLicenseRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.IssueLicenseRequest.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.IssueLicenseRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.IssueLicenseRequest.displayName = "proto.atfai.console.v1.IssueLicenseRequest";
    }
    proto.atfai.console.v1.IssueLicenseResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.IssueLicenseResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.IssueLicenseResponse.displayName = "proto.atfai.console.v1.IssueLicenseResponse";
    }
    proto.atfai.console.v1.AssignLicenseRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.AssignLicenseRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.AssignLicenseRequest.displayName = "proto.atfai.console.v1.AssignLicenseRequest";
    }
    proto.atfai.console.v1.AssignLicenseResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.AssignLicenseResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.AssignLicenseResponse.displayName = "proto.atfai.console.v1.AssignLicenseResponse";
    }
    proto.atfai.console.v1.SuspendLicenseRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.SuspendLicenseRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.SuspendLicenseRequest.displayName = "proto.atfai.console.v1.SuspendLicenseRequest";
    }
    proto.atfai.console.v1.SuspendLicenseResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.SuspendLicenseResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.SuspendLicenseResponse.displayName = "proto.atfai.console.v1.SuspendLicenseResponse";
    }
    proto.atfai.console.v1.ResumeLicenseRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ResumeLicenseRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ResumeLicenseRequest.displayName = "proto.atfai.console.v1.ResumeLicenseRequest";
    }
    proto.atfai.console.v1.ResumeLicenseResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ResumeLicenseResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ResumeLicenseResponse.displayName = "proto.atfai.console.v1.ResumeLicenseResponse";
    }
    proto.atfai.console.v1.RevokeLicenseRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RevokeLicenseRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RevokeLicenseRequest.displayName = "proto.atfai.console.v1.RevokeLicenseRequest";
    }
    proto.atfai.console.v1.RevokeLicenseResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RevokeLicenseResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RevokeLicenseResponse.displayName = "proto.atfai.console.v1.RevokeLicenseResponse";
    }
    proto.atfai.console.v1.GetLicenseRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetLicenseRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetLicenseRequest.displayName = "proto.atfai.console.v1.GetLicenseRequest";
    }
    proto.atfai.console.v1.GetLicenseResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetLicenseResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetLicenseResponse.displayName = "proto.atfai.console.v1.GetLicenseResponse";
    }
    proto.atfai.console.v1.ListLicensesRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListLicensesRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListLicensesRequest.displayName = "proto.atfai.console.v1.ListLicensesRequest";
    }
    proto.atfai.console.v1.ListLicensesResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListLicensesResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListLicensesResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListLicensesResponse.displayName = "proto.atfai.console.v1.ListLicensesResponse";
    }
    proto.atfai.console.v1.IngestUsageEventsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.IngestUsageEventsRequest.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.IngestUsageEventsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.IngestUsageEventsRequest.displayName = "proto.atfai.console.v1.IngestUsageEventsRequest";
    }
    proto.atfai.console.v1.IngestUsageEventsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.IngestUsageEventsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.IngestUsageEventsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.IngestUsageEventsResponse.displayName = "proto.atfai.console.v1.IngestUsageEventsResponse";
    }
    proto.atfai.console.v1.ConsoleOperator = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ConsoleOperator, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ConsoleOperator.displayName = "proto.atfai.console.v1.ConsoleOperator";
    }
    proto.atfai.console.v1.ConsoleApiKeyMetadata = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ConsoleApiKeyMetadata, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ConsoleApiKeyMetadata.displayName = "proto.atfai.console.v1.ConsoleApiKeyMetadata";
    }
    proto.atfai.console.v1.CreateOperatorRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateOperatorRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateOperatorRequest.displayName = "proto.atfai.console.v1.CreateOperatorRequest";
    }
    proto.atfai.console.v1.CreateOperatorResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateOperatorResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateOperatorResponse.displayName = "proto.atfai.console.v1.CreateOperatorResponse";
    }
    proto.atfai.console.v1.ListOperatorsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListOperatorsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListOperatorsRequest.displayName = "proto.atfai.console.v1.ListOperatorsRequest";
    }
    proto.atfai.console.v1.ListOperatorsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListOperatorsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListOperatorsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListOperatorsResponse.displayName = "proto.atfai.console.v1.ListOperatorsResponse";
    }
    proto.atfai.console.v1.CreateApiKeyRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateApiKeyRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateApiKeyRequest.displayName = "proto.atfai.console.v1.CreateApiKeyRequest";
    }
    proto.atfai.console.v1.CreateApiKeyResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateApiKeyResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateApiKeyResponse.displayName = "proto.atfai.console.v1.CreateApiKeyResponse";
    }
    proto.atfai.console.v1.RevokeApiKeyRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RevokeApiKeyRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RevokeApiKeyRequest.displayName = "proto.atfai.console.v1.RevokeApiKeyRequest";
    }
    proto.atfai.console.v1.RevokeApiKeyResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RevokeApiKeyResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RevokeApiKeyResponse.displayName = "proto.atfai.console.v1.RevokeApiKeyResponse";
    }
    proto.atfai.console.v1.DisableOperatorRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.DisableOperatorRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.DisableOperatorRequest.displayName = "proto.atfai.console.v1.DisableOperatorRequest";
    }
    proto.atfai.console.v1.DisableOperatorResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.DisableOperatorResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.DisableOperatorResponse.displayName = "proto.atfai.console.v1.DisableOperatorResponse";
    }
    proto.atfai.console.v1.SetOperatorPasswordRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.SetOperatorPasswordRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.SetOperatorPasswordRequest.displayName = "proto.atfai.console.v1.SetOperatorPasswordRequest";
    }
    proto.atfai.console.v1.SetOperatorPasswordResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.SetOperatorPasswordResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.SetOperatorPasswordResponse.displayName = "proto.atfai.console.v1.SetOperatorPasswordResponse";
    }
    proto.atfai.console.v1.WhoAmIRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.WhoAmIRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.WhoAmIRequest.displayName = "proto.atfai.console.v1.WhoAmIRequest";
    }
    proto.atfai.console.v1.WhoAmIOperator = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.WhoAmIOperator, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.WhoAmIOperator.displayName = "proto.atfai.console.v1.WhoAmIOperator";
    }
    proto.atfai.console.v1.WhoAmIInstance = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.WhoAmIInstance, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.WhoAmIInstance.displayName = "proto.atfai.console.v1.WhoAmIInstance";
    }
    proto.atfai.console.v1.WhoAmICustomer = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.WhoAmICustomer, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.WhoAmICustomer.displayName = "proto.atfai.console.v1.WhoAmICustomer";
    }
    proto.atfai.console.v1.WhoAmIResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.WhoAmIResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.WhoAmIResponse.displayName = "proto.atfai.console.v1.WhoAmIResponse";
    }
    proto.atfai.console.v1.ListUsageEventsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListUsageEventsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListUsageEventsRequest.displayName = "proto.atfai.console.v1.ListUsageEventsRequest";
    }
    proto.atfai.console.v1.ListUsageEventsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListUsageEventsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListUsageEventsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListUsageEventsResponse.displayName = "proto.atfai.console.v1.ListUsageEventsResponse";
    }
    proto.atfai.console.v1.ListApiKeysRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListApiKeysRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListApiKeysRequest.displayName = "proto.atfai.console.v1.ListApiKeysRequest";
    }
    proto.atfai.console.v1.ListApiKeysResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListApiKeysResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListApiKeysResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListApiKeysResponse.displayName = "proto.atfai.console.v1.ListApiKeysResponse";
    }
    proto.atfai.console.v1.CreateContractRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateContractRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateContractRequest.displayName = "proto.atfai.console.v1.CreateContractRequest";
    }
    proto.atfai.console.v1.CreateContractResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CreateContractResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CreateContractResponse.displayName = "proto.atfai.console.v1.CreateContractResponse";
    }
    proto.atfai.console.v1.GetContractStatusRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetContractStatusRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetContractStatusRequest.displayName = "proto.atfai.console.v1.GetContractStatusRequest";
    }
    proto.atfai.console.v1.GetContractStatusResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetContractStatusResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetContractStatusResponse.displayName = "proto.atfai.console.v1.GetContractStatusResponse";
    }
    proto.atfai.console.v1.CancelContractRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CancelContractRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CancelContractRequest.displayName = "proto.atfai.console.v1.CancelContractRequest";
    }
    proto.atfai.console.v1.CancelContractResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CancelContractResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CancelContractResponse.displayName = "proto.atfai.console.v1.CancelContractResponse";
    }
    proto.atfai.console.v1.ChangeMyPasswordRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ChangeMyPasswordRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ChangeMyPasswordRequest.displayName = "proto.atfai.console.v1.ChangeMyPasswordRequest";
    }
    proto.atfai.console.v1.ChangeMyPasswordResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ChangeMyPasswordResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ChangeMyPasswordResponse.displayName = "proto.atfai.console.v1.ChangeMyPasswordResponse";
    }
    proto.atfai.console.v1.ListMyLicensesRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListMyLicensesRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListMyLicensesRequest.displayName = "proto.atfai.console.v1.ListMyLicensesRequest";
    }
    proto.atfai.console.v1.ListMyLicensesResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListMyLicensesResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListMyLicensesResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListMyLicensesResponse.displayName = "proto.atfai.console.v1.ListMyLicensesResponse";
    }
    proto.atfai.console.v1.GetMyLicenseRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetMyLicenseRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetMyLicenseRequest.displayName = "proto.atfai.console.v1.GetMyLicenseRequest";
    }
    proto.atfai.console.v1.GetMyLicenseResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetMyLicenseResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetMyLicenseResponse.displayName = "proto.atfai.console.v1.GetMyLicenseResponse";
    }
    proto.atfai.console.v1.DownloadMyLicenseRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.DownloadMyLicenseRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.DownloadMyLicenseRequest.displayName = "proto.atfai.console.v1.DownloadMyLicenseRequest";
    }
    proto.atfai.console.v1.DownloadMyLicenseResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.DownloadMyLicenseResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.DownloadMyLicenseResponse.displayName = "proto.atfai.console.v1.DownloadMyLicenseResponse";
    }
    proto.atfai.console.v1.ListMyUsageEventsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListMyUsageEventsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListMyUsageEventsRequest.displayName = "proto.atfai.console.v1.ListMyUsageEventsRequest";
    }
    proto.atfai.console.v1.ListMyUsageEventsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListMyUsageEventsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListMyUsageEventsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListMyUsageEventsResponse.displayName = "proto.atfai.console.v1.ListMyUsageEventsResponse";
    }
    proto.atfai.console.v1.GetMyContractStatusRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetMyContractStatusRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetMyContractStatusRequest.displayName = "proto.atfai.console.v1.GetMyContractStatusRequest";
    }
    proto.atfai.console.v1.GetMyContractStatusResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetMyContractStatusResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetMyContractStatusResponse.displayName = "proto.atfai.console.v1.GetMyContractStatusResponse";
    }
    proto.atfai.console.v1.LicenseHealthAlert = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.LicenseHealthAlert, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.LicenseHealthAlert.displayName = "proto.atfai.console.v1.LicenseHealthAlert";
    }
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListLicenseHealthAlertsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListLicenseHealthAlertsRequest.displayName = "proto.atfai.console.v1.ListLicenseHealthAlertsRequest";
    }
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListLicenseHealthAlertsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListLicenseHealthAlertsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListLicenseHealthAlertsResponse.displayName = "proto.atfai.console.v1.ListLicenseHealthAlertsResponse";
    }
    proto.atfai.console.v1.OrgScopeAlert = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.OrgScopeAlert, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.OrgScopeAlert.displayName = "proto.atfai.console.v1.OrgScopeAlert";
    }
    proto.atfai.console.v1.StaleHeartbeatAlert = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.StaleHeartbeatAlert, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.StaleHeartbeatAlert.displayName = "proto.atfai.console.v1.StaleHeartbeatAlert";
    }
    proto.atfai.console.v1.OrgUsageSummary = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.OrgUsageSummary, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.OrgUsageSummary.displayName = "proto.atfai.console.v1.OrgUsageSummary";
    }
    proto.atfai.console.v1.GetOrgUsageRollupRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetOrgUsageRollupRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetOrgUsageRollupRequest.displayName = "proto.atfai.console.v1.GetOrgUsageRollupRequest";
    }
    proto.atfai.console.v1.GetOrgUsageRollupResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.GetOrgUsageRollupResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetOrgUsageRollupResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetOrgUsageRollupResponse.displayName = "proto.atfai.console.v1.GetOrgUsageRollupResponse";
    }
    proto.atfai.console.v1.RevenueTierBucket = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RevenueTierBucket, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RevenueTierBucket.displayName = "proto.atfai.console.v1.RevenueTierBucket";
    }
    proto.atfai.console.v1.GetRevenueOverviewRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetRevenueOverviewRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetRevenueOverviewRequest.displayName = "proto.atfai.console.v1.GetRevenueOverviewRequest";
    }
    proto.atfai.console.v1.GetRevenueOverviewResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.GetRevenueOverviewResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.GetRevenueOverviewResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.GetRevenueOverviewResponse.displayName = "proto.atfai.console.v1.GetRevenueOverviewResponse";
    }
    proto.atfai.console.v1.InviteMemberRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.InviteMemberRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.InviteMemberRequest.displayName = "proto.atfai.console.v1.InviteMemberRequest";
    }
    proto.atfai.console.v1.InviteMemberResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.InviteMemberResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.InviteMemberResponse.displayName = "proto.atfai.console.v1.InviteMemberResponse";
    }
    proto.atfai.console.v1.InviteFirstCustomerRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.InviteFirstCustomerRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.InviteFirstCustomerRequest.displayName = "proto.atfai.console.v1.InviteFirstCustomerRequest";
    }
    proto.atfai.console.v1.InviteFirstCustomerResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.InviteFirstCustomerResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.InviteFirstCustomerResponse.displayName = "proto.atfai.console.v1.InviteFirstCustomerResponse";
    }
    proto.atfai.console.v1.ListMembersRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListMembersRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListMembersRequest.displayName = "proto.atfai.console.v1.ListMembersRequest";
    }
    proto.atfai.console.v1.AccountMember = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.AccountMember, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.AccountMember.displayName = "proto.atfai.console.v1.AccountMember";
    }
    proto.atfai.console.v1.ListMembersResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListMembersResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListMembersResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListMembersResponse.displayName = "proto.atfai.console.v1.ListMembersResponse";
    }
    proto.atfai.console.v1.RemoveMemberRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RemoveMemberRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RemoveMemberRequest.displayName = "proto.atfai.console.v1.RemoveMemberRequest";
    }
    proto.atfai.console.v1.RemoveMemberResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RemoveMemberResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RemoveMemberResponse.displayName = "proto.atfai.console.v1.RemoveMemberResponse";
    }
    proto.atfai.console.v1.SetMemberRoleRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.SetMemberRoleRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.SetMemberRoleRequest.displayName = "proto.atfai.console.v1.SetMemberRoleRequest";
    }
    proto.atfai.console.v1.SetMemberRoleResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.SetMemberRoleResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.SetMemberRoleResponse.displayName = "proto.atfai.console.v1.SetMemberRoleResponse";
    }
    proto.atfai.console.v1.AcceptInviteRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.AcceptInviteRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.AcceptInviteRequest.displayName = "proto.atfai.console.v1.AcceptInviteRequest";
    }
    proto.atfai.console.v1.AcceptInviteResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.AcceptInviteResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.AcceptInviteResponse.displayName = "proto.atfai.console.v1.AcceptInviteResponse";
    }
    proto.atfai.console.v1.RequestSeatChangeRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RequestSeatChangeRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RequestSeatChangeRequest.displayName = "proto.atfai.console.v1.RequestSeatChangeRequest";
    }
    proto.atfai.console.v1.RequestSeatChangeResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RequestSeatChangeResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RequestSeatChangeResponse.displayName = "proto.atfai.console.v1.RequestSeatChangeResponse";
    }
    proto.atfai.console.v1.RequestCancellationRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RequestCancellationRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RequestCancellationRequest.displayName = "proto.atfai.console.v1.RequestCancellationRequest";
    }
    proto.atfai.console.v1.RequestCancellationResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RequestCancellationResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RequestCancellationResponse.displayName = "proto.atfai.console.v1.RequestCancellationResponse";
    }
    proto.atfai.console.v1.RequestSupportRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RequestSupportRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RequestSupportRequest.displayName = "proto.atfai.console.v1.RequestSupportRequest";
    }
    proto.atfai.console.v1.RequestSupportResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.RequestSupportResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.RequestSupportResponse.displayName = "proto.atfai.console.v1.RequestSupportResponse";
    }
    proto.atfai.console.v1.CustomerRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.CustomerRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.CustomerRequest.displayName = "proto.atfai.console.v1.CustomerRequest";
    }
    proto.atfai.console.v1.ListCustomerRequestsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListCustomerRequestsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListCustomerRequestsRequest.displayName = "proto.atfai.console.v1.ListCustomerRequestsRequest";
    }
    proto.atfai.console.v1.ListCustomerRequestsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListCustomerRequestsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListCustomerRequestsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListCustomerRequestsResponse.displayName = "proto.atfai.console.v1.ListCustomerRequestsResponse";
    }
    proto.atfai.console.v1.AcknowledgeCustomerRequestRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.AcknowledgeCustomerRequestRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.displayName = "proto.atfai.console.v1.AcknowledgeCustomerRequestRequest";
    }
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.AcknowledgeCustomerRequestResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.displayName = "proto.atfai.console.v1.AcknowledgeCustomerRequestResponse";
    }
    proto.atfai.console.v1.ResolveCustomerRequestRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ResolveCustomerRequestRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ResolveCustomerRequestRequest.displayName = "proto.atfai.console.v1.ResolveCustomerRequestRequest";
    }
    proto.atfai.console.v1.ResolveCustomerRequestResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ResolveCustomerRequestResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ResolveCustomerRequestResponse.displayName = "proto.atfai.console.v1.ResolveCustomerRequestResponse";
    }
    proto.atfai.console.v1.OrgBillingPortal = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.OrgBillingPortal, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.OrgBillingPortal.displayName = "proto.atfai.console.v1.OrgBillingPortal";
    }
    proto.atfai.console.v1.ListMyOrgBillingPortalsRequest = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListMyOrgBillingPortalsRequest, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.displayName = "proto.atfai.console.v1.ListMyOrgBillingPortalsRequest";
    }
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse = function(opt_data) {
      jspb2.Message.initialize(this, opt_data, 0, -1, proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.repeatedFields_, null);
    };
    goog2.inherits(proto.atfai.console.v1.ListMyOrgBillingPortalsResponse, jspb2.Message);
    if (goog2.DEBUG && !COMPILED) {
      proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.displayName = "proto.atfai.console.v1.ListMyOrgBillingPortalsResponse";
    }
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.Account.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.Account.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.Account.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          name: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          partnerId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          dealRegistrationId: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          identityProvider: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          externalSubject: jspb2.Message.getFieldWithDefault(msg, 6, ""),
          createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          billingEmail: jspb2.Message.getFieldWithDefault(msg, 10, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.Account.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.Account();
      return proto.atfai.console.v1.Account.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.Account.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPartnerId(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDealRegistrationId(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setIdentityProvider(value);
            break;
          case 6:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setExternalSubject(value);
            break;
          case 7:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCreatedAt(value);
            break;
          case 8:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setUpdatedAt(value);
            break;
          case 9:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setDeletedAt(value);
            break;
          case 10:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setBillingEmail(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.Account.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.Account.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.Account.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getPartnerId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getDealRegistrationId();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getIdentityProvider();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getExternalSubject();
      if (f.length > 0) {
        writer.writeString(
          6,
          f
        );
      }
      f = message.getCreatedAt();
      if (f != null) {
        writer.writeMessage(
          7,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getUpdatedAt();
      if (f != null) {
        writer.writeMessage(
          8,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getDeletedAt();
      if (f != null) {
        writer.writeMessage(
          9,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getBillingEmail();
      if (f.length > 0) {
        writer.writeString(
          10,
          f
        );
      }
    };
    proto.atfai.console.v1.Account.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.Account.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.Account.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.Account.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.Account.prototype.getPartnerId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.Account.prototype.setPartnerId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.Account.prototype.getDealRegistrationId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.Account.prototype.setDealRegistrationId = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.Account.prototype.getIdentityProvider = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.Account.prototype.setIdentityProvider = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.Account.prototype.getExternalSubject = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 6, "")
      );
    };
    proto.atfai.console.v1.Account.prototype.setExternalSubject = function(value) {
      return jspb2.Message.setProto3StringField(this, 6, value);
    };
    proto.atfai.console.v1.Account.prototype.getCreatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
      );
    };
    proto.atfai.console.v1.Account.prototype.setCreatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 7, value);
    };
    proto.atfai.console.v1.Account.prototype.clearCreatedAt = function() {
      return this.setCreatedAt(void 0);
    };
    proto.atfai.console.v1.Account.prototype.hasCreatedAt = function() {
      return jspb2.Message.getField(this, 7) != null;
    };
    proto.atfai.console.v1.Account.prototype.getUpdatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
      );
    };
    proto.atfai.console.v1.Account.prototype.setUpdatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 8, value);
    };
    proto.atfai.console.v1.Account.prototype.clearUpdatedAt = function() {
      return this.setUpdatedAt(void 0);
    };
    proto.atfai.console.v1.Account.prototype.hasUpdatedAt = function() {
      return jspb2.Message.getField(this, 8) != null;
    };
    proto.atfai.console.v1.Account.prototype.getDeletedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
      );
    };
    proto.atfai.console.v1.Account.prototype.setDeletedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 9, value);
    };
    proto.atfai.console.v1.Account.prototype.clearDeletedAt = function() {
      return this.setDeletedAt(void 0);
    };
    proto.atfai.console.v1.Account.prototype.hasDeletedAt = function() {
      return jspb2.Message.getField(this, 9) != null;
    };
    proto.atfai.console.v1.Account.prototype.getBillingEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 10, "")
      );
    };
    proto.atfai.console.v1.Account.prototype.setBillingEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 10, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.Org.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.Org.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.Org.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          name: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          slug: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          deletedAt: (f = msg.getDeletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          purgeImmediately: jspb2.Message.getBooleanFieldWithDefault(msg, 8, false),
          purgeAfterAt: (f = msg.getPurgeAfterAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          purgedAt: (f = msg.getPurgedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.Org.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.Org();
      return proto.atfai.console.v1.Org.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.Org.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setSlug(value);
            break;
          case 5:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCreatedAt(value);
            break;
          case 6:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setUpdatedAt(value);
            break;
          case 7:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setDeletedAt(value);
            break;
          case 8:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setPurgeImmediately(value);
            break;
          case 9:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setPurgeAfterAt(value);
            break;
          case 10:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setPurgedAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.Org.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.Org.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.Org.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getSlug();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getCreatedAt();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getUpdatedAt();
      if (f != null) {
        writer.writeMessage(
          6,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getDeletedAt();
      if (f != null) {
        writer.writeMessage(
          7,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getPurgeImmediately();
      if (f) {
        writer.writeBool(
          8,
          f
        );
      }
      f = message.getPurgeAfterAt();
      if (f != null) {
        writer.writeMessage(
          9,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getPurgedAt();
      if (f != null) {
        writer.writeMessage(
          10,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.Org.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.Org.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.Org.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.Org.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.Org.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.Org.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.Org.prototype.getSlug = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.Org.prototype.setSlug = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.Org.prototype.getCreatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
      );
    };
    proto.atfai.console.v1.Org.prototype.setCreatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.Org.prototype.clearCreatedAt = function() {
      return this.setCreatedAt(void 0);
    };
    proto.atfai.console.v1.Org.prototype.hasCreatedAt = function() {
      return jspb2.Message.getField(this, 5) != null;
    };
    proto.atfai.console.v1.Org.prototype.getUpdatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
      );
    };
    proto.atfai.console.v1.Org.prototype.setUpdatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.Org.prototype.clearUpdatedAt = function() {
      return this.setUpdatedAt(void 0);
    };
    proto.atfai.console.v1.Org.prototype.hasUpdatedAt = function() {
      return jspb2.Message.getField(this, 6) != null;
    };
    proto.atfai.console.v1.Org.prototype.getDeletedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
      );
    };
    proto.atfai.console.v1.Org.prototype.setDeletedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 7, value);
    };
    proto.atfai.console.v1.Org.prototype.clearDeletedAt = function() {
      return this.setDeletedAt(void 0);
    };
    proto.atfai.console.v1.Org.prototype.hasDeletedAt = function() {
      return jspb2.Message.getField(this, 7) != null;
    };
    proto.atfai.console.v1.Org.prototype.getPurgeImmediately = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 8, false)
      );
    };
    proto.atfai.console.v1.Org.prototype.setPurgeImmediately = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 8, value);
    };
    proto.atfai.console.v1.Org.prototype.getPurgeAfterAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
      );
    };
    proto.atfai.console.v1.Org.prototype.setPurgeAfterAt = function(value) {
      return jspb2.Message.setWrapperField(this, 9, value);
    };
    proto.atfai.console.v1.Org.prototype.clearPurgeAfterAt = function() {
      return this.setPurgeAfterAt(void 0);
    };
    proto.atfai.console.v1.Org.prototype.hasPurgeAfterAt = function() {
      return jspb2.Message.getField(this, 9) != null;
    };
    proto.atfai.console.v1.Org.prototype.getPurgedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10)
      );
    };
    proto.atfai.console.v1.Org.prototype.setPurgedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 10, value);
    };
    proto.atfai.console.v1.Org.prototype.clearPurgedAt = function() {
      return this.setPurgedAt(void 0);
    };
    proto.atfai.console.v1.Org.prototype.hasPurgedAt = function() {
      return jspb2.Message.getField(this, 10) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.Instance.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.Instance.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.Instance.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          name: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          deploymentType: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          connectivityMode: jspb2.Message.getFieldWithDefault(msg, 5, 0),
          enrollmentStatus: jspb2.Message.getFieldWithDefault(msg, 6, 0),
          licenseId: jspb2.Message.getFieldWithDefault(msg, 7, ""),
          lastHandshakeAt: (f = msg.getLastHandshakeAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          atfVersion: jspb2.Message.getFieldWithDefault(msg, 9, ""),
          helmChartVersion: jspb2.Message.getFieldWithDefault(msg, 10, ""),
          labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, void 0) : [],
          createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          environment: jspb2.Message.getFieldWithDefault(msg, 14, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.Instance.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.Instance();
      return proto.atfai.console.v1.Instance.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.Instance.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 4:
            var value = (
              /** @type {!proto.atfai.console.v1.DeploymentType} */
              reader.readEnum()
            );
            msg.setDeploymentType(value);
            break;
          case 5:
            var value = (
              /** @type {!proto.atfai.console.v1.ConnectivityMode} */
              reader.readEnum()
            );
            msg.setConnectivityMode(value);
            break;
          case 6:
            var value = (
              /** @type {!proto.atfai.console.v1.InstanceEnrollmentStatus} */
              reader.readEnum()
            );
            msg.setEnrollmentStatus(value);
            break;
          case 7:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 8:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setLastHandshakeAt(value);
            break;
          case 9:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAtfVersion(value);
            break;
          case 10:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setHelmChartVersion(value);
            break;
          case 11:
            var value = msg.getLabelsMap();
            reader.readMessage(value, function(message, reader2) {
              jspb2.Map.deserializeBinary(message, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readString, null, "", "");
            });
            break;
          case 12:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCreatedAt(value);
            break;
          case 13:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setUpdatedAt(value);
            break;
          case 14:
            var value = (
              /** @type {!proto.atfai.console.v1.InstanceEnvironment} */
              reader.readEnum()
            );
            msg.setEnvironment(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.Instance.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.Instance.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.Instance.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getDeploymentType();
      if (f !== 0) {
        writer.writeEnum(
          4,
          f
        );
      }
      f = message.getConnectivityMode();
      if (f !== 0) {
        writer.writeEnum(
          5,
          f
        );
      }
      f = message.getEnrollmentStatus();
      if (f !== 0) {
        writer.writeEnum(
          6,
          f
        );
      }
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          7,
          f
        );
      }
      f = message.getLastHandshakeAt();
      if (f != null) {
        writer.writeMessage(
          8,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getAtfVersion();
      if (f.length > 0) {
        writer.writeString(
          9,
          f
        );
      }
      f = message.getHelmChartVersion();
      if (f.length > 0) {
        writer.writeString(
          10,
          f
        );
      }
      f = message.getLabelsMap(true);
      if (f && f.getLength() > 0) {
        f.serializeBinary(11, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeString);
      }
      f = message.getCreatedAt();
      if (f != null) {
        writer.writeMessage(
          12,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getUpdatedAt();
      if (f != null) {
        writer.writeMessage(
          13,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getEnvironment();
      if (f !== 0) {
        writer.writeEnum(
          14,
          f
        );
      }
    };
    proto.atfai.console.v1.Instance.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.Instance.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.Instance.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.Instance.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.Instance.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.Instance.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.Instance.prototype.getDeploymentType = function() {
      return (
        /** @type {!proto.atfai.console.v1.DeploymentType} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.Instance.prototype.setDeploymentType = function(value) {
      return jspb2.Message.setProto3EnumField(this, 4, value);
    };
    proto.atfai.console.v1.Instance.prototype.getConnectivityMode = function() {
      return (
        /** @type {!proto.atfai.console.v1.ConnectivityMode} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.Instance.prototype.setConnectivityMode = function(value) {
      return jspb2.Message.setProto3EnumField(this, 5, value);
    };
    proto.atfai.console.v1.Instance.prototype.getEnrollmentStatus = function() {
      return (
        /** @type {!proto.atfai.console.v1.InstanceEnrollmentStatus} */
        jspb2.Message.getFieldWithDefault(this, 6, 0)
      );
    };
    proto.atfai.console.v1.Instance.prototype.setEnrollmentStatus = function(value) {
      return jspb2.Message.setProto3EnumField(this, 6, value);
    };
    proto.atfai.console.v1.Instance.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 7, "")
      );
    };
    proto.atfai.console.v1.Instance.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 7, value);
    };
    proto.atfai.console.v1.Instance.prototype.getLastHandshakeAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
      );
    };
    proto.atfai.console.v1.Instance.prototype.setLastHandshakeAt = function(value) {
      return jspb2.Message.setWrapperField(this, 8, value);
    };
    proto.atfai.console.v1.Instance.prototype.clearLastHandshakeAt = function() {
      return this.setLastHandshakeAt(void 0);
    };
    proto.atfai.console.v1.Instance.prototype.hasLastHandshakeAt = function() {
      return jspb2.Message.getField(this, 8) != null;
    };
    proto.atfai.console.v1.Instance.prototype.getAtfVersion = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 9, "")
      );
    };
    proto.atfai.console.v1.Instance.prototype.setAtfVersion = function(value) {
      return jspb2.Message.setProto3StringField(this, 9, value);
    };
    proto.atfai.console.v1.Instance.prototype.getHelmChartVersion = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 10, "")
      );
    };
    proto.atfai.console.v1.Instance.prototype.setHelmChartVersion = function(value) {
      return jspb2.Message.setProto3StringField(this, 10, value);
    };
    proto.atfai.console.v1.Instance.prototype.getLabelsMap = function(opt_noLazyCreate) {
      return (
        /** @type {!jspb.Map<string,string>} */
        jspb2.Message.getMapField(
          this,
          11,
          opt_noLazyCreate,
          null
        )
      );
    };
    proto.atfai.console.v1.Instance.prototype.clearLabelsMap = function() {
      this.getLabelsMap().clear();
      return this;
    };
    proto.atfai.console.v1.Instance.prototype.getCreatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12)
      );
    };
    proto.atfai.console.v1.Instance.prototype.setCreatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 12, value);
    };
    proto.atfai.console.v1.Instance.prototype.clearCreatedAt = function() {
      return this.setCreatedAt(void 0);
    };
    proto.atfai.console.v1.Instance.prototype.hasCreatedAt = function() {
      return jspb2.Message.getField(this, 12) != null;
    };
    proto.atfai.console.v1.Instance.prototype.getUpdatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13)
      );
    };
    proto.atfai.console.v1.Instance.prototype.setUpdatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 13, value);
    };
    proto.atfai.console.v1.Instance.prototype.clearUpdatedAt = function() {
      return this.setUpdatedAt(void 0);
    };
    proto.atfai.console.v1.Instance.prototype.hasUpdatedAt = function() {
      return jspb2.Message.getField(this, 13) != null;
    };
    proto.atfai.console.v1.Instance.prototype.getEnvironment = function() {
      return (
        /** @type {!proto.atfai.console.v1.InstanceEnvironment} */
        jspb2.Message.getFieldWithDefault(this, 14, 0)
      );
    };
    proto.atfai.console.v1.Instance.prototype.setEnvironment = function(value) {
      return jspb2.Message.setProto3EnumField(this, 14, value);
    };
    proto.atfai.console.v1.License.repeatedFields_ = [12];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.License.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.License.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.License.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          deploymentType: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          seatLimit: jspb2.Message.getFieldWithDefault(msg, 5, 0),
          connectivityMode: jspb2.Message.getFieldWithDefault(msg, 6, 0),
          telemetryRequired: jspb2.Message.getBooleanFieldWithDefault(msg, 7, false),
          billingModel: jspb2.Message.getFieldWithDefault(msg, 8, 0),
          billingState: jspb2.Message.getFieldWithDefault(msg, 9, 0),
          status: jspb2.Message.getFieldWithDefault(msg, 10, 0),
          expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          featureFlagsList: (f = jspb2.Message.getRepeatedField(msg, 12)) == null ? void 0 : f,
          tier: jspb2.Message.getFieldWithDefault(msg, 13, 0),
          orgScope: jspb2.Message.getFieldWithDefault(msg, 21, 0),
          partnerId: jspb2.Message.getFieldWithDefault(msg, 14, ""),
          dealRegistrationId: jspb2.Message.getFieldWithDefault(msg, 15, ""),
          signedToken: jspb2.Message.getFieldWithDefault(msg, 16, ""),
          publicKeyFingerprint: jspb2.Message.getFieldWithDefault(msg, 17, ""),
          instanceLimit: (f = jspb2.Message.getField(msg, 18)) == null ? void 0 : f,
          createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          stripeCustomerId: jspb2.Message.getFieldWithDefault(msg, 22, ""),
          stripeSubscriptionId: jspb2.Message.getFieldWithDefault(msg, 23, ""),
          stripePriceId: jspb2.Message.getFieldWithDefault(msg, 24, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.License.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.License();
      return proto.atfai.console.v1.License.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.License.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 4:
            var value = (
              /** @type {!proto.atfai.console.v1.DeploymentType} */
              reader.readEnum()
            );
            msg.setDeploymentType(value);
            break;
          case 5:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setSeatLimit(value);
            break;
          case 6:
            var value = (
              /** @type {!proto.atfai.console.v1.ConnectivityMode} */
              reader.readEnum()
            );
            msg.setConnectivityMode(value);
            break;
          case 7:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setTelemetryRequired(value);
            break;
          case 8:
            var value = (
              /** @type {!proto.atfai.console.v1.BillingModel} */
              reader.readEnum()
            );
            msg.setBillingModel(value);
            break;
          case 9:
            var value = (
              /** @type {!proto.atfai.console.v1.BillingState} */
              reader.readEnum()
            );
            msg.setBillingState(value);
            break;
          case 10:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseStatus} */
              reader.readEnum()
            );
            msg.setStatus(value);
            break;
          case 11:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setExpiresAt(value);
            break;
          case 12:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.addFeatureFlags(value);
            break;
          case 13:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseTier} */
              reader.readEnum()
            );
            msg.setTier(value);
            break;
          case 21:
            var value = (
              /** @type {!proto.atfai.console.v1.OrgScope} */
              reader.readEnum()
            );
            msg.setOrgScope(value);
            break;
          case 14:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPartnerId(value);
            break;
          case 15:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDealRegistrationId(value);
            break;
          case 16:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setSignedToken(value);
            break;
          case 17:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPublicKeyFingerprint(value);
            break;
          case 18:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setInstanceLimit(value);
            break;
          case 19:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCreatedAt(value);
            break;
          case 20:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setUpdatedAt(value);
            break;
          case 22:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeCustomerId(value);
            break;
          case 23:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeSubscriptionId(value);
            break;
          case 24:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripePriceId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.License.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.License.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.License.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getDeploymentType();
      if (f !== 0) {
        writer.writeEnum(
          4,
          f
        );
      }
      f = message.getSeatLimit();
      if (f !== 0) {
        writer.writeInt32(
          5,
          f
        );
      }
      f = message.getConnectivityMode();
      if (f !== 0) {
        writer.writeEnum(
          6,
          f
        );
      }
      f = message.getTelemetryRequired();
      if (f) {
        writer.writeBool(
          7,
          f
        );
      }
      f = message.getBillingModel();
      if (f !== 0) {
        writer.writeEnum(
          8,
          f
        );
      }
      f = message.getBillingState();
      if (f !== 0) {
        writer.writeEnum(
          9,
          f
        );
      }
      f = message.getStatus();
      if (f !== 0) {
        writer.writeEnum(
          10,
          f
        );
      }
      f = message.getExpiresAt();
      if (f != null) {
        writer.writeMessage(
          11,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getFeatureFlagsList();
      if (f.length > 0) {
        writer.writeRepeatedString(
          12,
          f
        );
      }
      f = message.getTier();
      if (f !== 0) {
        writer.writeEnum(
          13,
          f
        );
      }
      f = message.getOrgScope();
      if (f !== 0) {
        writer.writeEnum(
          21,
          f
        );
      }
      f = message.getPartnerId();
      if (f.length > 0) {
        writer.writeString(
          14,
          f
        );
      }
      f = message.getDealRegistrationId();
      if (f.length > 0) {
        writer.writeString(
          15,
          f
        );
      }
      f = message.getSignedToken();
      if (f.length > 0) {
        writer.writeString(
          16,
          f
        );
      }
      f = message.getPublicKeyFingerprint();
      if (f.length > 0) {
        writer.writeString(
          17,
          f
        );
      }
      f = /** @type {number} */
      jspb2.Message.getField(message, 18);
      if (f != null) {
        writer.writeInt32(
          18,
          f
        );
      }
      f = message.getCreatedAt();
      if (f != null) {
        writer.writeMessage(
          19,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getUpdatedAt();
      if (f != null) {
        writer.writeMessage(
          20,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getStripeCustomerId();
      if (f.length > 0) {
        writer.writeString(
          22,
          f
        );
      }
      f = message.getStripeSubscriptionId();
      if (f.length > 0) {
        writer.writeString(
          23,
          f
        );
      }
      f = message.getStripePriceId();
      if (f.length > 0) {
        writer.writeString(
          24,
          f
        );
      }
    };
    proto.atfai.console.v1.License.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.License.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.License.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.License.prototype.getDeploymentType = function() {
      return (
        /** @type {!proto.atfai.console.v1.DeploymentType} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setDeploymentType = function(value) {
      return jspb2.Message.setProto3EnumField(this, 4, value);
    };
    proto.atfai.console.v1.License.prototype.getSeatLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setSeatLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 5, value);
    };
    proto.atfai.console.v1.License.prototype.getConnectivityMode = function() {
      return (
        /** @type {!proto.atfai.console.v1.ConnectivityMode} */
        jspb2.Message.getFieldWithDefault(this, 6, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setConnectivityMode = function(value) {
      return jspb2.Message.setProto3EnumField(this, 6, value);
    };
    proto.atfai.console.v1.License.prototype.getTelemetryRequired = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 7, false)
      );
    };
    proto.atfai.console.v1.License.prototype.setTelemetryRequired = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 7, value);
    };
    proto.atfai.console.v1.License.prototype.getBillingModel = function() {
      return (
        /** @type {!proto.atfai.console.v1.BillingModel} */
        jspb2.Message.getFieldWithDefault(this, 8, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setBillingModel = function(value) {
      return jspb2.Message.setProto3EnumField(this, 8, value);
    };
    proto.atfai.console.v1.License.prototype.getBillingState = function() {
      return (
        /** @type {!proto.atfai.console.v1.BillingState} */
        jspb2.Message.getFieldWithDefault(this, 9, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setBillingState = function(value) {
      return jspb2.Message.setProto3EnumField(this, 9, value);
    };
    proto.atfai.console.v1.License.prototype.getStatus = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseStatus} */
        jspb2.Message.getFieldWithDefault(this, 10, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3EnumField(this, 10, value);
    };
    proto.atfai.console.v1.License.prototype.getExpiresAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11)
      );
    };
    proto.atfai.console.v1.License.prototype.setExpiresAt = function(value) {
      return jspb2.Message.setWrapperField(this, 11, value);
    };
    proto.atfai.console.v1.License.prototype.clearExpiresAt = function() {
      return this.setExpiresAt(void 0);
    };
    proto.atfai.console.v1.License.prototype.hasExpiresAt = function() {
      return jspb2.Message.getField(this, 11) != null;
    };
    proto.atfai.console.v1.License.prototype.getFeatureFlagsList = function() {
      return (
        /** @type {!Array<string>} */
        jspb2.Message.getRepeatedField(this, 12)
      );
    };
    proto.atfai.console.v1.License.prototype.setFeatureFlagsList = function(value) {
      return jspb2.Message.setField(this, 12, value || []);
    };
    proto.atfai.console.v1.License.prototype.addFeatureFlags = function(value, opt_index) {
      return jspb2.Message.addToRepeatedField(this, 12, value, opt_index);
    };
    proto.atfai.console.v1.License.prototype.clearFeatureFlagsList = function() {
      return this.setFeatureFlagsList([]);
    };
    proto.atfai.console.v1.License.prototype.getTier = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseTier} */
        jspb2.Message.getFieldWithDefault(this, 13, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setTier = function(value) {
      return jspb2.Message.setProto3EnumField(this, 13, value);
    };
    proto.atfai.console.v1.License.prototype.getOrgScope = function() {
      return (
        /** @type {!proto.atfai.console.v1.OrgScope} */
        jspb2.Message.getFieldWithDefault(this, 21, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setOrgScope = function(value) {
      return jspb2.Message.setProto3EnumField(this, 21, value);
    };
    proto.atfai.console.v1.License.prototype.getPartnerId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 14, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setPartnerId = function(value) {
      return jspb2.Message.setProto3StringField(this, 14, value);
    };
    proto.atfai.console.v1.License.prototype.getDealRegistrationId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 15, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setDealRegistrationId = function(value) {
      return jspb2.Message.setProto3StringField(this, 15, value);
    };
    proto.atfai.console.v1.License.prototype.getSignedToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 16, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setSignedToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 16, value);
    };
    proto.atfai.console.v1.License.prototype.getPublicKeyFingerprint = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 17, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setPublicKeyFingerprint = function(value) {
      return jspb2.Message.setProto3StringField(this, 17, value);
    };
    proto.atfai.console.v1.License.prototype.getInstanceLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 18, 0)
      );
    };
    proto.atfai.console.v1.License.prototype.setInstanceLimit = function(value) {
      return jspb2.Message.setField(this, 18, value);
    };
    proto.atfai.console.v1.License.prototype.clearInstanceLimit = function() {
      return jspb2.Message.setField(this, 18, void 0);
    };
    proto.atfai.console.v1.License.prototype.hasInstanceLimit = function() {
      return jspb2.Message.getField(this, 18) != null;
    };
    proto.atfai.console.v1.License.prototype.getCreatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 19)
      );
    };
    proto.atfai.console.v1.License.prototype.setCreatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 19, value);
    };
    proto.atfai.console.v1.License.prototype.clearCreatedAt = function() {
      return this.setCreatedAt(void 0);
    };
    proto.atfai.console.v1.License.prototype.hasCreatedAt = function() {
      return jspb2.Message.getField(this, 19) != null;
    };
    proto.atfai.console.v1.License.prototype.getUpdatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20)
      );
    };
    proto.atfai.console.v1.License.prototype.setUpdatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 20, value);
    };
    proto.atfai.console.v1.License.prototype.clearUpdatedAt = function() {
      return this.setUpdatedAt(void 0);
    };
    proto.atfai.console.v1.License.prototype.hasUpdatedAt = function() {
      return jspb2.Message.getField(this, 20) != null;
    };
    proto.atfai.console.v1.License.prototype.getStripeCustomerId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 22, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setStripeCustomerId = function(value) {
      return jspb2.Message.setProto3StringField(this, 22, value);
    };
    proto.atfai.console.v1.License.prototype.getStripeSubscriptionId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 23, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setStripeSubscriptionId = function(value) {
      return jspb2.Message.setProto3StringField(this, 23, value);
    };
    proto.atfai.console.v1.License.prototype.getStripePriceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 24, "")
      );
    };
    proto.atfai.console.v1.License.prototype.setStripePriceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 24, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.UsageEvent.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.UsageEvent.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.UsageEvent.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          licenseId: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          eventType: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          occurredAt: (f = msg.getOccurredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          dataClassification: jspb2.Message.getFieldWithDefault(msg, 7, 0),
          activeSeatCount: jspb2.Message.getFieldWithDefault(msg, 8, 0),
          attributesMap: (f = msg.getAttributesMap()) ? f.toObject(includeInstance, void 0) : [],
          reportingSource: jspb2.Message.getFieldWithDefault(msg, 10, 0),
          deploymentType: jspb2.Message.getFieldWithDefault(msg, 11, 0),
          orgId: jspb2.Message.getFieldWithDefault(msg, 12, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.UsageEvent.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.UsageEvent();
      return proto.atfai.console.v1.UsageEvent.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.UsageEvent.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEventType(value);
            break;
          case 6:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setOccurredAt(value);
            break;
          case 7:
            var value = (
              /** @type {!proto.atfai.console.v1.DataClassification} */
              reader.readEnum()
            );
            msg.setDataClassification(value);
            break;
          case 8:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setActiveSeatCount(value);
            break;
          case 9:
            var value = msg.getAttributesMap();
            reader.readMessage(value, function(message, reader2) {
              jspb2.Map.deserializeBinary(message, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readString, null, "", "");
            });
            break;
          case 10:
            var value = (
              /** @type {!proto.atfai.console.v1.ReportingSource} */
              reader.readEnum()
            );
            msg.setReportingSource(value);
            break;
          case 11:
            var value = (
              /** @type {!proto.atfai.console.v1.DeploymentType} */
              reader.readEnum()
            );
            msg.setDeploymentType(value);
            break;
          case 12:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.UsageEvent.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.UsageEvent.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.UsageEvent.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getEventType();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getOccurredAt();
      if (f != null) {
        writer.writeMessage(
          6,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getDataClassification();
      if (f !== 0) {
        writer.writeEnum(
          7,
          f
        );
      }
      f = message.getActiveSeatCount();
      if (f !== 0) {
        writer.writeInt32(
          8,
          f
        );
      }
      f = message.getAttributesMap(true);
      if (f && f.getLength() > 0) {
        f.serializeBinary(9, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeString);
      }
      f = message.getReportingSource();
      if (f !== 0) {
        writer.writeEnum(
          10,
          f
        );
      }
      f = message.getDeploymentType();
      if (f !== 0) {
        writer.writeEnum(
          11,
          f
        );
      }
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          12,
          f
        );
      }
    };
    proto.atfai.console.v1.UsageEvent.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getEventType = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setEventType = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getOccurredAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setOccurredAt = function(value) {
      return jspb2.Message.setWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.clearOccurredAt = function() {
      return this.setOccurredAt(void 0);
    };
    proto.atfai.console.v1.UsageEvent.prototype.hasOccurredAt = function() {
      return jspb2.Message.getField(this, 6) != null;
    };
    proto.atfai.console.v1.UsageEvent.prototype.getDataClassification = function() {
      return (
        /** @type {!proto.atfai.console.v1.DataClassification} */
        jspb2.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setDataClassification = function(value) {
      return jspb2.Message.setProto3EnumField(this, 7, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getActiveSeatCount = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 8, 0)
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setActiveSeatCount = function(value) {
      return jspb2.Message.setProto3IntField(this, 8, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getAttributesMap = function(opt_noLazyCreate) {
      return (
        /** @type {!jspb.Map<string,string>} */
        jspb2.Message.getMapField(
          this,
          9,
          opt_noLazyCreate,
          null
        )
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.clearAttributesMap = function() {
      this.getAttributesMap().clear();
      return this;
    };
    proto.atfai.console.v1.UsageEvent.prototype.getReportingSource = function() {
      return (
        /** @type {!proto.atfai.console.v1.ReportingSource} */
        jspb2.Message.getFieldWithDefault(this, 10, 0)
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setReportingSource = function(value) {
      return jspb2.Message.setProto3EnumField(this, 10, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getDeploymentType = function() {
      return (
        /** @type {!proto.atfai.console.v1.DeploymentType} */
        jspb2.Message.getFieldWithDefault(this, 11, 0)
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setDeploymentType = function(value) {
      return jspb2.Message.setProto3EnumField(this, 11, value);
    };
    proto.atfai.console.v1.UsageEvent.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 12, "")
      );
    };
    proto.atfai.console.v1.UsageEvent.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 12, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.AuditEvent.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.AuditEvent.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.AuditEvent.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          action: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          actorId: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          actorType: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          targetType: jspb2.Message.getFieldWithDefault(msg, 6, ""),
          targetId: jspb2.Message.getFieldWithDefault(msg, 7, ""),
          detailJson: jspb2.Message.getFieldWithDefault(msg, 8, ""),
          occurredAt: (f = msg.getOccurredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.AuditEvent.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.AuditEvent();
      return proto.atfai.console.v1.AuditEvent.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.AuditEvent.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.AuditAction} */
              reader.readEnum()
            );
            msg.setAction(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setActorId(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setActorType(value);
            break;
          case 6:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setTargetType(value);
            break;
          case 7:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setTargetId(value);
            break;
          case 8:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDetailJson(value);
            break;
          case 9:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setOccurredAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.AuditEvent.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.AuditEvent.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.AuditEvent.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getAction();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
      f = message.getActorId();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getActorType();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getTargetType();
      if (f.length > 0) {
        writer.writeString(
          6,
          f
        );
      }
      f = message.getTargetId();
      if (f.length > 0) {
        writer.writeString(
          7,
          f
        );
      }
      f = message.getDetailJson();
      if (f.length > 0) {
        writer.writeString(
          8,
          f
        );
      }
      f = message.getOccurredAt();
      if (f != null) {
        writer.writeMessage(
          9,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.AuditEvent.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.getAction = function() {
      return (
        /** @type {!proto.atfai.console.v1.AuditAction} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setAction = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.getActorId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setActorId = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.getActorType = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setActorType = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.getTargetType = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 6, "")
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setTargetType = function(value) {
      return jspb2.Message.setProto3StringField(this, 6, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.getTargetId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 7, "")
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setTargetId = function(value) {
      return jspb2.Message.setProto3StringField(this, 7, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.getDetailJson = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 8, "")
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setDetailJson = function(value) {
      return jspb2.Message.setProto3StringField(this, 8, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.getOccurredAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
      );
    };
    proto.atfai.console.v1.AuditEvent.prototype.setOccurredAt = function(value) {
      return jspb2.Message.setWrapperField(this, 9, value);
    };
    proto.atfai.console.v1.AuditEvent.prototype.clearOccurredAt = function() {
      return this.setOccurredAt(void 0);
    };
    proto.atfai.console.v1.AuditEvent.prototype.hasOccurredAt = function() {
      return jspb2.Message.getField(this, 9) != null;
    };
    proto.atfai.console.v1.UpdateMask.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.UpdateMask.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.UpdateMask.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.UpdateMask.toObject = function(includeInstance, msg) {
        var f, obj = {
          pathsList: (f = jspb2.Message.getRepeatedField(msg, 1)) == null ? void 0 : f
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.UpdateMask.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.UpdateMask();
      return proto.atfai.console.v1.UpdateMask.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.UpdateMask.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.addPaths(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.UpdateMask.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.UpdateMask.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.UpdateMask.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getPathsList();
      if (f.length > 0) {
        writer.writeRepeatedString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.UpdateMask.prototype.getPathsList = function() {
      return (
        /** @type {!Array<string>} */
        jspb2.Message.getRepeatedField(this, 1)
      );
    };
    proto.atfai.console.v1.UpdateMask.prototype.setPathsList = function(value) {
      return jspb2.Message.setField(this, 1, value || []);
    };
    proto.atfai.console.v1.UpdateMask.prototype.addPaths = function(value, opt_index) {
      return jspb2.Message.addToRepeatedField(this, 1, value, opt_index);
    };
    proto.atfai.console.v1.UpdateMask.prototype.clearPathsList = function() {
      return this.setPathsList([]);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateAccountRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateAccountRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateAccountRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          name: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          partnerId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          dealRegistrationId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          identityProvider: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          externalSubject: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          idempotencyKey: jspb2.Message.getFieldWithDefault(msg, 6, ""),
          billingEmail: jspb2.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateAccountRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateAccountRequest();
      return proto.atfai.console.v1.CreateAccountRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPartnerId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDealRegistrationId(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setIdentityProvider(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setExternalSubject(value);
            break;
          case 6:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setIdempotencyKey(value);
            break;
          case 7:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setBillingEmail(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateAccountRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateAccountRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getPartnerId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getDealRegistrationId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getIdentityProvider();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getExternalSubject();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getIdempotencyKey();
      if (f.length > 0) {
        writer.writeString(
          6,
          f
        );
      }
      f = message.getBillingEmail();
      if (f.length > 0) {
        writer.writeString(
          7,
          f
        );
      }
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.getPartnerId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.setPartnerId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.getDealRegistrationId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.setDealRegistrationId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.getIdentityProvider = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.setIdentityProvider = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.getExternalSubject = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.setExternalSubject = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.getIdempotencyKey = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 6, "")
      );
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.setIdempotencyKey = function(value) {
      return jspb2.Message.setProto3StringField(this, 6, value);
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.getBillingEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 7, "")
      );
    };
    proto.atfai.console.v1.CreateAccountRequest.prototype.setBillingEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 7, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateAccountResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateAccountResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateAccountResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          account: (f = msg.getAccount()) && proto.atfai.console.v1.Account.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateAccountResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateAccountResponse();
      return proto.atfai.console.v1.CreateAccountResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Account();
            reader.readMessage(value, proto.atfai.console.v1.Account.deserializeBinaryFromReader);
            msg.setAccount(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateAccountResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateAccountResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateAccountResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccount();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Account.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.CreateAccountResponse.prototype.getAccount = function() {
      return (
        /** @type{?proto.atfai.console.v1.Account} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Account, 1)
      );
    };
    proto.atfai.console.v1.CreateAccountResponse.prototype.setAccount = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.CreateAccountResponse.prototype.clearAccount = function() {
      return this.setAccount(void 0);
    };
    proto.atfai.console.v1.CreateAccountResponse.prototype.hasAccount = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetAccountRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetAccountRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetAccountRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetAccountRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetAccountRequest();
      return proto.atfai.console.v1.GetAccountRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetAccountRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetAccountRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetAccountRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.GetAccountRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetAccountRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetAccountResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetAccountResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetAccountResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          account: (f = msg.getAccount()) && proto.atfai.console.v1.Account.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetAccountResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetAccountResponse();
      return proto.atfai.console.v1.GetAccountResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Account();
            reader.readMessage(value, proto.atfai.console.v1.Account.deserializeBinaryFromReader);
            msg.setAccount(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetAccountResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetAccountResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetAccountResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccount();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Account.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetAccountResponse.prototype.getAccount = function() {
      return (
        /** @type{?proto.atfai.console.v1.Account} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Account, 1)
      );
    };
    proto.atfai.console.v1.GetAccountResponse.prototype.setAccount = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.GetAccountResponse.prototype.clearAccount = function() {
      return this.setAccount(void 0);
    };
    proto.atfai.console.v1.GetAccountResponse.prototype.hasAccount = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListAccountsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListAccountsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListAccountsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          partnerFilter: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          nameContains: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          limit: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          offset: jspb2.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListAccountsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListAccountsRequest();
      return proto.atfai.console.v1.ListAccountsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListAccountsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPartnerFilter(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setNameContains(value);
            break;
          case 3:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setLimit(value);
            break;
          case 4:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setOffset(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListAccountsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListAccountsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getPartnerFilter();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getNameContains();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getLimit();
      if (f !== 0) {
        writer.writeInt32(
          3,
          f
        );
      }
      f = message.getOffset();
      if (f !== 0) {
        writer.writeInt32(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.getPartnerFilter = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.setPartnerFilter = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.getNameContains = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.setNameContains = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.getLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.setLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 3, value);
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.getOffset = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.ListAccountsRequest.prototype.setOffset = function(value) {
      return jspb2.Message.setProto3IntField(this, 4, value);
    };
    proto.atfai.console.v1.ListAccountsResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListAccountsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListAccountsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListAccountsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountsList: jspb2.Message.toObjectList(
            msg.getAccountsList(),
            proto.atfai.console.v1.Account.toObject,
            includeInstance
          ),
          total: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListAccountsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListAccountsResponse();
      return proto.atfai.console.v1.ListAccountsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListAccountsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Account();
            reader.readMessage(value, proto.atfai.console.v1.Account.deserializeBinaryFromReader);
            msg.addAccounts(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotal(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListAccountsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListAccountsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListAccountsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.Account.serializeBinaryToWriter
        );
      }
      f = message.getTotal();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListAccountsResponse.prototype.getAccountsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.Account>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.Account, 1)
      );
    };
    proto.atfai.console.v1.ListAccountsResponse.prototype.setAccountsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListAccountsResponse.prototype.addAccounts = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.Account, opt_index);
    };
    proto.atfai.console.v1.ListAccountsResponse.prototype.clearAccountsList = function() {
      return this.setAccountsList([]);
    };
    proto.atfai.console.v1.ListAccountsResponse.prototype.getTotal = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListAccountsResponse.prototype.setTotal = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.UpdateAccountRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.UpdateAccountRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.UpdateAccountRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          updateMask: (f = msg.getUpdateMask()) && proto.atfai.console.v1.UpdateMask.toObject(includeInstance, f),
          name: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          partnerId: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          dealRegistrationId: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          identityProvider: jspb2.Message.getFieldWithDefault(msg, 6, ""),
          externalSubject: jspb2.Message.getFieldWithDefault(msg, 7, ""),
          billingEmail: jspb2.Message.getFieldWithDefault(msg, 8, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.UpdateAccountRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.UpdateAccountRequest();
      return proto.atfai.console.v1.UpdateAccountRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.UpdateAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.UpdateMask();
            reader.readMessage(value, proto.atfai.console.v1.UpdateMask.deserializeBinaryFromReader);
            msg.setUpdateMask(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPartnerId(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDealRegistrationId(value);
            break;
          case 6:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setIdentityProvider(value);
            break;
          case 7:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setExternalSubject(value);
            break;
          case 8:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setBillingEmail(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.UpdateAccountRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.UpdateAccountRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getUpdateMask();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.UpdateMask.serializeBinaryToWriter
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getPartnerId();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getDealRegistrationId();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getIdentityProvider();
      if (f.length > 0) {
        writer.writeString(
          6,
          f
        );
      }
      f = message.getExternalSubject();
      if (f.length > 0) {
        writer.writeString(
          7,
          f
        );
      }
      f = message.getBillingEmail();
      if (f.length > 0) {
        writer.writeString(
          8,
          f
        );
      }
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.getUpdateMask = function() {
      return (
        /** @type{?proto.atfai.console.v1.UpdateMask} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.UpdateMask, 2)
      );
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.setUpdateMask = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.clearUpdateMask = function() {
      return this.setUpdateMask(void 0);
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.hasUpdateMask = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.getPartnerId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.setPartnerId = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.getDealRegistrationId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.setDealRegistrationId = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.getIdentityProvider = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 6, "")
      );
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.setIdentityProvider = function(value) {
      return jspb2.Message.setProto3StringField(this, 6, value);
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.getExternalSubject = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 7, "")
      );
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.setExternalSubject = function(value) {
      return jspb2.Message.setProto3StringField(this, 7, value);
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.getBillingEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 8, "")
      );
    };
    proto.atfai.console.v1.UpdateAccountRequest.prototype.setBillingEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 8, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.UpdateAccountResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.UpdateAccountResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.UpdateAccountResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          account: (f = msg.getAccount()) && proto.atfai.console.v1.Account.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.UpdateAccountResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.UpdateAccountResponse();
      return proto.atfai.console.v1.UpdateAccountResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.UpdateAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Account();
            reader.readMessage(value, proto.atfai.console.v1.Account.deserializeBinaryFromReader);
            msg.setAccount(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.UpdateAccountResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.UpdateAccountResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.UpdateAccountResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccount();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Account.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.UpdateAccountResponse.prototype.getAccount = function() {
      return (
        /** @type{?proto.atfai.console.v1.Account} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Account, 1)
      );
    };
    proto.atfai.console.v1.UpdateAccountResponse.prototype.setAccount = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.UpdateAccountResponse.prototype.clearAccount = function() {
      return this.setAccount(void 0);
    };
    proto.atfai.console.v1.UpdateAccountResponse.prototype.hasAccount = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.DeleteAccountRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.DeleteAccountRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.DeleteAccountRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.DeleteAccountRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.DeleteAccountRequest();
      return proto.atfai.console.v1.DeleteAccountRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.DeleteAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.DeleteAccountRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.DeleteAccountRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.DeleteAccountRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.DeleteAccountRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.DeleteAccountRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.DeleteAccountResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.DeleteAccountResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.DeleteAccountResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          success: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
          account: (f = msg.getAccount()) && proto.atfai.console.v1.Account.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.DeleteAccountResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.DeleteAccountResponse();
      return proto.atfai.console.v1.DeleteAccountResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.DeleteAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setSuccess(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.Account();
            reader.readMessage(value, proto.atfai.console.v1.Account.deserializeBinaryFromReader);
            msg.setAccount(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.DeleteAccountResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.DeleteAccountResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.DeleteAccountResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getSuccess();
      if (f) {
        writer.writeBool(
          1,
          f
        );
      }
      f = message.getAccount();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.Account.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.DeleteAccountResponse.prototype.getSuccess = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 1, false)
      );
    };
    proto.atfai.console.v1.DeleteAccountResponse.prototype.setSuccess = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 1, value);
    };
    proto.atfai.console.v1.DeleteAccountResponse.prototype.getAccount = function() {
      return (
        /** @type{?proto.atfai.console.v1.Account} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Account, 2)
      );
    };
    proto.atfai.console.v1.DeleteAccountResponse.prototype.setAccount = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.DeleteAccountResponse.prototype.clearAccount = function() {
      return this.setAccount(void 0);
    };
    proto.atfai.console.v1.DeleteAccountResponse.prototype.hasAccount = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateOrgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateOrgRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateOrgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          name: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          slug: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          idempotencyKey: jspb2.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateOrgRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateOrgRequest();
      return proto.atfai.console.v1.CreateOrgRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateOrgRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setSlug(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setIdempotencyKey(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateOrgRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateOrgRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getSlug();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getIdempotencyKey();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.getSlug = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.setSlug = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.getIdempotencyKey = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.CreateOrgRequest.prototype.setIdempotencyKey = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateOrgResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateOrgResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateOrgResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          org: (f = msg.getOrg()) && proto.atfai.console.v1.Org.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateOrgResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateOrgResponse();
      return proto.atfai.console.v1.CreateOrgResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateOrgResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Org();
            reader.readMessage(value, proto.atfai.console.v1.Org.deserializeBinaryFromReader);
            msg.setOrg(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateOrgResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateOrgResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateOrgResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrg();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Org.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.CreateOrgResponse.prototype.getOrg = function() {
      return (
        /** @type{?proto.atfai.console.v1.Org} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Org, 1)
      );
    };
    proto.atfai.console.v1.CreateOrgResponse.prototype.setOrg = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.CreateOrgResponse.prototype.clearOrg = function() {
      return this.setOrg(void 0);
    };
    proto.atfai.console.v1.CreateOrgResponse.prototype.hasOrg = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetOrgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetOrgRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetOrgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetOrgRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetOrgRequest();
      return proto.atfai.console.v1.GetOrgRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetOrgRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetOrgRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetOrgRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetOrgRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.GetOrgRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetOrgRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetOrgResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetOrgResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetOrgResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          org: (f = msg.getOrg()) && proto.atfai.console.v1.Org.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetOrgResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetOrgResponse();
      return proto.atfai.console.v1.GetOrgResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetOrgResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Org();
            reader.readMessage(value, proto.atfai.console.v1.Org.deserializeBinaryFromReader);
            msg.setOrg(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetOrgResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetOrgResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetOrgResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrg();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Org.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetOrgResponse.prototype.getOrg = function() {
      return (
        /** @type{?proto.atfai.console.v1.Org} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Org, 1)
      );
    };
    proto.atfai.console.v1.GetOrgResponse.prototype.setOrg = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.GetOrgResponse.prototype.clearOrg = function() {
      return this.setOrg(void 0);
    };
    proto.atfai.console.v1.GetOrgResponse.prototype.hasOrg = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListOrgsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListOrgsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListOrgsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          limit: jspb2.Message.getFieldWithDefault(msg, 2, 0),
          offset: jspb2.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListOrgsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListOrgsRequest();
      return proto.atfai.console.v1.ListOrgsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListOrgsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setLimit(value);
            break;
          case 3:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setOffset(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListOrgsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListOrgsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListOrgsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getLimit();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
      f = message.getOffset();
      if (f !== 0) {
        writer.writeInt32(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.ListOrgsRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ListOrgsRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ListOrgsRequest.prototype.getLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListOrgsRequest.prototype.setLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    proto.atfai.console.v1.ListOrgsRequest.prototype.getOffset = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.ListOrgsRequest.prototype.setOffset = function(value) {
      return jspb2.Message.setProto3IntField(this, 3, value);
    };
    proto.atfai.console.v1.ListOrgsResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListOrgsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListOrgsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListOrgsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgsList: jspb2.Message.toObjectList(
            msg.getOrgsList(),
            proto.atfai.console.v1.Org.toObject,
            includeInstance
          ),
          total: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListOrgsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListOrgsResponse();
      return proto.atfai.console.v1.ListOrgsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListOrgsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Org();
            reader.readMessage(value, proto.atfai.console.v1.Org.deserializeBinaryFromReader);
            msg.addOrgs(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotal(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListOrgsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListOrgsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListOrgsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.Org.serializeBinaryToWriter
        );
      }
      f = message.getTotal();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListOrgsResponse.prototype.getOrgsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.Org>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.Org, 1)
      );
    };
    proto.atfai.console.v1.ListOrgsResponse.prototype.setOrgsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListOrgsResponse.prototype.addOrgs = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.Org, opt_index);
    };
    proto.atfai.console.v1.ListOrgsResponse.prototype.clearOrgsList = function() {
      return this.setOrgsList([]);
    };
    proto.atfai.console.v1.ListOrgsResponse.prototype.getTotal = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListOrgsResponse.prototype.setTotal = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.UpdateOrgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.UpdateOrgRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.UpdateOrgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          updateMask: (f = msg.getUpdateMask()) && proto.atfai.console.v1.UpdateMask.toObject(includeInstance, f),
          name: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          slug: jspb2.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.UpdateOrgRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.UpdateOrgRequest();
      return proto.atfai.console.v1.UpdateOrgRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.UpdateOrgRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.UpdateMask();
            reader.readMessage(value, proto.atfai.console.v1.UpdateMask.deserializeBinaryFromReader);
            msg.setUpdateMask(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setSlug(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.UpdateOrgRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.UpdateOrgRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getUpdateMask();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.UpdateMask.serializeBinaryToWriter
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getSlug();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.getUpdateMask = function() {
      return (
        /** @type{?proto.atfai.console.v1.UpdateMask} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.UpdateMask, 2)
      );
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.setUpdateMask = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.clearUpdateMask = function() {
      return this.setUpdateMask(void 0);
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.hasUpdateMask = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.getSlug = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.UpdateOrgRequest.prototype.setSlug = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.UpdateOrgResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.UpdateOrgResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.UpdateOrgResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          org: (f = msg.getOrg()) && proto.atfai.console.v1.Org.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.UpdateOrgResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.UpdateOrgResponse();
      return proto.atfai.console.v1.UpdateOrgResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.UpdateOrgResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Org();
            reader.readMessage(value, proto.atfai.console.v1.Org.deserializeBinaryFromReader);
            msg.setOrg(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.UpdateOrgResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.UpdateOrgResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.UpdateOrgResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrg();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Org.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.UpdateOrgResponse.prototype.getOrg = function() {
      return (
        /** @type{?proto.atfai.console.v1.Org} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Org, 1)
      );
    };
    proto.atfai.console.v1.UpdateOrgResponse.prototype.setOrg = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.UpdateOrgResponse.prototype.clearOrg = function() {
      return this.setOrg(void 0);
    };
    proto.atfai.console.v1.UpdateOrgResponse.prototype.hasOrg = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.DeleteOrgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.DeleteOrgRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.DeleteOrgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          purgeImmediately: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.DeleteOrgRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.DeleteOrgRequest();
      return proto.atfai.console.v1.DeleteOrgRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.DeleteOrgRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 2:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setPurgeImmediately(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.DeleteOrgRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.DeleteOrgRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.DeleteOrgRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getPurgeImmediately();
      if (f) {
        writer.writeBool(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.DeleteOrgRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.DeleteOrgRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.DeleteOrgRequest.prototype.getPurgeImmediately = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 2, false)
      );
    };
    proto.atfai.console.v1.DeleteOrgRequest.prototype.setPurgeImmediately = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.DeleteOrgResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.DeleteOrgResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.DeleteOrgResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          success: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
          org: (f = msg.getOrg()) && proto.atfai.console.v1.Org.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.DeleteOrgResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.DeleteOrgResponse();
      return proto.atfai.console.v1.DeleteOrgResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.DeleteOrgResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setSuccess(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.Org();
            reader.readMessage(value, proto.atfai.console.v1.Org.deserializeBinaryFromReader);
            msg.setOrg(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.DeleteOrgResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.DeleteOrgResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.DeleteOrgResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getSuccess();
      if (f) {
        writer.writeBool(
          1,
          f
        );
      }
      f = message.getOrg();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.Org.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.DeleteOrgResponse.prototype.getSuccess = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 1, false)
      );
    };
    proto.atfai.console.v1.DeleteOrgResponse.prototype.setSuccess = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 1, value);
    };
    proto.atfai.console.v1.DeleteOrgResponse.prototype.getOrg = function() {
      return (
        /** @type{?proto.atfai.console.v1.Org} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Org, 2)
      );
    };
    proto.atfai.console.v1.DeleteOrgResponse.prototype.setOrg = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.DeleteOrgResponse.prototype.clearOrg = function() {
      return this.setOrg(void 0);
    };
    proto.atfai.console.v1.DeleteOrgResponse.prototype.hasOrg = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RestoreOrgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RestoreOrgRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RestoreOrgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RestoreOrgRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RestoreOrgRequest();
      return proto.atfai.console.v1.RestoreOrgRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RestoreOrgRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RestoreOrgRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RestoreOrgRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RestoreOrgRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.RestoreOrgRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.RestoreOrgRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RestoreOrgResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RestoreOrgResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RestoreOrgResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          success: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
          org: (f = msg.getOrg()) && proto.atfai.console.v1.Org.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RestoreOrgResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RestoreOrgResponse();
      return proto.atfai.console.v1.RestoreOrgResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RestoreOrgResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setSuccess(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.Org();
            reader.readMessage(value, proto.atfai.console.v1.Org.deserializeBinaryFromReader);
            msg.setOrg(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RestoreOrgResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RestoreOrgResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RestoreOrgResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getSuccess();
      if (f) {
        writer.writeBool(
          1,
          f
        );
      }
      f = message.getOrg();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.Org.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.RestoreOrgResponse.prototype.getSuccess = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 1, false)
      );
    };
    proto.atfai.console.v1.RestoreOrgResponse.prototype.setSuccess = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 1, value);
    };
    proto.atfai.console.v1.RestoreOrgResponse.prototype.getOrg = function() {
      return (
        /** @type{?proto.atfai.console.v1.Org} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Org, 2)
      );
    };
    proto.atfai.console.v1.RestoreOrgResponse.prototype.setOrg = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.RestoreOrgResponse.prototype.clearOrg = function() {
      return this.setOrg(void 0);
    };
    proto.atfai.console.v1.RestoreOrgResponse.prototype.hasOrg = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          limit: jspb2.Message.getFieldWithDefault(msg, 1, 0),
          offset: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListPurgeEligibleOrgsRequest();
      return proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setLimit(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setOffset(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLimit();
      if (f !== 0) {
        writer.writeInt32(
          1,
          f
        );
      }
      f = message.getOffset();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.prototype.getLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.prototype.setLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 1, value);
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.prototype.getOffset = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsRequest.prototype.setOffset = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgsList: jspb2.Message.toObjectList(
            msg.getOrgsList(),
            proto.atfai.console.v1.Org.toObject,
            includeInstance
          ),
          total: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListPurgeEligibleOrgsResponse();
      return proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Org();
            reader.readMessage(value, proto.atfai.console.v1.Org.deserializeBinaryFromReader);
            msg.addOrgs(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotal(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.Org.serializeBinaryToWriter
        );
      }
      f = message.getTotal();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.prototype.getOrgsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.Org>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.Org, 1)
      );
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.prototype.setOrgsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.prototype.addOrgs = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.Org, opt_index);
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.prototype.clearOrgsList = function() {
      return this.setOrgsList([]);
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.prototype.getTotal = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListPurgeEligibleOrgsResponse.prototype.setTotal = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.MarkOrgPurgedRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.MarkOrgPurgedRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.MarkOrgPurgedRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          rowsPurgedMap: (f = msg.getRowsPurgedMap()) ? f.toObject(includeInstance, void 0) : []
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.MarkOrgPurgedRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.MarkOrgPurgedRequest();
      return proto.atfai.console.v1.MarkOrgPurgedRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.MarkOrgPurgedRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 2:
            var value = msg.getRowsPurgedMap();
            reader.readMessage(value, function(message, reader2) {
              jspb2.Map.deserializeBinary(message, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readInt64, null, "", 0);
            });
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.MarkOrgPurgedRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.MarkOrgPurgedRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.MarkOrgPurgedRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getRowsPurgedMap(true);
      if (f && f.getLength() > 0) {
        f.serializeBinary(2, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeInt64);
      }
    };
    proto.atfai.console.v1.MarkOrgPurgedRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.MarkOrgPurgedRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.MarkOrgPurgedRequest.prototype.getRowsPurgedMap = function(opt_noLazyCreate) {
      return (
        /** @type {!jspb.Map<string,number>} */
        jspb2.Message.getMapField(
          this,
          2,
          opt_noLazyCreate,
          null
        )
      );
    };
    proto.atfai.console.v1.MarkOrgPurgedRequest.prototype.clearRowsPurgedMap = function() {
      this.getRowsPurgedMap().clear();
      return this;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.MarkOrgPurgedResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.MarkOrgPurgedResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.MarkOrgPurgedResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          success: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
          org: (f = msg.getOrg()) && proto.atfai.console.v1.Org.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.MarkOrgPurgedResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.MarkOrgPurgedResponse();
      return proto.atfai.console.v1.MarkOrgPurgedResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setSuccess(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.Org();
            reader.readMessage(value, proto.atfai.console.v1.Org.deserializeBinaryFromReader);
            msg.setOrg(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.MarkOrgPurgedResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getSuccess();
      if (f) {
        writer.writeBool(
          1,
          f
        );
      }
      f = message.getOrg();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.Org.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.prototype.getSuccess = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 1, false)
      );
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.prototype.setSuccess = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 1, value);
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.prototype.getOrg = function() {
      return (
        /** @type{?proto.atfai.console.v1.Org} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Org, 2)
      );
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.prototype.setOrg = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.prototype.clearOrg = function() {
      return this.setOrg(void 0);
    };
    proto.atfai.console.v1.MarkOrgPurgedResponse.prototype.hasOrg = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.MintSignupRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.MintSignupRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.MintSignupRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          correlationId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          orgName: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          orgSlug: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          userEmail: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          identityProvider: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          externalSubject: jspb2.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.MintSignupRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.MintSignupRequest();
      return proto.atfai.console.v1.MintSignupRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.MintSignupRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setCorrelationId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgName(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgSlug(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setUserEmail(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setIdentityProvider(value);
            break;
          case 6:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setExternalSubject(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.MintSignupRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.MintSignupRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getCorrelationId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getOrgName();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getOrgSlug();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getUserEmail();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getIdentityProvider();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getExternalSubject();
      if (f.length > 0) {
        writer.writeString(
          6,
          f
        );
      }
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.getCorrelationId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.setCorrelationId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.getOrgName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.setOrgName = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.getOrgSlug = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.setOrgSlug = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.getUserEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.setUserEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.getIdentityProvider = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.setIdentityProvider = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.getExternalSubject = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 6, "")
      );
    };
    proto.atfai.console.v1.MintSignupRequest.prototype.setExternalSubject = function(value) {
      return jspb2.Message.setProto3StringField(this, 6, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.MintSignupResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.MintSignupResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.MintSignupResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          globalOrgId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          userId: jspb2.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.MintSignupResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.MintSignupResponse();
      return proto.atfai.console.v1.MintSignupResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.MintSignupResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setGlobalOrgId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setUserId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.MintSignupResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.MintSignupResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.MintSignupResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getGlobalOrgId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getUserId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.MintSignupResponse.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.MintSignupResponse.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.MintSignupResponse.prototype.getGlobalOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.MintSignupResponse.prototype.setGlobalOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.MintSignupResponse.prototype.getUserId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.MintSignupResponse.prototype.setUserId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          subject: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          detail: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          orgId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          requesterEmail: jspb2.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.SubmitInstanceSupportRequestRequest();
      return proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setSubject(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDetail(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequesterEmail(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getSubject();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getDetail();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getRequesterEmail();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.getSubject = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.setSubject = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.getDetail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.setDetail = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.getRequesterEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestRequest.prototype.setRequesterEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          requestId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.SubmitInstanceSupportRequestResponse();
      return proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequestId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequestId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.prototype.getRequestId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.SubmitInstanceSupportRequestResponse.prototype.setRequestId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RegisterInstanceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RegisterInstanceRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RegisterInstanceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          registrationToken: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          name: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          deploymentType: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          connectivityMode: jspb2.Message.getFieldWithDefault(msg, 5, 0),
          atfVersion: jspb2.Message.getFieldWithDefault(msg, 6, ""),
          helmChartVersion: jspb2.Message.getFieldWithDefault(msg, 7, ""),
          labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, void 0) : [],
          licenseId: jspb2.Message.getFieldWithDefault(msg, 9, ""),
          environment: jspb2.Message.getFieldWithDefault(msg, 10, 0),
          idempotencyKey: jspb2.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RegisterInstanceRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RegisterInstanceRequest();
      return proto.atfai.console.v1.RegisterInstanceRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRegistrationToken(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 4:
            var value = (
              /** @type {!proto.atfai.console.v1.DeploymentType} */
              reader.readEnum()
            );
            msg.setDeploymentType(value);
            break;
          case 5:
            var value = (
              /** @type {!proto.atfai.console.v1.ConnectivityMode} */
              reader.readEnum()
            );
            msg.setConnectivityMode(value);
            break;
          case 6:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAtfVersion(value);
            break;
          case 7:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setHelmChartVersion(value);
            break;
          case 8:
            var value = msg.getLabelsMap();
            reader.readMessage(value, function(message, reader2) {
              jspb2.Map.deserializeBinary(message, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readString, null, "", "");
            });
            break;
          case 9:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 10:
            var value = (
              /** @type {!proto.atfai.console.v1.InstanceEnvironment} */
              reader.readEnum()
            );
            msg.setEnvironment(value);
            break;
          case 11:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setIdempotencyKey(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RegisterInstanceRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RegisterInstanceRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRegistrationToken();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getDeploymentType();
      if (f !== 0) {
        writer.writeEnum(
          4,
          f
        );
      }
      f = message.getConnectivityMode();
      if (f !== 0) {
        writer.writeEnum(
          5,
          f
        );
      }
      f = message.getAtfVersion();
      if (f.length > 0) {
        writer.writeString(
          6,
          f
        );
      }
      f = message.getHelmChartVersion();
      if (f.length > 0) {
        writer.writeString(
          7,
          f
        );
      }
      f = message.getLabelsMap(true);
      if (f && f.getLength() > 0) {
        f.serializeBinary(8, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeString);
      }
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          9,
          f
        );
      }
      f = message.getEnvironment();
      if (f !== 0) {
        writer.writeEnum(
          10,
          f
        );
      }
      f = message.getIdempotencyKey();
      if (f.length > 0) {
        writer.writeString(
          11,
          f
        );
      }
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getRegistrationToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setRegistrationToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getDeploymentType = function() {
      return (
        /** @type {!proto.atfai.console.v1.DeploymentType} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setDeploymentType = function(value) {
      return jspb2.Message.setProto3EnumField(this, 4, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getConnectivityMode = function() {
      return (
        /** @type {!proto.atfai.console.v1.ConnectivityMode} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setConnectivityMode = function(value) {
      return jspb2.Message.setProto3EnumField(this, 5, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getAtfVersion = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 6, "")
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setAtfVersion = function(value) {
      return jspb2.Message.setProto3StringField(this, 6, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getHelmChartVersion = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 7, "")
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setHelmChartVersion = function(value) {
      return jspb2.Message.setProto3StringField(this, 7, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getLabelsMap = function(opt_noLazyCreate) {
      return (
        /** @type {!jspb.Map<string,string>} */
        jspb2.Message.getMapField(
          this,
          8,
          opt_noLazyCreate,
          null
        )
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.clearLabelsMap = function() {
      this.getLabelsMap().clear();
      return this;
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 9, "")
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 9, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getEnvironment = function() {
      return (
        /** @type {!proto.atfai.console.v1.InstanceEnvironment} */
        jspb2.Message.getFieldWithDefault(this, 10, 0)
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setEnvironment = function(value) {
      return jspb2.Message.setProto3EnumField(this, 10, value);
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.getIdempotencyKey = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 11, "")
      );
    };
    proto.atfai.console.v1.RegisterInstanceRequest.prototype.setIdempotencyKey = function(value) {
      return jspb2.Message.setProto3StringField(this, 11, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RegisterInstanceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RegisterInstanceResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RegisterInstanceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          instance: (f = msg.getInstance()) && proto.atfai.console.v1.Instance.toObject(includeInstance, f),
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f),
          instanceToken: jspb2.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RegisterInstanceResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RegisterInstanceResponse();
      return proto.atfai.console.v1.RegisterInstanceResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RegisterInstanceResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Instance();
            reader.readMessage(value, proto.atfai.console.v1.Instance.deserializeBinaryFromReader);
            msg.setInstance(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceToken(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RegisterInstanceResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RegisterInstanceResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstance();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Instance.serializeBinaryToWriter
        );
      }
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
      f = message.getInstanceToken();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.getInstance = function() {
      return (
        /** @type{?proto.atfai.console.v1.Instance} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Instance, 1)
      );
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.setInstance = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.clearInstance = function() {
      return this.setInstance(void 0);
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.hasInstance = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 2)
      );
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.getInstanceToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.RegisterInstanceResponse.prototype.setInstanceToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.InstanceHeartbeatRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.InstanceHeartbeatRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          instanceId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          reportedAt: (f = msg.getReportedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          atfVersion: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          helmChartVersion: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          activeSeatCount: jspb2.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.InstanceHeartbeatRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.InstanceHeartbeatRequest();
      return proto.atfai.console.v1.InstanceHeartbeatRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 2:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setReportedAt(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAtfVersion(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setHelmChartVersion(value);
            break;
          case 5:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setActiveSeatCount(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.InstanceHeartbeatRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getReportedAt();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getAtfVersion();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getHelmChartVersion();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getActiveSeatCount();
      if (f !== 0) {
        writer.writeInt32(
          5,
          f
        );
      }
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.getReportedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.setReportedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.clearReportedAt = function() {
      return this.setReportedAt(void 0);
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.hasReportedAt = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.getAtfVersion = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.setAtfVersion = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.getHelmChartVersion = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.setHelmChartVersion = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.getActiveSeatCount = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatRequest.prototype.setActiveSeatCount = function(value) {
      return jspb2.Message.setProto3IntField(this, 5, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.InstanceHeartbeatResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.InstanceHeartbeatResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          instance: (f = msg.getInstance()) && proto.atfai.console.v1.Instance.toObject(includeInstance, f),
          licenseStatus: jspb2.Message.getFieldWithDefault(msg, 2, 0),
          licenseValid: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false),
          licenseExpiresAt: (f = msg.getLicenseExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          refreshedToken: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          gracePeriodSeconds: jspb2.Message.getFieldWithDefault(msg, 6, 0),
          refreshedLicenseToken: jspb2.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.InstanceHeartbeatResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.InstanceHeartbeatResponse();
      return proto.atfai.console.v1.InstanceHeartbeatResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Instance();
            reader.readMessage(value, proto.atfai.console.v1.Instance.deserializeBinaryFromReader);
            msg.setInstance(value);
            break;
          case 2:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseStatus} */
              reader.readEnum()
            );
            msg.setLicenseStatus(value);
            break;
          case 3:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setLicenseValid(value);
            break;
          case 4:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setLicenseExpiresAt(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRefreshedToken(value);
            break;
          case 6:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setGracePeriodSeconds(value);
            break;
          case 7:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRefreshedLicenseToken(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.InstanceHeartbeatResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstance();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Instance.serializeBinaryToWriter
        );
      }
      f = message.getLicenseStatus();
      if (f !== 0) {
        writer.writeEnum(
          2,
          f
        );
      }
      f = message.getLicenseValid();
      if (f) {
        writer.writeBool(
          3,
          f
        );
      }
      f = message.getLicenseExpiresAt();
      if (f != null) {
        writer.writeMessage(
          4,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getRefreshedToken();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getGracePeriodSeconds();
      if (f !== 0) {
        writer.writeInt32(
          6,
          f
        );
      }
      f = message.getRefreshedLicenseToken();
      if (f.length > 0) {
        writer.writeString(
          7,
          f
        );
      }
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.getInstance = function() {
      return (
        /** @type{?proto.atfai.console.v1.Instance} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Instance, 1)
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.setInstance = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.clearInstance = function() {
      return this.setInstance(void 0);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.hasInstance = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.getLicenseStatus = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseStatus} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.setLicenseStatus = function(value) {
      return jspb2.Message.setProto3EnumField(this, 2, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.getLicenseValid = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 3, false)
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.setLicenseValid = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 3, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.getLicenseExpiresAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.setLicenseExpiresAt = function(value) {
      return jspb2.Message.setWrapperField(this, 4, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.clearLicenseExpiresAt = function() {
      return this.setLicenseExpiresAt(void 0);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.hasLicenseExpiresAt = function() {
      return jspb2.Message.getField(this, 4) != null;
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.getRefreshedToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.setRefreshedToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.getGracePeriodSeconds = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 6, 0)
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.setGracePeriodSeconds = function(value) {
      return jspb2.Message.setProto3IntField(this, 6, value);
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.getRefreshedLicenseToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 7, "")
      );
    };
    proto.atfai.console.v1.InstanceHeartbeatResponse.prototype.setRefreshedLicenseToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 7, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetInstanceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetInstanceRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetInstanceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          instanceId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetInstanceRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetInstanceRequest();
      return proto.atfai.console.v1.GetInstanceRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetInstanceRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetInstanceRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetInstanceRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.GetInstanceRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetInstanceRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetInstanceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetInstanceResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetInstanceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          instance: (f = msg.getInstance()) && proto.atfai.console.v1.Instance.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetInstanceResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetInstanceResponse();
      return proto.atfai.console.v1.GetInstanceResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetInstanceResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Instance();
            reader.readMessage(value, proto.atfai.console.v1.Instance.deserializeBinaryFromReader);
            msg.setInstance(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetInstanceResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetInstanceResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetInstanceResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstance();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Instance.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetInstanceResponse.prototype.getInstance = function() {
      return (
        /** @type{?proto.atfai.console.v1.Instance} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Instance, 1)
      );
    };
    proto.atfai.console.v1.GetInstanceResponse.prototype.setInstance = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.GetInstanceResponse.prototype.clearInstance = function() {
      return this.setInstance(void 0);
    };
    proto.atfai.console.v1.GetInstanceResponse.prototype.hasInstance = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListInstancesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListInstancesRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListInstancesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          statusFilter: jspb2.Message.getFieldWithDefault(msg, 2, 0),
          deploymentTypeFilter: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          limit: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          offset: jspb2.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListInstancesRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListInstancesRequest();
      return proto.atfai.console.v1.ListInstancesRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListInstancesRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = (
              /** @type {!proto.atfai.console.v1.InstanceEnrollmentStatus} */
              reader.readEnum()
            );
            msg.setStatusFilter(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.DeploymentType} */
              reader.readEnum()
            );
            msg.setDeploymentTypeFilter(value);
            break;
          case 4:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setLimit(value);
            break;
          case 5:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setOffset(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListInstancesRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListInstancesRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getStatusFilter();
      if (f !== 0) {
        writer.writeEnum(
          2,
          f
        );
      }
      f = message.getDeploymentTypeFilter();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
      f = message.getLimit();
      if (f !== 0) {
        writer.writeInt32(
          4,
          f
        );
      }
      f = message.getOffset();
      if (f !== 0) {
        writer.writeInt32(
          5,
          f
        );
      }
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.getStatusFilter = function() {
      return (
        /** @type {!proto.atfai.console.v1.InstanceEnrollmentStatus} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.setStatusFilter = function(value) {
      return jspb2.Message.setProto3EnumField(this, 2, value);
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.getDeploymentTypeFilter = function() {
      return (
        /** @type {!proto.atfai.console.v1.DeploymentType} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.setDeploymentTypeFilter = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.getLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.setLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 4, value);
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.getOffset = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.ListInstancesRequest.prototype.setOffset = function(value) {
      return jspb2.Message.setProto3IntField(this, 5, value);
    };
    proto.atfai.console.v1.ListInstancesResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListInstancesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListInstancesResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListInstancesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          instancesList: jspb2.Message.toObjectList(
            msg.getInstancesList(),
            proto.atfai.console.v1.Instance.toObject,
            includeInstance
          ),
          total: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListInstancesResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListInstancesResponse();
      return proto.atfai.console.v1.ListInstancesResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListInstancesResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Instance();
            reader.readMessage(value, proto.atfai.console.v1.Instance.deserializeBinaryFromReader);
            msg.addInstances(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotal(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListInstancesResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListInstancesResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListInstancesResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstancesList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.Instance.serializeBinaryToWriter
        );
      }
      f = message.getTotal();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListInstancesResponse.prototype.getInstancesList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.Instance>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.Instance, 1)
      );
    };
    proto.atfai.console.v1.ListInstancesResponse.prototype.setInstancesList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListInstancesResponse.prototype.addInstances = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.Instance, opt_index);
    };
    proto.atfai.console.v1.ListInstancesResponse.prototype.clearInstancesList = function() {
      return this.setInstancesList([]);
    };
    proto.atfai.console.v1.ListInstancesResponse.prototype.getTotal = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListInstancesResponse.prototype.setTotal = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.UpdateInstanceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.UpdateInstanceRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.UpdateInstanceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          instanceId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          updateMask: (f = msg.getUpdateMask()) && proto.atfai.console.v1.UpdateMask.toObject(includeInstance, f),
          name: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, void 0) : []
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.UpdateInstanceRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.UpdateInstanceRequest();
      return proto.atfai.console.v1.UpdateInstanceRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.UpdateInstanceRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.UpdateMask();
            reader.readMessage(value, proto.atfai.console.v1.UpdateMask.deserializeBinaryFromReader);
            msg.setUpdateMask(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 4:
            var value = msg.getLabelsMap();
            reader.readMessage(value, function(message, reader2) {
              jspb2.Map.deserializeBinary(message, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readString, null, "", "");
            });
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.UpdateInstanceRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.UpdateInstanceRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getUpdateMask();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.UpdateMask.serializeBinaryToWriter
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getLabelsMap(true);
      if (f && f.getLength() > 0) {
        f.serializeBinary(4, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeString);
      }
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.getUpdateMask = function() {
      return (
        /** @type{?proto.atfai.console.v1.UpdateMask} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.UpdateMask, 2)
      );
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.setUpdateMask = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.clearUpdateMask = function() {
      return this.setUpdateMask(void 0);
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.hasUpdateMask = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.getLabelsMap = function(opt_noLazyCreate) {
      return (
        /** @type {!jspb.Map<string,string>} */
        jspb2.Message.getMapField(
          this,
          4,
          opt_noLazyCreate,
          null
        )
      );
    };
    proto.atfai.console.v1.UpdateInstanceRequest.prototype.clearLabelsMap = function() {
      this.getLabelsMap().clear();
      return this;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.UpdateInstanceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.UpdateInstanceResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.UpdateInstanceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          instance: (f = msg.getInstance()) && proto.atfai.console.v1.Instance.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.UpdateInstanceResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.UpdateInstanceResponse();
      return proto.atfai.console.v1.UpdateInstanceResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.UpdateInstanceResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.Instance();
            reader.readMessage(value, proto.atfai.console.v1.Instance.deserializeBinaryFromReader);
            msg.setInstance(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.UpdateInstanceResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.UpdateInstanceResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.UpdateInstanceResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstance();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.Instance.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.UpdateInstanceResponse.prototype.getInstance = function() {
      return (
        /** @type{?proto.atfai.console.v1.Instance} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Instance, 1)
      );
    };
    proto.atfai.console.v1.UpdateInstanceResponse.prototype.setInstance = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.UpdateInstanceResponse.prototype.clearInstance = function() {
      return this.setInstance(void 0);
    };
    proto.atfai.console.v1.UpdateInstanceResponse.prototype.hasInstance = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.MintInstanceTokenRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.MintInstanceTokenRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.MintInstanceTokenRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          instanceId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.MintInstanceTokenRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.MintInstanceTokenRequest();
      return proto.atfai.console.v1.MintInstanceTokenRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.MintInstanceTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.MintInstanceTokenRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.MintInstanceTokenRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.MintInstanceTokenRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.MintInstanceTokenRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.MintInstanceTokenRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.MintInstanceTokenResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.MintInstanceTokenResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.MintInstanceTokenResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          instanceToken: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          tokenPrefix: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.MintInstanceTokenResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.MintInstanceTokenResponse();
      return proto.atfai.console.v1.MintInstanceTokenResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.MintInstanceTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceToken(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setTokenPrefix(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.MintInstanceTokenResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.MintInstanceTokenResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.MintInstanceTokenResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstanceToken();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getTokenPrefix();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.MintInstanceTokenResponse.prototype.getInstanceToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.MintInstanceTokenResponse.prototype.setInstanceToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.MintInstanceTokenResponse.prototype.getTokenPrefix = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.MintInstanceTokenResponse.prototype.setTokenPrefix = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.repeatedFields_ = [10];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.IssueLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.IssueLicenseRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.IssueLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          deploymentType: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          seatLimit: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          connectivityMode: jspb2.Message.getFieldWithDefault(msg, 5, 0),
          telemetryRequired: jspb2.Message.getBooleanFieldWithDefault(msg, 6, false),
          billingModel: jspb2.Message.getFieldWithDefault(msg, 7, 0),
          billingState: jspb2.Message.getFieldWithDefault(msg, 8, 0),
          expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          featureFlagsList: (f = jspb2.Message.getRepeatedField(msg, 10)) == null ? void 0 : f,
          tier: jspb2.Message.getFieldWithDefault(msg, 11, 0),
          instanceLimit: (f = jspb2.Message.getField(msg, 12)) == null ? void 0 : f,
          idempotencyKey: jspb2.Message.getFieldWithDefault(msg, 13, ""),
          orgScope: jspb2.Message.getFieldWithDefault(msg, 14, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.IssueLicenseRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.IssueLicenseRequest();
      return proto.atfai.console.v1.IssueLicenseRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.IssueLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.DeploymentType} */
              reader.readEnum()
            );
            msg.setDeploymentType(value);
            break;
          case 4:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setSeatLimit(value);
            break;
          case 5:
            var value = (
              /** @type {!proto.atfai.console.v1.ConnectivityMode} */
              reader.readEnum()
            );
            msg.setConnectivityMode(value);
            break;
          case 6:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setTelemetryRequired(value);
            break;
          case 7:
            var value = (
              /** @type {!proto.atfai.console.v1.BillingModel} */
              reader.readEnum()
            );
            msg.setBillingModel(value);
            break;
          case 8:
            var value = (
              /** @type {!proto.atfai.console.v1.BillingState} */
              reader.readEnum()
            );
            msg.setBillingState(value);
            break;
          case 9:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setExpiresAt(value);
            break;
          case 10:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.addFeatureFlags(value);
            break;
          case 11:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseTier} */
              reader.readEnum()
            );
            msg.setTier(value);
            break;
          case 12:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setInstanceLimit(value);
            break;
          case 13:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setIdempotencyKey(value);
            break;
          case 14:
            var value = (
              /** @type {!proto.atfai.console.v1.OrgScope} */
              reader.readEnum()
            );
            msg.setOrgScope(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.IssueLicenseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.IssueLicenseRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getDeploymentType();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
      f = message.getSeatLimit();
      if (f !== 0) {
        writer.writeInt32(
          4,
          f
        );
      }
      f = message.getConnectivityMode();
      if (f !== 0) {
        writer.writeEnum(
          5,
          f
        );
      }
      f = message.getTelemetryRequired();
      if (f) {
        writer.writeBool(
          6,
          f
        );
      }
      f = message.getBillingModel();
      if (f !== 0) {
        writer.writeEnum(
          7,
          f
        );
      }
      f = message.getBillingState();
      if (f !== 0) {
        writer.writeEnum(
          8,
          f
        );
      }
      f = message.getExpiresAt();
      if (f != null) {
        writer.writeMessage(
          9,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getFeatureFlagsList();
      if (f.length > 0) {
        writer.writeRepeatedString(
          10,
          f
        );
      }
      f = message.getTier();
      if (f !== 0) {
        writer.writeEnum(
          11,
          f
        );
      }
      f = /** @type {number} */
      jspb2.Message.getField(message, 12);
      if (f != null) {
        writer.writeInt32(
          12,
          f
        );
      }
      f = message.getIdempotencyKey();
      if (f.length > 0) {
        writer.writeString(
          13,
          f
        );
      }
      f = message.getOrgScope();
      if (f !== 0) {
        writer.writeEnum(
          14,
          f
        );
      }
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getDeploymentType = function() {
      return (
        /** @type {!proto.atfai.console.v1.DeploymentType} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setDeploymentType = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getSeatLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setSeatLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 4, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getConnectivityMode = function() {
      return (
        /** @type {!proto.atfai.console.v1.ConnectivityMode} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setConnectivityMode = function(value) {
      return jspb2.Message.setProto3EnumField(this, 5, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getTelemetryRequired = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 6, false)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setTelemetryRequired = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 6, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getBillingModel = function() {
      return (
        /** @type {!proto.atfai.console.v1.BillingModel} */
        jspb2.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setBillingModel = function(value) {
      return jspb2.Message.setProto3EnumField(this, 7, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getBillingState = function() {
      return (
        /** @type {!proto.atfai.console.v1.BillingState} */
        jspb2.Message.getFieldWithDefault(this, 8, 0)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setBillingState = function(value) {
      return jspb2.Message.setProto3EnumField(this, 8, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getExpiresAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setExpiresAt = function(value) {
      return jspb2.Message.setWrapperField(this, 9, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.clearExpiresAt = function() {
      return this.setExpiresAt(void 0);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.hasExpiresAt = function() {
      return jspb2.Message.getField(this, 9) != null;
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getFeatureFlagsList = function() {
      return (
        /** @type {!Array<string>} */
        jspb2.Message.getRepeatedField(this, 10)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setFeatureFlagsList = function(value) {
      return jspb2.Message.setField(this, 10, value || []);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.addFeatureFlags = function(value, opt_index) {
      return jspb2.Message.addToRepeatedField(this, 10, value, opt_index);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.clearFeatureFlagsList = function() {
      return this.setFeatureFlagsList([]);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getTier = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseTier} */
        jspb2.Message.getFieldWithDefault(this, 11, 0)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setTier = function(value) {
      return jspb2.Message.setProto3EnumField(this, 11, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getInstanceLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 12, 0)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setInstanceLimit = function(value) {
      return jspb2.Message.setField(this, 12, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.clearInstanceLimit = function() {
      return jspb2.Message.setField(this, 12, void 0);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.hasInstanceLimit = function() {
      return jspb2.Message.getField(this, 12) != null;
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getIdempotencyKey = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 13, "")
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setIdempotencyKey = function(value) {
      return jspb2.Message.setProto3StringField(this, 13, value);
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.getOrgScope = function() {
      return (
        /** @type {!proto.atfai.console.v1.OrgScope} */
        jspb2.Message.getFieldWithDefault(this, 14, 0)
      );
    };
    proto.atfai.console.v1.IssueLicenseRequest.prototype.setOrgScope = function(value) {
      return jspb2.Message.setProto3EnumField(this, 14, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.IssueLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.IssueLicenseResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.IssueLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.IssueLicenseResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.IssueLicenseResponse();
      return proto.atfai.console.v1.IssueLicenseResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.IssueLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.IssueLicenseResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.IssueLicenseResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.IssueLicenseResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.IssueLicenseResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.IssueLicenseResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.IssueLicenseResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.IssueLicenseResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.AssignLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.AssignLicenseRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.AssignLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.AssignLicenseRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.AssignLicenseRequest();
      return proto.atfai.console.v1.AssignLicenseRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.AssignLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.AssignLicenseRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.AssignLicenseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.AssignLicenseRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.AssignLicenseRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.AssignLicenseRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.AssignLicenseRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.AssignLicenseRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.AssignLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.AssignLicenseResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.AssignLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f),
          instance: (f = msg.getInstance()) && proto.atfai.console.v1.Instance.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.AssignLicenseResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.AssignLicenseResponse();
      return proto.atfai.console.v1.AssignLicenseResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.AssignLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.Instance();
            reader.readMessage(value, proto.atfai.console.v1.Instance.deserializeBinaryFromReader);
            msg.setInstance(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.AssignLicenseResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.AssignLicenseResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
      f = message.getInstance();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.Instance.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.getInstance = function() {
      return (
        /** @type{?proto.atfai.console.v1.Instance} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.Instance, 2)
      );
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.setInstance = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.clearInstance = function() {
      return this.setInstance(void 0);
    };
    proto.atfai.console.v1.AssignLicenseResponse.prototype.hasInstance = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.SuspendLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.SuspendLicenseRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.SuspendLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          reason: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.SuspendLicenseRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.SuspendLicenseRequest();
      return proto.atfai.console.v1.SuspendLicenseRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.SuspendLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setReason(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.SuspendLicenseRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.SuspendLicenseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.SuspendLicenseRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getReason();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.SuspendLicenseRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.SuspendLicenseRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.SuspendLicenseRequest.prototype.getReason = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.SuspendLicenseRequest.prototype.setReason = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.SuspendLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.SuspendLicenseResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.SuspendLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.SuspendLicenseResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.SuspendLicenseResponse();
      return proto.atfai.console.v1.SuspendLicenseResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.SuspendLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.SuspendLicenseResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.SuspendLicenseResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.SuspendLicenseResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.SuspendLicenseResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.SuspendLicenseResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.SuspendLicenseResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.SuspendLicenseResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ResumeLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ResumeLicenseRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ResumeLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ResumeLicenseRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ResumeLicenseRequest();
      return proto.atfai.console.v1.ResumeLicenseRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ResumeLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ResumeLicenseRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ResumeLicenseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ResumeLicenseRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.ResumeLicenseRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ResumeLicenseRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ResumeLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ResumeLicenseResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ResumeLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ResumeLicenseResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ResumeLicenseResponse();
      return proto.atfai.console.v1.ResumeLicenseResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ResumeLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ResumeLicenseResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ResumeLicenseResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ResumeLicenseResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.ResumeLicenseResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.ResumeLicenseResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ResumeLicenseResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.ResumeLicenseResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RevokeLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RevokeLicenseRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RevokeLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          reason: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RevokeLicenseRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RevokeLicenseRequest();
      return proto.atfai.console.v1.RevokeLicenseRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RevokeLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setReason(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RevokeLicenseRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RevokeLicenseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RevokeLicenseRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getReason();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.RevokeLicenseRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.RevokeLicenseRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.RevokeLicenseRequest.prototype.getReason = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.RevokeLicenseRequest.prototype.setReason = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RevokeLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RevokeLicenseResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RevokeLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RevokeLicenseResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RevokeLicenseResponse();
      return proto.atfai.console.v1.RevokeLicenseResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RevokeLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RevokeLicenseResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RevokeLicenseResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RevokeLicenseResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.RevokeLicenseResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.RevokeLicenseResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.RevokeLicenseResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.RevokeLicenseResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetLicenseRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetLicenseRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetLicenseRequest();
      return proto.atfai.console.v1.GetLicenseRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetLicenseRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetLicenseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetLicenseRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.GetLicenseRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetLicenseRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetLicenseResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetLicenseResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetLicenseResponse();
      return proto.atfai.console.v1.GetLicenseResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetLicenseResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetLicenseResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetLicenseResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetLicenseResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.GetLicenseResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.GetLicenseResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.GetLicenseResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListLicensesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListLicensesRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListLicensesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          statusFilter: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          tierFilter: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          billingStateFilter: jspb2.Message.getFieldWithDefault(msg, 5, 0),
          limit: jspb2.Message.getFieldWithDefault(msg, 6, 0),
          offset: jspb2.Message.getFieldWithDefault(msg, 7, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListLicensesRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListLicensesRequest();
      return proto.atfai.console.v1.ListLicensesRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListLicensesRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseStatus} */
              reader.readEnum()
            );
            msg.setStatusFilter(value);
            break;
          case 4:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseTier} */
              reader.readEnum()
            );
            msg.setTierFilter(value);
            break;
          case 5:
            var value = (
              /** @type {!proto.atfai.console.v1.BillingState} */
              reader.readEnum()
            );
            msg.setBillingStateFilter(value);
            break;
          case 6:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setLimit(value);
            break;
          case 7:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setOffset(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListLicensesRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListLicensesRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getStatusFilter();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
      f = message.getTierFilter();
      if (f !== 0) {
        writer.writeEnum(
          4,
          f
        );
      }
      f = message.getBillingStateFilter();
      if (f !== 0) {
        writer.writeEnum(
          5,
          f
        );
      }
      f = message.getLimit();
      if (f !== 0) {
        writer.writeInt32(
          6,
          f
        );
      }
      f = message.getOffset();
      if (f !== 0) {
        writer.writeInt32(
          7,
          f
        );
      }
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.getStatusFilter = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseStatus} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.setStatusFilter = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.getTierFilter = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseTier} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.setTierFilter = function(value) {
      return jspb2.Message.setProto3EnumField(this, 4, value);
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.getBillingStateFilter = function() {
      return (
        /** @type {!proto.atfai.console.v1.BillingState} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.setBillingStateFilter = function(value) {
      return jspb2.Message.setProto3EnumField(this, 5, value);
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.getLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 6, 0)
      );
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.setLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 6, value);
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.getOffset = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    proto.atfai.console.v1.ListLicensesRequest.prototype.setOffset = function(value) {
      return jspb2.Message.setProto3IntField(this, 7, value);
    };
    proto.atfai.console.v1.ListLicensesResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListLicensesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListLicensesResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListLicensesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          licensesList: jspb2.Message.toObjectList(
            msg.getLicensesList(),
            proto.atfai.console.v1.License.toObject,
            includeInstance
          ),
          total: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListLicensesResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListLicensesResponse();
      return proto.atfai.console.v1.ListLicensesResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListLicensesResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.addLicenses(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotal(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListLicensesResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListLicensesResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListLicensesResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicensesList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
      f = message.getTotal();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListLicensesResponse.prototype.getLicensesList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.License>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.ListLicensesResponse.prototype.setLicensesList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListLicensesResponse.prototype.addLicenses = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.License, opt_index);
    };
    proto.atfai.console.v1.ListLicensesResponse.prototype.clearLicensesList = function() {
      return this.setLicensesList([]);
    };
    proto.atfai.console.v1.ListLicensesResponse.prototype.getTotal = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListLicensesResponse.prototype.setTotal = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    proto.atfai.console.v1.IngestUsageEventsRequest.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.IngestUsageEventsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.IngestUsageEventsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.IngestUsageEventsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          eventsList: jspb2.Message.toObjectList(
            msg.getEventsList(),
            proto.atfai.console.v1.UsageEvent.toObject,
            includeInstance
          )
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.IngestUsageEventsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.IngestUsageEventsRequest();
      return proto.atfai.console.v1.IngestUsageEventsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.IngestUsageEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.UsageEvent();
            reader.readMessage(value, proto.atfai.console.v1.UsageEvent.deserializeBinaryFromReader);
            msg.addEvents(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.IngestUsageEventsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.IngestUsageEventsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.IngestUsageEventsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getEventsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.UsageEvent.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.IngestUsageEventsRequest.prototype.getEventsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.UsageEvent>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.UsageEvent, 1)
      );
    };
    proto.atfai.console.v1.IngestUsageEventsRequest.prototype.setEventsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.IngestUsageEventsRequest.prototype.addEvents = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.UsageEvent, opt_index);
    };
    proto.atfai.console.v1.IngestUsageEventsRequest.prototype.clearEventsList = function() {
      return this.setEventsList([]);
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.repeatedFields_ = [3];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.IngestUsageEventsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.IngestUsageEventsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.IngestUsageEventsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          acceptedCount: jspb2.Message.getFieldWithDefault(msg, 1, 0),
          duplicateCount: jspb2.Message.getFieldWithDefault(msg, 2, 0),
          rejectedIdsList: (f = jspb2.Message.getRepeatedField(msg, 3)) == null ? void 0 : f
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.IngestUsageEventsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.IngestUsageEventsResponse();
      return proto.atfai.console.v1.IngestUsageEventsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setAcceptedCount(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setDuplicateCount(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.addRejectedIds(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.IngestUsageEventsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAcceptedCount();
      if (f !== 0) {
        writer.writeInt32(
          1,
          f
        );
      }
      f = message.getDuplicateCount();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
      f = message.getRejectedIdsList();
      if (f.length > 0) {
        writer.writeRepeatedString(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.getAcceptedCount = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.setAcceptedCount = function(value) {
      return jspb2.Message.setProto3IntField(this, 1, value);
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.getDuplicateCount = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.setDuplicateCount = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.getRejectedIdsList = function() {
      return (
        /** @type {!Array<string>} */
        jspb2.Message.getRepeatedField(this, 3)
      );
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.setRejectedIdsList = function(value) {
      return jspb2.Message.setField(this, 3, value || []);
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.addRejectedIds = function(value, opt_index) {
      return jspb2.Message.addToRepeatedField(this, 3, value, opt_index);
    };
    proto.atfai.console.v1.IngestUsageEventsResponse.prototype.clearRejectedIdsList = function() {
      return this.setRejectedIdsList([]);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ConsoleOperator.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ConsoleOperator.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ConsoleOperator.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          name: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          email: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          role: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          disabled: jspb2.Message.getBooleanFieldWithDefault(msg, 5, false),
          createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ConsoleOperator.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ConsoleOperator();
      return proto.atfai.console.v1.ConsoleOperator.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ConsoleOperator.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEmail(value);
            break;
          case 4:
            var value = (
              /** @type {!proto.atfai.console.v1.ConsoleOperatorRole} */
              reader.readEnum()
            );
            msg.setRole(value);
            break;
          case 5:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setDisabled(value);
            break;
          case 6:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCreatedAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ConsoleOperator.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ConsoleOperator.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getEmail();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getRole();
      if (f !== 0) {
        writer.writeEnum(
          4,
          f
        );
      }
      f = message.getDisabled();
      if (f) {
        writer.writeBool(
          5,
          f
        );
      }
      f = message.getCreatedAt();
      if (f != null) {
        writer.writeMessage(
          6,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.getEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.setEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.getRole = function() {
      return (
        /** @type {!proto.atfai.console.v1.ConsoleOperatorRole} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.setRole = function(value) {
      return jspb2.Message.setProto3EnumField(this, 4, value);
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.getDisabled = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 5, false)
      );
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.setDisabled = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 5, value);
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.getCreatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
      );
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.setCreatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.clearCreatedAt = function() {
      return this.setCreatedAt(void 0);
    };
    proto.atfai.console.v1.ConsoleOperator.prototype.hasCreatedAt = function() {
      return jspb2.Message.getField(this, 6) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ConsoleApiKeyMetadata.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ConsoleApiKeyMetadata.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          operatorId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          keyPrefix: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          name: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          lastUsedAt: (f = msg.getLastUsedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          revokedAt: (f = msg.getRevokedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ConsoleApiKeyMetadata.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ConsoleApiKeyMetadata();
      return proto.atfai.console.v1.ConsoleApiKeyMetadata.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOperatorId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setKeyPrefix(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 5:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setLastUsedAt(value);
            break;
          case 6:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setExpiresAt(value);
            break;
          case 7:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setRevokedAt(value);
            break;
          case 8:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCreatedAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ConsoleApiKeyMetadata.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getOperatorId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getKeyPrefix();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getLastUsedAt();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getExpiresAt();
      if (f != null) {
        writer.writeMessage(
          6,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getRevokedAt();
      if (f != null) {
        writer.writeMessage(
          7,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getCreatedAt();
      if (f != null) {
        writer.writeMessage(
          8,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.getOperatorId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.setOperatorId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.getKeyPrefix = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.setKeyPrefix = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.getLastUsedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
      );
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.setLastUsedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.clearLastUsedAt = function() {
      return this.setLastUsedAt(void 0);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.hasLastUsedAt = function() {
      return jspb2.Message.getField(this, 5) != null;
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.getExpiresAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
      );
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.setExpiresAt = function(value) {
      return jspb2.Message.setWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.clearExpiresAt = function() {
      return this.setExpiresAt(void 0);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.hasExpiresAt = function() {
      return jspb2.Message.getField(this, 6) != null;
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.getRevokedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
      );
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.setRevokedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 7, value);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.clearRevokedAt = function() {
      return this.setRevokedAt(void 0);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.hasRevokedAt = function() {
      return jspb2.Message.getField(this, 7) != null;
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.getCreatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
      );
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.setCreatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 8, value);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.clearCreatedAt = function() {
      return this.setCreatedAt(void 0);
    };
    proto.atfai.console.v1.ConsoleApiKeyMetadata.prototype.hasCreatedAt = function() {
      return jspb2.Message.getField(this, 8) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateOperatorRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateOperatorRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateOperatorRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          name: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          email: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          role: jspb2.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateOperatorRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateOperatorRequest();
      return proto.atfai.console.v1.CreateOperatorRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateOperatorRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEmail(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.ConsoleOperatorRole} */
              reader.readEnum()
            );
            msg.setRole(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateOperatorRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateOperatorRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateOperatorRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getEmail();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getRole();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.CreateOperatorRequest.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.CreateOperatorRequest.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.CreateOperatorRequest.prototype.getEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.CreateOperatorRequest.prototype.setEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.CreateOperatorRequest.prototype.getRole = function() {
      return (
        /** @type {!proto.atfai.console.v1.ConsoleOperatorRole} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.CreateOperatorRequest.prototype.setRole = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateOperatorResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateOperatorResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateOperatorResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          operator: (f = msg.getOperator()) && proto.atfai.console.v1.ConsoleOperator.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateOperatorResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateOperatorResponse();
      return proto.atfai.console.v1.CreateOperatorResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateOperatorResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.ConsoleOperator();
            reader.readMessage(value, proto.atfai.console.v1.ConsoleOperator.deserializeBinaryFromReader);
            msg.setOperator(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateOperatorResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateOperatorResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateOperatorResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperator();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.ConsoleOperator.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.CreateOperatorResponse.prototype.getOperator = function() {
      return (
        /** @type{?proto.atfai.console.v1.ConsoleOperator} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.ConsoleOperator, 1)
      );
    };
    proto.atfai.console.v1.CreateOperatorResponse.prototype.setOperator = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.CreateOperatorResponse.prototype.clearOperator = function() {
      return this.setOperator(void 0);
    };
    proto.atfai.console.v1.CreateOperatorResponse.prototype.hasOperator = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListOperatorsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListOperatorsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListOperatorsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          limit: jspb2.Message.getFieldWithDefault(msg, 1, 0),
          offset: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListOperatorsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListOperatorsRequest();
      return proto.atfai.console.v1.ListOperatorsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListOperatorsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setLimit(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setOffset(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListOperatorsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListOperatorsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListOperatorsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLimit();
      if (f !== 0) {
        writer.writeInt32(
          1,
          f
        );
      }
      f = message.getOffset();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListOperatorsRequest.prototype.getLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    proto.atfai.console.v1.ListOperatorsRequest.prototype.setLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 1, value);
    };
    proto.atfai.console.v1.ListOperatorsRequest.prototype.getOffset = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListOperatorsRequest.prototype.setOffset = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    proto.atfai.console.v1.ListOperatorsResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListOperatorsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListOperatorsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListOperatorsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          operatorsList: jspb2.Message.toObjectList(
            msg.getOperatorsList(),
            proto.atfai.console.v1.ConsoleOperator.toObject,
            includeInstance
          ),
          total: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListOperatorsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListOperatorsResponse();
      return proto.atfai.console.v1.ListOperatorsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListOperatorsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.ConsoleOperator();
            reader.readMessage(value, proto.atfai.console.v1.ConsoleOperator.deserializeBinaryFromReader);
            msg.addOperators(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotal(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListOperatorsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListOperatorsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListOperatorsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperatorsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.ConsoleOperator.serializeBinaryToWriter
        );
      }
      f = message.getTotal();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListOperatorsResponse.prototype.getOperatorsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.ConsoleOperator>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.ConsoleOperator, 1)
      );
    };
    proto.atfai.console.v1.ListOperatorsResponse.prototype.setOperatorsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListOperatorsResponse.prototype.addOperators = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.ConsoleOperator, opt_index);
    };
    proto.atfai.console.v1.ListOperatorsResponse.prototype.clearOperatorsList = function() {
      return this.setOperatorsList([]);
    };
    proto.atfai.console.v1.ListOperatorsResponse.prototype.getTotal = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListOperatorsResponse.prototype.setTotal = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateApiKeyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateApiKeyRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateApiKeyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          operatorId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          name: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateApiKeyRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateApiKeyRequest();
      return proto.atfai.console.v1.CreateApiKeyRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateApiKeyRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOperatorId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setName(value);
            break;
          case 3:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setExpiresAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateApiKeyRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateApiKeyRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperatorId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getName();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getExpiresAt();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.getOperatorId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.setOperatorId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.getName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.setName = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.getExpiresAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
      );
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.setExpiresAt = function(value) {
      return jspb2.Message.setWrapperField(this, 3, value);
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.clearExpiresAt = function() {
      return this.setExpiresAt(void 0);
    };
    proto.atfai.console.v1.CreateApiKeyRequest.prototype.hasExpiresAt = function() {
      return jspb2.Message.getField(this, 3) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateApiKeyResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateApiKeyResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateApiKeyResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          keyMetadata: (f = msg.getKeyMetadata()) && proto.atfai.console.v1.ConsoleApiKeyMetadata.toObject(includeInstance, f),
          plaintextKey: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateApiKeyResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateApiKeyResponse();
      return proto.atfai.console.v1.CreateApiKeyResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateApiKeyResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.ConsoleApiKeyMetadata();
            reader.readMessage(value, proto.atfai.console.v1.ConsoleApiKeyMetadata.deserializeBinaryFromReader);
            msg.setKeyMetadata(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPlaintextKey(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateApiKeyResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateApiKeyResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateApiKeyResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getKeyMetadata();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.ConsoleApiKeyMetadata.serializeBinaryToWriter
        );
      }
      f = message.getPlaintextKey();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.CreateApiKeyResponse.prototype.getKeyMetadata = function() {
      return (
        /** @type{?proto.atfai.console.v1.ConsoleApiKeyMetadata} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.ConsoleApiKeyMetadata, 1)
      );
    };
    proto.atfai.console.v1.CreateApiKeyResponse.prototype.setKeyMetadata = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.CreateApiKeyResponse.prototype.clearKeyMetadata = function() {
      return this.setKeyMetadata(void 0);
    };
    proto.atfai.console.v1.CreateApiKeyResponse.prototype.hasKeyMetadata = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    proto.atfai.console.v1.CreateApiKeyResponse.prototype.getPlaintextKey = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.CreateApiKeyResponse.prototype.setPlaintextKey = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RevokeApiKeyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RevokeApiKeyRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RevokeApiKeyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          keyId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RevokeApiKeyRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RevokeApiKeyRequest();
      return proto.atfai.console.v1.RevokeApiKeyRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RevokeApiKeyRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setKeyId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RevokeApiKeyRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RevokeApiKeyRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RevokeApiKeyRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getKeyId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.RevokeApiKeyRequest.prototype.getKeyId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.RevokeApiKeyRequest.prototype.setKeyId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RevokeApiKeyResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RevokeApiKeyResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RevokeApiKeyResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          keyMetadata: (f = msg.getKeyMetadata()) && proto.atfai.console.v1.ConsoleApiKeyMetadata.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RevokeApiKeyResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RevokeApiKeyResponse();
      return proto.atfai.console.v1.RevokeApiKeyResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RevokeApiKeyResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.ConsoleApiKeyMetadata();
            reader.readMessage(value, proto.atfai.console.v1.ConsoleApiKeyMetadata.deserializeBinaryFromReader);
            msg.setKeyMetadata(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RevokeApiKeyResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RevokeApiKeyResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RevokeApiKeyResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getKeyMetadata();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.ConsoleApiKeyMetadata.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.RevokeApiKeyResponse.prototype.getKeyMetadata = function() {
      return (
        /** @type{?proto.atfai.console.v1.ConsoleApiKeyMetadata} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.ConsoleApiKeyMetadata, 1)
      );
    };
    proto.atfai.console.v1.RevokeApiKeyResponse.prototype.setKeyMetadata = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.RevokeApiKeyResponse.prototype.clearKeyMetadata = function() {
      return this.setKeyMetadata(void 0);
    };
    proto.atfai.console.v1.RevokeApiKeyResponse.prototype.hasKeyMetadata = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.DisableOperatorRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.DisableOperatorRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.DisableOperatorRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          operatorId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.DisableOperatorRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.DisableOperatorRequest();
      return proto.atfai.console.v1.DisableOperatorRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.DisableOperatorRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOperatorId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.DisableOperatorRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.DisableOperatorRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.DisableOperatorRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperatorId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.DisableOperatorRequest.prototype.getOperatorId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.DisableOperatorRequest.prototype.setOperatorId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.DisableOperatorResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.DisableOperatorResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.DisableOperatorResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          operator: (f = msg.getOperator()) && proto.atfai.console.v1.ConsoleOperator.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.DisableOperatorResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.DisableOperatorResponse();
      return proto.atfai.console.v1.DisableOperatorResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.DisableOperatorResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.ConsoleOperator();
            reader.readMessage(value, proto.atfai.console.v1.ConsoleOperator.deserializeBinaryFromReader);
            msg.setOperator(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.DisableOperatorResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.DisableOperatorResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.DisableOperatorResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperator();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.ConsoleOperator.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.DisableOperatorResponse.prototype.getOperator = function() {
      return (
        /** @type{?proto.atfai.console.v1.ConsoleOperator} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.ConsoleOperator, 1)
      );
    };
    proto.atfai.console.v1.DisableOperatorResponse.prototype.setOperator = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.DisableOperatorResponse.prototype.clearOperator = function() {
      return this.setOperator(void 0);
    };
    proto.atfai.console.v1.DisableOperatorResponse.prototype.hasOperator = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.SetOperatorPasswordRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.SetOperatorPasswordRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.SetOperatorPasswordRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          operatorId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          newPassword: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.SetOperatorPasswordRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.SetOperatorPasswordRequest();
      return proto.atfai.console.v1.SetOperatorPasswordRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.SetOperatorPasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOperatorId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setNewPassword(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.SetOperatorPasswordRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.SetOperatorPasswordRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.SetOperatorPasswordRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperatorId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getNewPassword();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.SetOperatorPasswordRequest.prototype.getOperatorId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.SetOperatorPasswordRequest.prototype.setOperatorId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.SetOperatorPasswordRequest.prototype.getNewPassword = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.SetOperatorPasswordRequest.prototype.setNewPassword = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.SetOperatorPasswordResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.SetOperatorPasswordResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.SetOperatorPasswordResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          operator: (f = msg.getOperator()) && proto.atfai.console.v1.ConsoleOperator.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.SetOperatorPasswordResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.SetOperatorPasswordResponse();
      return proto.atfai.console.v1.SetOperatorPasswordResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.SetOperatorPasswordResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.ConsoleOperator();
            reader.readMessage(value, proto.atfai.console.v1.ConsoleOperator.deserializeBinaryFromReader);
            msg.setOperator(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.SetOperatorPasswordResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.SetOperatorPasswordResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.SetOperatorPasswordResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperator();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.ConsoleOperator.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.SetOperatorPasswordResponse.prototype.getOperator = function() {
      return (
        /** @type{?proto.atfai.console.v1.ConsoleOperator} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.ConsoleOperator, 1)
      );
    };
    proto.atfai.console.v1.SetOperatorPasswordResponse.prototype.setOperator = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.SetOperatorPasswordResponse.prototype.clearOperator = function() {
      return this.setOperator(void 0);
    };
    proto.atfai.console.v1.SetOperatorPasswordResponse.prototype.hasOperator = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.WhoAmIRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.WhoAmIRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.WhoAmIRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.WhoAmIRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.WhoAmIRequest();
      return proto.atfai.console.v1.WhoAmIRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.WhoAmIRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.WhoAmIRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.WhoAmIRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.WhoAmIRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.WhoAmIOperator.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.WhoAmIOperator.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.WhoAmIOperator.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          email: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          role: jspb2.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.WhoAmIOperator.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.WhoAmIOperator();
      return proto.atfai.console.v1.WhoAmIOperator.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.WhoAmIOperator.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEmail(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.ConsoleOperatorRole} */
              reader.readEnum()
            );
            msg.setRole(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.WhoAmIOperator.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.WhoAmIOperator.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.WhoAmIOperator.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getEmail();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getRole();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.WhoAmIOperator.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.WhoAmIOperator.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.WhoAmIOperator.prototype.getEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.WhoAmIOperator.prototype.setEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.WhoAmIOperator.prototype.getRole = function() {
      return (
        /** @type {!proto.atfai.console.v1.ConsoleOperatorRole} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.WhoAmIOperator.prototype.setRole = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.WhoAmIInstance.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.WhoAmIInstance.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.WhoAmIInstance.toObject = function(includeInstance, msg) {
        var f, obj = {
          instanceId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.WhoAmIInstance.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.WhoAmIInstance();
      return proto.atfai.console.v1.WhoAmIInstance.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.WhoAmIInstance.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.WhoAmIInstance.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.WhoAmIInstance.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.WhoAmIInstance.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.WhoAmIInstance.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.WhoAmIInstance.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.WhoAmIInstance.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.WhoAmIInstance.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.WhoAmICustomer.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.WhoAmICustomer.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.WhoAmICustomer.toObject = function(includeInstance, msg) {
        var f, obj = {
          userId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          email: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          role: jspb2.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.WhoAmICustomer.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.WhoAmICustomer();
      return proto.atfai.console.v1.WhoAmICustomer.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.WhoAmICustomer.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setUserId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEmail(value);
            break;
          case 4:
            var value = (
              /** @type {!proto.atfai.console.v1.AccountRole} */
              reader.readEnum()
            );
            msg.setRole(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.WhoAmICustomer.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.WhoAmICustomer.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getUserId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getEmail();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getRole();
      if (f !== 0) {
        writer.writeEnum(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.getUserId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.setUserId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.getEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.setEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.getRole = function() {
      return (
        /** @type {!proto.atfai.console.v1.AccountRole} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.WhoAmICustomer.prototype.setRole = function(value) {
      return jspb2.Message.setProto3EnumField(this, 4, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.WhoAmIResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.WhoAmIResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.WhoAmIResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          operator: (f = msg.getOperator()) && proto.atfai.console.v1.WhoAmIOperator.toObject(includeInstance, f),
          instance: (f = msg.getInstance()) && proto.atfai.console.v1.WhoAmIInstance.toObject(includeInstance, f),
          customer: (f = msg.getCustomer()) && proto.atfai.console.v1.WhoAmICustomer.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.WhoAmIResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.WhoAmIResponse();
      return proto.atfai.console.v1.WhoAmIResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.WhoAmIResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.WhoAmIOperator();
            reader.readMessage(value, proto.atfai.console.v1.WhoAmIOperator.deserializeBinaryFromReader);
            msg.setOperator(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.WhoAmIInstance();
            reader.readMessage(value, proto.atfai.console.v1.WhoAmIInstance.deserializeBinaryFromReader);
            msg.setInstance(value);
            break;
          case 3:
            var value = new proto.atfai.console.v1.WhoAmICustomer();
            reader.readMessage(value, proto.atfai.console.v1.WhoAmICustomer.deserializeBinaryFromReader);
            msg.setCustomer(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.WhoAmIResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.WhoAmIResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperator();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.WhoAmIOperator.serializeBinaryToWriter
        );
      }
      f = message.getInstance();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.atfai.console.v1.WhoAmIInstance.serializeBinaryToWriter
        );
      }
      f = message.getCustomer();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          proto.atfai.console.v1.WhoAmICustomer.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.getOperator = function() {
      return (
        /** @type{?proto.atfai.console.v1.WhoAmIOperator} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.WhoAmIOperator, 1)
      );
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.setOperator = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.clearOperator = function() {
      return this.setOperator(void 0);
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.hasOperator = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.getInstance = function() {
      return (
        /** @type{?proto.atfai.console.v1.WhoAmIInstance} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.WhoAmIInstance, 2)
      );
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.setInstance = function(value) {
      return jspb2.Message.setWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.clearInstance = function() {
      return this.setInstance(void 0);
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.hasInstance = function() {
      return jspb2.Message.getField(this, 2) != null;
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.getCustomer = function() {
      return (
        /** @type{?proto.atfai.console.v1.WhoAmICustomer} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.WhoAmICustomer, 3)
      );
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.setCustomer = function(value) {
      return jspb2.Message.setWrapperField(this, 3, value);
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.clearCustomer = function() {
      return this.setCustomer(void 0);
    };
    proto.atfai.console.v1.WhoAmIResponse.prototype.hasCustomer = function() {
      return jspb2.Message.getField(this, 3) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListUsageEventsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListUsageEventsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListUsageEventsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          orgId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          eventType: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          occurredAfter: (f = msg.getOccurredAfter()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          occurredBefore: (f = msg.getOccurredBefore()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          pageSize: jspb2.Message.getFieldWithDefault(msg, 7, 0),
          pageToken: jspb2.Message.getFieldWithDefault(msg, 8, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListUsageEventsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListUsageEventsRequest();
      return proto.atfai.console.v1.ListUsageEventsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEventType(value);
            break;
          case 5:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setOccurredAfter(value);
            break;
          case 6:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setOccurredBefore(value);
            break;
          case 7:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setPageSize(value);
            break;
          case 8:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPageToken(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListUsageEventsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListUsageEventsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getEventType();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getOccurredAfter();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getOccurredBefore();
      if (f != null) {
        writer.writeMessage(
          6,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getPageSize();
      if (f !== 0) {
        writer.writeInt32(
          7,
          f
        );
      }
      f = message.getPageToken();
      if (f.length > 0) {
        writer.writeString(
          8,
          f
        );
      }
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.getEventType = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.setEventType = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.getOccurredAfter = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
      );
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.setOccurredAfter = function(value) {
      return jspb2.Message.setWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.clearOccurredAfter = function() {
      return this.setOccurredAfter(void 0);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.hasOccurredAfter = function() {
      return jspb2.Message.getField(this, 5) != null;
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.getOccurredBefore = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
      );
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.setOccurredBefore = function(value) {
      return jspb2.Message.setWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.clearOccurredBefore = function() {
      return this.setOccurredBefore(void 0);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.hasOccurredBefore = function() {
      return jspb2.Message.getField(this, 6) != null;
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.getPageSize = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.setPageSize = function(value) {
      return jspb2.Message.setProto3IntField(this, 7, value);
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.getPageToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 8, "")
      );
    };
    proto.atfai.console.v1.ListUsageEventsRequest.prototype.setPageToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 8, value);
    };
    proto.atfai.console.v1.ListUsageEventsResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListUsageEventsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListUsageEventsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListUsageEventsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          eventsList: jspb2.Message.toObjectList(
            msg.getEventsList(),
            proto.atfai.console.v1.UsageEvent.toObject,
            includeInstance
          ),
          nextPageToken: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListUsageEventsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListUsageEventsResponse();
      return proto.atfai.console.v1.ListUsageEventsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListUsageEventsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.UsageEvent();
            reader.readMessage(value, proto.atfai.console.v1.UsageEvent.deserializeBinaryFromReader);
            msg.addEvents(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setNextPageToken(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListUsageEventsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListUsageEventsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListUsageEventsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getEventsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.UsageEvent.serializeBinaryToWriter
        );
      }
      f = message.getNextPageToken();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListUsageEventsResponse.prototype.getEventsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.UsageEvent>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.UsageEvent, 1)
      );
    };
    proto.atfai.console.v1.ListUsageEventsResponse.prototype.setEventsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListUsageEventsResponse.prototype.addEvents = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.UsageEvent, opt_index);
    };
    proto.atfai.console.v1.ListUsageEventsResponse.prototype.clearEventsList = function() {
      return this.setEventsList([]);
    };
    proto.atfai.console.v1.ListUsageEventsResponse.prototype.getNextPageToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListUsageEventsResponse.prototype.setNextPageToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListApiKeysRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListApiKeysRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListApiKeysRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          operatorId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          limit: jspb2.Message.getFieldWithDefault(msg, 2, 0),
          offset: jspb2.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListApiKeysRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListApiKeysRequest();
      return proto.atfai.console.v1.ListApiKeysRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListApiKeysRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOperatorId(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setLimit(value);
            break;
          case 3:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setOffset(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListApiKeysRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListApiKeysRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListApiKeysRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOperatorId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getLimit();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
      f = message.getOffset();
      if (f !== 0) {
        writer.writeInt32(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.ListApiKeysRequest.prototype.getOperatorId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ListApiKeysRequest.prototype.setOperatorId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ListApiKeysRequest.prototype.getLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListApiKeysRequest.prototype.setLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    proto.atfai.console.v1.ListApiKeysRequest.prototype.getOffset = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.ListApiKeysRequest.prototype.setOffset = function(value) {
      return jspb2.Message.setProto3IntField(this, 3, value);
    };
    proto.atfai.console.v1.ListApiKeysResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListApiKeysResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListApiKeysResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListApiKeysResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          keysList: jspb2.Message.toObjectList(
            msg.getKeysList(),
            proto.atfai.console.v1.ConsoleApiKeyMetadata.toObject,
            includeInstance
          ),
          total: jspb2.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListApiKeysResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListApiKeysResponse();
      return proto.atfai.console.v1.ListApiKeysResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListApiKeysResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.ConsoleApiKeyMetadata();
            reader.readMessage(value, proto.atfai.console.v1.ConsoleApiKeyMetadata.deserializeBinaryFromReader);
            msg.addKeys(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotal(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListApiKeysResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListApiKeysResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListApiKeysResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getKeysList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.ConsoleApiKeyMetadata.serializeBinaryToWriter
        );
      }
      f = message.getTotal();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListApiKeysResponse.prototype.getKeysList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.ConsoleApiKeyMetadata>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.ConsoleApiKeyMetadata, 1)
      );
    };
    proto.atfai.console.v1.ListApiKeysResponse.prototype.setKeysList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListApiKeysResponse.prototype.addKeys = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.ConsoleApiKeyMetadata, opt_index);
    };
    proto.atfai.console.v1.ListApiKeysResponse.prototype.clearKeysList = function() {
      return this.setKeysList([]);
    };
    proto.atfai.console.v1.ListApiKeysResponse.prototype.getTotal = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.ListApiKeysResponse.prototype.setTotal = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateContractRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateContractRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateContractRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateContractRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateContractRequest();
      return proto.atfai.console.v1.CreateContractRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateContractRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateContractRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateContractRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateContractRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.CreateContractRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.CreateContractRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CreateContractResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CreateContractResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CreateContractResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f),
          stripeCustomerId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          stripeSubscriptionId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          stripeSubscriptionStatus: jspb2.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CreateContractResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CreateContractResponse();
      return proto.atfai.console.v1.CreateContractResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CreateContractResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeCustomerId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeSubscriptionId(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeSubscriptionStatus(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CreateContractResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CreateContractResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
      f = message.getStripeCustomerId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getStripeSubscriptionId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getStripeSubscriptionStatus();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.getStripeCustomerId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.setStripeCustomerId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.getStripeSubscriptionId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.setStripeSubscriptionId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.getStripeSubscriptionStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.CreateContractResponse.prototype.setStripeSubscriptionStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetContractStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetContractStatusRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetContractStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetContractStatusRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetContractStatusRequest();
      return proto.atfai.console.v1.GetContractStatusRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetContractStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetContractStatusRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetContractStatusRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetContractStatusRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.GetContractStatusRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetContractStatusRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetContractStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetContractStatusResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetContractStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          stripeCustomerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          stripeSubscriptionId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          stripeSubscriptionStatus: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          fromLiveStripeRead: jspb2.Message.getBooleanFieldWithDefault(msg, 4, false),
          currentPeriodEnd: (f = msg.getCurrentPeriodEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetContractStatusResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetContractStatusResponse();
      return proto.atfai.console.v1.GetContractStatusResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetContractStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeCustomerId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeSubscriptionId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeSubscriptionStatus(value);
            break;
          case 4:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setFromLiveStripeRead(value);
            break;
          case 5:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCurrentPeriodEnd(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetContractStatusResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetContractStatusResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getStripeCustomerId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getStripeSubscriptionId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getStripeSubscriptionStatus();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getFromLiveStripeRead();
      if (f) {
        writer.writeBool(
          4,
          f
        );
      }
      f = message.getCurrentPeriodEnd();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.getStripeCustomerId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.setStripeCustomerId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.getStripeSubscriptionId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.setStripeSubscriptionId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.getStripeSubscriptionStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.setStripeSubscriptionStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.getFromLiveStripeRead = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 4, false)
      );
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.setFromLiveStripeRead = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 4, value);
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.getCurrentPeriodEnd = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
      );
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.setCurrentPeriodEnd = function(value) {
      return jspb2.Message.setWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.clearCurrentPeriodEnd = function() {
      return this.setCurrentPeriodEnd(void 0);
    };
    proto.atfai.console.v1.GetContractStatusResponse.prototype.hasCurrentPeriodEnd = function() {
      return jspb2.Message.getField(this, 5) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CancelContractRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CancelContractRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CancelContractRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          immediate: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
          reason: jspb2.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CancelContractRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CancelContractRequest();
      return proto.atfai.console.v1.CancelContractRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CancelContractRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 2:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setImmediate(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setReason(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CancelContractRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CancelContractRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CancelContractRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getImmediate();
      if (f) {
        writer.writeBool(
          2,
          f
        );
      }
      f = message.getReason();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.CancelContractRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.CancelContractRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.CancelContractRequest.prototype.getImmediate = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 2, false)
      );
    };
    proto.atfai.console.v1.CancelContractRequest.prototype.setImmediate = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 2, value);
    };
    proto.atfai.console.v1.CancelContractRequest.prototype.getReason = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.CancelContractRequest.prototype.setReason = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CancelContractResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CancelContractResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CancelContractResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f),
          stripeSubscriptionStatus: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CancelContractResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CancelContractResponse();
      return proto.atfai.console.v1.CancelContractResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CancelContractResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeSubscriptionStatus(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CancelContractResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CancelContractResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CancelContractResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
      f = message.getStripeSubscriptionStatus();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.CancelContractResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.CancelContractResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.CancelContractResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.CancelContractResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    proto.atfai.console.v1.CancelContractResponse.prototype.getStripeSubscriptionStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.CancelContractResponse.prototype.setStripeSubscriptionStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ChangeMyPasswordRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ChangeMyPasswordRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ChangeMyPasswordRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          oldPassword: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          newPassword: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ChangeMyPasswordRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ChangeMyPasswordRequest();
      return proto.atfai.console.v1.ChangeMyPasswordRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ChangeMyPasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOldPassword(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setNewPassword(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ChangeMyPasswordRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ChangeMyPasswordRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ChangeMyPasswordRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOldPassword();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getNewPassword();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ChangeMyPasswordRequest.prototype.getOldPassword = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ChangeMyPasswordRequest.prototype.setOldPassword = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ChangeMyPasswordRequest.prototype.getNewPassword = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ChangeMyPasswordRequest.prototype.setNewPassword = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ChangeMyPasswordResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ChangeMyPasswordResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ChangeMyPasswordResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          status: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ChangeMyPasswordResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ChangeMyPasswordResponse();
      return proto.atfai.console.v1.ChangeMyPasswordResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ChangeMyPasswordResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStatus(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ChangeMyPasswordResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ChangeMyPasswordResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ChangeMyPasswordResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getStatus();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.ChangeMyPasswordResponse.prototype.getStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ChangeMyPasswordResponse.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListMyLicensesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListMyLicensesRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListMyLicensesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListMyLicensesRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListMyLicensesRequest();
      return proto.atfai.console.v1.ListMyLicensesRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListMyLicensesRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListMyLicensesRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListMyLicensesRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListMyLicensesRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
    };
    proto.atfai.console.v1.ListMyLicensesResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListMyLicensesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListMyLicensesResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListMyLicensesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          licensesList: jspb2.Message.toObjectList(
            msg.getLicensesList(),
            proto.atfai.console.v1.License.toObject,
            includeInstance
          )
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListMyLicensesResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListMyLicensesResponse();
      return proto.atfai.console.v1.ListMyLicensesResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListMyLicensesResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.addLicenses(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListMyLicensesResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListMyLicensesResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListMyLicensesResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicensesList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.ListMyLicensesResponse.prototype.getLicensesList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.License>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.ListMyLicensesResponse.prototype.setLicensesList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListMyLicensesResponse.prototype.addLicenses = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.License, opt_index);
    };
    proto.atfai.console.v1.ListMyLicensesResponse.prototype.clearLicensesList = function() {
      return this.setLicensesList([]);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetMyLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetMyLicenseRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetMyLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetMyLicenseRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetMyLicenseRequest();
      return proto.atfai.console.v1.GetMyLicenseRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetMyLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetMyLicenseRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetMyLicenseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetMyLicenseRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.GetMyLicenseRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetMyLicenseRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetMyLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetMyLicenseResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetMyLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetMyLicenseResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetMyLicenseResponse();
      return proto.atfai.console.v1.GetMyLicenseResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetMyLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetMyLicenseResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetMyLicenseResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetMyLicenseResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetMyLicenseResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.GetMyLicenseResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.GetMyLicenseResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.GetMyLicenseResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.DownloadMyLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.DownloadMyLicenseRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.DownloadMyLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.DownloadMyLicenseRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.DownloadMyLicenseRequest();
      return proto.atfai.console.v1.DownloadMyLicenseRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.DownloadMyLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.DownloadMyLicenseRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.DownloadMyLicenseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.DownloadMyLicenseRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.DownloadMyLicenseRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.DownloadMyLicenseRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.DownloadMyLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.DownloadMyLicenseResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.DownloadMyLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          license: (f = msg.getLicense()) && proto.atfai.console.v1.License.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.DownloadMyLicenseResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.DownloadMyLicenseResponse();
      return proto.atfai.console.v1.DownloadMyLicenseResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.DownloadMyLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.License();
            reader.readMessage(value, proto.atfai.console.v1.License.deserializeBinaryFromReader);
            msg.setLicense(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.DownloadMyLicenseResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.DownloadMyLicenseResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.DownloadMyLicenseResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicense();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.License.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.DownloadMyLicenseResponse.prototype.getLicense = function() {
      return (
        /** @type{?proto.atfai.console.v1.License} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.License, 1)
      );
    };
    proto.atfai.console.v1.DownloadMyLicenseResponse.prototype.setLicense = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.DownloadMyLicenseResponse.prototype.clearLicense = function() {
      return this.setLicense(void 0);
    };
    proto.atfai.console.v1.DownloadMyLicenseResponse.prototype.hasLicense = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListMyUsageEventsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListMyUsageEventsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          instanceId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          orgId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          eventType: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          occurredAfter: (f = msg.getOccurredAfter()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          occurredBefore: (f = msg.getOccurredBefore()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          pageSize: jspb2.Message.getFieldWithDefault(msg, 7, 0),
          pageToken: jspb2.Message.getFieldWithDefault(msg, 8, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListMyUsageEventsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListMyUsageEventsRequest();
      return proto.atfai.console.v1.ListMyUsageEventsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEventType(value);
            break;
          case 5:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setOccurredAfter(value);
            break;
          case 6:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setOccurredBefore(value);
            break;
          case 7:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setPageSize(value);
            break;
          case 8:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPageToken(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListMyUsageEventsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getEventType();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getOccurredAfter();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getOccurredBefore();
      if (f != null) {
        writer.writeMessage(
          6,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getPageSize();
      if (f !== 0) {
        writer.writeInt32(
          7,
          f
        );
      }
      f = message.getPageToken();
      if (f.length > 0) {
        writer.writeString(
          8,
          f
        );
      }
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.getEventType = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.setEventType = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.getOccurredAfter = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.setOccurredAfter = function(value) {
      return jspb2.Message.setWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.clearOccurredAfter = function() {
      return this.setOccurredAfter(void 0);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.hasOccurredAfter = function() {
      return jspb2.Message.getField(this, 5) != null;
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.getOccurredBefore = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.setOccurredBefore = function(value) {
      return jspb2.Message.setWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.clearOccurredBefore = function() {
      return this.setOccurredBefore(void 0);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.hasOccurredBefore = function() {
      return jspb2.Message.getField(this, 6) != null;
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.getPageSize = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.setPageSize = function(value) {
      return jspb2.Message.setProto3IntField(this, 7, value);
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.getPageToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 8, "")
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsRequest.prototype.setPageToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 8, value);
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListMyUsageEventsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListMyUsageEventsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListMyUsageEventsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          eventsList: jspb2.Message.toObjectList(
            msg.getEventsList(),
            proto.atfai.console.v1.UsageEvent.toObject,
            includeInstance
          ),
          nextPageToken: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListMyUsageEventsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListMyUsageEventsResponse();
      return proto.atfai.console.v1.ListMyUsageEventsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.UsageEvent();
            reader.readMessage(value, proto.atfai.console.v1.UsageEvent.deserializeBinaryFromReader);
            msg.addEvents(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setNextPageToken(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListMyUsageEventsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getEventsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.UsageEvent.serializeBinaryToWriter
        );
      }
      f = message.getNextPageToken();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.prototype.getEventsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.UsageEvent>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.UsageEvent, 1)
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.prototype.setEventsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.prototype.addEvents = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.UsageEvent, opt_index);
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.prototype.clearEventsList = function() {
      return this.setEventsList([]);
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.prototype.getNextPageToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListMyUsageEventsResponse.prototype.setNextPageToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetMyContractStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetMyContractStatusRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetMyContractStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetMyContractStatusRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetMyContractStatusRequest();
      return proto.atfai.console.v1.GetMyContractStatusRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetMyContractStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetMyContractStatusRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetMyContractStatusRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetMyContractStatusRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.GetMyContractStatusRequest.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetMyContractStatusRequest.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetMyContractStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetMyContractStatusResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetMyContractStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          stripeCustomerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          stripeSubscriptionId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          stripeSubscriptionStatus: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          fromLiveStripeRead: jspb2.Message.getBooleanFieldWithDefault(msg, 4, false),
          currentPeriodEnd: (f = msg.getCurrentPeriodEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetMyContractStatusResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetMyContractStatusResponse();
      return proto.atfai.console.v1.GetMyContractStatusResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeCustomerId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeSubscriptionId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStripeSubscriptionStatus(value);
            break;
          case 4:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setFromLiveStripeRead(value);
            break;
          case 5:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCurrentPeriodEnd(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetMyContractStatusResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getStripeCustomerId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getStripeSubscriptionId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getStripeSubscriptionStatus();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getFromLiveStripeRead();
      if (f) {
        writer.writeBool(
          4,
          f
        );
      }
      f = message.getCurrentPeriodEnd();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.getStripeCustomerId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.setStripeCustomerId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.getStripeSubscriptionId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.setStripeSubscriptionId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.getStripeSubscriptionStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.setStripeSubscriptionStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.getFromLiveStripeRead = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 4, false)
      );
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.setFromLiveStripeRead = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 4, value);
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.getCurrentPeriodEnd = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
      );
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.setCurrentPeriodEnd = function(value) {
      return jspb2.Message.setWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.clearCurrentPeriodEnd = function() {
      return this.setCurrentPeriodEnd(void 0);
    };
    proto.atfai.console.v1.GetMyContractStatusResponse.prototype.hasCurrentPeriodEnd = function() {
      return jspb2.Message.getField(this, 5) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.LicenseHealthAlert.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.LicenseHealthAlert.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.LicenseHealthAlert.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          accountName: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          tier: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          status: jspb2.Message.getFieldWithDefault(msg, 5, 0),
          deploymentType: jspb2.Message.getFieldWithDefault(msg, 6, 0),
          connectivityMode: jspb2.Message.getFieldWithDefault(msg, 7, 0),
          expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          daysUntilExpiry: jspb2.Message.getFieldWithDefault(msg, 9, 0),
          seatLimit: jspb2.Message.getFieldWithDefault(msg, 10, 0),
          activeSeatCount: jspb2.Message.getFieldWithDefault(msg, 11, 0),
          isAirGapped: jspb2.Message.getBooleanFieldWithDefault(msg, 12, false)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.LicenseHealthAlert.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.LicenseHealthAlert();
      return proto.atfai.console.v1.LicenseHealthAlert.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.LicenseHealthAlert.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountName(value);
            break;
          case 4:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseTier} */
              reader.readEnum()
            );
            msg.setTier(value);
            break;
          case 5:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseStatus} */
              reader.readEnum()
            );
            msg.setStatus(value);
            break;
          case 6:
            var value = (
              /** @type {!proto.atfai.console.v1.DeploymentType} */
              reader.readEnum()
            );
            msg.setDeploymentType(value);
            break;
          case 7:
            var value = (
              /** @type {!proto.atfai.console.v1.ConnectivityMode} */
              reader.readEnum()
            );
            msg.setConnectivityMode(value);
            break;
          case 8:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setExpiresAt(value);
            break;
          case 9:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setDaysUntilExpiry(value);
            break;
          case 10:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setSeatLimit(value);
            break;
          case 11:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setActiveSeatCount(value);
            break;
          case 12:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setIsAirGapped(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.LicenseHealthAlert.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.LicenseHealthAlert.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getAccountName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getTier();
      if (f !== 0) {
        writer.writeEnum(
          4,
          f
        );
      }
      f = message.getStatus();
      if (f !== 0) {
        writer.writeEnum(
          5,
          f
        );
      }
      f = message.getDeploymentType();
      if (f !== 0) {
        writer.writeEnum(
          6,
          f
        );
      }
      f = message.getConnectivityMode();
      if (f !== 0) {
        writer.writeEnum(
          7,
          f
        );
      }
      f = message.getExpiresAt();
      if (f != null) {
        writer.writeMessage(
          8,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getDaysUntilExpiry();
      if (f !== 0) {
        writer.writeInt32(
          9,
          f
        );
      }
      f = message.getSeatLimit();
      if (f !== 0) {
        writer.writeInt32(
          10,
          f
        );
      }
      f = message.getActiveSeatCount();
      if (f !== 0) {
        writer.writeInt32(
          11,
          f
        );
      }
      f = message.getIsAirGapped();
      if (f) {
        writer.writeBool(
          12,
          f
        );
      }
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getAccountName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setAccountName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getTier = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseTier} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setTier = function(value) {
      return jspb2.Message.setProto3EnumField(this, 4, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getStatus = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseStatus} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3EnumField(this, 5, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getDeploymentType = function() {
      return (
        /** @type {!proto.atfai.console.v1.DeploymentType} */
        jspb2.Message.getFieldWithDefault(this, 6, 0)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setDeploymentType = function(value) {
      return jspb2.Message.setProto3EnumField(this, 6, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getConnectivityMode = function() {
      return (
        /** @type {!proto.atfai.console.v1.ConnectivityMode} */
        jspb2.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setConnectivityMode = function(value) {
      return jspb2.Message.setProto3EnumField(this, 7, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getExpiresAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setExpiresAt = function(value) {
      return jspb2.Message.setWrapperField(this, 8, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.clearExpiresAt = function() {
      return this.setExpiresAt(void 0);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.hasExpiresAt = function() {
      return jspb2.Message.getField(this, 8) != null;
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getDaysUntilExpiry = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 9, 0)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setDaysUntilExpiry = function(value) {
      return jspb2.Message.setProto3IntField(this, 9, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getSeatLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 10, 0)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setSeatLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 10, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getActiveSeatCount = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 11, 0)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setActiveSeatCount = function(value) {
      return jspb2.Message.setProto3IntField(this, 11, value);
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.getIsAirGapped = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 12, false)
      );
    };
    proto.atfai.console.v1.LicenseHealthAlert.prototype.setIsAirGapped = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 12, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListLicenseHealthAlertsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListLicenseHealthAlertsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListLicenseHealthAlertsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          expiringWithinDays: jspb2.Message.getFieldWithDefault(msg, 1, 0),
          staleHeartbeatThresholdHours: jspb2.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListLicenseHealthAlertsRequest();
      return proto.atfai.console.v1.ListLicenseHealthAlertsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setExpiringWithinDays(value);
            break;
          case 4:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setStaleHeartbeatThresholdHours(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListLicenseHealthAlertsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getExpiringWithinDays();
      if (f !== 0) {
        writer.writeInt32(
          1,
          f
        );
      }
      f = message.getStaleHeartbeatThresholdHours();
      if (f !== 0) {
        writer.writeInt32(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest.prototype.getExpiringWithinDays = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest.prototype.setExpiringWithinDays = function(value) {
      return jspb2.Message.setProto3IntField(this, 1, value);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest.prototype.getStaleHeartbeatThresholdHours = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsRequest.prototype.setStaleHeartbeatThresholdHours = function(value) {
      return jspb2.Message.setProto3IntField(this, 4, value);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.repeatedFields_ = [1, 2, 3, 5, 6];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListLicenseHealthAlertsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListLicenseHealthAlertsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          expiringSoonList: jspb2.Message.toObjectList(
            msg.getExpiringSoonList(),
            proto.atfai.console.v1.LicenseHealthAlert.toObject,
            includeInstance
          ),
          suspendedList: jspb2.Message.toObjectList(
            msg.getSuspendedList(),
            proto.atfai.console.v1.LicenseHealthAlert.toObject,
            includeInstance
          ),
          seatOverLimitList: jspb2.Message.toObjectList(
            msg.getSeatOverLimitList(),
            proto.atfai.console.v1.LicenseHealthAlert.toObject,
            includeInstance
          ),
          orgScopeAlertsList: jspb2.Message.toObjectList(
            msg.getOrgScopeAlertsList(),
            proto.atfai.console.v1.OrgScopeAlert.toObject,
            includeInstance
          ),
          staleHeartbeatAlertsList: jspb2.Message.toObjectList(
            msg.getStaleHeartbeatAlertsList(),
            proto.atfai.console.v1.StaleHeartbeatAlert.toObject,
            includeInstance
          )
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListLicenseHealthAlertsResponse();
      return proto.atfai.console.v1.ListLicenseHealthAlertsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.LicenseHealthAlert();
            reader.readMessage(value, proto.atfai.console.v1.LicenseHealthAlert.deserializeBinaryFromReader);
            msg.addExpiringSoon(value);
            break;
          case 2:
            var value = new proto.atfai.console.v1.LicenseHealthAlert();
            reader.readMessage(value, proto.atfai.console.v1.LicenseHealthAlert.deserializeBinaryFromReader);
            msg.addSuspended(value);
            break;
          case 3:
            var value = new proto.atfai.console.v1.LicenseHealthAlert();
            reader.readMessage(value, proto.atfai.console.v1.LicenseHealthAlert.deserializeBinaryFromReader);
            msg.addSeatOverLimit(value);
            break;
          case 5:
            var value = new proto.atfai.console.v1.OrgScopeAlert();
            reader.readMessage(value, proto.atfai.console.v1.OrgScopeAlert.deserializeBinaryFromReader);
            msg.addOrgScopeAlerts(value);
            break;
          case 6:
            var value = new proto.atfai.console.v1.StaleHeartbeatAlert();
            reader.readMessage(value, proto.atfai.console.v1.StaleHeartbeatAlert.deserializeBinaryFromReader);
            msg.addStaleHeartbeatAlerts(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListLicenseHealthAlertsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getExpiringSoonList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.LicenseHealthAlert.serializeBinaryToWriter
        );
      }
      f = message.getSuspendedList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          2,
          f,
          proto.atfai.console.v1.LicenseHealthAlert.serializeBinaryToWriter
        );
      }
      f = message.getSeatOverLimitList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          3,
          f,
          proto.atfai.console.v1.LicenseHealthAlert.serializeBinaryToWriter
        );
      }
      f = message.getOrgScopeAlertsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          5,
          f,
          proto.atfai.console.v1.OrgScopeAlert.serializeBinaryToWriter
        );
      }
      f = message.getStaleHeartbeatAlertsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          6,
          f,
          proto.atfai.console.v1.StaleHeartbeatAlert.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.getExpiringSoonList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.LicenseHealthAlert>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.LicenseHealthAlert, 1)
      );
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.setExpiringSoonList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.addExpiringSoon = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.LicenseHealthAlert, opt_index);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.clearExpiringSoonList = function() {
      return this.setExpiringSoonList([]);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.getSuspendedList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.LicenseHealthAlert>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.LicenseHealthAlert, 2)
      );
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.setSuspendedList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 2, value);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.addSuspended = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.atfai.console.v1.LicenseHealthAlert, opt_index);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.clearSuspendedList = function() {
      return this.setSuspendedList([]);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.getSeatOverLimitList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.LicenseHealthAlert>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.LicenseHealthAlert, 3)
      );
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.setSeatOverLimitList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 3, value);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.addSeatOverLimit = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.atfai.console.v1.LicenseHealthAlert, opt_index);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.clearSeatOverLimitList = function() {
      return this.setSeatOverLimitList([]);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.getOrgScopeAlertsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.OrgScopeAlert>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.OrgScopeAlert, 5)
      );
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.setOrgScopeAlertsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.addOrgScopeAlerts = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.atfai.console.v1.OrgScopeAlert, opt_index);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.clearOrgScopeAlertsList = function() {
      return this.setOrgScopeAlertsList([]);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.getStaleHeartbeatAlertsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.StaleHeartbeatAlert>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.StaleHeartbeatAlert, 6)
      );
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.setStaleHeartbeatAlertsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.addStaleHeartbeatAlerts = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.atfai.console.v1.StaleHeartbeatAlert, opt_index);
    };
    proto.atfai.console.v1.ListLicenseHealthAlertsResponse.prototype.clearStaleHeartbeatAlertsList = function() {
      return this.setStaleHeartbeatAlertsList([]);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.OrgScopeAlert.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.OrgScopeAlert.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.OrgScopeAlert.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          accountName: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          orgLimit: jspb2.Message.getFieldWithDefault(msg, 4, 0),
          currentOrgCount: jspb2.Message.getFieldWithDefault(msg, 5, 0),
          lastNewOrgSeenAt: (f = msg.getLastNewOrgSeenAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.OrgScopeAlert.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.OrgScopeAlert();
      return proto.atfai.console.v1.OrgScopeAlert.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.OrgScopeAlert.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountName(value);
            break;
          case 4:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setOrgLimit(value);
            break;
          case 5:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setCurrentOrgCount(value);
            break;
          case 6:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setLastNewOrgSeenAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.OrgScopeAlert.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.OrgScopeAlert.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getAccountName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getOrgLimit();
      if (f !== 0) {
        writer.writeInt32(
          4,
          f
        );
      }
      f = message.getCurrentOrgCount();
      if (f !== 0) {
        writer.writeInt32(
          5,
          f
        );
      }
      f = message.getLastNewOrgSeenAt();
      if (f != null) {
        writer.writeMessage(
          6,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.getAccountName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.setAccountName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.getOrgLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.setOrgLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 4, value);
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.getCurrentOrgCount = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 5, 0)
      );
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.setCurrentOrgCount = function(value) {
      return jspb2.Message.setProto3IntField(this, 5, value);
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.getLastNewOrgSeenAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
      );
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.setLastNewOrgSeenAt = function(value) {
      return jspb2.Message.setWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.clearLastNewOrgSeenAt = function() {
      return this.setLastNewOrgSeenAt(void 0);
    };
    proto.atfai.console.v1.OrgScopeAlert.prototype.hasLastNewOrgSeenAt = function() {
      return jspb2.Message.getField(this, 6) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.StaleHeartbeatAlert.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.StaleHeartbeatAlert.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.StaleHeartbeatAlert.toObject = function(includeInstance, msg) {
        var f, obj = {
          licenseId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          accountName: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          lastHandshakeAt: (f = msg.getLastHandshakeAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          hoursSinceHandshake: jspb2.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.StaleHeartbeatAlert.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.StaleHeartbeatAlert();
      return proto.atfai.console.v1.StaleHeartbeatAlert.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setLicenseId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountName(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 5:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setLastHandshakeAt(value);
            break;
          case 6:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setHoursSinceHandshake(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.StaleHeartbeatAlert.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getLicenseId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getAccountName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getLastHandshakeAt();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getHoursSinceHandshake();
      if (f !== 0) {
        writer.writeInt32(
          6,
          f
        );
      }
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.getLicenseId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.setLicenseId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.getAccountName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.setAccountName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.getLastHandshakeAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
      );
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.setLastHandshakeAt = function(value) {
      return jspb2.Message.setWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.clearLastHandshakeAt = function() {
      return this.setLastHandshakeAt(void 0);
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.hasLastHandshakeAt = function() {
      return jspb2.Message.getField(this, 5) != null;
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.getHoursSinceHandshake = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 6, 0)
      );
    };
    proto.atfai.console.v1.StaleHeartbeatAlert.prototype.setHoursSinceHandshake = function(value) {
      return jspb2.Message.setProto3IntField(this, 6, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.OrgUsageSummary.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.OrgUsageSummary.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.OrgUsageSummary.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          orgName: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          orgSlug: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          firstSeenAt: (f = msg.getFirstSeenAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          lastSeenAt: (f = msg.getLastSeenAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          eventCount: jspb2.Message.getFieldWithDefault(msg, 7, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.OrgUsageSummary.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.OrgUsageSummary();
      return proto.atfai.console.v1.OrgUsageSummary.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.OrgUsageSummary.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgName(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgSlug(value);
            break;
          case 5:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setFirstSeenAt(value);
            break;
          case 6:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setLastSeenAt(value);
            break;
          case 7:
            var value = (
              /** @type {number} */
              reader.readInt64()
            );
            msg.setEventCount(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.OrgUsageSummary.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.OrgUsageSummary.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getOrgName();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getOrgSlug();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getFirstSeenAt();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getLastSeenAt();
      if (f != null) {
        writer.writeMessage(
          6,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getEventCount();
      if (f !== 0) {
        writer.writeInt64(
          7,
          f
        );
      }
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.getOrgName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.setOrgName = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.getOrgSlug = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.setOrgSlug = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.getFirstSeenAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
      );
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.setFirstSeenAt = function(value) {
      return jspb2.Message.setWrapperField(this, 5, value);
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.clearFirstSeenAt = function() {
      return this.setFirstSeenAt(void 0);
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.hasFirstSeenAt = function() {
      return jspb2.Message.getField(this, 5) != null;
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.getLastSeenAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
      );
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.setLastSeenAt = function(value) {
      return jspb2.Message.setWrapperField(this, 6, value);
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.clearLastSeenAt = function() {
      return this.setLastSeenAt(void 0);
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.hasLastSeenAt = function() {
      return jspb2.Message.getField(this, 6) != null;
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.getEventCount = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 7, 0)
      );
    };
    proto.atfai.console.v1.OrgUsageSummary.prototype.setEventCount = function(value) {
      return jspb2.Message.setProto3IntField(this, 7, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetOrgUsageRollupRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetOrgUsageRollupRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          instanceId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          orgId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          since: (f = msg.getSince()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          until: (f = msg.getUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetOrgUsageRollupRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetOrgUsageRollupRequest();
      return proto.atfai.console.v1.GetOrgUsageRollupRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 3:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setSince(value);
            break;
          case 4:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setUntil(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetOrgUsageRollupRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getSince();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getUntil();
      if (f != null) {
        writer.writeMessage(
          4,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.getSince = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
      );
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.setSince = function(value) {
      return jspb2.Message.setWrapperField(this, 3, value);
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.clearSince = function() {
      return this.setSince(void 0);
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.hasSince = function() {
      return jspb2.Message.getField(this, 3) != null;
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.getUntil = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
      );
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.setUntil = function(value) {
      return jspb2.Message.setWrapperField(this, 4, value);
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.clearUntil = function() {
      return this.setUntil(void 0);
    };
    proto.atfai.console.v1.GetOrgUsageRollupRequest.prototype.hasUntil = function() {
      return jspb2.Message.getField(this, 4) != null;
    };
    proto.atfai.console.v1.GetOrgUsageRollupResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetOrgUsageRollupResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetOrgUsageRollupResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetOrgUsageRollupResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          summariesList: jspb2.Message.toObjectList(
            msg.getSummariesList(),
            proto.atfai.console.v1.OrgUsageSummary.toObject,
            includeInstance
          )
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetOrgUsageRollupResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetOrgUsageRollupResponse();
      return proto.atfai.console.v1.GetOrgUsageRollupResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetOrgUsageRollupResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.OrgUsageSummary();
            reader.readMessage(value, proto.atfai.console.v1.OrgUsageSummary.deserializeBinaryFromReader);
            msg.addSummaries(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetOrgUsageRollupResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetOrgUsageRollupResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetOrgUsageRollupResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getSummariesList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.OrgUsageSummary.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetOrgUsageRollupResponse.prototype.getSummariesList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.OrgUsageSummary>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.OrgUsageSummary, 1)
      );
    };
    proto.atfai.console.v1.GetOrgUsageRollupResponse.prototype.setSummariesList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.GetOrgUsageRollupResponse.prototype.addSummaries = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.OrgUsageSummary, opt_index);
    };
    proto.atfai.console.v1.GetOrgUsageRollupResponse.prototype.clearSummariesList = function() {
      return this.setSummariesList([]);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RevenueTierBucket.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RevenueTierBucket.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RevenueTierBucket.toObject = function(includeInstance, msg) {
        var f, obj = {
          tier: jspb2.Message.getFieldWithDefault(msg, 1, 0),
          billingState: jspb2.Message.getFieldWithDefault(msg, 2, 0),
          licenseCount: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          totalSeatLimit: jspb2.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RevenueTierBucket.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RevenueTierBucket();
      return proto.atfai.console.v1.RevenueTierBucket.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RevenueTierBucket.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {!proto.atfai.console.v1.LicenseTier} */
              reader.readEnum()
            );
            msg.setTier(value);
            break;
          case 2:
            var value = (
              /** @type {!proto.atfai.console.v1.BillingState} */
              reader.readEnum()
            );
            msg.setBillingState(value);
            break;
          case 3:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setLicenseCount(value);
            break;
          case 4:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotalSeatLimit(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RevenueTierBucket.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RevenueTierBucket.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getTier();
      if (f !== 0) {
        writer.writeEnum(
          1,
          f
        );
      }
      f = message.getBillingState();
      if (f !== 0) {
        writer.writeEnum(
          2,
          f
        );
      }
      f = message.getLicenseCount();
      if (f !== 0) {
        writer.writeInt32(
          3,
          f
        );
      }
      f = message.getTotalSeatLimit();
      if (f !== 0) {
        writer.writeInt32(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.getTier = function() {
      return (
        /** @type {!proto.atfai.console.v1.LicenseTier} */
        jspb2.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.setTier = function(value) {
      return jspb2.Message.setProto3EnumField(this, 1, value);
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.getBillingState = function() {
      return (
        /** @type {!proto.atfai.console.v1.BillingState} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.setBillingState = function(value) {
      return jspb2.Message.setProto3EnumField(this, 2, value);
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.getLicenseCount = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.setLicenseCount = function(value) {
      return jspb2.Message.setProto3IntField(this, 3, value);
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.getTotalSeatLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 4, 0)
      );
    };
    proto.atfai.console.v1.RevenueTierBucket.prototype.setTotalSeatLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 4, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetRevenueOverviewRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetRevenueOverviewRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetRevenueOverviewRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetRevenueOverviewRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetRevenueOverviewRequest();
      return proto.atfai.console.v1.GetRevenueOverviewRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetRevenueOverviewRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetRevenueOverviewRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetRevenueOverviewRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetRevenueOverviewRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.repeatedFields_ = [4];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.GetRevenueOverviewResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.GetRevenueOverviewResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          totalAccounts: jspb2.Message.getFieldWithDefault(msg, 1, 0),
          totalLicenses: jspb2.Message.getFieldWithDefault(msg, 2, 0),
          totalSeatLimit: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          byTierList: jspb2.Message.toObjectList(
            msg.getByTierList(),
            proto.atfai.console.v1.RevenueTierBucket.toObject,
            includeInstance
          )
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.GetRevenueOverviewResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.GetRevenueOverviewResponse();
      return proto.atfai.console.v1.GetRevenueOverviewResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotalAccounts(value);
            break;
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotalLicenses(value);
            break;
          case 3:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setTotalSeatLimit(value);
            break;
          case 4:
            var value = new proto.atfai.console.v1.RevenueTierBucket();
            reader.readMessage(value, proto.atfai.console.v1.RevenueTierBucket.deserializeBinaryFromReader);
            msg.addByTier(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.GetRevenueOverviewResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getTotalAccounts();
      if (f !== 0) {
        writer.writeInt32(
          1,
          f
        );
      }
      f = message.getTotalLicenses();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
      f = message.getTotalSeatLimit();
      if (f !== 0) {
        writer.writeInt32(
          3,
          f
        );
      }
      f = message.getByTierList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          4,
          f,
          proto.atfai.console.v1.RevenueTierBucket.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.getTotalAccounts = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 1, 0)
      );
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.setTotalAccounts = function(value) {
      return jspb2.Message.setProto3IntField(this, 1, value);
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.getTotalLicenses = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.setTotalLicenses = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.getTotalSeatLimit = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.setTotalSeatLimit = function(value) {
      return jspb2.Message.setProto3IntField(this, 3, value);
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.getByTierList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.RevenueTierBucket>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.RevenueTierBucket, 4)
      );
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.setByTierList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 4, value);
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.addByTier = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.atfai.console.v1.RevenueTierBucket, opt_index);
    };
    proto.atfai.console.v1.GetRevenueOverviewResponse.prototype.clearByTierList = function() {
      return this.setByTierList([]);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.InviteMemberRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.InviteMemberRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.InviteMemberRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          email: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          role: jspb2.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.InviteMemberRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.InviteMemberRequest();
      return proto.atfai.console.v1.InviteMemberRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.InviteMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEmail(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.AccountRole} */
              reader.readEnum()
            );
            msg.setRole(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.InviteMemberRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.InviteMemberRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.InviteMemberRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getEmail();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getRole();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.InviteMemberRequest.prototype.getEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.InviteMemberRequest.prototype.setEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.InviteMemberRequest.prototype.getRole = function() {
      return (
        /** @type {!proto.atfai.console.v1.AccountRole} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.InviteMemberRequest.prototype.setRole = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.InviteMemberResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.InviteMemberResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.InviteMemberResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          inviteId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          inviteToken: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.InviteMemberResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.InviteMemberResponse();
      return proto.atfai.console.v1.InviteMemberResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.InviteMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInviteId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInviteToken(value);
            break;
          case 3:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setExpiresAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.InviteMemberResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.InviteMemberResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInviteId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getInviteToken();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getExpiresAt();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.getInviteId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.setInviteId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.getInviteToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.setInviteToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.getExpiresAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
      );
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.setExpiresAt = function(value) {
      return jspb2.Message.setWrapperField(this, 3, value);
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.clearExpiresAt = function() {
      return this.setExpiresAt(void 0);
    };
    proto.atfai.console.v1.InviteMemberResponse.prototype.hasExpiresAt = function() {
      return jspb2.Message.getField(this, 3) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.InviteFirstCustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.InviteFirstCustomerRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.InviteFirstCustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          accountId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          email: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          role: jspb2.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.InviteFirstCustomerRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.InviteFirstCustomerRequest();
      return proto.atfai.console.v1.InviteFirstCustomerRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEmail(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.AccountRole} */
              reader.readEnum()
            );
            msg.setRole(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.InviteFirstCustomerRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getEmail();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getRole();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.prototype.getEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.prototype.setEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.prototype.getRole = function() {
      return (
        /** @type {!proto.atfai.console.v1.AccountRole} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.InviteFirstCustomerRequest.prototype.setRole = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.InviteFirstCustomerResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.InviteFirstCustomerResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          inviteId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          inviteToken: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          expiresAt: (f = msg.getExpiresAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.InviteFirstCustomerResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.InviteFirstCustomerResponse();
      return proto.atfai.console.v1.InviteFirstCustomerResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInviteId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInviteToken(value);
            break;
          case 3:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setExpiresAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.InviteFirstCustomerResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getInviteId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getInviteToken();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getExpiresAt();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.getInviteId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.setInviteId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.getInviteToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.setInviteToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.getExpiresAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
      );
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.setExpiresAt = function(value) {
      return jspb2.Message.setWrapperField(this, 3, value);
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.clearExpiresAt = function() {
      return this.setExpiresAt(void 0);
    };
    proto.atfai.console.v1.InviteFirstCustomerResponse.prototype.hasExpiresAt = function() {
      return jspb2.Message.getField(this, 3) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListMembersRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListMembersRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListMembersRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListMembersRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListMembersRequest();
      return proto.atfai.console.v1.ListMembersRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListMembersRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListMembersRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListMembersRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListMembersRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.AccountMember.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.AccountMember.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.AccountMember.toObject = function(includeInstance, msg) {
        var f, obj = {
          userId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          email: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          role: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.AccountMember.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.AccountMember();
      return proto.atfai.console.v1.AccountMember.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.AccountMember.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setUserId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setEmail(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.AccountRole} */
              reader.readEnum()
            );
            msg.setRole(value);
            break;
          case 4:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCreatedAt(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.AccountMember.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.AccountMember.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.AccountMember.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getUserId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getEmail();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getRole();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
      f = message.getCreatedAt();
      if (f != null) {
        writer.writeMessage(
          4,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.AccountMember.prototype.getUserId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.AccountMember.prototype.setUserId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.AccountMember.prototype.getEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.AccountMember.prototype.setEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.AccountMember.prototype.getRole = function() {
      return (
        /** @type {!proto.atfai.console.v1.AccountRole} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.AccountMember.prototype.setRole = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    proto.atfai.console.v1.AccountMember.prototype.getCreatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
      );
    };
    proto.atfai.console.v1.AccountMember.prototype.setCreatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 4, value);
    };
    proto.atfai.console.v1.AccountMember.prototype.clearCreatedAt = function() {
      return this.setCreatedAt(void 0);
    };
    proto.atfai.console.v1.AccountMember.prototype.hasCreatedAt = function() {
      return jspb2.Message.getField(this, 4) != null;
    };
    proto.atfai.console.v1.ListMembersResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListMembersResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListMembersResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListMembersResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          membersList: jspb2.Message.toObjectList(
            msg.getMembersList(),
            proto.atfai.console.v1.AccountMember.toObject,
            includeInstance
          )
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListMembersResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListMembersResponse();
      return proto.atfai.console.v1.ListMembersResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListMembersResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.AccountMember();
            reader.readMessage(value, proto.atfai.console.v1.AccountMember.deserializeBinaryFromReader);
            msg.addMembers(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListMembersResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListMembersResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListMembersResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getMembersList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.AccountMember.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.ListMembersResponse.prototype.getMembersList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.AccountMember>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.AccountMember, 1)
      );
    };
    proto.atfai.console.v1.ListMembersResponse.prototype.setMembersList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListMembersResponse.prototype.addMembers = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.AccountMember, opt_index);
    };
    proto.atfai.console.v1.ListMembersResponse.prototype.clearMembersList = function() {
      return this.setMembersList([]);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RemoveMemberRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RemoveMemberRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RemoveMemberRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          userId: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RemoveMemberRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RemoveMemberRequest();
      return proto.atfai.console.v1.RemoveMemberRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RemoveMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setUserId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RemoveMemberRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RemoveMemberRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RemoveMemberRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getUserId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.RemoveMemberRequest.prototype.getUserId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.RemoveMemberRequest.prototype.setUserId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RemoveMemberResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RemoveMemberResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RemoveMemberResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          status: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RemoveMemberResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RemoveMemberResponse();
      return proto.atfai.console.v1.RemoveMemberResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RemoveMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStatus(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RemoveMemberResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RemoveMemberResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RemoveMemberResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getStatus();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.RemoveMemberResponse.prototype.getStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.RemoveMemberResponse.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.SetMemberRoleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.SetMemberRoleRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.SetMemberRoleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          userId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          newRole: jspb2.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.SetMemberRoleRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.SetMemberRoleRequest();
      return proto.atfai.console.v1.SetMemberRoleRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.SetMemberRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setUserId(value);
            break;
          case 3:
            var value = (
              /** @type {!proto.atfai.console.v1.AccountRole} */
              reader.readEnum()
            );
            msg.setNewRole(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.SetMemberRoleRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.SetMemberRoleRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.SetMemberRoleRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getUserId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getNewRole();
      if (f !== 0) {
        writer.writeEnum(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.SetMemberRoleRequest.prototype.getUserId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.SetMemberRoleRequest.prototype.setUserId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.SetMemberRoleRequest.prototype.getNewRole = function() {
      return (
        /** @type {!proto.atfai.console.v1.AccountRole} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.SetMemberRoleRequest.prototype.setNewRole = function(value) {
      return jspb2.Message.setProto3EnumField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.SetMemberRoleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.SetMemberRoleResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.SetMemberRoleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          member: (f = msg.getMember()) && proto.atfai.console.v1.AccountMember.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.SetMemberRoleResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.SetMemberRoleResponse();
      return proto.atfai.console.v1.SetMemberRoleResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.SetMemberRoleResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.AccountMember();
            reader.readMessage(value, proto.atfai.console.v1.AccountMember.deserializeBinaryFromReader);
            msg.setMember(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.SetMemberRoleResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.SetMemberRoleResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.SetMemberRoleResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getMember();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.AccountMember.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.SetMemberRoleResponse.prototype.getMember = function() {
      return (
        /** @type{?proto.atfai.console.v1.AccountMember} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.AccountMember, 1)
      );
    };
    proto.atfai.console.v1.SetMemberRoleResponse.prototype.setMember = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.SetMemberRoleResponse.prototype.clearMember = function() {
      return this.setMember(void 0);
    };
    proto.atfai.console.v1.SetMemberRoleResponse.prototype.hasMember = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.AcceptInviteRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.AcceptInviteRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.AcceptInviteRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          token: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          newPassword: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.AcceptInviteRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.AcceptInviteRequest();
      return proto.atfai.console.v1.AcceptInviteRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.AcceptInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setToken(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setNewPassword(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.AcceptInviteRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.AcceptInviteRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.AcceptInviteRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getToken();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getNewPassword();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.AcceptInviteRequest.prototype.getToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.AcceptInviteRequest.prototype.setToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.AcceptInviteRequest.prototype.getNewPassword = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.AcceptInviteRequest.prototype.setNewPassword = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.AcceptInviteResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.AcceptInviteResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.AcceptInviteResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          status: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          userId: jspb2.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.AcceptInviteResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.AcceptInviteResponse();
      return proto.atfai.console.v1.AcceptInviteResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.AcceptInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStatus(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setUserId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.AcceptInviteResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.AcceptInviteResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.AcceptInviteResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getStatus();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getUserId();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.AcceptInviteResponse.prototype.getStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.AcceptInviteResponse.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.AcceptInviteResponse.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.AcceptInviteResponse.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.AcceptInviteResponse.prototype.getUserId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.AcceptInviteResponse.prototype.setUserId = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RequestSeatChangeRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RequestSeatChangeRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RequestSeatChangeRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          requestedSeats: jspb2.Message.getFieldWithDefault(msg, 2, 0),
          detail: jspb2.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RequestSeatChangeRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RequestSeatChangeRequest();
      return proto.atfai.console.v1.RequestSeatChangeRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RequestSeatChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 2:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setRequestedSeats(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDetail(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RequestSeatChangeRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RequestSeatChangeRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RequestSeatChangeRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequestedSeats();
      if (f !== 0) {
        writer.writeInt32(
          2,
          f
        );
      }
      f = message.getDetail();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.RequestSeatChangeRequest.prototype.getRequestedSeats = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 2, 0)
      );
    };
    proto.atfai.console.v1.RequestSeatChangeRequest.prototype.setRequestedSeats = function(value) {
      return jspb2.Message.setProto3IntField(this, 2, value);
    };
    proto.atfai.console.v1.RequestSeatChangeRequest.prototype.getDetail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.RequestSeatChangeRequest.prototype.setDetail = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RequestSeatChangeResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RequestSeatChangeResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RequestSeatChangeResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          requestId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          status: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RequestSeatChangeResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RequestSeatChangeResponse();
      return proto.atfai.console.v1.RequestSeatChangeResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RequestSeatChangeResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequestId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStatus(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RequestSeatChangeResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RequestSeatChangeResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RequestSeatChangeResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequestId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getStatus();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.RequestSeatChangeResponse.prototype.getRequestId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.RequestSeatChangeResponse.prototype.setRequestId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.RequestSeatChangeResponse.prototype.getStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.RequestSeatChangeResponse.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RequestCancellationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RequestCancellationRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RequestCancellationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          detail: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RequestCancellationRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RequestCancellationRequest();
      return proto.atfai.console.v1.RequestCancellationRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RequestCancellationRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDetail(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RequestCancellationRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RequestCancellationRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RequestCancellationRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getDetail();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.RequestCancellationRequest.prototype.getDetail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.RequestCancellationRequest.prototype.setDetail = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RequestCancellationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RequestCancellationResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RequestCancellationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          requestId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          status: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RequestCancellationResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RequestCancellationResponse();
      return proto.atfai.console.v1.RequestCancellationResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RequestCancellationResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequestId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStatus(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RequestCancellationResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RequestCancellationResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RequestCancellationResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequestId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getStatus();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.RequestCancellationResponse.prototype.getRequestId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.RequestCancellationResponse.prototype.setRequestId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.RequestCancellationResponse.prototype.getStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.RequestCancellationResponse.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RequestSupportRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RequestSupportRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RequestSupportRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          subject: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          detail: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          instanceId: jspb2.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RequestSupportRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RequestSupportRequest();
      return proto.atfai.console.v1.RequestSupportRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RequestSupportRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setSubject(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setDetail(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setInstanceId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RequestSupportRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RequestSupportRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RequestSupportRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getSubject();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getDetail();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getInstanceId();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
    };
    proto.atfai.console.v1.RequestSupportRequest.prototype.getSubject = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.RequestSupportRequest.prototype.setSubject = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.RequestSupportRequest.prototype.getDetail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.RequestSupportRequest.prototype.setDetail = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.RequestSupportRequest.prototype.getInstanceId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.RequestSupportRequest.prototype.setInstanceId = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.RequestSupportResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.RequestSupportResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.RequestSupportResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          requestId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          status: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.RequestSupportResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.RequestSupportResponse();
      return proto.atfai.console.v1.RequestSupportResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.RequestSupportResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequestId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStatus(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.RequestSupportResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.RequestSupportResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.RequestSupportResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequestId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getStatus();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.RequestSupportResponse.prototype.getRequestId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.RequestSupportResponse.prototype.setRequestId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.RequestSupportResponse.prototype.getStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.RequestSupportResponse.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.CustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.CustomerRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.CustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          kind: jspb2.Message.getFieldWithDefault(msg, 3, ""),
          payloadJson: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          status: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          requestedBy: jspb2.Message.getFieldWithDefault(msg, 6, ""),
          createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          ackedBy: jspb2.Message.getFieldWithDefault(msg, 8, ""),
          ackedAt: (f = msg.getAckedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          resolvedBy: jspb2.Message.getFieldWithDefault(msg, 10, ""),
          resolvedAt: (f = msg.getResolvedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
          resolutionNote: jspb2.Message.getFieldWithDefault(msg, 12, ""),
          source: jspb2.Message.getFieldWithDefault(msg, 13, ""),
          orgId: jspb2.Message.getFieldWithDefault(msg, 14, ""),
          requesterEmail: jspb2.Message.getFieldWithDefault(msg, 15, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.CustomerRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.CustomerRequest();
      return proto.atfai.console.v1.CustomerRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.CustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountId(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setKind(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPayloadJson(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStatus(value);
            break;
          case 6:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequestedBy(value);
            break;
          case 7:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setCreatedAt(value);
            break;
          case 8:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAckedBy(value);
            break;
          case 9:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setAckedAt(value);
            break;
          case 10:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setResolvedBy(value);
            break;
          case 11:
            var value = new google_protobuf_timestamp_pb.Timestamp();
            reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
            msg.setResolvedAt(value);
            break;
          case 12:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setResolutionNote(value);
            break;
          case 13:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setSource(value);
            break;
          case 14:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 15:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequesterEmail(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.CustomerRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.CustomerRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.CustomerRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountId();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getKind();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getPayloadJson();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getStatus();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getRequestedBy();
      if (f.length > 0) {
        writer.writeString(
          6,
          f
        );
      }
      f = message.getCreatedAt();
      if (f != null) {
        writer.writeMessage(
          7,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getAckedBy();
      if (f.length > 0) {
        writer.writeString(
          8,
          f
        );
      }
      f = message.getAckedAt();
      if (f != null) {
        writer.writeMessage(
          9,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getResolvedBy();
      if (f.length > 0) {
        writer.writeString(
          10,
          f
        );
      }
      f = message.getResolvedAt();
      if (f != null) {
        writer.writeMessage(
          11,
          f,
          google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
        );
      }
      f = message.getResolutionNote();
      if (f.length > 0) {
        writer.writeString(
          12,
          f
        );
      }
      f = message.getSource();
      if (f.length > 0) {
        writer.writeString(
          13,
          f
        );
      }
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          14,
          f
        );
      }
      f = message.getRequesterEmail();
      if (f.length > 0) {
        writer.writeString(
          15,
          f
        );
      }
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getAccountId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setAccountId = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getKind = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setKind = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getPayloadJson = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setPayloadJson = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getStatus = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setStatus = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getRequestedBy = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 6, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setRequestedBy = function(value) {
      return jspb2.Message.setProto3StringField(this, 6, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getCreatedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setCreatedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 7, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.clearCreatedAt = function() {
      return this.setCreatedAt(void 0);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.hasCreatedAt = function() {
      return jspb2.Message.getField(this, 7) != null;
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getAckedBy = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 8, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setAckedBy = function(value) {
      return jspb2.Message.setProto3StringField(this, 8, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getAckedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setAckedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 9, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.clearAckedAt = function() {
      return this.setAckedAt(void 0);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.hasAckedAt = function() {
      return jspb2.Message.getField(this, 9) != null;
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getResolvedBy = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 10, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setResolvedBy = function(value) {
      return jspb2.Message.setProto3StringField(this, 10, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getResolvedAt = function() {
      return (
        /** @type{?proto.google.protobuf.Timestamp} */
        jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11)
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setResolvedAt = function(value) {
      return jspb2.Message.setWrapperField(this, 11, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.clearResolvedAt = function() {
      return this.setResolvedAt(void 0);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.hasResolvedAt = function() {
      return jspb2.Message.getField(this, 11) != null;
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getResolutionNote = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 12, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setResolutionNote = function(value) {
      return jspb2.Message.setProto3StringField(this, 12, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getSource = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 13, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setSource = function(value) {
      return jspb2.Message.setProto3StringField(this, 13, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 14, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 14, value);
    };
    proto.atfai.console.v1.CustomerRequest.prototype.getRequesterEmail = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 15, "")
      );
    };
    proto.atfai.console.v1.CustomerRequest.prototype.setRequesterEmail = function(value) {
      return jspb2.Message.setProto3StringField(this, 15, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListCustomerRequestsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListCustomerRequestsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          statusFilter: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          accountIdFilter: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          pageSize: jspb2.Message.getFieldWithDefault(msg, 3, 0),
          pageToken: jspb2.Message.getFieldWithDefault(msg, 4, ""),
          kindFilter: jspb2.Message.getFieldWithDefault(msg, 5, ""),
          sourceFilter: jspb2.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListCustomerRequestsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListCustomerRequestsRequest();
      return proto.atfai.console.v1.ListCustomerRequestsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setStatusFilter(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setAccountIdFilter(value);
            break;
          case 3:
            var value = (
              /** @type {number} */
              reader.readInt32()
            );
            msg.setPageSize(value);
            break;
          case 4:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPageToken(value);
            break;
          case 5:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setKindFilter(value);
            break;
          case 6:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setSourceFilter(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListCustomerRequestsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getStatusFilter();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAccountIdFilter();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getPageSize();
      if (f !== 0) {
        writer.writeInt32(
          3,
          f
        );
      }
      f = message.getPageToken();
      if (f.length > 0) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getKindFilter();
      if (f.length > 0) {
        writer.writeString(
          5,
          f
        );
      }
      f = message.getSourceFilter();
      if (f.length > 0) {
        writer.writeString(
          6,
          f
        );
      }
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.getStatusFilter = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.setStatusFilter = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.getAccountIdFilter = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.setAccountIdFilter = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.getPageSize = function() {
      return (
        /** @type {number} */
        jspb2.Message.getFieldWithDefault(this, 3, 0)
      );
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.setPageSize = function(value) {
      return jspb2.Message.setProto3IntField(this, 3, value);
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.getPageToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 4, "")
      );
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.setPageToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 4, value);
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.getKindFilter = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 5, "")
      );
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.setKindFilter = function(value) {
      return jspb2.Message.setProto3StringField(this, 5, value);
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.getSourceFilter = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 6, "")
      );
    };
    proto.atfai.console.v1.ListCustomerRequestsRequest.prototype.setSourceFilter = function(value) {
      return jspb2.Message.setProto3StringField(this, 6, value);
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListCustomerRequestsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListCustomerRequestsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListCustomerRequestsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          requestsList: jspb2.Message.toObjectList(
            msg.getRequestsList(),
            proto.atfai.console.v1.CustomerRequest.toObject,
            includeInstance
          ),
          nextPageToken: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListCustomerRequestsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListCustomerRequestsResponse();
      return proto.atfai.console.v1.ListCustomerRequestsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.CustomerRequest();
            reader.readMessage(value, proto.atfai.console.v1.CustomerRequest.deserializeBinaryFromReader);
            msg.addRequests(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setNextPageToken(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListCustomerRequestsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequestsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.CustomerRequest.serializeBinaryToWriter
        );
      }
      f = message.getNextPageToken();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.prototype.getRequestsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.CustomerRequest>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.CustomerRequest, 1)
      );
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.prototype.setRequestsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.prototype.addRequests = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.CustomerRequest, opt_index);
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.prototype.clearRequestsList = function() {
      return this.setRequestsList([]);
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.prototype.getNextPageToken = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListCustomerRequestsResponse.prototype.setNextPageToken = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          requestId: jspb2.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.AcknowledgeCustomerRequestRequest();
      return proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequestId(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequestId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.prototype.getRequestId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestRequest.prototype.setRequestId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          request: (f = msg.getRequest()) && proto.atfai.console.v1.CustomerRequest.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.AcknowledgeCustomerRequestResponse();
      return proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.CustomerRequest();
            reader.readMessage(value, proto.atfai.console.v1.CustomerRequest.deserializeBinaryFromReader);
            msg.setRequest(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequest();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.CustomerRequest.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.prototype.getRequest = function() {
      return (
        /** @type{?proto.atfai.console.v1.CustomerRequest} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.CustomerRequest, 1)
      );
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.prototype.setRequest = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.prototype.clearRequest = function() {
      return this.setRequest(void 0);
    };
    proto.atfai.console.v1.AcknowledgeCustomerRequestResponse.prototype.hasRequest = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ResolveCustomerRequestRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ResolveCustomerRequestRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ResolveCustomerRequestRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          requestId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          note: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ResolveCustomerRequestRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ResolveCustomerRequestRequest();
      return proto.atfai.console.v1.ResolveCustomerRequestRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ResolveCustomerRequestRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setRequestId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setNote(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ResolveCustomerRequestRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ResolveCustomerRequestRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ResolveCustomerRequestRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequestId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getNote();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ResolveCustomerRequestRequest.prototype.getRequestId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.ResolveCustomerRequestRequest.prototype.setRequestId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.ResolveCustomerRequestRequest.prototype.getNote = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ResolveCustomerRequestRequest.prototype.setNote = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ResolveCustomerRequestResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ResolveCustomerRequestResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ResolveCustomerRequestResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          request: (f = msg.getRequest()) && proto.atfai.console.v1.CustomerRequest.toObject(includeInstance, f)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ResolveCustomerRequestResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ResolveCustomerRequestResponse();
      return proto.atfai.console.v1.ResolveCustomerRequestResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ResolveCustomerRequestResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.CustomerRequest();
            reader.readMessage(value, proto.atfai.console.v1.CustomerRequest.deserializeBinaryFromReader);
            msg.setRequest(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ResolveCustomerRequestResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ResolveCustomerRequestResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ResolveCustomerRequestResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getRequest();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.atfai.console.v1.CustomerRequest.serializeBinaryToWriter
        );
      }
    };
    proto.atfai.console.v1.ResolveCustomerRequestResponse.prototype.getRequest = function() {
      return (
        /** @type{?proto.atfai.console.v1.CustomerRequest} */
        jspb2.Message.getWrapperField(this, proto.atfai.console.v1.CustomerRequest, 1)
      );
    };
    proto.atfai.console.v1.ResolveCustomerRequestResponse.prototype.setRequest = function(value) {
      return jspb2.Message.setWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ResolveCustomerRequestResponse.prototype.clearRequest = function() {
      return this.setRequest(void 0);
    };
    proto.atfai.console.v1.ResolveCustomerRequestResponse.prototype.hasRequest = function() {
      return jspb2.Message.getField(this, 1) != null;
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.OrgBillingPortal.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.OrgBillingPortal.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.OrgBillingPortal.toObject = function(includeInstance, msg) {
        var f, obj = {
          orgId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
          orgName: jspb2.Message.getFieldWithDefault(msg, 2, ""),
          portalUrl: jspb2.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.OrgBillingPortal.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.OrgBillingPortal();
      return proto.atfai.console.v1.OrgBillingPortal.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.OrgBillingPortal.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgId(value);
            break;
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setOrgName(value);
            break;
          case 3:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setPortalUrl(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.OrgBillingPortal.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.OrgBillingPortal.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.OrgBillingPortal.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getOrgId();
      if (f.length > 0) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getOrgName();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getPortalUrl();
      if (f.length > 0) {
        writer.writeString(
          3,
          f
        );
      }
    };
    proto.atfai.console.v1.OrgBillingPortal.prototype.getOrgId = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 1, "")
      );
    };
    proto.atfai.console.v1.OrgBillingPortal.prototype.setOrgId = function(value) {
      return jspb2.Message.setProto3StringField(this, 1, value);
    };
    proto.atfai.console.v1.OrgBillingPortal.prototype.getOrgName = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.OrgBillingPortal.prototype.setOrgName = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.OrgBillingPortal.prototype.getPortalUrl = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 3, "")
      );
    };
    proto.atfai.console.v1.OrgBillingPortal.prototype.setPortalUrl = function(value) {
      return jspb2.Message.setProto3StringField(this, 3, value);
    };
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
          returnUrl: jspb2.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListMyOrgBillingPortalsRequest();
      return proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 2:
            var value = (
              /** @type {string} */
              reader.readString()
            );
            msg.setReturnUrl(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getReturnUrl();
      if (f.length > 0) {
        writer.writeString(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.prototype.getReturnUrl = function() {
      return (
        /** @type {string} */
        jspb2.Message.getFieldWithDefault(this, 2, "")
      );
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsRequest.prototype.setReturnUrl = function(value) {
      return jspb2.Message.setProto3StringField(this, 2, value);
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.repeatedFields_ = [1];
    if (jspb2.Message.GENERATE_TO_OBJECT) {
      proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.toObject(opt_includeInstance, this);
      };
      proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
          portalsList: jspb2.Message.toObjectList(
            msg.getPortalsList(),
            proto.atfai.console.v1.OrgBillingPortal.toObject,
            includeInstance
          ),
          billingUnavailable: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) {
          obj.$jspbMessageInstance = msg;
        }
        return obj;
      };
    }
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.deserializeBinary = function(bytes) {
      var reader = new jspb2.BinaryReader(bytes);
      var msg = new proto.atfai.console.v1.ListMyOrgBillingPortalsResponse();
      return proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.deserializeBinaryFromReader(msg, reader);
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
          case 1:
            var value = new proto.atfai.console.v1.OrgBillingPortal();
            reader.readMessage(value, proto.atfai.console.v1.OrgBillingPortal.deserializeBinaryFromReader);
            msg.addPortals(value);
            break;
          case 2:
            var value = (
              /** @type {boolean} */
              reader.readBool()
            );
            msg.setBillingUnavailable(value);
            break;
          default:
            reader.skipField();
            break;
        }
      }
      return msg;
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.prototype.serializeBinary = function() {
      var writer = new jspb2.BinaryWriter();
      proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.serializeBinaryToWriter = function(message, writer) {
      var f = void 0;
      f = message.getPortalsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.atfai.console.v1.OrgBillingPortal.serializeBinaryToWriter
        );
      }
      f = message.getBillingUnavailable();
      if (f) {
        writer.writeBool(
          2,
          f
        );
      }
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.prototype.getPortalsList = function() {
      return (
        /** @type{!Array<!proto.atfai.console.v1.OrgBillingPortal>} */
        jspb2.Message.getRepeatedWrapperField(this, proto.atfai.console.v1.OrgBillingPortal, 1)
      );
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.prototype.setPortalsList = function(value) {
      return jspb2.Message.setRepeatedWrapperField(this, 1, value);
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.prototype.addPortals = function(opt_value, opt_index) {
      return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.atfai.console.v1.OrgBillingPortal, opt_index);
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.prototype.clearPortalsList = function() {
      return this.setPortalsList([]);
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.prototype.getBillingUnavailable = function() {
      return (
        /** @type {boolean} */
        jspb2.Message.getBooleanFieldWithDefault(this, 2, false)
      );
    };
    proto.atfai.console.v1.ListMyOrgBillingPortalsResponse.prototype.setBillingUnavailable = function(value) {
      return jspb2.Message.setProto3BooleanField(this, 2, value);
    };
    proto.atfai.console.v1.DeploymentType = {
      DEPLOYMENT_TYPE_UNSPECIFIED: 0,
      DEPLOYMENT_TYPE_HOSTED: 1,
      DEPLOYMENT_TYPE_PRIVATE_CONNECTED: 2,
      DEPLOYMENT_TYPE_PRIVATE_OFFLINE: 3
    };
    proto.atfai.console.v1.ConnectivityMode = {
      CONNECTIVITY_MODE_UNSPECIFIED: 0,
      CONNECTIVITY_MODE_CONNECTED: 1,
      CONNECTIVITY_MODE_OFFLINE: 2
    };
    proto.atfai.console.v1.BillingModel = {
      BILLING_MODEL_UNSPECIFIED: 0,
      BILLING_MODEL_PER_SEAT: 1,
      BILLING_MODEL_FLAT: 2,
      BILLING_MODEL_CONTRACT: 3,
      BILLING_MODEL_NONE: 4
    };
    proto.atfai.console.v1.BillingState = {
      BILLING_STATE_UNSPECIFIED: 0,
      BILLING_STATE_ACTIVE: 1,
      BILLING_STATE_DELAYED: 2,
      BILLING_STATE_UNMETERED: 3,
      BILLING_STATE_PROMOTIONAL: 4,
      BILLING_STATE_PARTNER: 5,
      BILLING_STATE_COMP: 6
    };
    proto.atfai.console.v1.LicenseStatus = {
      LICENSE_STATUS_UNSPECIFIED: 0,
      LICENSE_STATUS_ACTIVE: 1,
      LICENSE_STATUS_SUSPENDED: 2,
      LICENSE_STATUS_REVOKED: 3
    };
    proto.atfai.console.v1.LicenseTier = {
      LICENSE_TIER_UNSPECIFIED: 0,
      LICENSE_TIER_TIER1: 1,
      LICENSE_TIER_TIER2: 2,
      LICENSE_TIER_TIER3: 3,
      LICENSE_TIER_TIER4: 4,
      LICENSE_TIER_INTERNAL: 5,
      LICENSE_TIER_CUSTOM: 6
    };
    proto.atfai.console.v1.InstanceEnvironment = {
      INSTANCE_ENVIRONMENT_UNSPECIFIED: 0,
      INSTANCE_ENVIRONMENT_PRODUCTION: 1,
      INSTANCE_ENVIRONMENT_STAGING: 2,
      INSTANCE_ENVIRONMENT_DEV: 3,
      INSTANCE_ENVIRONMENT_SANDBOX: 4
    };
    proto.atfai.console.v1.OrgScope = {
      ORG_SCOPE_UNSPECIFIED: 0,
      ORG_SCOPE_WILDCARD: 1,
      ORG_SCOPE_ACCOUNT_BOUND: 2
    };
    proto.atfai.console.v1.InstanceEnrollmentStatus = {
      INSTANCE_ENROLLMENT_STATUS_UNSPECIFIED: 0,
      INSTANCE_ENROLLMENT_STATUS_PENDING: 1,
      INSTANCE_ENROLLMENT_STATUS_ACTIVE: 2,
      INSTANCE_ENROLLMENT_STATUS_SUSPENDED: 3,
      INSTANCE_ENROLLMENT_STATUS_DECOMMISSIONED: 4
    };
    proto.atfai.console.v1.DataClassification = {
      DATA_CLASSIFICATION_UNSPECIFIED: 0,
      DATA_CLASSIFICATION_OPERATIONAL: 1,
      DATA_CLASSIFICATION_BILLING: 2,
      DATA_CLASSIFICATION_DIAGNOSTIC: 3
    };
    proto.atfai.console.v1.ReportingSource = {
      REPORTING_SOURCE_UNSPECIFIED: 0,
      REPORTING_SOURCE_DIRECT_READ: 1,
      REPORTING_SOURCE_PUSHED: 2
    };
    proto.atfai.console.v1.AuditAction = {
      AUDIT_ACTION_UNSPECIFIED: 0,
      AUDIT_ACTION_ACCOUNT_CREATED: 1,
      AUDIT_ACTION_ACCOUNT_UPDATED: 2,
      AUDIT_ACTION_ACCOUNT_DELETED: 3,
      AUDIT_ACTION_INSTANCE_REGISTERED: 4,
      AUDIT_ACTION_INSTANCE_UPDATED: 5,
      AUDIT_ACTION_LICENSE_ISSUED: 6,
      AUDIT_ACTION_LICENSE_ASSIGNED: 7,
      AUDIT_ACTION_LICENSE_SUSPENDED: 8,
      AUDIT_ACTION_LICENSE_RESUMED: 9,
      AUDIT_ACTION_LICENSE_REVOKED: 10,
      AUDIT_ACTION_INSTANCE_TOKEN_MINTED: 11,
      AUDIT_ACTION_LICENSE_BILLING_STATE_CHANGED: 12,
      AUDIT_ACTION_STRIPE_CONTRACT_CREATED: 13,
      AUDIT_ACTION_STRIPE_CONTRACT_CANCELED: 14,
      AUDIT_ACTION_STRIPE_WEBHOOK_PROCESSED: 15,
      AUDIT_ACTION_ORG_CREATED: 16,
      AUDIT_ACTION_ORG_UPDATED: 17,
      AUDIT_ACTION_ORG_DELETED: 18,
      AUDIT_ACTION_USER_CREATED: 19,
      AUDIT_ACTION_MEMBERSHIP_CREATED: 20,
      AUDIT_ACTION_ORG_RESTORED: 21
    };
    proto.atfai.console.v1.ConsoleOperatorRole = {
      CONSOLE_OPERATOR_ROLE_UNSPECIFIED: 0,
      CONSOLE_OPERATOR_ROLE_ADMIN: 1,
      CONSOLE_OPERATOR_ROLE_VIEWER: 2
    };
    proto.atfai.console.v1.AccountRole = {
      ACCOUNT_ROLE_UNSPECIFIED: 0,
      ACCOUNT_ROLE_OWNER: 1,
      ACCOUNT_ROLE_ADMIN: 2,
      ACCOUNT_ROLE_MEMBER: 3
    };
    goog2.object.extend(exports2, proto.atfai.console.v1);
  }
});
const __consolePbDefault = require_console_pb();
export default __consolePbDefault;

// --- Named re-exports (post-generation ESM patch, see
// scripts/generate-grpc-web.sh) so
// `import * as pb from './console_pb'; pb.Foo` resolves the same
// way it did against the original CommonJS output under Node's
// require(), without reintroducing any require() call -- esbuild's
// bundle above already resolved google-protobuf at codegen time, so
// this file has zero runtime require(...) calls left.
export const AcceptInviteRequest = __consolePbDefault.AcceptInviteRequest;
export const AcceptInviteResponse = __consolePbDefault.AcceptInviteResponse;
export const Account = __consolePbDefault.Account;
export const AccountMember = __consolePbDefault.AccountMember;
export const AccountRole = __consolePbDefault.AccountRole;
export const AcknowledgeCustomerRequestRequest = __consolePbDefault.AcknowledgeCustomerRequestRequest;
export const AcknowledgeCustomerRequestResponse = __consolePbDefault.AcknowledgeCustomerRequestResponse;
export const AssignLicenseRequest = __consolePbDefault.AssignLicenseRequest;
export const AssignLicenseResponse = __consolePbDefault.AssignLicenseResponse;
export const AuditAction = __consolePbDefault.AuditAction;
export const AuditEvent = __consolePbDefault.AuditEvent;
export const BillingModel = __consolePbDefault.BillingModel;
export const BillingState = __consolePbDefault.BillingState;
export const CancelContractRequest = __consolePbDefault.CancelContractRequest;
export const CancelContractResponse = __consolePbDefault.CancelContractResponse;
export const ChangeMyPasswordRequest = __consolePbDefault.ChangeMyPasswordRequest;
export const ChangeMyPasswordResponse = __consolePbDefault.ChangeMyPasswordResponse;
export const ConnectivityMode = __consolePbDefault.ConnectivityMode;
export const ConsoleApiKeyMetadata = __consolePbDefault.ConsoleApiKeyMetadata;
export const ConsoleOperator = __consolePbDefault.ConsoleOperator;
export const ConsoleOperatorRole = __consolePbDefault.ConsoleOperatorRole;
export const CreateAccountRequest = __consolePbDefault.CreateAccountRequest;
export const CreateAccountResponse = __consolePbDefault.CreateAccountResponse;
export const CreateApiKeyRequest = __consolePbDefault.CreateApiKeyRequest;
export const CreateApiKeyResponse = __consolePbDefault.CreateApiKeyResponse;
export const CreateContractRequest = __consolePbDefault.CreateContractRequest;
export const CreateContractResponse = __consolePbDefault.CreateContractResponse;
export const CreateOperatorRequest = __consolePbDefault.CreateOperatorRequest;
export const CreateOperatorResponse = __consolePbDefault.CreateOperatorResponse;
export const CreateOrgRequest = __consolePbDefault.CreateOrgRequest;
export const CreateOrgResponse = __consolePbDefault.CreateOrgResponse;
export const CustomerRequest = __consolePbDefault.CustomerRequest;
export const DataClassification = __consolePbDefault.DataClassification;
export const DeleteAccountRequest = __consolePbDefault.DeleteAccountRequest;
export const DeleteAccountResponse = __consolePbDefault.DeleteAccountResponse;
export const DeleteOrgRequest = __consolePbDefault.DeleteOrgRequest;
export const DeleteOrgResponse = __consolePbDefault.DeleteOrgResponse;
export const DeploymentType = __consolePbDefault.DeploymentType;
export const DisableOperatorRequest = __consolePbDefault.DisableOperatorRequest;
export const DisableOperatorResponse = __consolePbDefault.DisableOperatorResponse;
export const DownloadMyLicenseRequest = __consolePbDefault.DownloadMyLicenseRequest;
export const DownloadMyLicenseResponse = __consolePbDefault.DownloadMyLicenseResponse;
export const GetAccountRequest = __consolePbDefault.GetAccountRequest;
export const GetAccountResponse = __consolePbDefault.GetAccountResponse;
export const GetContractStatusRequest = __consolePbDefault.GetContractStatusRequest;
export const GetContractStatusResponse = __consolePbDefault.GetContractStatusResponse;
export const GetInstanceRequest = __consolePbDefault.GetInstanceRequest;
export const GetInstanceResponse = __consolePbDefault.GetInstanceResponse;
export const GetLicenseRequest = __consolePbDefault.GetLicenseRequest;
export const GetLicenseResponse = __consolePbDefault.GetLicenseResponse;
export const GetMyContractStatusRequest = __consolePbDefault.GetMyContractStatusRequest;
export const GetMyContractStatusResponse = __consolePbDefault.GetMyContractStatusResponse;
export const GetMyLicenseRequest = __consolePbDefault.GetMyLicenseRequest;
export const GetMyLicenseResponse = __consolePbDefault.GetMyLicenseResponse;
export const GetOrgRequest = __consolePbDefault.GetOrgRequest;
export const GetOrgResponse = __consolePbDefault.GetOrgResponse;
export const GetOrgUsageRollupRequest = __consolePbDefault.GetOrgUsageRollupRequest;
export const GetOrgUsageRollupResponse = __consolePbDefault.GetOrgUsageRollupResponse;
export const GetRevenueOverviewRequest = __consolePbDefault.GetRevenueOverviewRequest;
export const GetRevenueOverviewResponse = __consolePbDefault.GetRevenueOverviewResponse;
export const IngestUsageEventsRequest = __consolePbDefault.IngestUsageEventsRequest;
export const IngestUsageEventsResponse = __consolePbDefault.IngestUsageEventsResponse;
export const Instance = __consolePbDefault.Instance;
export const InstanceEnrollmentStatus = __consolePbDefault.InstanceEnrollmentStatus;
export const InstanceEnvironment = __consolePbDefault.InstanceEnvironment;
export const InstanceHeartbeatRequest = __consolePbDefault.InstanceHeartbeatRequest;
export const InstanceHeartbeatResponse = __consolePbDefault.InstanceHeartbeatResponse;
export const InviteFirstCustomerRequest = __consolePbDefault.InviteFirstCustomerRequest;
export const InviteFirstCustomerResponse = __consolePbDefault.InviteFirstCustomerResponse;
export const InviteMemberRequest = __consolePbDefault.InviteMemberRequest;
export const InviteMemberResponse = __consolePbDefault.InviteMemberResponse;
export const IssueLicenseRequest = __consolePbDefault.IssueLicenseRequest;
export const IssueLicenseResponse = __consolePbDefault.IssueLicenseResponse;
export const License = __consolePbDefault.License;
export const LicenseHealthAlert = __consolePbDefault.LicenseHealthAlert;
export const LicenseStatus = __consolePbDefault.LicenseStatus;
export const LicenseTier = __consolePbDefault.LicenseTier;
export const ListAccountsRequest = __consolePbDefault.ListAccountsRequest;
export const ListAccountsResponse = __consolePbDefault.ListAccountsResponse;
export const ListApiKeysRequest = __consolePbDefault.ListApiKeysRequest;
export const ListApiKeysResponse = __consolePbDefault.ListApiKeysResponse;
export const ListCustomerRequestsRequest = __consolePbDefault.ListCustomerRequestsRequest;
export const ListCustomerRequestsResponse = __consolePbDefault.ListCustomerRequestsResponse;
export const ListInstancesRequest = __consolePbDefault.ListInstancesRequest;
export const ListInstancesResponse = __consolePbDefault.ListInstancesResponse;
export const ListLicenseHealthAlertsRequest = __consolePbDefault.ListLicenseHealthAlertsRequest;
export const ListLicenseHealthAlertsResponse = __consolePbDefault.ListLicenseHealthAlertsResponse;
export const ListLicensesRequest = __consolePbDefault.ListLicensesRequest;
export const ListLicensesResponse = __consolePbDefault.ListLicensesResponse;
export const ListMembersRequest = __consolePbDefault.ListMembersRequest;
export const ListMembersResponse = __consolePbDefault.ListMembersResponse;
export const ListMyLicensesRequest = __consolePbDefault.ListMyLicensesRequest;
export const ListMyLicensesResponse = __consolePbDefault.ListMyLicensesResponse;
export const ListMyOrgBillingPortalsRequest = __consolePbDefault.ListMyOrgBillingPortalsRequest;
export const ListMyOrgBillingPortalsResponse = __consolePbDefault.ListMyOrgBillingPortalsResponse;
export const ListMyUsageEventsRequest = __consolePbDefault.ListMyUsageEventsRequest;
export const ListMyUsageEventsResponse = __consolePbDefault.ListMyUsageEventsResponse;
export const ListOperatorsRequest = __consolePbDefault.ListOperatorsRequest;
export const ListOperatorsResponse = __consolePbDefault.ListOperatorsResponse;
export const ListOrgsRequest = __consolePbDefault.ListOrgsRequest;
export const ListOrgsResponse = __consolePbDefault.ListOrgsResponse;
export const ListPurgeEligibleOrgsRequest = __consolePbDefault.ListPurgeEligibleOrgsRequest;
export const ListPurgeEligibleOrgsResponse = __consolePbDefault.ListPurgeEligibleOrgsResponse;
export const ListUsageEventsRequest = __consolePbDefault.ListUsageEventsRequest;
export const ListUsageEventsResponse = __consolePbDefault.ListUsageEventsResponse;
export const MarkOrgPurgedRequest = __consolePbDefault.MarkOrgPurgedRequest;
export const MarkOrgPurgedResponse = __consolePbDefault.MarkOrgPurgedResponse;
export const MintInstanceTokenRequest = __consolePbDefault.MintInstanceTokenRequest;
export const MintInstanceTokenResponse = __consolePbDefault.MintInstanceTokenResponse;
export const MintSignupRequest = __consolePbDefault.MintSignupRequest;
export const MintSignupResponse = __consolePbDefault.MintSignupResponse;
export const Org = __consolePbDefault.Org;
export const OrgBillingPortal = __consolePbDefault.OrgBillingPortal;
export const OrgScope = __consolePbDefault.OrgScope;
export const OrgScopeAlert = __consolePbDefault.OrgScopeAlert;
export const OrgUsageSummary = __consolePbDefault.OrgUsageSummary;
export const RegisterInstanceRequest = __consolePbDefault.RegisterInstanceRequest;
export const RegisterInstanceResponse = __consolePbDefault.RegisterInstanceResponse;
export const RemoveMemberRequest = __consolePbDefault.RemoveMemberRequest;
export const RemoveMemberResponse = __consolePbDefault.RemoveMemberResponse;
export const ReportingSource = __consolePbDefault.ReportingSource;
export const RequestCancellationRequest = __consolePbDefault.RequestCancellationRequest;
export const RequestCancellationResponse = __consolePbDefault.RequestCancellationResponse;
export const RequestSeatChangeRequest = __consolePbDefault.RequestSeatChangeRequest;
export const RequestSeatChangeResponse = __consolePbDefault.RequestSeatChangeResponse;
export const RequestSupportRequest = __consolePbDefault.RequestSupportRequest;
export const RequestSupportResponse = __consolePbDefault.RequestSupportResponse;
export const ResolveCustomerRequestRequest = __consolePbDefault.ResolveCustomerRequestRequest;
export const ResolveCustomerRequestResponse = __consolePbDefault.ResolveCustomerRequestResponse;
export const RestoreOrgRequest = __consolePbDefault.RestoreOrgRequest;
export const RestoreOrgResponse = __consolePbDefault.RestoreOrgResponse;
export const ResumeLicenseRequest = __consolePbDefault.ResumeLicenseRequest;
export const ResumeLicenseResponse = __consolePbDefault.ResumeLicenseResponse;
export const RevenueTierBucket = __consolePbDefault.RevenueTierBucket;
export const RevokeApiKeyRequest = __consolePbDefault.RevokeApiKeyRequest;
export const RevokeApiKeyResponse = __consolePbDefault.RevokeApiKeyResponse;
export const RevokeLicenseRequest = __consolePbDefault.RevokeLicenseRequest;
export const RevokeLicenseResponse = __consolePbDefault.RevokeLicenseResponse;
export const SetMemberRoleRequest = __consolePbDefault.SetMemberRoleRequest;
export const SetMemberRoleResponse = __consolePbDefault.SetMemberRoleResponse;
export const SetOperatorPasswordRequest = __consolePbDefault.SetOperatorPasswordRequest;
export const SetOperatorPasswordResponse = __consolePbDefault.SetOperatorPasswordResponse;
export const StaleHeartbeatAlert = __consolePbDefault.StaleHeartbeatAlert;
export const SubmitInstanceSupportRequestRequest = __consolePbDefault.SubmitInstanceSupportRequestRequest;
export const SubmitInstanceSupportRequestResponse = __consolePbDefault.SubmitInstanceSupportRequestResponse;
export const SuspendLicenseRequest = __consolePbDefault.SuspendLicenseRequest;
export const SuspendLicenseResponse = __consolePbDefault.SuspendLicenseResponse;
export const UpdateAccountRequest = __consolePbDefault.UpdateAccountRequest;
export const UpdateAccountResponse = __consolePbDefault.UpdateAccountResponse;
export const UpdateInstanceRequest = __consolePbDefault.UpdateInstanceRequest;
export const UpdateInstanceResponse = __consolePbDefault.UpdateInstanceResponse;
export const UpdateMask = __consolePbDefault.UpdateMask;
export const UpdateOrgRequest = __consolePbDefault.UpdateOrgRequest;
export const UpdateOrgResponse = __consolePbDefault.UpdateOrgResponse;
export const UsageEvent = __consolePbDefault.UsageEvent;
export const WhoAmICustomer = __consolePbDefault.WhoAmICustomer;
export const WhoAmIInstance = __consolePbDefault.WhoAmIInstance;
export const WhoAmIOperator = __consolePbDefault.WhoAmIOperator;
export const WhoAmIRequest = __consolePbDefault.WhoAmIRequest;
export const WhoAmIResponse = __consolePbDefault.WhoAmIResponse;
